var df = Object.defineProperty;
var ff = (e, n, t) => n in e ? df(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var xe = (e, n, t) => ff(e, typeof n != "symbol" ? n + "" : n, t);
import { defineComponent as Se, computed as M, openBlock as w, createElementBlock as T, normalizeStyle as Ve, normalizeClass as ne, createCommentVNode as P, toDisplayString as ue, ref as ee, shallowRef as It, onMounted as et, watch as We, onUnmounted as rn, h as bt, nextTick as Ze, createBlock as de, unref as v, useSlots as Ht, resolveDynamicComponent as ht, mergeProps as rt, withCtx as fe, renderSlot as U, createTextVNode as Ue, createElementVNode as E, withModifiers as Fe, createVNode as oe, useId as Or, watchEffect as Ut, withDirectives as mn, vModelCheckbox as hf, toValue as Qe, reactive as ga, getCurrentScope as Su, onScopeDispose as _r, shallowReadonly as $a, useTemplateRef as Je, createSlots as dt, renderList as Pe, normalizeProps as Mt, guardReactiveProps as Bt, mergeDefaults as Tu, provide as Na, readonly as ei, toRef as vr, Teleport as zn, Transition as Dt, inject as ea, Fragment as Te, onBeforeUpdate as mf, vShow as Fn, withKeys as Pt, useModel as es, mergeModels as Ln, TransitionGroup as $l, getCurrentInstance as ti, hasInjectionContext as Mu, toRaw as $u, onUpdated as vf, onBeforeUnmount as Is, useAttrs as ni, isVNode as us, vModelText as pf, onDeactivated as Cu, onActivated as Du, triggerRef as Cl, isRef as Ou, markRaw as Ni, resolveComponent as _u, isMemoSame as gf, defineAsyncComponent as yf } from "vue";
import { RouterLink as bf, useRouter as Eu, onBeforeRouteLeave as wf, useRoute as ai } from "vue-router";
import { defineStore as kf } from "pinia";
const xf = ["alt", "src"], Sf = {
  key: 1,
  class: "select-none"
}, Tf = /* @__PURE__ */ Se({
  __name: "VAvatar",
  props: {
    name: { default: "" },
    avatar: { default: void 0 },
    size: { default: "md" },
    customSize: { default: void 0 },
    shape: { default: "circle" },
    online: { type: Boolean, default: !1 },
    alt: { default: "User avatar" }
  },
  setup(e) {
    const n = e, t = M(() => ({
      xs: "w-6 h-6 text-xs",
      sm: "w-8 h-8 text-sm",
      md: "w-10 h-10 text-base",
      lg: "w-12 h-12 text-lg",
      xl: "w-16 h-16 text-xl"
    })[n.size]), a = M(
      () => n.shape === "square" ? "rounded-md" : "rounded-full"
    ), s = M(() => n.customSize ? {
      width: `${n.customSize}px`,
      height: `${n.customSize}px`,
      fontSize: `${n.customSize * 0.4}px`
    } : {}), r = M(() => {
      if (!n.name) return "?";
      const o = n.name.trim().split(/\s+/);
      return o.length >= 2 ? `${o[0][0]}${o[1][0]}`.toUpperCase() : n.name.substring(0, 2).toUpperCase();
    }), l = M(() => {
      if (!n.name) return "bg-base-200 text-secondaryText";
      let o = 0;
      for (let c = 0; c < n.name.length; c++)
        o = n.name.charCodeAt(c) + ((o << 5) - o);
      const u = [
        "bg-blue-500 text-white",
        "bg-purple-500 text-white",
        "bg-pink-500 text-white",
        "bg-green-500 text-white",
        "bg-orange-500 text-white",
        "bg-primary text-white",
        "bg-indigo-500 text-white",
        "bg-cyan-500 text-white"
      ];
      return u[Math.abs(o) % u.length];
    }), i = M(() => !!n.avatar);
    return (o, u) => (w(), T("div", {
      class: ne([[t.value, a.value, !i.value && l.value], "user-avatar relative inline-flex items-center justify-center overflow-hidden flex-shrink-0 font-medium transition-all duration-200"]),
      style: Ve(s.value)
    }, [
      i.value ? (w(), T("img", {
        key: 0,
        alt: e.alt,
        src: e.avatar,
        class: "w-full h-full object-cover",
        onError: u[0] || (u[0] = (c) => c.target.style.display = "none")
      }, null, 40, xf)) : P("", !0),
      i.value ? P("", !0) : (w(), T("span", Sf, ue(r.value), 1)),
      e.online ? (w(), T("span", {
        key: 2,
        class: ne([{
          "w-1.5 h-1.5": e.size === "xs",
          "w-2 h-2": e.size === "sm",
          "w-2.5 h-2.5": e.size === "md",
          "w-3 h-3": e.size === "lg",
          "w-4 h-4": e.size === "xl"
        }, "absolute bottom-0 right-0 block rounded-full bg-success ring-2 ring-base-100 transition-all"]),
        "aria-label": "Online"
      }, null, 2)) : P("", !0)
    ], 6));
  }
}), je = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n)
    t[a] = s;
  return t;
}, sD = /* @__PURE__ */ je(Tf, [["__scopeId", "data-v-985a3a1e"]]), Iu = /^[a-z0-9]+(-[a-z0-9]+)*$/, Er = (e, n, t, a = "") => {
  const s = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (s.length < 2 || s.length > 3)
      return null;
    a = s.shift().slice(1);
  }
  if (s.length > 3 || !s.length)
    return null;
  if (s.length > 1) {
    const i = s.pop(), o = s.pop(), u = {
      // Allow provider without '@': "provider:prefix:name"
      provider: s.length > 0 ? s[0] : a,
      prefix: o,
      name: i
    };
    return n && !ur(u) ? null : u;
  }
  const r = s[0], l = r.split("-");
  if (l.length > 1) {
    const i = {
      provider: a,
      prefix: l.shift(),
      name: l.join("-")
    };
    return n && !ur(i) ? null : i;
  }
  if (t && a === "") {
    const i = {
      provider: a,
      prefix: "",
      name: r
    };
    return n && !ur(i, t) ? null : i;
  }
  return null;
}, ur = (e, n) => e ? !!// Check prefix: cannot be empty, unless allowSimpleName is enabled
// Check name: cannot be empty
((n && e.prefix === "" || e.prefix) && e.name) : !1, Pu = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), pr = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Ir = Object.freeze({
  ...Pu,
  ...pr
}), Dl = Object.freeze({
  ...Ir,
  body: "",
  hidden: !1
});
function Mf(e, n) {
  const t = {};
  !e.hFlip != !n.hFlip && (t.hFlip = !0), !e.vFlip != !n.vFlip && (t.vFlip = !0);
  const a = ((e.rotate || 0) + (n.rotate || 0)) % 4;
  return a && (t.rotate = a), t;
}
function Bi(e, n) {
  const t = Mf(e, n);
  for (const a in Dl)
    a in pr ? a in e && !(a in t) && (t[a] = pr[a]) : a in n ? t[a] = n[a] : a in e && (t[a] = e[a]);
  return t;
}
function $f(e, n) {
  const t = e.icons, a = e.aliases || /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  function r(l) {
    if (t[l])
      return s[l] = [];
    if (!(l in s)) {
      s[l] = null;
      const i = a[l] && a[l].parent, o = i && r(i);
      o && (s[l] = [i].concat(o));
    }
    return s[l];
  }
  return Object.keys(t).concat(Object.keys(a)).forEach(r), s;
}
function Cf(e, n, t) {
  const a = e.icons, s = e.aliases || /* @__PURE__ */ Object.create(null);
  let r = {};
  function l(i) {
    r = Bi(
      a[i] || s[i],
      r
    );
  }
  return l(n), t.forEach(l), Bi(e, r);
}
function Au(e, n) {
  const t = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return t;
  e.not_found instanceof Array && e.not_found.forEach((s) => {
    n(s, null), t.push(s);
  });
  const a = $f(e);
  for (const s in a) {
    const r = a[s];
    r && (n(s, Cf(e, s, r)), t.push(s));
  }
  return t;
}
const Df = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Pu
};
function tl(e, n) {
  for (const t in n)
    if (t in e && typeof e[t] != typeof n[t])
      return !1;
  return !0;
}
function Ru(e) {
  if (typeof e != "object" || e === null)
    return null;
  const n = e;
  if (typeof n.prefix != "string" || !e.icons || typeof e.icons != "object" || !tl(e, Df))
    return null;
  const t = n.icons;
  for (const s in t) {
    const r = t[s];
    if (
      // Name cannot be empty
      !s || // Must have body
      typeof r.body != "string" || // Check other props
      !tl(
        r,
        Dl
      )
    )
      return null;
  }
  const a = n.aliases || /* @__PURE__ */ Object.create(null);
  for (const s in a) {
    const r = a[s], l = r.parent;
    if (
      // Name cannot be empty
      !s || // Parent must be set and point to existing icon
      typeof l != "string" || !t[l] && !a[l] || // Check other props
      !tl(
        r,
        Dl
      )
    )
      return null;
  }
  return n;
}
const zi = /* @__PURE__ */ Object.create(null);
function Of(e, n) {
  return {
    provider: e,
    prefix: n,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function qa(e, n) {
  const t = zi[e] || (zi[e] = /* @__PURE__ */ Object.create(null));
  return t[n] || (t[n] = Of(e, n));
}
function Fu(e, n) {
  return Ru(n) ? Au(n, (t, a) => {
    a ? e.icons[t] = a : e.missing.add(t);
  }) : [];
}
function _f(e, n, t) {
  try {
    if (typeof t.body == "string")
      return e.icons[n] = { ...t }, !0;
  } catch {
  }
  return !1;
}
let Ds = !1;
function Vu(e) {
  return typeof e == "boolean" && (Ds = e), Ds;
}
function Ef(e) {
  const n = typeof e == "string" ? Er(e, !0, Ds) : e;
  if (n) {
    const t = qa(n.provider, n.prefix), a = n.name;
    return t.icons[a] || (t.missing.has(a) ? null : void 0);
  }
}
function If(e, n) {
  const t = Er(e, !0, Ds);
  if (!t)
    return !1;
  const a = qa(t.provider, t.prefix);
  return n ? _f(a, t.name, n) : (a.missing.add(t.name), !0);
}
function Pf(e, n) {
  if (typeof e != "object")
    return !1;
  if (typeof n != "string" && (n = e.provider || ""), Ds && !n && !e.prefix) {
    let s = !1;
    return Ru(e) && (e.prefix = "", Au(e, (r, l) => {
      If(r, l) && (s = !0);
    })), s;
  }
  const t = e.prefix;
  if (!ur({
    prefix: t,
    name: "a"
  }))
    return !1;
  const a = qa(n, t);
  return !!Fu(a, e);
}
const Lu = Object.freeze({
  width: null,
  height: null
}), Nu = Object.freeze({
  // Dimensions
  ...Lu,
  // Transformations
  ...pr
}), Af = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Rf = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Wi(e, n, t) {
  if (n === 1)
    return e;
  if (t = t || 100, typeof e == "number")
    return Math.ceil(e * n * t) / t;
  if (typeof e != "string")
    return e;
  const a = e.split(Af);
  if (a === null || !a.length)
    return e;
  const s = [];
  let r = a.shift(), l = Rf.test(r);
  for (; ; ) {
    if (l) {
      const i = parseFloat(r);
      isNaN(i) ? s.push(r) : s.push(Math.ceil(i * n * t) / t);
    } else
      s.push(r);
    if (r = a.shift(), r === void 0)
      return s.join("");
    l = !l;
  }
}
function Ff(e, n = "defs") {
  let t = "";
  const a = e.indexOf("<" + n);
  for (; a >= 0; ) {
    const s = e.indexOf(">", a), r = e.indexOf("</" + n);
    if (s === -1 || r === -1)
      break;
    const l = e.indexOf(">", r);
    if (l === -1)
      break;
    t += e.slice(s + 1, r).trim(), e = e.slice(0, a).trim() + e.slice(l + 1);
  }
  return {
    defs: t,
    content: e
  };
}
function Vf(e, n) {
  return e ? "<defs>" + e + "</defs>" + n : n;
}
function Lf(e, n, t) {
  const a = Ff(e);
  return Vf(a.defs, n + a.content + t);
}
const Nf = (e) => e === "unset" || e === "undefined" || e === "none";
function Bf(e, n) {
  const t = {
    ...Ir,
    ...e
  }, a = {
    ...Nu,
    ...n
  }, s = {
    left: t.left,
    top: t.top,
    width: t.width,
    height: t.height
  };
  let r = t.body;
  [t, a].forEach((g) => {
    const k = [], y = g.hFlip, h = g.vFlip;
    let b = g.rotate;
    y ? h ? b += 2 : (k.push(
      "translate(" + (s.width + s.left).toString() + " " + (0 - s.top).toString() + ")"
    ), k.push("scale(-1 1)"), s.top = s.left = 0) : h && (k.push(
      "translate(" + (0 - s.left).toString() + " " + (s.height + s.top).toString() + ")"
    ), k.push("scale(1 -1)"), s.top = s.left = 0);
    let S;
    switch (b < 0 && (b -= Math.floor(b / 4) * 4), b = b % 4, b) {
      case 1:
        S = s.height / 2 + s.top, k.unshift(
          "rotate(90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
      case 2:
        k.unshift(
          "rotate(180 " + (s.width / 2 + s.left).toString() + " " + (s.height / 2 + s.top).toString() + ")"
        );
        break;
      case 3:
        S = s.width / 2 + s.left, k.unshift(
          "rotate(-90 " + S.toString() + " " + S.toString() + ")"
        );
        break;
    }
    b % 2 === 1 && (s.left !== s.top && (S = s.left, s.left = s.top, s.top = S), s.width !== s.height && (S = s.width, s.width = s.height, s.height = S)), k.length && (r = Lf(
      r,
      '<g transform="' + k.join(" ") + '">',
      "</g>"
    ));
  });
  const l = a.width, i = a.height, o = s.width, u = s.height;
  let c, f;
  l === null ? (f = i === null ? "1em" : i === "auto" ? u : i, c = Wi(f, o / u)) : (c = l === "auto" ? o : l, f = i === null ? Wi(c, u / o) : i === "auto" ? u : i);
  const m = {}, d = (g, k) => {
    Nf(k) || (m[g] = k.toString());
  };
  d("width", c), d("height", f);
  const p = [s.left, s.top, o, u];
  return m.viewBox = p.join(" "), {
    attributes: m,
    viewBox: p,
    body: r
  };
}
const zf = /\sid="(\S+)"/g, Wf = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Yf = 0;
function Hf(e, n = Wf) {
  const t = [];
  let a;
  for (; a = zf.exec(e); )
    t.push(a[1]);
  if (!t.length)
    return e;
  const s = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return t.forEach((r) => {
    const l = typeof n == "function" ? n(r) : n + (Yf++).toString(), i = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + i + ')([")]|\\.[a-z])', "g"),
      "$1" + l + s + "$3"
    );
  }), e = e.replace(new RegExp(s, "g"), ""), e;
}
const Ol = /* @__PURE__ */ Object.create(null);
function Uf(e, n) {
  Ol[e] = n;
}
function _l(e) {
  return Ol[e] || Ol[""];
}
function si(e) {
  let n;
  if (typeof e.resources == "string")
    n = [e.resources];
  else if (n = e.resources, !(n instanceof Array) || !n.length)
    return null;
  return {
    // API hosts
    resources: n,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const ri = /* @__PURE__ */ Object.create(null), cs = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], cr = [];
for (; cs.length > 0; )
  cs.length === 1 || Math.random() > 0.5 ? cr.push(cs.shift()) : cr.push(cs.pop());
ri[""] = si({
  resources: ["https://api.iconify.design"].concat(cr)
});
function qf(e, n) {
  const t = si(n);
  return t === null ? !1 : (ri[e] = t, !0);
}
function li(e) {
  return ri[e];
}
const jf = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Yi = jf();
function Gf(e, n) {
  const t = li(e);
  if (!t)
    return 0;
  let a;
  if (!t.maxURL)
    a = 0;
  else {
    let s = 0;
    t.resources.forEach((l) => {
      s = Math.max(s, l.length);
    });
    const r = n + ".json?icons=";
    a = t.maxURL - s - t.path.length - r.length;
  }
  return a;
}
function Kf(e) {
  return e === 404;
}
const Zf = (e, n, t) => {
  const a = [], s = Gf(e, n), r = "icons";
  let l = {
    type: r,
    provider: e,
    prefix: n,
    icons: []
  }, i = 0;
  return t.forEach((o, u) => {
    i += o.length + 1, i >= s && u > 0 && (a.push(l), l = {
      type: r,
      provider: e,
      prefix: n,
      icons: []
    }, i = o.length), l.icons.push(o);
  }), a.push(l), a;
};
function Xf(e) {
  if (typeof e == "string") {
    const n = li(e);
    if (n)
      return n.path;
  }
  return "/";
}
const Jf = (e, n, t) => {
  if (!Yi) {
    t("abort", 424);
    return;
  }
  let a = Xf(n.provider);
  switch (n.type) {
    case "icons": {
      const r = n.prefix, i = n.icons.join(","), o = new URLSearchParams({
        icons: i
      });
      a += r + ".json?" + o.toString();
      break;
    }
    case "custom": {
      const r = n.uri;
      a += r.slice(0, 1) === "/" ? r.slice(1) : r;
      break;
    }
    default:
      t("abort", 400);
      return;
  }
  let s = 503;
  Yi(e + a).then((r) => {
    const l = r.status;
    if (l !== 200) {
      setTimeout(() => {
        t(Kf(l) ? "abort" : "next", l);
      });
      return;
    }
    return s = 501, r.json();
  }).then((r) => {
    if (typeof r != "object" || r === null) {
      setTimeout(() => {
        r === 404 ? t("abort", r) : t("next", s);
      });
      return;
    }
    setTimeout(() => {
      t("success", r);
    });
  }).catch(() => {
    t("next", s);
  });
}, Qf = {
  prepare: Zf,
  send: Jf
};
function eh(e) {
  const n = {
    loaded: [],
    missing: [],
    pending: []
  }, t = /* @__PURE__ */ Object.create(null);
  e.sort((s, r) => s.provider !== r.provider ? s.provider.localeCompare(r.provider) : s.prefix !== r.prefix ? s.prefix.localeCompare(r.prefix) : s.name.localeCompare(r.name));
  let a = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((s) => {
    if (a.name === s.name && a.prefix === s.prefix && a.provider === s.provider)
      return;
    a = s;
    const r = s.provider, l = s.prefix, i = s.name, o = t[r] || (t[r] = /* @__PURE__ */ Object.create(null)), u = o[l] || (o[l] = qa(r, l));
    let c;
    i in u.icons ? c = n.loaded : l === "" || u.missing.has(i) ? c = n.missing : c = n.pending;
    const f = {
      provider: r,
      prefix: l,
      name: i
    };
    c.push(f);
  }), n;
}
function Bu(e, n) {
  e.forEach((t) => {
    const a = t.loaderCallbacks;
    a && (t.loaderCallbacks = a.filter((s) => s.id !== n));
  });
}
function th(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const n = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!n.length)
      return;
    let t = !1;
    const a = e.provider, s = e.prefix;
    n.forEach((r) => {
      const l = r.icons, i = l.pending.length;
      l.pending = l.pending.filter((o) => {
        if (o.prefix !== s)
          return !0;
        const u = o.name;
        if (e.icons[u])
          l.loaded.push({
            provider: a,
            prefix: s,
            name: u
          });
        else if (e.missing.has(u))
          l.missing.push({
            provider: a,
            prefix: s,
            name: u
          });
        else
          return t = !0, !0;
        return !1;
      }), l.pending.length !== i && (t || Bu([e], r.id), r.callback(
        l.loaded.slice(0),
        l.missing.slice(0),
        l.pending.slice(0),
        r.abort
      ));
    });
  }));
}
let nh = 0;
function ah(e, n, t) {
  const a = nh++, s = Bu.bind(null, t, a);
  if (!n.pending.length)
    return s;
  const r = {
    id: a,
    icons: n,
    callback: e,
    abort: s
  };
  return t.forEach((l) => {
    (l.loaderCallbacks || (l.loaderCallbacks = [])).push(r);
  }), s;
}
function sh(e, n = !0, t = !1) {
  const a = [];
  return e.forEach((s) => {
    const r = typeof s == "string" ? Er(s, n, t) : s;
    r && a.push(r);
  }), a;
}
var rh = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function lh(e, n, t, a) {
  const s = e.resources.length, r = e.random ? Math.floor(Math.random() * s) : e.index;
  let l;
  if (e.random) {
    let C = e.resources.slice(0);
    for (l = []; C.length > 1; ) {
      const $ = Math.floor(Math.random() * C.length);
      l.push(C[$]), C = C.slice(0, $).concat(C.slice($ + 1));
    }
    l = l.concat(C);
  } else
    l = e.resources.slice(r).concat(e.resources.slice(0, r));
  const i = Date.now();
  let o = "pending", u = 0, c, f = null, m = [], d = [];
  typeof a == "function" && d.push(a);
  function p() {
    f && (clearTimeout(f), f = null);
  }
  function g() {
    o === "pending" && (o = "aborted"), p(), m.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), m = [];
  }
  function k(C, $) {
    $ && (d = []), typeof C == "function" && d.push(C);
  }
  function y() {
    return {
      startTime: i,
      payload: n,
      status: o,
      queriesSent: u,
      queriesPending: m.length,
      subscribe: k,
      abort: g
    };
  }
  function h() {
    o = "failed", d.forEach((C) => {
      C(void 0, c);
    });
  }
  function b() {
    m.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), m = [];
  }
  function S(C, $, _) {
    const A = $ !== "success";
    switch (m = m.filter((D) => D !== C), o) {
      case "pending":
        break;
      case "failed":
        if (A || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if ($ === "abort") {
      c = _, h();
      return;
    }
    if (A) {
      c = _, m.length || (l.length ? x() : h());
      return;
    }
    if (p(), b(), !e.random) {
      const D = e.resources.indexOf(C.resource);
      D !== -1 && D !== e.index && (e.index = D);
    }
    o = "completed", d.forEach((D) => {
      D(_);
    });
  }
  function x() {
    if (o !== "pending")
      return;
    p();
    const C = l.shift();
    if (C === void 0) {
      if (m.length) {
        f = setTimeout(() => {
          p(), o === "pending" && (b(), h());
        }, e.timeout);
        return;
      }
      h();
      return;
    }
    const $ = {
      status: "pending",
      resource: C,
      callback: (_, A) => {
        S($, _, A);
      }
    };
    m.push($), u++, f = setTimeout(x, e.rotate), t(C, n, $.callback);
  }
  return setTimeout(x), y;
}
function zu(e) {
  const n = {
    ...rh,
    ...e
  };
  let t = [];
  function a() {
    t = t.filter((i) => i().status === "pending");
  }
  function s(i, o, u) {
    const c = lh(
      n,
      i,
      o,
      (f, m) => {
        a(), u && u(f, m);
      }
    );
    return t.push(c), c;
  }
  function r(i) {
    return t.find((o) => i(o)) || null;
  }
  return {
    query: s,
    find: r,
    setIndex: (i) => {
      n.index = i;
    },
    getIndex: () => n.index,
    cleanup: a
  };
}
function Hi() {
}
const nl = /* @__PURE__ */ Object.create(null);
function ih(e) {
  if (!nl[e]) {
    const n = li(e);
    if (!n)
      return;
    const t = zu(n), a = {
      config: n,
      redundancy: t
    };
    nl[e] = a;
  }
  return nl[e];
}
function oh(e, n, t) {
  let a, s;
  if (typeof e == "string") {
    const r = _l(e);
    if (!r)
      return t(void 0, 424), Hi;
    s = r.send;
    const l = ih(e);
    l && (a = l.redundancy);
  } else {
    const r = si(e);
    if (r) {
      a = zu(r);
      const l = e.resources ? e.resources[0] : "", i = _l(l);
      i && (s = i.send);
    }
  }
  return !a || !s ? (t(void 0, 424), Hi) : a.query(n, s, t)().abort;
}
function Ui() {
}
function uh(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, th(e);
  }));
}
function ch(e) {
  const n = [], t = [];
  return e.forEach((a) => {
    (a.match(Iu) ? n : t).push(a);
  }), {
    valid: n,
    invalid: t
  };
}
function ds(e, n, t) {
  function a() {
    const s = e.pendingIcons;
    n.forEach((r) => {
      s && s.delete(r), e.icons[r] || e.missing.add(r);
    });
  }
  if (t && typeof t == "object")
    try {
      if (!Fu(e, t).length) {
        a();
        return;
      }
    } catch (s) {
      console.error(s);
    }
  a(), uh(e);
}
function qi(e, n) {
  e instanceof Promise ? e.then((t) => {
    n(t);
  }).catch(() => {
    n(null);
  }) : n(e);
}
function dh(e, n) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(n).sort() : e.iconsToLoad = n, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: t, prefix: a } = e, s = e.iconsToLoad;
    if (delete e.iconsToLoad, !s || !s.length)
      return;
    const r = e.loadIcon;
    if (e.loadIcons && (s.length > 1 || !r)) {
      qi(
        e.loadIcons(s, a, t),
        (c) => {
          ds(e, s, c);
        }
      );
      return;
    }
    if (r) {
      s.forEach((c) => {
        const f = r(c, a, t);
        qi(f, (m) => {
          const d = m ? {
            prefix: a,
            icons: {
              [c]: m
            }
          } : null;
          ds(e, [c], d);
        });
      });
      return;
    }
    const { valid: l, invalid: i } = ch(s);
    if (i.length && ds(e, i, null), !l.length)
      return;
    const o = a.match(Iu) ? _l(t) : null;
    if (!o) {
      ds(e, l, null);
      return;
    }
    o.prepare(t, a, l).forEach((c) => {
      oh(t, c, (f) => {
        ds(e, c.icons, f);
      });
    });
  }));
}
const fh = (e, n) => {
  const t = sh(e, !0, Vu()), a = eh(t);
  if (!a.pending.length) {
    let o = !0;
    return n && setTimeout(() => {
      o && n(
        a.loaded,
        a.missing,
        a.pending,
        Ui
      );
    }), () => {
      o = !1;
    };
  }
  const s = /* @__PURE__ */ Object.create(null), r = [];
  let l, i;
  return a.pending.forEach((o) => {
    const { provider: u, prefix: c } = o;
    if (c === i && u === l)
      return;
    l = u, i = c, r.push(qa(u, c));
    const f = s[u] || (s[u] = /* @__PURE__ */ Object.create(null));
    f[c] || (f[c] = []);
  }), a.pending.forEach((o) => {
    const { provider: u, prefix: c, name: f } = o, m = qa(u, c), d = m.pendingIcons || (m.pendingIcons = /* @__PURE__ */ new Set());
    d.has(f) || (d.add(f), s[u][c].push(f));
  }), r.forEach((o) => {
    const u = s[o.provider][o.prefix];
    u.length && dh(o, u);
  }), n ? ah(n, a, r) : Ui;
};
function hh(e, n) {
  const t = {
    ...e
  };
  for (const a in n) {
    const s = n[a], r = typeof s;
    a in Lu ? (s === null || s && (r === "string" || r === "number")) && (t[a] = s) : r === typeof t[a] && (t[a] = a === "rotate" ? s % 4 : s);
  }
  return t;
}
const mh = /[\s,]+/;
function vh(e, n) {
  n.split(mh).forEach((t) => {
    switch (t.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function ph(e, n = 0) {
  const t = e.replace(/^-?[0-9.]*/, "");
  function a(s) {
    for (; s < 0; )
      s += 4;
    return s % 4;
  }
  if (t === "") {
    const s = parseInt(e);
    return isNaN(s) ? 0 : a(s);
  } else if (t !== e) {
    let s = 0;
    switch (t) {
      case "%":
        s = 25;
        break;
      case "deg":
        s = 90;
    }
    if (s) {
      let r = parseFloat(e.slice(0, e.length - t.length));
      return isNaN(r) ? 0 : (r = r / s, r % 1 === 0 ? a(r) : 0);
    }
  }
  return n;
}
function gh(e, n) {
  let t = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const a in n)
    t += " " + a + '="' + n[a] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + t + ">" + e + "</svg>";
}
function yh(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function bh(e) {
  return "data:image/svg+xml," + yh(e);
}
function wh(e) {
  return 'url("' + bh(e) + '")';
}
const ji = {
  ...Nu,
  inline: !1
}, kh = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, xh = {
  display: "inline-block"
}, El = {
  backgroundColor: "currentColor"
}, Wu = {
  backgroundColor: "transparent"
}, Gi = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, Ki = {
  webkitMask: El,
  mask: El,
  background: Wu
};
for (const e in Ki) {
  const n = Ki[e];
  for (const t in Gi)
    n[e + t] = Gi[t];
}
const dr = {};
["horizontal", "vertical"].forEach((e) => {
  const n = e.slice(0, 1) + "Flip";
  dr[e + "-flip"] = n, dr[e.slice(0, 1) + "-flip"] = n, dr[e + "Flip"] = n;
});
function Zi(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const Xi = (e, n) => {
  const t = hh(ji, n), a = { ...kh }, s = n.mode || "svg", r = {}, l = n.style, i = typeof l == "object" && !(l instanceof Array) ? l : {};
  for (let g in n) {
    const k = n[g];
    if (k !== void 0)
      switch (g) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          t[g] = k === !0 || k === "true" || k === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof k == "string" && vh(t, k);
          break;
        // Color: override style
        case "color":
          r.color = k;
          break;
        // Rotation as string
        case "rotate":
          typeof k == "string" ? t[g] = ph(k) : typeof k == "number" && (t[g] = k);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          k !== !0 && k !== "true" && delete a["aria-hidden"];
          break;
        default: {
          const y = dr[g];
          y ? (k === !0 || k === "true" || k === 1) && (t[y] = !0) : ji[g] === void 0 && (a[g] = k);
        }
      }
  }
  const o = Bf(e, t), u = o.attributes;
  if (t.inline && (r.verticalAlign = "-0.125em"), s === "svg") {
    a.style = {
      ...r,
      ...i
    }, Object.assign(a, u);
    let g = 0, k = n.id;
    return typeof k == "string" && (k = k.replace(/-/g, "_")), a.innerHTML = Hf(o.body, k ? () => k + "ID" + g++ : "iconifyVue"), bt("svg", a);
  }
  const { body: c, width: f, height: m } = e, d = s === "mask" || (s === "bg" ? !1 : c.indexOf("currentColor") !== -1), p = gh(c, {
    ...u,
    width: f + "",
    height: m + ""
  });
  return a.style = {
    ...r,
    "--svg": wh(p),
    width: Zi(u.width),
    height: Zi(u.height),
    ...xh,
    ...d ? El : Wu,
    ...i
  }, bt("span", a);
};
Vu(!0);
Uf("", Qf);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const n = e.IconifyPreload, t = "Invalid IconifyPreload syntax.";
    typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((a) => {
      try {
        // Check if item is an object and not null/array
        (typeof a != "object" || a === null || a instanceof Array || // Check for 'icons' and 'prefix'
        typeof a.icons != "object" || typeof a.prefix != "string" || // Add icon set
        !Pf(a)) && console.error(t);
      } catch {
        console.error(t);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const n = e.IconifyProviders;
    if (typeof n == "object" && n !== null)
      for (let t in n) {
        const a = "IconifyProviders[" + t + "] is invalid.";
        try {
          const s = n[t];
          if (typeof s != "object" || !s || s.resources === void 0)
            continue;
          qf(t, s) || console.error(a);
        } catch {
          console.error(a);
        }
      }
  }
}
const Sh = {
  ...Ir,
  body: ""
}, Th = Se((e, { emit: n }) => {
  const t = ee(null);
  function a() {
    var u, c;
    t.value && ((c = (u = t.value).abort) == null || c.call(u), t.value = null);
  }
  const s = ee(!!e.ssr), r = ee(""), l = It(null);
  function i() {
    const u = e.icon;
    if (typeof u == "object" && u !== null && typeof u.body == "string")
      return r.value = "", {
        data: u
      };
    let c;
    if (typeof u != "string" || (c = Er(u, !1, !0)) === null)
      return null;
    let f = Ef(c);
    if (!f) {
      const p = t.value;
      return (!p || p.name !== u) && (f === null ? t.value = {
        name: u
      } : t.value = {
        name: u,
        abort: fh([c], o)
      }), null;
    }
    a(), r.value !== u && (r.value = u, Ze(() => {
      n("load", u);
    }));
    const m = e.customise;
    if (m) {
      f = Object.assign({}, f);
      const p = m(f.body, c.name, c.prefix, c.provider);
      typeof p == "string" && (f.body = p);
    }
    const d = ["iconify"];
    return c.prefix !== "" && d.push("iconify--" + c.prefix), c.provider !== "" && d.push("iconify--" + c.provider), { data: f, classes: d };
  }
  function o() {
    var c;
    const u = i();
    u ? u.data !== ((c = l.value) == null ? void 0 : c.data) && (l.value = u) : l.value = null;
  }
  return s.value ? o() : et(() => {
    s.value = !0, o();
  }), We(() => e.icon, o), rn(a), () => {
    const u = l.value;
    if (!u)
      return Xi(Sh, e);
    let c = e;
    return u.classes && (c = {
      ...e,
      class: u.classes.join(" ")
    }), Xi({
      ...Ir,
      ...u.data
    }, c);
  };
}, {
  props: [
    // Icon and render mode
    "icon",
    "mode",
    "ssr",
    // Layout and style
    "width",
    "height",
    "style",
    "color",
    "inline",
    // Transformations
    "rotate",
    "hFlip",
    "horizontalFlip",
    "vFlip",
    "verticalFlip",
    "flip",
    // Misc
    "id",
    "ariaHidden",
    "customise",
    "title"
  ],
  emits: ["load"]
}), Mh = /* @__PURE__ */ Se({
  __name: "VIcon",
  props: {
    icon: {},
    size: { default: 24 },
    color: { default: "currentColor" },
    class: { default: "" },
    loading: { type: Boolean }
  },
  setup(e) {
    const n = M(() => e.color.startsWith("text-")), t = M(() => e.loading ? "lucide:loader-2" : e.icon), a = M(() => typeof e.size == "number" ? `${e.size}px` : e.size), s = M(() => n.value ? e.color : ""), r = M(() => n.value ? void 0 : { color: e.color });
    return (l, i) => (w(), de(v(Th), {
      class: ne([[{ "v-icon--spin": e.loading }, s.value, e.class], "v-icon"]),
      height: a.value,
      icon: t.value,
      style: Ve(r.value),
      width: a.value,
      "aria-hidden": "true",
      focusable: "false"
    }, null, 8, ["class", "height", "icon", "style", "width"]));
  }
}), ke = /* @__PURE__ */ je(Mh, [["__scopeId", "data-v-68f452e3"]]), $h = {
  key: 0,
  class: "v-button__icon"
}, Ch = {
  key: 1,
  class: "v-button__content"
}, Dh = { key: 0 }, Oh = {
  key: 2,
  class: "v-button__icon"
}, _h = /* @__PURE__ */ Se({
  __name: "VButton",
  props: {
    text: { default: "" },
    type: { default: "button" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: { default: void 0 },
    variant: { default: "default" },
    to: { default: void 0 },
    replace: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = Ht(), t = e, a = M(() => !t.text && !!t.icon && !n.default), s = M(() => {
      switch (t.variant) {
        case "primary":
          return "v-button--primary";
        case "positive":
          return "v-button--positive";
        case "negative":
          return "v-button--negative";
        case "warning":
          return "v-button--warning";
        case "link":
          return "v-button--link";
        case "secondary":
          return "v-button--secondary";
        default:
          return "v-button--primary";
      }
    }), r = M(() => !!t.to);
    return (l, i) => (w(), de(ht(r.value ? v(bf) : "button"), rt(
      {
        class: [
          "v-button",
          s.value,
          {
            "v-button--icon-only": a.value,
            "v-button--disabled cursor-not-allowed": t.disabled || t.loading
          }
        ]
      },
      r.value ? {
        to: t.disabled || t.loading ? void 0 : t.to,
        replace: t.replace,
        ...l.$attrs
      } : { type: t.type, disabled: t.disabled || t.loading, ...l.$attrs }
    ), {
      default: fe(() => [
        l.$slots.iconLeft || t.loading || t.icon ? (w(), T("span", $h, [
          t.loading ? (w(), de(ke, {
            key: 0,
            loading: t.loading,
            size: 24,
            icon: "lucide:loading"
          }, null, 8, ["loading"])) : U(l.$slots, "iconLeft", { key: 1 }, () => [
            t.icon ? (w(), de(ke, {
              key: 0,
              icon: t.icon
            }, null, 8, ["icon"])) : P("", !0)
          ], !0)
        ])) : P("", !0),
        a.value ? P("", !0) : (w(), T("span", Ch, [
          t.text ? (w(), T("span", Dh, ue(t.text), 1)) : P("", !0),
          U(l.$slots, "default", {}, void 0, !0)
        ])),
        l.$slots.iconRight ? (w(), T("span", Oh, [
          U(l.$slots, "iconRight", {}, void 0, !0)
        ])) : P("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), qt = /* @__PURE__ */ je(_h, [["__scopeId", "data-v-ec924d87"]]), Eh = { key: 1 }, Ih = /* @__PURE__ */ Se({
  __name: "VTag",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "primary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    iconPosition: { default: "left" },
    rounded: { type: Boolean, default: !1 },
    class: { default: "" },
    customColor: { default: void 0 }
  },
  setup(e) {
    const n = e, t = M(() => ({
      xs: 12,
      sm: 14,
      md: 16,
      lg: 18
    })[n.size]), a = M(() => `vtag--${n.size}`), s = M(
      () => n.customColor ? { "--_tag-color": `var(${n.customColor})` } : void 0
    ), r = M(
      () => n.customColor ? `vtag--custom-${n.variant}` : `vtag--${n.variant}-${n.color}`
    ), l = M(() => n.rounded ? "vtag--rounded" : "vtag--square");
    return (i, o) => (w(), T("span", {
      style: Ve(s.value),
      class: ne([[a.value, r.value, l.value, n.class], "vtag"])
    }, [
      e.icon && e.iconPosition === "left" ? (w(), de(ke, {
        key: 0,
        icon: e.icon,
        size: t.value
      }, null, 8, ["icon", "size"])) : P("", !0),
      e.label || i.$slots.default ? (w(), T("span", Eh, [
        U(i.$slots, "default", {}, () => [
          Ue(ue(e.label), 1)
        ], !0)
      ])) : P("", !0),
      U(i.$slots, "icon-right", {}, () => [
        e.icon && e.iconPosition === "right" ? (w(), de(ke, {
          key: 0,
          icon: e.icon,
          size: t.value
        }, null, 8, ["icon", "size"])) : P("", !0)
      ], !0)
    ], 6));
  }
}), Yu = /* @__PURE__ */ je(Ih, [["__scopeId", "data-v-6a630cc7"]]), Ph = { class: "vchip__content" }, Ah = {
  key: 1,
  class: "vchip__label"
}, Rh = ["disabled"], Fh = /* @__PURE__ */ Se({
  __name: "VChip",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "default" },
    selectedColor: { default: "primary" },
    size: { default: "md" },
    icon: { default: void 0 },
    closable: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    badge: { default: void 0 },
    badgeColor: { default: "primary" },
    class: { default: "" },
    value: { type: [String, Number, Boolean, Object, null], default: void 0 },
    modelValue: { default: void 0 },
    multiple: { type: Boolean, default: !1 },
    valueComparator: { type: Function, default: void 0 }
  },
  emits: ["click", "close", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (m, d) => {
      if (t.valueComparator)
        return t.valueComparator(m, d);
      if (m === d) return !0;
      if (m == null || d == null) return !1;
      if (typeof m == "object" && typeof d == "object")
        try {
          return JSON.stringify(m) === JSON.stringify(d);
        } catch {
          return !1;
        }
      return m === d;
    }, r = M(() => t.modelValue !== void 0 && t.value !== void 0 ? t.multiple ? Array.isArray(t.modelValue) && t.modelValue.some((m) => s(m, t.value)) : s(t.modelValue, t.value) : t.active), l = M(() => ({
      sm: 14,
      md: 16,
      lg: 18
    })[t.size]), i = M(() => `vchip--${t.size}`), o = M(() => {
      if (t.color === "default" && r.value)
        return `vchip--${t.variant}-${t.selectedColor}-selected`;
      const m = `vchip--${t.variant}-${t.color}`;
      return r.value ? `${m}-selected` : m;
    }), u = M(() => t.disabled ? "vchip--disabled" : "vchip--interactive"), c = (m) => {
      if (!t.disabled) {
        if (t.value !== void 0 && t.modelValue !== void 0)
          if (t.multiple) {
            const d = Array.isArray(t.modelValue) ? t.modelValue : [];
            if (d.findIndex((g) => s(g, t.value)) > -1) {
              const g = d.filter((k) => !s(k, t.value));
              a("update:modelValue", g);
            } else
              a("update:modelValue", [...d, t.value]);
          } else
            s(t.modelValue, t.value) ? a("update:modelValue", null) : a("update:modelValue", t.value);
        a("click", m);
      }
    }, f = (m) => {
      t.disabled || a("close", m);
    };
    return (m, d) => (w(), T("span", {
      class: ne([[i.value, o.value, u.value, t.class], "vchip"]),
      onClick: c
    }, [
      E("span", Ph, [
        e.icon ? (w(), de(ke, {
          key: 0,
          icon: e.icon,
          size: l.value,
          class: "vchip__icon"
        }, null, 8, ["icon", "size"])) : P("", !0),
        e.label || m.$slots.default ? (w(), T("span", Ah, [
          U(m.$slots, "default", {}, () => [
            Ue(ue(e.label), 1)
          ], !0)
        ])) : P("", !0),
        U(m.$slots, "badge", {}, () => [
          e.badge ? (w(), de(Yu, {
            key: 0,
            color: e.badgeColor,
            label: e.badge,
            size: "sm",
            variant: "outline"
          }, null, 8, ["color", "label"])) : P("", !0)
        ], !0)
      ]),
      e.closable ? (w(), T("button", {
        key: 0,
        disabled: e.disabled,
        class: "vchip__close",
        type: "button",
        onClick: Fe(f, ["stop"])
      }, [
        oe(ke, {
          size: l.value - 2,
          icon: "lucide:x"
        }, null, 8, ["size"])
      ], 8, Rh)) : P("", !0)
    ], 2));
  }
}), rD = /* @__PURE__ */ je(Fh, [["__scopeId", "data-v-d99cc188"]]);
class wa extends Error {
}
class Vh extends wa {
  constructor(n) {
    super(`Invalid DateTime: ${n.toMessage()}`);
  }
}
class Lh extends wa {
  constructor(n) {
    super(`Invalid Interval: ${n.toMessage()}`);
  }
}
class Nh extends wa {
  constructor(n) {
    super(`Invalid Duration: ${n.toMessage()}`);
  }
}
class Ra extends wa {
}
class Hu extends wa {
  constructor(n) {
    super(`Invalid unit ${n}`);
  }
}
class Rt extends wa {
}
class qn extends wa {
  constructor() {
    super("Zone is an abstract class");
  }
}
const $e = "numeric", yn = "short", Gt = "long", gr = {
  year: $e,
  month: $e,
  day: $e
}, Uu = {
  year: $e,
  month: yn,
  day: $e
}, Bh = {
  year: $e,
  month: yn,
  day: $e,
  weekday: yn
}, qu = {
  year: $e,
  month: Gt,
  day: $e
}, ju = {
  year: $e,
  month: Gt,
  day: $e,
  weekday: Gt
}, Gu = {
  hour: $e,
  minute: $e
}, Ku = {
  hour: $e,
  minute: $e,
  second: $e
}, Zu = {
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: yn
}, Xu = {
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: Gt
}, Ju = {
  hour: $e,
  minute: $e,
  hourCycle: "h23"
}, Qu = {
  hour: $e,
  minute: $e,
  second: $e,
  hourCycle: "h23"
}, ec = {
  hour: $e,
  minute: $e,
  second: $e,
  hourCycle: "h23",
  timeZoneName: yn
}, tc = {
  hour: $e,
  minute: $e,
  second: $e,
  hourCycle: "h23",
  timeZoneName: Gt
}, nc = {
  year: $e,
  month: $e,
  day: $e,
  hour: $e,
  minute: $e
}, ac = {
  year: $e,
  month: $e,
  day: $e,
  hour: $e,
  minute: $e,
  second: $e
}, sc = {
  year: $e,
  month: yn,
  day: $e,
  hour: $e,
  minute: $e
}, rc = {
  year: $e,
  month: yn,
  day: $e,
  hour: $e,
  minute: $e,
  second: $e
}, zh = {
  year: $e,
  month: yn,
  day: $e,
  weekday: yn,
  hour: $e,
  minute: $e
}, lc = {
  year: $e,
  month: Gt,
  day: $e,
  hour: $e,
  minute: $e,
  timeZoneName: yn
}, ic = {
  year: $e,
  month: Gt,
  day: $e,
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: yn
}, oc = {
  year: $e,
  month: Gt,
  day: $e,
  weekday: Gt,
  hour: $e,
  minute: $e,
  timeZoneName: Gt
}, uc = {
  year: $e,
  month: Gt,
  day: $e,
  weekday: Gt,
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: Gt
};
class Ps {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new qn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new qn();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new qn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, t) {
    throw new qn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    throw new qn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    throw new qn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    throw new qn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new qn();
  }
}
let al = null;
class Pr extends Ps {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return al === null && (al = new Pr()), al;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: t, locale: a }) {
    return wc(n, t, a);
  }
  /** @override **/
  formatOffset(n, t) {
    return Ss(this.offset(n), t);
  }
  /** @override **/
  offset(n) {
    return -new Date(n).getTimezoneOffset();
  }
  /** @override **/
  equals(n) {
    return n.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Il = /* @__PURE__ */ new Map();
function Wh(e) {
  let n = Il.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), Il.set(e, n)), n;
}
const Yh = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function Hh(e, n) {
  const t = e.format(n).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(t), [, s, r, l, i, o, u, c] = a;
  return [l, s, r, i, o, u, c];
}
function Uh(e, n) {
  const t = e.formatToParts(n), a = [];
  for (let s = 0; s < t.length; s++) {
    const { type: r, value: l } = t[s], i = Yh[r];
    r === "era" ? a[i] = l : Ne(i) || (a[i] = parseInt(l, 10));
  }
  return a;
}
const sl = /* @__PURE__ */ new Map();
class Nn extends Ps {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(n) {
    let t = sl.get(n);
    return t === void 0 && sl.set(n, t = new Nn(n)), t;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    sl.clear(), Il.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(n) {
    return this.isValidZone(n);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(n) {
    if (!n)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: n }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(n) {
    super(), this.zoneName = n, this.valid = Nn.isValidZone(n);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, { format: t, locale: a }) {
    return wc(n, t, a, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ss(this.offset(n), t);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    if (!this.valid) return NaN;
    const t = new Date(n);
    if (isNaN(t)) return NaN;
    const a = Wh(this.name);
    let [s, r, l, i, o, u, c] = a.formatToParts ? Uh(a, t) : Hh(a, t);
    i === "BC" && (s = -Math.abs(s) + 1);
    const m = Rr({
      year: s,
      month: r,
      day: l,
      hour: o === 24 ? 0 : o,
      minute: u,
      second: c,
      millisecond: 0
    });
    let d = +t;
    const p = d % 1e3;
    return d -= p >= 0 ? p : 1e3 + p, (m - d) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "iana" && n.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let Ji = {};
function qh(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Ji[t];
  return a || (a = new Intl.ListFormat(e, n), Ji[t] = a), a;
}
const Pl = /* @__PURE__ */ new Map();
function Al(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Pl.get(t);
  return a === void 0 && (a = new Intl.DateTimeFormat(e, n), Pl.set(t, a)), a;
}
const Rl = /* @__PURE__ */ new Map();
function jh(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Rl.get(t);
  return a === void 0 && (a = new Intl.NumberFormat(e, n), Rl.set(t, a)), a;
}
const Fl = /* @__PURE__ */ new Map();
function Gh(e, n = {}) {
  const { base: t, ...a } = n, s = JSON.stringify([e, a]);
  let r = Fl.get(s);
  return r === void 0 && (r = new Intl.RelativeTimeFormat(e, n), Fl.set(s, r)), r;
}
let bs = null;
function Kh() {
  return bs || (bs = new Intl.DateTimeFormat().resolvedOptions().locale, bs);
}
const Vl = /* @__PURE__ */ new Map();
function cc(e) {
  let n = Vl.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat(e).resolvedOptions(), Vl.set(e, n)), n;
}
const Ll = /* @__PURE__ */ new Map();
function Zh(e) {
  let n = Ll.get(e);
  if (!n) {
    const t = new Intl.Locale(e);
    n = "getWeekInfo" in t ? t.getWeekInfo() : t.weekInfo, "minimalDays" in n || (n = { ...dc, ...n }), Ll.set(e, n);
  }
  return n;
}
function Xh(e) {
  const n = e.indexOf("-x-");
  n !== -1 && (e = e.substring(0, n));
  const t = e.indexOf("-u-");
  if (t === -1)
    return [e];
  {
    let a, s;
    try {
      a = Al(e).resolvedOptions(), s = e;
    } catch {
      const o = e.substring(0, t);
      a = Al(o).resolvedOptions(), s = o;
    }
    const { numberingSystem: r, calendar: l } = a;
    return [s, r, l];
  }
}
function Jh(e, n, t) {
  return (t || n) && (e.includes("-u-") || (e += "-u"), t && (e += `-ca-${t}`), n && (e += `-nu-${n}`)), e;
}
function Qh(e) {
  const n = [];
  for (let t = 1; t <= 12; t++) {
    const a = Oe.utc(2009, t, 1);
    n.push(e(a));
  }
  return n;
}
function em(e) {
  const n = [];
  for (let t = 1; t <= 7; t++) {
    const a = Oe.utc(2016, 11, 13 + t);
    n.push(e(a));
  }
  return n;
}
function Xs(e, n, t, a) {
  const s = e.listingMode();
  return s === "error" ? null : s === "en" ? t(n) : a(n);
}
function tm(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || cc(e.locale).numberingSystem === "latn";
}
class nm {
  constructor(n, t, a) {
    this.padTo = a.padTo || 0, this.floor = a.floor || !1;
    const { padTo: s, floor: r, ...l } = a;
    if (!t || Object.keys(l).length > 0) {
      const i = { useGrouping: !1, ...a };
      a.padTo > 0 && (i.minimumIntegerDigits = a.padTo), this.inf = jh(n, i);
    }
  }
  format(n) {
    if (this.inf) {
      const t = this.floor ? Math.floor(n) : n;
      return this.inf.format(t);
    } else {
      const t = this.floor ? Math.floor(n) : di(n, 3);
      return Tt(t, this.padTo);
    }
  }
}
class am {
  constructor(n, t, a) {
    this.opts = a, this.originalZone = void 0;
    let s;
    if (this.opts.timeZone)
      this.dt = n;
    else if (n.zone.type === "fixed") {
      const l = -1 * (n.offset / 60), i = l >= 0 ? `Etc/GMT+${l}` : `Etc/GMT${l}`;
      n.offset !== 0 && Nn.create(i).valid ? (s = i, this.dt = n) : (s = "UTC", this.dt = n.offset === 0 ? n : n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    } else n.zone.type === "system" ? this.dt = n : n.zone.type === "iana" ? (this.dt = n, s = n.zone.name) : (s = "UTC", this.dt = n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    const r = { ...this.opts };
    r.timeZone = r.timeZone || s, this.dtf = Al(t, r);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: n }) => n).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const n = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? n.map((t) => {
      if (t.type === "timeZoneName") {
        const a = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...t,
          value: a
        };
      } else
        return t;
    }) : n;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class sm {
  constructor(n, t, a) {
    this.opts = { style: "long", ...a }, !t && yc() && (this.rtf = Gh(n, a));
  }
  format(n, t) {
    return this.rtf ? this.rtf.format(n, t) : $m(t, n, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(n, t) {
    return this.rtf ? this.rtf.formatToParts(n, t) : [];
  }
}
const dc = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class st {
  static fromOpts(n) {
    return st.create(
      n.locale,
      n.numberingSystem,
      n.outputCalendar,
      n.weekSettings,
      n.defaultToEN
    );
  }
  static create(n, t, a, s, r = !1) {
    const l = n || pt.defaultLocale, i = l || (r ? "en-US" : Kh()), o = t || pt.defaultNumberingSystem, u = a || pt.defaultOutputCalendar, c = Bl(s) || pt.defaultWeekSettings;
    return new st(i, o, u, c, l);
  }
  static resetCache() {
    bs = null, Pl.clear(), Rl.clear(), Fl.clear(), Vl.clear(), Ll.clear();
  }
  static fromObject({ locale: n, numberingSystem: t, outputCalendar: a, weekSettings: s } = {}) {
    return st.create(n, t, a, s);
  }
  constructor(n, t, a, s, r) {
    const [l, i, o] = Xh(n);
    this.locale = l, this.numberingSystem = t || i || null, this.outputCalendar = a || o || null, this.weekSettings = s, this.intl = Jh(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = r, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = tm(this)), this.fastNumbersCached;
  }
  listingMode() {
    const n = this.isEnglish(), t = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return n && t ? "en" : "intl";
  }
  clone(n) {
    return !n || Object.getOwnPropertyNames(n).length === 0 ? this : st.create(
      n.locale || this.specifiedLocale,
      n.numberingSystem || this.numberingSystem,
      n.outputCalendar || this.outputCalendar,
      Bl(n.weekSettings) || this.weekSettings,
      n.defaultToEN || !1
    );
  }
  redefaultToEN(n = {}) {
    return this.clone({ ...n, defaultToEN: !0 });
  }
  redefaultToSystem(n = {}) {
    return this.clone({ ...n, defaultToEN: !1 });
  }
  months(n, t = !1) {
    return Xs(this, n, Sc, () => {
      const a = this.intl === "ja" || this.intl.startsWith("ja-");
      t &= !a;
      const s = t ? { month: n, day: "numeric" } : { month: n }, r = t ? "format" : "standalone";
      if (!this.monthsCache[r][n]) {
        const l = a ? (i) => this.dtFormatter(i, s).format() : (i) => this.extract(i, s, "month");
        this.monthsCache[r][n] = Qh(l);
      }
      return this.monthsCache[r][n];
    });
  }
  weekdays(n, t = !1) {
    return Xs(this, n, $c, () => {
      const a = t ? { weekday: n, year: "numeric", month: "long", day: "numeric" } : { weekday: n }, s = t ? "format" : "standalone";
      return this.weekdaysCache[s][n] || (this.weekdaysCache[s][n] = em(
        (r) => this.extract(r, a, "weekday")
      )), this.weekdaysCache[s][n];
    });
  }
  meridiems() {
    return Xs(
      this,
      void 0,
      () => Cc,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Oe.utc(2016, 11, 13, 9), Oe.utc(2016, 11, 13, 19)].map(
            (t) => this.extract(t, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(n) {
    return Xs(this, n, Dc, () => {
      const t = { era: n };
      return this.eraCache[n] || (this.eraCache[n] = [Oe.utc(-40, 1, 1), Oe.utc(2017, 1, 1)].map(
        (a) => this.extract(a, t, "era")
      )), this.eraCache[n];
    });
  }
  extract(n, t, a) {
    const s = this.dtFormatter(n, t), r = s.formatToParts(), l = r.find((i) => i.type.toLowerCase() === a);
    return l ? l.value : null;
  }
  numberFormatter(n = {}) {
    return new nm(this.intl, n.forceSimple || this.fastNumbers, n);
  }
  dtFormatter(n, t = {}) {
    return new am(n, this.intl, t);
  }
  relFormatter(n = {}) {
    return new sm(this.intl, this.isEnglish(), n);
  }
  listFormatter(n = {}) {
    return qh(this.intl, n);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || cc(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : bc() ? Zh(this.locale) : dc;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(n) {
    return this.locale === n.locale && this.numberingSystem === n.numberingSystem && this.outputCalendar === n.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let rl = null;
class zt extends Ps {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return rl === null && (rl = new zt(0)), rl;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(n) {
    return n === 0 ? zt.utcInstance : new zt(n);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(n) {
    if (n) {
      const t = n.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (t)
        return new zt(Fr(t[1], t[2]));
    }
    return null;
  }
  constructor(n) {
    super(), this.fixed = n;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Ss(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Ss(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ss(this.fixed, t);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "fixed" && n.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class rm extends Ps {
  constructor(n) {
    super(), this.zoneName = n;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Xn(e, n) {
  if (Ne(e) || e === null)
    return n;
  if (e instanceof Ps)
    return e;
  if (dm(e)) {
    const t = e.toLowerCase();
    return t === "default" ? n : t === "local" || t === "system" ? Pr.instance : t === "utc" || t === "gmt" ? zt.utcInstance : zt.parseSpecifier(t) || Nn.create(e);
  } else return Qn(e) ? zt.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new rm(e);
}
const ii = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, Qi = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, lm = ii.hanidec.replace(/[\[|\]]/g, "").split("");
function im(e) {
  let n = parseInt(e, 10);
  if (isNaN(n)) {
    n = "";
    for (let t = 0; t < e.length; t++) {
      const a = e.charCodeAt(t);
      if (e[t].search(ii.hanidec) !== -1)
        n += lm.indexOf(e[t]);
      else
        for (const s in Qi) {
          const [r, l] = Qi[s];
          a >= r && a <= l && (n += a - r);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
const Nl = /* @__PURE__ */ new Map();
function om() {
  Nl.clear();
}
function un({ numberingSystem: e }, n = "") {
  const t = e || "latn";
  let a = Nl.get(t);
  a === void 0 && (a = /* @__PURE__ */ new Map(), Nl.set(t, a));
  let s = a.get(n);
  return s === void 0 && (s = new RegExp(`${ii[t]}${n}`), a.set(n, s)), s;
}
let eo = () => Date.now(), to = "system", no = null, ao = null, so = null, ro = 60, lo, io = null;
class pt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return eo;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    eo = n;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(n) {
    to = n;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Xn(to, Pr.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return no;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(n) {
    no = n;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return ao;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(n) {
    ao = n;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return so;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(n) {
    so = n;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return io;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(n) {
    io = Bl(n);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return ro;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(n) {
    ro = n % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return lo;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(n) {
    lo = n;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    st.resetCache(), Nn.resetCache(), Oe.resetCache(), om();
  }
}
class vn {
  constructor(n, t) {
    this.reason = n, this.explanation = t;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const fc = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], hc = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function nn(e, n) {
  return new vn(
    "unit out of range",
    `you specified ${n} (of type ${typeof n}) as a ${e}, which is invalid`
  );
}
function oi(e, n, t) {
  const a = new Date(Date.UTC(e, n - 1, t));
  e < 100 && e >= 0 && a.setUTCFullYear(a.getUTCFullYear() - 1900);
  const s = a.getUTCDay();
  return s === 0 ? 7 : s;
}
function mc(e, n, t) {
  return t + (As(e) ? hc : fc)[n - 1];
}
function vc(e, n) {
  const t = As(e) ? hc : fc, a = t.findIndex((r) => r < n), s = n - t[a];
  return { month: a + 1, day: s };
}
function ui(e, n) {
  return (e - n + 7) % 7 + 1;
}
function yr(e, n = 4, t = 1) {
  const { year: a, month: s, day: r } = e, l = mc(a, s, r), i = ui(oi(a, s, r), t);
  let o = Math.floor((l - i + 14 - n) / 7), u;
  return o < 1 ? (u = a - 1, o = Os(u, n, t)) : o > Os(a, n, t) ? (u = a + 1, o = 1) : u = a, { weekYear: u, weekNumber: o, weekday: i, ...Vr(e) };
}
function oo(e, n = 4, t = 1) {
  const { weekYear: a, weekNumber: s, weekday: r } = e, l = ui(oi(a, 1, n), t), i = Ba(a);
  let o = s * 7 + r - l - 7 + n, u;
  o < 1 ? (u = a - 1, o += Ba(u)) : o > i ? (u = a + 1, o -= Ba(a)) : u = a;
  const { month: c, day: f } = vc(u, o);
  return { year: u, month: c, day: f, ...Vr(e) };
}
function ll(e) {
  const { year: n, month: t, day: a } = e, s = mc(n, t, a);
  return { year: n, ordinal: s, ...Vr(e) };
}
function uo(e) {
  const { year: n, ordinal: t } = e, { month: a, day: s } = vc(n, t);
  return { year: n, month: a, day: s, ...Vr(e) };
}
function co(e, n) {
  if (!Ne(e.localWeekday) || !Ne(e.localWeekNumber) || !Ne(e.localWeekYear)) {
    if (!Ne(e.weekday) || !Ne(e.weekNumber) || !Ne(e.weekYear))
      throw new Ra(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Ne(e.localWeekday) || (e.weekday = e.localWeekday), Ne(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Ne(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: n.getMinDaysInFirstWeek(),
      startOfWeek: n.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function um(e, n = 4, t = 1) {
  const a = Ar(e.weekYear), s = an(
    e.weekNumber,
    1,
    Os(e.weekYear, n, t)
  ), r = an(e.weekday, 1, 7);
  return a ? s ? r ? !1 : nn("weekday", e.weekday) : nn("week", e.weekNumber) : nn("weekYear", e.weekYear);
}
function cm(e) {
  const n = Ar(e.year), t = an(e.ordinal, 1, Ba(e.year));
  return n ? t ? !1 : nn("ordinal", e.ordinal) : nn("year", e.year);
}
function pc(e) {
  const n = Ar(e.year), t = an(e.month, 1, 12), a = an(e.day, 1, br(e.year, e.month));
  return n ? t ? a ? !1 : nn("day", e.day) : nn("month", e.month) : nn("year", e.year);
}
function gc(e) {
  const { hour: n, minute: t, second: a, millisecond: s } = e, r = an(n, 0, 23) || n === 24 && t === 0 && a === 0 && s === 0, l = an(t, 0, 59), i = an(a, 0, 59), o = an(s, 0, 999);
  return r ? l ? i ? o ? !1 : nn("millisecond", s) : nn("second", a) : nn("minute", t) : nn("hour", n);
}
function Ne(e) {
  return typeof e > "u";
}
function Qn(e) {
  return typeof e == "number";
}
function Ar(e) {
  return typeof e == "number" && e % 1 === 0;
}
function dm(e) {
  return typeof e == "string";
}
function fm(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function yc() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function bc() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function hm(e) {
  return Array.isArray(e) ? e : [e];
}
function fo(e, n, t) {
  if (e.length !== 0)
    return e.reduce((a, s) => {
      const r = [n(s), s];
      return a && t(a[0], r[0]) === a[0] ? a : r;
    }, null)[1];
}
function mm(e, n) {
  return n.reduce((t, a) => (t[a] = e[a], t), {});
}
function ja(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function Bl(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Rt("Week settings must be an object");
  if (!an(e.firstDay, 1, 7) || !an(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((n) => !an(n, 1, 7)))
    throw new Rt("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function an(e, n, t) {
  return Ar(e) && e >= n && e <= t;
}
function vm(e, n) {
  return e - n * Math.floor(e / n);
}
function Tt(e, n = 2) {
  const t = e < 0;
  let a;
  return t ? a = "-" + ("" + -e).padStart(n, "0") : a = ("" + e).padStart(n, "0"), a;
}
function Zn(e) {
  if (!(Ne(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function la(e) {
  if (!(Ne(e) || e === null || e === ""))
    return parseFloat(e);
}
function ci(e) {
  if (!(Ne(e) || e === null || e === "")) {
    const n = parseFloat("0." + e) * 1e3;
    return Math.floor(n);
  }
}
function di(e, n, t = "round") {
  const a = 10 ** n;
  switch (t) {
    case "expand":
      return e > 0 ? Math.ceil(e * a) / a : Math.floor(e * a) / a;
    case "trunc":
      return Math.trunc(e * a) / a;
    case "round":
      return Math.round(e * a) / a;
    case "floor":
      return Math.floor(e * a) / a;
    case "ceil":
      return Math.ceil(e * a) / a;
    default:
      throw new RangeError(`Value rounding ${t} is out of range`);
  }
}
function As(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Ba(e) {
  return As(e) ? 366 : 365;
}
function br(e, n) {
  const t = vm(n - 1, 12) + 1, a = e + (n - t) / 12;
  return t === 2 ? As(a) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][t - 1];
}
function Rr(e) {
  let n = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (n = new Date(n), n.setUTCFullYear(e.year, e.month - 1, e.day)), +n;
}
function ho(e, n, t) {
  return -ui(oi(e, 1, n), t) + n - 1;
}
function Os(e, n = 4, t = 1) {
  const a = ho(e, n, t), s = ho(e + 1, n, t);
  return (Ba(e) - a + s) / 7;
}
function zl(e) {
  return e > 99 ? e : e > pt.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function wc(e, n, t, a = null) {
  const s = new Date(e), r = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  a && (r.timeZone = a);
  const l = { timeZoneName: n, ...r }, i = new Intl.DateTimeFormat(t, l).formatToParts(s).find((o) => o.type.toLowerCase() === "timezonename");
  return i ? i.value : null;
}
function Fr(e, n) {
  let t = parseInt(e, 10);
  Number.isNaN(t) && (t = 0);
  const a = parseInt(n, 10) || 0, s = t < 0 || Object.is(t, -0) ? -a : a;
  return t * 60 + s;
}
function kc(e) {
  const n = Number(e);
  if (typeof e == "boolean" || e === "" || !Number.isFinite(n))
    throw new Rt(`Invalid unit value ${e}`);
  return n;
}
function wr(e, n) {
  const t = {};
  for (const a in e)
    if (ja(e, a)) {
      const s = e[a];
      if (s == null) continue;
      t[n(a)] = kc(s);
    }
  return t;
}
function Ss(e, n) {
  const t = Math.trunc(Math.abs(e / 60)), a = Math.trunc(Math.abs(e % 60)), s = e >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${s}${Tt(t, 2)}:${Tt(a, 2)}`;
    case "narrow":
      return `${s}${t}${a > 0 ? `:${a}` : ""}`;
    case "techie":
      return `${s}${Tt(t, 2)}${Tt(a, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function Vr(e) {
  return mm(e, ["hour", "minute", "second", "millisecond"]);
}
const pm = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], xc = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], gm = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Sc(e) {
  switch (e) {
    case "narrow":
      return [...gm];
    case "short":
      return [...xc];
    case "long":
      return [...pm];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Tc = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Mc = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], ym = ["M", "T", "W", "T", "F", "S", "S"];
function $c(e) {
  switch (e) {
    case "narrow":
      return [...ym];
    case "short":
      return [...Mc];
    case "long":
      return [...Tc];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Cc = ["AM", "PM"], bm = ["Before Christ", "Anno Domini"], wm = ["BC", "AD"], km = ["B", "A"];
function Dc(e) {
  switch (e) {
    case "narrow":
      return [...km];
    case "short":
      return [...wm];
    case "long":
      return [...bm];
    default:
      return null;
  }
}
function xm(e) {
  return Cc[e.hour < 12 ? 0 : 1];
}
function Sm(e, n) {
  return $c(n)[e.weekday - 1];
}
function Tm(e, n) {
  return Sc(n)[e.month - 1];
}
function Mm(e, n) {
  return Dc(n)[e.year < 0 ? 0 : 1];
}
function $m(e, n, t = "always", a = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, r = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (t === "auto" && r) {
    const f = e === "days";
    switch (n) {
      case 1:
        return f ? "tomorrow" : `next ${s[e][0]}`;
      case -1:
        return f ? "yesterday" : `last ${s[e][0]}`;
      case 0:
        return f ? "today" : `this ${s[e][0]}`;
    }
  }
  const l = Object.is(n, -0) || n < 0, i = Math.abs(n), o = i === 1, u = s[e], c = a ? o ? u[1] : u[2] || u[1] : o ? s[e][0] : e;
  return l ? `${i} ${c} ago` : `in ${i} ${c}`;
}
function mo(e, n) {
  let t = "";
  for (const a of e)
    a.literal ? t += a.val : t += n(a.val);
  return t;
}
const Cm = {
  D: gr,
  DD: Uu,
  DDD: qu,
  DDDD: ju,
  t: Gu,
  tt: Ku,
  ttt: Zu,
  tttt: Xu,
  T: Ju,
  TT: Qu,
  TTT: ec,
  TTTT: tc,
  f: nc,
  ff: sc,
  fff: lc,
  ffff: oc,
  F: ac,
  FF: rc,
  FFF: ic,
  FFFF: uc
};
class Ft {
  static create(n, t = {}) {
    return new Ft(n, t);
  }
  static parseFormat(n) {
    let t = null, a = "", s = !1;
    const r = [];
    for (let l = 0; l < n.length; l++) {
      const i = n.charAt(l);
      i === "'" ? ((a.length > 0 || s) && r.push({
        literal: s || /^\s+$/.test(a),
        val: a === "" ? "'" : a
      }), t = null, a = "", s = !s) : s || i === t ? a += i : (a.length > 0 && r.push({ literal: /^\s+$/.test(a), val: a }), a = i, t = i);
    }
    return a.length > 0 && r.push({ literal: s || /^\s+$/.test(a), val: a }), r;
  }
  static macroTokenToFormatOpts(n) {
    return Cm[n];
  }
  constructor(n, t) {
    this.opts = t, this.loc = n, this.systemLoc = null;
  }
  formatWithSystemDefault(n, t) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(n, { ...this.opts, ...t }).format();
  }
  dtFormatter(n, t = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...t });
  }
  formatDateTime(n, t) {
    return this.dtFormatter(n, t).format();
  }
  formatDateTimeParts(n, t) {
    return this.dtFormatter(n, t).formatToParts();
  }
  formatInterval(n, t) {
    return this.dtFormatter(n.start, t).dtf.formatRange(n.start.toJSDate(), n.end.toJSDate());
  }
  resolvedOptions(n, t) {
    return this.dtFormatter(n, t).resolvedOptions();
  }
  num(n, t = 0, a = void 0) {
    if (this.opts.forceSimple)
      return Tt(n, t);
    const s = { ...this.opts };
    return t > 0 && (s.padTo = t), a && (s.signDisplay = a), this.loc.numberFormatter(s).format(n);
  }
  formatDateTimeFromString(n, t) {
    const a = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", r = (d, p) => this.loc.extract(n, d, p), l = (d) => n.isOffsetFixed && n.offset === 0 && d.allowZ ? "Z" : n.isValid ? n.zone.formatOffset(n.ts, d.format) : "", i = () => a ? xm(n) : r({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), o = (d, p) => a ? Tm(n, d) : r(p ? { month: d } : { month: d, day: "numeric" }, "month"), u = (d, p) => a ? Sm(n, d) : r(
      p ? { weekday: d } : { weekday: d, month: "long", day: "numeric" },
      "weekday"
    ), c = (d) => {
      const p = Ft.macroTokenToFormatOpts(d);
      return p ? this.formatWithSystemDefault(n, p) : d;
    }, f = (d) => a ? Mm(n, d) : r({ era: d }, "era"), m = (d) => {
      switch (d) {
        // ms
        case "S":
          return this.num(n.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(n.millisecond, 3);
        // seconds
        case "s":
          return this.num(n.second);
        case "ss":
          return this.num(n.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(n.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(n.millisecond / 100));
        // minutes
        case "m":
          return this.num(n.minute);
        case "mm":
          return this.num(n.minute, 2);
        // hours
        case "h":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12);
        case "hh":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12, 2);
        case "H":
          return this.num(n.hour);
        case "HH":
          return this.num(n.hour, 2);
        // offset
        case "Z":
          return l({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return l({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return l({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return n.zone.offsetName(n.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return n.zone.offsetName(n.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return n.zoneName;
        // meridiems
        case "a":
          return i();
        // dates
        case "d":
          return s ? r({ day: "numeric" }, "day") : this.num(n.day);
        case "dd":
          return s ? r({ day: "2-digit" }, "day") : this.num(n.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(n.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(n.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return s ? r({ month: "numeric", day: "numeric" }, "month") : this.num(n.month);
        case "LL":
          return s ? r({ month: "2-digit", day: "numeric" }, "month") : this.num(n.month, 2);
        case "LLL":
          return o("short", !0);
        case "LLLL":
          return o("long", !0);
        case "LLLLL":
          return o("narrow", !0);
        // months - format
        case "M":
          return s ? r({ month: "numeric" }, "month") : this.num(n.month);
        case "MM":
          return s ? r({ month: "2-digit" }, "month") : this.num(n.month, 2);
        case "MMM":
          return o("short", !1);
        case "MMMM":
          return o("long", !1);
        case "MMMMM":
          return o("narrow", !1);
        // years
        case "y":
          return s ? r({ year: "numeric" }, "year") : this.num(n.year);
        case "yy":
          return s ? r({ year: "2-digit" }, "year") : this.num(n.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? r({ year: "numeric" }, "year") : this.num(n.year, 4);
        case "yyyyyy":
          return s ? r({ year: "numeric" }, "year") : this.num(n.year, 6);
        // eras
        case "G":
          return f("short");
        case "GG":
          return f("long");
        case "GGGGG":
          return f("narrow");
        case "kk":
          return this.num(n.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(n.weekYear, 4);
        case "W":
          return this.num(n.weekNumber);
        case "WW":
          return this.num(n.weekNumber, 2);
        case "n":
          return this.num(n.localWeekNumber);
        case "nn":
          return this.num(n.localWeekNumber, 2);
        case "ii":
          return this.num(n.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(n.localWeekYear, 4);
        case "o":
          return this.num(n.ordinal);
        case "ooo":
          return this.num(n.ordinal, 3);
        case "q":
          return this.num(n.quarter);
        case "qq":
          return this.num(n.quarter, 2);
        case "X":
          return this.num(Math.floor(n.ts / 1e3));
        case "x":
          return this.num(n.ts);
        default:
          return c(d);
      }
    };
    return mo(Ft.parseFormat(t), m);
  }
  formatDurationFromString(n, t) {
    const a = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, s = (c) => {
      switch (c[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, r = (c, f) => (m) => {
      const d = s(m);
      if (d) {
        const p = f.isNegativeDuration && d !== f.largestUnit ? a : 1;
        let g;
        return this.opts.signMode === "negativeLargestOnly" && d !== f.largestUnit ? g = "never" : this.opts.signMode === "all" ? g = "always" : g = "auto", this.num(c.get(d) * p, m.length, g);
      } else
        return m;
    }, l = Ft.parseFormat(t), i = l.reduce(
      (c, { literal: f, val: m }) => f ? c : c.concat(m),
      []
    ), o = n.shiftTo(...i.map(s).filter((c) => c)), u = {
      isNegativeDuration: o < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(o.values)[0]
    };
    return mo(l, r(o, u));
  }
}
const Oc = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function ts(...e) {
  const n = e.reduce((t, a) => t + a.source, "");
  return RegExp(`^${n}$`);
}
function ns(...e) {
  return (n) => e.reduce(
    ([t, a, s], r) => {
      const [l, i, o] = r(n, s);
      return [{ ...t, ...l }, i || a, o];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function as(e, ...n) {
  if (e == null)
    return [null, null];
  for (const [t, a] of n) {
    const s = t.exec(e);
    if (s)
      return a(s);
  }
  return [null, null];
}
function _c(...e) {
  return (n, t) => {
    const a = {};
    let s;
    for (s = 0; s < e.length; s++)
      a[e[s]] = Zn(n[t + s]);
    return [a, null, t + s];
  };
}
const Ec = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, Dm = `(?:${Ec.source}?(?:\\[(${Oc.source})\\])?)?`, fi = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Ic = RegExp(`${fi.source}${Dm}`), hi = RegExp(`(?:[Tt]${Ic.source})?`), Om = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, _m = /(\d{4})-?W(\d\d)(?:-?(\d))?/, Em = /(\d{4})-?(\d{3})/, Im = _c("weekYear", "weekNumber", "weekDay"), Pm = _c("year", "ordinal"), Am = /(\d{4})-(\d\d)-(\d\d)/, Pc = RegExp(
  `${fi.source} ?(?:${Ec.source}|(${Oc.source}))?`
), Rm = RegExp(`(?: ${Pc.source})?`);
function za(e, n, t) {
  const a = e[n];
  return Ne(a) ? t : Zn(a);
}
function Fm(e, n) {
  return [{
    year: za(e, n),
    month: za(e, n + 1, 1),
    day: za(e, n + 2, 1)
  }, null, n + 3];
}
function ss(e, n) {
  return [{
    hours: za(e, n, 0),
    minutes: za(e, n + 1, 0),
    seconds: za(e, n + 2, 0),
    milliseconds: ci(e[n + 3])
  }, null, n + 4];
}
function Rs(e, n) {
  const t = !e[n] && !e[n + 1], a = Fr(e[n + 1], e[n + 2]), s = t ? null : zt.instance(a);
  return [{}, s, n + 3];
}
function Fs(e, n) {
  const t = e[n] ? Nn.create(e[n]) : null;
  return [{}, t, n + 1];
}
const Vm = RegExp(`^T?${fi.source}$`), Lm = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function Nm(e) {
  const [n, t, a, s, r, l, i, o, u] = e, c = n[0] === "-", f = o && o[0] === "-", m = (d, p = !1) => d !== void 0 && (p || d && c) ? -d : d;
  return [
    {
      years: m(la(t)),
      months: m(la(a)),
      weeks: m(la(s)),
      days: m(la(r)),
      hours: m(la(l)),
      minutes: m(la(i)),
      seconds: m(la(o), o === "-0"),
      milliseconds: m(ci(u), f)
    }
  ];
}
const Bm = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function mi(e, n, t, a, s, r, l) {
  const i = {
    year: n.length === 2 ? zl(Zn(n)) : Zn(n),
    month: xc.indexOf(t) + 1,
    day: Zn(a),
    hour: Zn(s),
    minute: Zn(r)
  };
  return l && (i.second = Zn(l)), e && (i.weekday = e.length > 3 ? Tc.indexOf(e) + 1 : Mc.indexOf(e) + 1), i;
}
const zm = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Wm(e) {
  const [
    ,
    n,
    t,
    a,
    s,
    r,
    l,
    i,
    o,
    u,
    c,
    f
  ] = e, m = mi(n, s, a, t, r, l, i);
  let d;
  return o ? d = Bm[o] : u ? d = 0 : d = Fr(c, f), [m, new zt(d)];
}
function Ym(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const Hm = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Um = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, qm = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function vo(e) {
  const [, n, t, a, s, r, l, i] = e;
  return [mi(n, s, a, t, r, l, i), zt.utcInstance];
}
function jm(e) {
  const [, n, t, a, s, r, l, i] = e;
  return [mi(n, i, t, a, s, r, l), zt.utcInstance];
}
const Gm = ts(Om, hi), Km = ts(_m, hi), Zm = ts(Em, hi), Xm = ts(Ic), Ac = ns(
  Fm,
  ss,
  Rs,
  Fs
), Jm = ns(
  Im,
  ss,
  Rs,
  Fs
), Qm = ns(
  Pm,
  ss,
  Rs,
  Fs
), ev = ns(
  ss,
  Rs,
  Fs
);
function tv(e) {
  return as(
    e,
    [Gm, Ac],
    [Km, Jm],
    [Zm, Qm],
    [Xm, ev]
  );
}
function nv(e) {
  return as(Ym(e), [zm, Wm]);
}
function av(e) {
  return as(
    e,
    [Hm, vo],
    [Um, vo],
    [qm, jm]
  );
}
function sv(e) {
  return as(e, [Lm, Nm]);
}
const rv = ns(ss);
function lv(e) {
  return as(e, [Vm, rv]);
}
const iv = ts(Am, Rm), ov = ts(Pc), uv = ns(
  ss,
  Rs,
  Fs
);
function cv(e) {
  return as(
    e,
    [iv, Ac],
    [ov, uv]
  );
}
const po = "Invalid Duration", Rc = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, dv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...Rc
}, Jt = 146097 / 400, Ca = 146097 / 4800, fv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Jt / 7,
    days: Jt,
    hours: Jt * 24,
    minutes: Jt * 24 * 60,
    seconds: Jt * 24 * 60 * 60,
    milliseconds: Jt * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Jt / 28,
    days: Jt / 4,
    hours: Jt * 24 / 4,
    minutes: Jt * 24 * 60 / 4,
    seconds: Jt * 24 * 60 * 60 / 4,
    milliseconds: Jt * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Ca / 7,
    days: Ca,
    hours: Ca * 24,
    minutes: Ca * 24 * 60,
    seconds: Ca * 24 * 60 * 60,
    milliseconds: Ca * 24 * 60 * 60 * 1e3
  },
  ...Rc
}, fa = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], hv = fa.slice(0).reverse();
function An(e, n, t = !1) {
  const a = {
    values: t ? n.values : { ...e.values, ...n.values || {} },
    loc: e.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || e.conversionAccuracy,
    matrix: n.matrix || e.matrix
  };
  return new Xe(a);
}
function Fc(e, n) {
  let t = n.milliseconds ?? 0;
  for (const a of hv.slice(1))
    n[a] && (t += n[a] * e[a].milliseconds);
  return t;
}
function go(e, n) {
  const t = Fc(e, n) < 0 ? -1 : 1;
  fa.reduceRight((a, s) => {
    if (Ne(n[s]))
      return a;
    if (a) {
      const r = n[a] * t, l = e[s][a], i = Math.floor(r / l);
      n[s] += i * t, n[a] -= i * l * t;
    }
    return s;
  }, null), fa.reduce((a, s) => {
    if (Ne(n[s]))
      return a;
    if (a) {
      const r = n[a] % 1;
      n[a] -= r, n[s] += r * e[a][s];
    }
    return s;
  }, null);
}
function yo(e) {
  const n = {};
  for (const [t, a] of Object.entries(e))
    a !== 0 && (n[t] = a);
  return n;
}
class Xe {
  /**
   * @private
   */
  constructor(n) {
    const t = n.conversionAccuracy === "longterm" || !1;
    let a = t ? fv : dv;
    n.matrix && (a = n.matrix), this.values = n.values, this.loc = n.loc || st.create(), this.conversionAccuracy = t ? "longterm" : "casual", this.invalid = n.invalid || null, this.matrix = a, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(n, t) {
    return Xe.fromObject({ milliseconds: n }, t);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(n, t = {}) {
    if (n == null || typeof n != "object")
      throw new Rt(
        `Duration.fromObject: argument expected to be an object, got ${n === null ? "null" : typeof n}`
      );
    return new Xe({
      values: wr(n, Xe.normalizeUnit),
      loc: st.fromObject(t),
      conversionAccuracy: t.conversionAccuracy,
      matrix: t.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(n) {
    if (Qn(n))
      return Xe.fromMillis(n);
    if (Xe.isDuration(n))
      return n;
    if (typeof n == "object")
      return Xe.fromObject(n);
    throw new Rt(
      `Unknown duration argument ${n} of type ${typeof n}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(n, t) {
    const [a] = sv(n);
    return a ? Xe.fromObject(a, t) : Xe.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(n, t) {
    const [a] = lv(n);
    return a ? Xe.fromObject(a, t) : Xe.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Rt("need to specify a reason the Duration is invalid");
    const a = n instanceof vn ? n : new vn(n, t);
    if (pt.throwOnInvalid)
      throw new Nh(a);
    return new Xe({ invalid: a });
  }
  /**
   * @private
   */
  static normalizeUnit(n) {
    const t = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[n && n.toLowerCase()];
    if (!t) throw new Hu(n);
    return t;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(n) {
    return n && n.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(n, t = {}) {
    const a = {
      ...t,
      floor: t.round !== !1 && t.floor !== !1
    };
    return this.isValid ? Ft.create(this.loc, a).formatDurationFromString(this, n) : po;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(n = {}) {
    if (!this.isValid) return po;
    const t = n.showZeros !== !1, a = fa.map((s) => {
      const r = this.values[s];
      return Ne(r) || r === 0 && !t ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...n, unit: s.slice(0, -1) }).format(r);
    }).filter((s) => s);
    return this.loc.listFormatter({ type: "conjunction", style: n.listStyle || "narrow", ...n }).format(a);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let n = "P";
    return this.years !== 0 && (n += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (n += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (n += this.weeks + "W"), this.days !== 0 && (n += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (n += "T"), this.hours !== 0 && (n += this.hours + "H"), this.minutes !== 0 && (n += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (n += di(this.seconds + this.milliseconds / 1e3, 3) + "S"), n === "P" && (n += "T0S"), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(n = {}) {
    if (!this.isValid) return null;
    const t = this.toMillis();
    return t < 0 || t >= 864e5 ? null : (n = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...n,
      includeOffset: !1
    }, Oe.fromMillis(t, { zone: "UTC" }).toISOTime(n));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Fc(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Xe.fromDurationLike(n), a = {};
    for (const s of fa)
      (ja(t.values, s) || ja(this.values, s)) && (a[s] = t.get(s) + this.get(s));
    return An(this, { values: a }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Xe.fromDurationLike(n);
    return this.plus(t.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(n) {
    if (!this.isValid) return this;
    const t = {};
    for (const a of Object.keys(this.values))
      t[a] = kc(n(this.values[a], a));
    return An(this, { values: t }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(n) {
    return this[Xe.normalizeUnit(n)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = { ...this.values, ...wr(n, Xe.normalizeUnit) };
    return An(this, { values: t });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: n, numberingSystem: t, conversionAccuracy: a, matrix: s } = {}) {
    const l = { loc: this.loc.clone({ locale: n, numberingSystem: t }), matrix: s, conversionAccuracy: a };
    return An(this, l);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(n) {
    return this.isValid ? this.shiftTo(n).get(n) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const n = this.toObject();
    return go(this.matrix, n), An(this, { values: n }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const n = yo(this.normalize().shiftToAll().toObject());
    return An(this, { values: n }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...n) {
    if (!this.isValid) return this;
    if (n.length === 0)
      return this;
    n = n.map((l) => Xe.normalizeUnit(l));
    const t = {}, a = {}, s = this.toObject();
    let r;
    for (const l of fa)
      if (n.indexOf(l) >= 0) {
        r = l;
        let i = 0;
        for (const u in a)
          i += this.matrix[u][l] * a[u], a[u] = 0;
        Qn(s[l]) && (i += s[l]);
        const o = Math.trunc(i);
        t[l] = o, a[l] = (i * 1e3 - o * 1e3) / 1e3;
      } else Qn(s[l]) && (a[l] = s[l]);
    for (const l in a)
      a[l] !== 0 && (t[r] += l === r ? a[l] : a[l] / this.matrix[r][l]);
    return go(this.matrix, t), An(this, { values: t }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const n = {};
    for (const t of Object.keys(this.values))
      n[t] = this.values[t] === 0 ? 0 : -this.values[t];
    return An(this, { values: n }, !0);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const n = yo(this.values);
    return An(this, { values: n }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(n) {
    if (!this.isValid || !n.isValid || !this.loc.equals(n.loc))
      return !1;
    function t(a, s) {
      return a === void 0 || a === 0 ? s === void 0 || s === 0 : a === s;
    }
    for (const a of fa)
      if (!t(this.values[a], n.values[a]))
        return !1;
    return !0;
  }
}
const Da = "Invalid Interval";
function mv(e, n) {
  return !e || !e.isValid ? vt.invalid("missing or invalid start") : !n || !n.isValid ? vt.invalid("missing or invalid end") : n < e ? vt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${n.toISO()}`
  ) : null;
}
class vt {
  /**
   * @private
   */
  constructor(n) {
    this.s = n.start, this.e = n.end, this.invalid = n.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Rt("need to specify a reason the Interval is invalid");
    const a = n instanceof vn ? n : new vn(n, t);
    if (pt.throwOnInvalid)
      throw new Lh(a);
    return new vt({ invalid: a });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(n, t) {
    const a = fs(n), s = fs(t), r = mv(a, s);
    return r ?? new vt({
      start: a,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(n, t) {
    const a = Xe.fromDurationLike(t), s = fs(n);
    return vt.fromDateTimes(s, s.plus(a));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(n, t) {
    const a = Xe.fromDurationLike(t), s = fs(n);
    return vt.fromDateTimes(s.minus(a), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(n, t) {
    const [a, s] = (n || "").split("/", 2);
    if (a && s) {
      let r, l;
      try {
        r = Oe.fromISO(a, t), l = r.isValid;
      } catch {
        l = !1;
      }
      let i, o;
      try {
        i = Oe.fromISO(s, t), o = i.isValid;
      } catch {
        o = !1;
      }
      if (l && o)
        return vt.fromDateTimes(r, i);
      if (l) {
        const u = Xe.fromISO(s, t);
        if (u.isValid)
          return vt.after(r, u);
      } else if (o) {
        const u = Xe.fromISO(a, t);
        if (u.isValid)
          return vt.before(i, u);
      }
    }
    return vt.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(n) {
    return n && n.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(n = "milliseconds") {
    return this.isValid ? this.toDuration(n).get(n) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(n = "milliseconds", t) {
    if (!this.isValid) return NaN;
    const a = this.start.startOf(n, t);
    let s;
    return t != null && t.useLocaleWeeks ? s = this.end.reconfigure({ locale: a.locale }) : s = this.end, s = s.startOf(n, t), Math.floor(s.diff(a, n).get(n)) + (s.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(n) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, n) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(n) {
    return this.isValid ? this.s > n : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(n) {
    return this.isValid ? this.e <= n : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(n) {
    return this.isValid ? this.s <= n && this.e > n : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: n, end: t } = {}) {
    return this.isValid ? vt.fromDateTimes(n || this.s, t || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...n) {
    if (!this.isValid) return [];
    const t = n.map(fs).filter((l) => this.contains(l)).sort((l, i) => l.toMillis() - i.toMillis()), a = [];
    let { s } = this, r = 0;
    for (; s < this.e; ) {
      const l = t[r] || this.e, i = +l > +this.e ? this.e : l;
      a.push(vt.fromDateTimes(s, i)), s = i, r += 1;
    }
    return a;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(n) {
    const t = Xe.fromDurationLike(n);
    if (!this.isValid || !t.isValid || t.as("milliseconds") === 0)
      return [];
    let { s: a } = this, s = 1, r;
    const l = [];
    for (; a < this.e; ) {
      const i = this.start.plus(t.mapUnits((o) => o * s));
      r = +i > +this.e ? this.e : i, l.push(vt.fromDateTimes(a, r)), a = r, s += 1;
    }
    return l;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(n) {
    return this.isValid ? this.splitBy(this.length() / n).slice(0, n) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(n) {
    return this.e > n.s && this.s < n.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(n) {
    return this.isValid ? +this.e == +n.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(n) {
    return this.isValid ? +n.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(n) {
    return this.isValid ? this.s <= n.s && this.e >= n.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(n) {
    return !this.isValid || !n.isValid ? !1 : this.s.equals(n.s) && this.e.equals(n.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(n) {
    if (!this.isValid) return this;
    const t = this.s > n.s ? this.s : n.s, a = this.e < n.e ? this.e : n.e;
    return t >= a ? null : vt.fromDateTimes(t, a);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(n) {
    if (!this.isValid) return this;
    const t = this.s < n.s ? this.s : n.s, a = this.e > n.e ? this.e : n.e;
    return vt.fromDateTimes(t, a);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(n) {
    const [t, a] = n.sort((s, r) => s.s - r.s).reduce(
      ([s, r], l) => r ? r.overlaps(l) || r.abutsStart(l) ? [s, r.union(l)] : [s.concat([r]), l] : [s, l],
      [[], null]
    );
    return a && t.push(a), t;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(n) {
    let t = null, a = 0;
    const s = [], r = n.map((o) => [
      { time: o.s, type: "s" },
      { time: o.e, type: "e" }
    ]), l = Array.prototype.concat(...r), i = l.sort((o, u) => o.time - u.time);
    for (const o of i)
      a += o.type === "s" ? 1 : -1, a === 1 ? t = o.time : (t && +t != +o.time && s.push(vt.fromDateTimes(t, o.time)), t = null);
    return vt.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...n) {
    return vt.xor([this].concat(n)).map((t) => this.intersection(t)).filter((t) => t && !t.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Da;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(n = gr, t = {}) {
    return this.isValid ? Ft.create(this.s.loc.clone(t), n).formatInterval(this) : Da;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(n) {
    return this.isValid ? `${this.s.toISO(n)}/${this.e.toISO(n)}` : Da;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Da;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(n) {
    return this.isValid ? `${this.s.toISOTime(n)}/${this.e.toISOTime(n)}` : Da;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(n, { separator: t = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(n)}${t}${this.e.toFormat(n)}` : Da;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(n, t) {
    return this.isValid ? this.e.diff(this.s, n, t) : Xe.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(n) {
    return vt.fromDateTimes(n(this.s), n(this.e));
  }
}
class Js {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(n = pt.defaultZone) {
    const t = Oe.now().setZone(n).set({ month: 12 });
    return !n.isUniversal && t.offset !== t.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(n) {
    return Nn.isValidZone(n);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(n) {
    return Xn(n, pt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: r = "gregory" } = {}) {
    return (s || st.create(t, a, r)).months(n);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: r = "gregory" } = {}) {
    return (s || st.create(t, a, r)).months(n, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: n = null } = {}) {
    return st.create(n).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(n = "short", { locale: t = null } = {}) {
    return st.create(t, null, "gregory").eras(n);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: yc(), localeWeek: bc() };
  }
}
function bo(e, n) {
  const t = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), a = t(n) - t(e);
  return Math.floor(Xe.fromMillis(a).as("days"));
}
function vv(e, n, t) {
  const a = [
    ["years", (o, u) => u.year - o.year],
    ["quarters", (o, u) => u.quarter - o.quarter + (u.year - o.year) * 4],
    ["months", (o, u) => u.month - o.month + (u.year - o.year) * 12],
    [
      "weeks",
      (o, u) => {
        const c = bo(o, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", bo]
  ], s = {}, r = e;
  let l, i;
  for (const [o, u] of a)
    t.indexOf(o) >= 0 && (l = o, s[o] = u(e, n), i = r.plus(s), i > n ? (s[o]--, e = r.plus(s), e > n && (i = e, s[o]--, e = r.plus(s))) : e = i);
  return [e, s, i, l];
}
function pv(e, n, t, a) {
  let [s, r, l, i] = vv(e, n, t);
  const o = n - s, u = t.filter(
    (f) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(f) >= 0
  );
  u.length === 0 && (l < n && (l = s.plus({ [i]: 1 })), l !== s && (r[i] = (r[i] || 0) + o / (l - s)));
  const c = Xe.fromObject(r, a);
  return u.length > 0 ? Xe.fromMillis(o, a).shiftTo(...u).plus(c) : c;
}
const gv = "missing Intl.DateTimeFormat.formatToParts support";
function tt(e, n = (t) => t) {
  return { regex: e, deser: ([t]) => n(im(t)) };
}
const yv = " ", Vc = `[ ${yv}]`, Lc = new RegExp(Vc, "g");
function bv(e) {
  return e.replace(/\./g, "\\.?").replace(Lc, Vc);
}
function wo(e) {
  return e.replace(/\./g, "").replace(Lc, " ").toLowerCase();
}
function cn(e, n) {
  return e === null ? null : {
    regex: RegExp(e.map(bv).join("|")),
    deser: ([t]) => e.findIndex((a) => wo(t) === wo(a)) + n
  };
}
function ko(e, n) {
  return { regex: e, deser: ([, t, a]) => Fr(t, a), groups: n };
}
function Qs(e) {
  return { regex: e, deser: ([n]) => n };
}
function wv(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function kv(e, n) {
  const t = un(n), a = un(n, "{2}"), s = un(n, "{3}"), r = un(n, "{4}"), l = un(n, "{6}"), i = un(n, "{1,2}"), o = un(n, "{1,3}"), u = un(n, "{1,6}"), c = un(n, "{1,9}"), f = un(n, "{2,4}"), m = un(n, "{4,6}"), d = (k) => ({ regex: RegExp(wv(k.val)), deser: ([y]) => y, literal: !0 }), g = ((k) => {
    if (e.literal)
      return d(k);
    switch (k.val) {
      // era
      case "G":
        return cn(n.eras("short"), 0);
      case "GG":
        return cn(n.eras("long"), 0);
      // years
      case "y":
        return tt(u);
      case "yy":
        return tt(f, zl);
      case "yyyy":
        return tt(r);
      case "yyyyy":
        return tt(m);
      case "yyyyyy":
        return tt(l);
      // months
      case "M":
        return tt(i);
      case "MM":
        return tt(a);
      case "MMM":
        return cn(n.months("short", !0), 1);
      case "MMMM":
        return cn(n.months("long", !0), 1);
      case "L":
        return tt(i);
      case "LL":
        return tt(a);
      case "LLL":
        return cn(n.months("short", !1), 1);
      case "LLLL":
        return cn(n.months("long", !1), 1);
      // dates
      case "d":
        return tt(i);
      case "dd":
        return tt(a);
      // ordinals
      case "o":
        return tt(o);
      case "ooo":
        return tt(s);
      // time
      case "HH":
        return tt(a);
      case "H":
        return tt(i);
      case "hh":
        return tt(a);
      case "h":
        return tt(i);
      case "mm":
        return tt(a);
      case "m":
        return tt(i);
      case "q":
        return tt(i);
      case "qq":
        return tt(a);
      case "s":
        return tt(i);
      case "ss":
        return tt(a);
      case "S":
        return tt(o);
      case "SSS":
        return tt(s);
      case "u":
        return Qs(c);
      case "uu":
        return Qs(i);
      case "uuu":
        return tt(t);
      // meridiem
      case "a":
        return cn(n.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return tt(r);
      case "kk":
        return tt(f, zl);
      // weekNumber (W)
      case "W":
        return tt(i);
      case "WW":
        return tt(a);
      // weekdays
      case "E":
      case "c":
        return tt(t);
      case "EEE":
        return cn(n.weekdays("short", !1), 1);
      case "EEEE":
        return cn(n.weekdays("long", !1), 1);
      case "ccc":
        return cn(n.weekdays("short", !0), 1);
      case "cccc":
        return cn(n.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return ko(new RegExp(`([+-]${i.source})(?::(${a.source}))?`), 2);
      case "ZZZ":
        return ko(new RegExp(`([+-]${i.source})(${a.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return Qs(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return Qs(/[^\S\n\r]/);
      default:
        return d(k);
    }
  })(e) || {
    invalidReason: gv
  };
  return g.token = e, g;
}
const xv = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function Sv(e, n, t) {
  const { type: a, value: s } = e;
  if (a === "literal") {
    const o = /^\s+$/.test(s);
    return {
      literal: !o,
      val: o ? " " : s
    };
  }
  const r = n[a];
  let l = a;
  a === "hour" && (n.hour12 != null ? l = n.hour12 ? "hour12" : "hour24" : n.hourCycle != null ? n.hourCycle === "h11" || n.hourCycle === "h12" ? l = "hour12" : l = "hour24" : l = t.hour12 ? "hour12" : "hour24");
  let i = xv[l];
  if (typeof i == "object" && (i = i[r]), i)
    return {
      literal: !1,
      val: i
    };
}
function Tv(e) {
  return [`^${e.map((t) => t.regex).reduce((t, a) => `${t}(${a.source})`, "")}$`, e];
}
function Mv(e, n, t) {
  const a = e.match(n);
  if (a) {
    const s = {};
    let r = 1;
    for (const l in t)
      if (ja(t, l)) {
        const i = t[l], o = i.groups ? i.groups + 1 : 1;
        !i.literal && i.token && (s[i.token.val[0]] = i.deser(a.slice(r, r + o))), r += o;
      }
    return [a, s];
  } else
    return [a, {}];
}
function $v(e) {
  const n = (r) => {
    switch (r) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let t = null, a;
  return Ne(e.z) || (t = Nn.create(e.z)), Ne(e.Z) || (t || (t = new zt(e.Z)), a = e.Z), Ne(e.q) || (e.M = (e.q - 1) * 3 + 1), Ne(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Ne(e.u) || (e.S = ci(e.u)), [Object.keys(e).reduce((r, l) => {
    const i = n(l);
    return i && (r[i] = e[l]), r;
  }, {}), t, a];
}
let il = null;
function Cv() {
  return il || (il = Oe.fromMillis(1555555555555)), il;
}
function Dv(e, n) {
  if (e.literal)
    return e;
  const t = Ft.macroTokenToFormatOpts(e.val), a = Wc(t, n);
  return a == null || a.includes(void 0) ? e : a;
}
function Nc(e, n) {
  return Array.prototype.concat(...e.map((t) => Dv(t, n)));
}
class Bc {
  constructor(n, t) {
    if (this.locale = n, this.format = t, this.tokens = Nc(Ft.parseFormat(t), n), this.units = this.tokens.map((a) => kv(a, n)), this.disqualifyingUnit = this.units.find((a) => a.invalidReason), !this.disqualifyingUnit) {
      const [a, s] = Tv(this.units);
      this.regex = RegExp(a, "i"), this.handlers = s;
    }
  }
  explainFromTokens(n) {
    if (this.isValid) {
      const [t, a] = Mv(n, this.regex, this.handlers), [s, r, l] = a ? $v(a) : [null, null, void 0];
      if (ja(a, "a") && ja(a, "H"))
        throw new Ra(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: n,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: t,
        matches: a,
        result: s,
        zone: r,
        specificOffset: l
      };
    } else
      return { input: n, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function zc(e, n, t) {
  return new Bc(e, t).explainFromTokens(n);
}
function Ov(e, n, t) {
  const { result: a, zone: s, specificOffset: r, invalidReason: l } = zc(e, n, t);
  return [a, s, r, l];
}
function Wc(e, n) {
  if (!e)
    return null;
  const a = Ft.create(n, e).dtFormatter(Cv()), s = a.formatToParts(), r = a.resolvedOptions();
  return s.map((l) => Sv(l, e, r));
}
const ol = "Invalid DateTime", xo = 864e13;
function ws(e) {
  return new vn("unsupported zone", `the zone "${e.name}" is not supported`);
}
function ul(e) {
  return e.weekData === null && (e.weekData = yr(e.c)), e.weekData;
}
function cl(e) {
  return e.localWeekData === null && (e.localWeekData = yr(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function ia(e, n) {
  const t = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Oe({ ...t, ...n, old: t });
}
function Yc(e, n, t) {
  let a = e - n * 60 * 1e3;
  const s = t.offset(a);
  if (n === s)
    return [a, n];
  a -= (s - n) * 60 * 1e3;
  const r = t.offset(a);
  return s === r ? [a, s] : [e - Math.min(s, r) * 60 * 1e3, Math.max(s, r)];
}
function er(e, n) {
  e += n * 60 * 1e3;
  const t = new Date(e);
  return {
    year: t.getUTCFullYear(),
    month: t.getUTCMonth() + 1,
    day: t.getUTCDate(),
    hour: t.getUTCHours(),
    minute: t.getUTCMinutes(),
    second: t.getUTCSeconds(),
    millisecond: t.getUTCMilliseconds()
  };
}
function fr(e, n, t) {
  return Yc(Rr(e), n, t);
}
function So(e, n) {
  const t = e.o, a = e.c.year + Math.trunc(n.years), s = e.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, r = {
    ...e.c,
    year: a,
    month: s,
    day: Math.min(e.c.day, br(a, s)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }, l = Xe.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), i = Rr(r);
  let [o, u] = Yc(i, t, e.zone);
  return l !== 0 && (o += l, u = e.zone.offset(o)), { ts: o, o: u };
}
function Oa(e, n, t, a, s, r) {
  const { setZone: l, zone: i } = t;
  if (e && Object.keys(e).length !== 0 || n) {
    const o = n || i, u = Oe.fromObject(e, {
      ...t,
      zone: o,
      specificOffset: r
    });
    return l ? u : u.setZone(i);
  } else
    return Oe.invalid(
      new vn("unparsable", `the input "${s}" can't be parsed as ${a}`)
    );
}
function tr(e, n, t = !0) {
  return e.isValid ? Ft.create(st.create("en-US"), {
    allowZ: t,
    forceSimple: !0
  }).formatDateTimeFromString(e, n) : null;
}
function dl(e, n, t) {
  const a = e.c.year > 9999 || e.c.year < 0;
  let s = "";
  if (a && e.c.year >= 0 && (s += "+"), s += Tt(e.c.year, a ? 6 : 4), t === "year") return s;
  if (n) {
    if (s += "-", s += Tt(e.c.month), t === "month") return s;
    s += "-";
  } else if (s += Tt(e.c.month), t === "month") return s;
  return s += Tt(e.c.day), s;
}
function To(e, n, t, a, s, r, l) {
  let i = !t || e.c.millisecond !== 0 || e.c.second !== 0, o = "";
  switch (l) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      if (o += Tt(e.c.hour), l === "hour") break;
      if (n) {
        if (o += ":", o += Tt(e.c.minute), l === "minute") break;
        i && (o += ":", o += Tt(e.c.second));
      } else {
        if (o += Tt(e.c.minute), l === "minute") break;
        i && (o += Tt(e.c.second));
      }
      if (l === "second") break;
      i && (!a || e.c.millisecond !== 0) && (o += ".", o += Tt(e.c.millisecond, 3));
  }
  return s && (e.isOffsetFixed && e.offset === 0 && !r ? o += "Z" : e.o < 0 ? (o += "-", o += Tt(Math.trunc(-e.o / 60)), o += ":", o += Tt(Math.trunc(-e.o % 60))) : (o += "+", o += Tt(Math.trunc(e.o / 60)), o += ":", o += Tt(Math.trunc(e.o % 60)))), r && (o += "[" + e.zone.ianaName + "]"), o;
}
const Hc = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, _v = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Ev = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, hr = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Iv = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], Pv = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function mr(e) {
  const n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!n) throw new Hu(e);
  return n;
}
function Mo(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return mr(e);
  }
}
function Av(e) {
  if (ks === void 0 && (ks = pt.now()), e.type !== "iana")
    return e.offset(ks);
  const n = e.name;
  let t = Wl.get(n);
  return t === void 0 && (t = e.offset(ks), Wl.set(n, t)), t;
}
function $o(e, n) {
  const t = Xn(n.zone, pt.defaultZone);
  if (!t.isValid)
    return Oe.invalid(ws(t));
  const a = st.fromObject(n);
  let s, r;
  if (Ne(e.year))
    s = pt.now();
  else {
    for (const o of hr)
      Ne(e[o]) && (e[o] = Hc[o]);
    const l = pc(e) || gc(e);
    if (l)
      return Oe.invalid(l);
    const i = Av(t);
    [s, r] = fr(e, i, t);
  }
  return new Oe({ ts: s, zone: t, loc: a, o: r });
}
function Co(e, n, t) {
  const a = Ne(t.round) ? !0 : t.round, s = Ne(t.rounding) ? "trunc" : t.rounding, r = (i, o) => (i = di(i, a || t.calendary ? 0 : 2, t.calendary ? "round" : s), n.loc.clone(t).relFormatter(t).format(i, o)), l = (i) => t.calendary ? n.hasSame(e, i) ? 0 : n.startOf(i).diff(e.startOf(i), i).get(i) : n.diff(e, i).get(i);
  if (t.unit)
    return r(l(t.unit), t.unit);
  for (const i of t.units) {
    const o = l(i);
    if (Math.abs(o) >= 1)
      return r(o, i);
  }
  return r(e > n ? -0 : 0, t.units[t.units.length - 1]);
}
function Do(e) {
  let n = {}, t;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (n = e[e.length - 1], t = Array.from(e).slice(0, e.length - 1)) : t = Array.from(e), [n, t];
}
let ks;
const Wl = /* @__PURE__ */ new Map();
class Oe {
  /**
   * @access private
   */
  constructor(n) {
    const t = n.zone || pt.defaultZone;
    let a = n.invalid || (Number.isNaN(n.ts) ? new vn("invalid input") : null) || (t.isValid ? null : ws(t));
    this.ts = Ne(n.ts) ? pt.now() : n.ts;
    let s = null, r = null;
    if (!a)
      if (n.old && n.old.ts === this.ts && n.old.zone.equals(t))
        [s, r] = [n.old.c, n.old.o];
      else {
        const i = Qn(n.o) && !n.old ? n.o : t.offset(this.ts);
        s = er(this.ts, i), a = Number.isNaN(s.year) ? new vn("invalid input") : null, s = a ? null : s, r = a ? null : i;
      }
    this._zone = t, this.loc = n.loc || st.create(), this.invalid = a, this.weekData = null, this.localWeekData = null, this.c = s, this.o = r, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Oe({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [n, t] = Do(arguments), [a, s, r, l, i, o, u] = t;
    return $o({ year: a, month: s, day: r, hour: l, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [n, t] = Do(arguments), [a, s, r, l, i, o, u] = t;
    return n.zone = zt.utcInstance, $o({ year: a, month: s, day: r, hour: l, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(n, t = {}) {
    const a = fm(n) ? n.valueOf() : NaN;
    if (Number.isNaN(a))
      return Oe.invalid("invalid input");
    const s = Xn(t.zone, pt.defaultZone);
    return s.isValid ? new Oe({
      ts: a,
      zone: s,
      loc: st.fromObject(t)
    }) : Oe.invalid(ws(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(n, t = {}) {
    if (Qn(n))
      return n < -xo || n > xo ? Oe.invalid("Timestamp out of range") : new Oe({
        ts: n,
        zone: Xn(t.zone, pt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Rt(
      `fromMillis requires a numerical input, but received a ${typeof n} with value ${n}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(n, t = {}) {
    if (Qn(n))
      return new Oe({
        ts: n * 1e3,
        zone: Xn(t.zone, pt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Rt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(n, t = {}) {
    n = n || {};
    const a = Xn(t.zone, pt.defaultZone);
    if (!a.isValid)
      return Oe.invalid(ws(a));
    const s = st.fromObject(t), r = wr(n, Mo), { minDaysInFirstWeek: l, startOfWeek: i } = co(r, s), o = pt.now(), u = Ne(t.specificOffset) ? a.offset(o) : t.specificOffset, c = !Ne(r.ordinal), f = !Ne(r.year), m = !Ne(r.month) || !Ne(r.day), d = f || m, p = r.weekYear || r.weekNumber;
    if ((d || c) && p)
      throw new Ra(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (m && c)
      throw new Ra("Can't mix ordinal dates with month/day");
    const g = p || r.weekday && !d;
    let k, y, h = er(o, u);
    g ? (k = Iv, y = _v, h = yr(h, l, i)) : c ? (k = Pv, y = Ev, h = ll(h)) : (k = hr, y = Hc);
    let b = !1;
    for (const D of k) {
      const Y = r[D];
      Ne(Y) ? b ? r[D] = y[D] : r[D] = h[D] : b = !0;
    }
    const S = g ? um(r, l, i) : c ? cm(r) : pc(r), x = S || gc(r);
    if (x)
      return Oe.invalid(x);
    const C = g ? oo(r, l, i) : c ? uo(r) : r, [$, _] = fr(C, u, a), A = new Oe({
      ts: $,
      zone: a,
      o: _,
      loc: s
    });
    return r.weekday && d && n.weekday !== A.weekday ? Oe.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${r.weekday} and a date of ${A.toISO()}`
    ) : A.isValid ? A : Oe.invalid(A.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(n, t = {}) {
    const [a, s] = tv(n);
    return Oa(a, s, t, "ISO 8601", n);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(n, t = {}) {
    const [a, s] = nv(n);
    return Oa(a, s, t, "RFC 2822", n);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(n, t = {}) {
    const [a, s] = av(n);
    return Oa(a, s, t, "HTTP", t);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(n, t, a = {}) {
    if (Ne(n) || Ne(t))
      throw new Rt("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: r = null } = a, l = st.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    }), [i, o, u, c] = Ov(l, n, t);
    return c ? Oe.invalid(c) : Oa(i, o, a, `format ${t}`, n, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(n, t, a = {}) {
    return Oe.fromFormat(n, t, a);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(n, t = {}) {
    const [a, s] = cv(n);
    return Oa(a, s, t, "SQL", n);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Rt("need to specify a reason the DateTime is invalid");
    const a = n instanceof vn ? n : new vn(n, t);
    if (pt.throwOnInvalid)
      throw new Vh(a);
    return new Oe({ invalid: a });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(n) {
    return n && n.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(n, t = {}) {
    const a = Wc(n, st.fromObject(t));
    return a ? a.map((s) => s ? s.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(n, t = {}) {
    return Nc(Ft.parseFormat(n), st.fromObject(t)).map((s) => s.val).join("");
  }
  static resetCache() {
    ks = void 0, Wl.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(n) {
    return this[n];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? ul(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? ul(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? ul(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? cl(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? cl(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? cl(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? ll(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Js.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Js.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Js.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Js.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const n = 864e5, t = 6e4, a = Rr(this.c), s = this.zone.offset(a - n), r = this.zone.offset(a + n), l = this.zone.offset(a - s * t), i = this.zone.offset(a - r * t);
    if (l === i)
      return [this];
    const o = a - l * t, u = a - i * t, c = er(o, l), f = er(u, i);
    return c.hour === f.hour && c.minute === f.minute && c.second === f.second && c.millisecond === f.millisecond ? [ia(this, { ts: o }), ia(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return As(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return br(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Ba(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Os(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? Os(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(n = {}) {
    const { locale: t, numberingSystem: a, calendar: s } = Ft.create(
      this.loc.clone(n),
      n
    ).resolvedOptions(this);
    return { locale: t, numberingSystem: a, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(n = 0, t = {}) {
    return this.setZone(zt.instance(n), t);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(pt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(n, { keepLocalTime: t = !1, keepCalendarTime: a = !1 } = {}) {
    if (n = Xn(n, pt.defaultZone), n.equals(this.zone))
      return this;
    if (n.isValid) {
      let s = this.ts;
      if (t || a) {
        const r = n.offset(this.ts), l = this.toObject();
        [s] = fr(l, r, n);
      }
      return ia(this, { ts: s, zone: n });
    } else
      return Oe.invalid(ws(n));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: n, numberingSystem: t, outputCalendar: a } = {}) {
    const s = this.loc.clone({ locale: n, numberingSystem: t, outputCalendar: a });
    return ia(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(n) {
    return this.reconfigure({ locale: n });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = wr(n, Mo), { minDaysInFirstWeek: a, startOfWeek: s } = co(t, this.loc), r = !Ne(t.weekYear) || !Ne(t.weekNumber) || !Ne(t.weekday), l = !Ne(t.ordinal), i = !Ne(t.year), o = !Ne(t.month) || !Ne(t.day), u = i || o, c = t.weekYear || t.weekNumber;
    if ((u || l) && c)
      throw new Ra(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (o && l)
      throw new Ra("Can't mix ordinal dates with month/day");
    let f;
    r ? f = oo(
      { ...yr(this.c, a, s), ...t },
      a,
      s
    ) : Ne(t.ordinal) ? (f = { ...this.toObject(), ...t }, Ne(t.day) && (f.day = Math.min(br(f.year, f.month), f.day))) : f = uo({ ...ll(this.c), ...t });
    const [m, d] = fr(f, this.o, this.zone);
    return ia(this, { ts: m, o: d });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Xe.fromDurationLike(n);
    return ia(this, So(this, t));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Xe.fromDurationLike(n).negate();
    return ia(this, So(this, t));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(n, { useLocaleWeeks: t = !1 } = {}) {
    if (!this.isValid) return this;
    const a = {}, s = Xe.normalizeUnit(n);
    switch (s) {
      case "years":
        a.month = 1;
      // falls through
      case "quarters":
      case "months":
        a.day = 1;
      // falls through
      case "weeks":
      case "days":
        a.hour = 0;
      // falls through
      case "hours":
        a.minute = 0;
      // falls through
      case "minutes":
        a.second = 0;
      // falls through
      case "seconds":
        a.millisecond = 0;
        break;
    }
    if (s === "weeks")
      if (t) {
        const r = this.loc.getStartOfWeek(), { weekday: l } = this;
        l < r && (a.weekNumber = this.weekNumber - 1), a.weekday = r;
      } else
        a.weekday = 1;
    if (s === "quarters") {
      const r = Math.ceil(this.month / 3);
      a.month = (r - 1) * 3 + 1;
    }
    return this.set(a);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(n, t) {
    return this.isValid ? this.plus({ [n]: 1 }).startOf(n, t).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(n, t = {}) {
    return this.isValid ? Ft.create(this.loc.redefaultToEN(t)).formatDateTimeFromString(this, n) : ol;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(n = gr, t = {}) {
    return this.isValid ? Ft.create(this.loc.clone(t), n).formatDateTime(this) : ol;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(n = {}) {
    return this.isValid ? Ft.create(this.loc.clone(n), n).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: n = "extended",
    suppressSeconds: t = !1,
    suppressMilliseconds: a = !1,
    includeOffset: s = !0,
    extendedZone: r = !1,
    precision: l = "milliseconds"
  } = {}) {
    if (!this.isValid)
      return null;
    l = mr(l);
    const i = n === "extended";
    let o = dl(this, i, l);
    return hr.indexOf(l) >= 3 && (o += "T"), o += To(
      this,
      i,
      t,
      a,
      s,
      r,
      l
    ), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: n = "extended", precision: t = "day" } = {}) {
    return this.isValid ? dl(this, n === "extended", mr(t)) : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return tr(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: n = !1,
    suppressSeconds: t = !1,
    includeOffset: a = !0,
    includePrefix: s = !1,
    extendedZone: r = !1,
    format: l = "extended",
    precision: i = "milliseconds"
  } = {}) {
    return this.isValid ? (i = mr(i), (s && hr.indexOf(i) >= 3 ? "T" : "") + To(
      this,
      l === "extended",
      t,
      n,
      a,
      r,
      i
    )) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return tr(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return tr(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? dl(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: n = !0, includeZone: t = !1, includeOffsetSpace: a = !0 } = {}) {
    let s = "HH:mm:ss.SSS";
    return (t || n) && (a && (s += " "), t ? s += "z" : n && (s += "ZZ")), tr(this, s, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(n = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(n)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : ol;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(n = {}) {
    if (!this.isValid) return {};
    const t = { ...this.c };
    return n.includeConfig && (t.outputCalendar = this.outputCalendar, t.numberingSystem = this.loc.numberingSystem, t.locale = this.loc.locale), t;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(n, t = "milliseconds", a = {}) {
    if (!this.isValid || !n.isValid)
      return Xe.invalid("created by diffing an invalid DateTime");
    const s = { locale: this.locale, numberingSystem: this.numberingSystem, ...a }, r = hm(t).map(Xe.normalizeUnit), l = n.valueOf() > this.valueOf(), i = l ? this : n, o = l ? n : this, u = pv(i, o, r, s);
    return l ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(n = "milliseconds", t = {}) {
    return this.diff(Oe.now(), n, t);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(n) {
    return this.isValid ? vt.fromDateTimes(this, n) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(n, t, a) {
    if (!this.isValid) return !1;
    const s = n.valueOf(), r = this.setZone(n.zone, { keepLocalTime: !0 });
    return r.startOf(t, a) <= s && s <= r.endOf(t, a);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(n) {
    return this.isValid && n.isValid && this.valueOf() === n.valueOf() && this.zone.equals(n.zone) && this.loc.equals(n.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(n = {}) {
    if (!this.isValid) return null;
    const t = n.base || Oe.fromObject({}, { zone: this.zone }), a = n.padding ? this < t ? -n.padding : n.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], r = n.unit;
    return Array.isArray(n.unit) && (s = n.unit, r = void 0), Co(t, this.plus(a), {
      ...n,
      numeric: "always",
      units: s,
      unit: r
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(n = {}) {
    return this.isValid ? Co(n.base || Oe.fromObject({}, { zone: this.zone }), this, {
      ...n,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...n) {
    if (!n.every(Oe.isDateTime))
      throw new Rt("min requires all arguments be DateTimes");
    return fo(n, (t) => t.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...n) {
    if (!n.every(Oe.isDateTime))
      throw new Rt("max requires all arguments be DateTimes");
    return fo(n, (t) => t.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(n, t, a = {}) {
    const { locale: s = null, numberingSystem: r = null } = a, l = st.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    });
    return zc(l, n, t);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(n, t, a = {}) {
    return Oe.fromFormatExplain(n, t, a);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(n, t = {}) {
    const { locale: a = null, numberingSystem: s = null } = t, r = st.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    });
    return new Bc(r, n);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(n, t, a = {}) {
    if (Ne(n) || Ne(t))
      throw new Rt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: s = null, numberingSystem: r = null } = a, l = st.fromOpts({
      locale: s,
      numberingSystem: r,
      defaultToEN: !0
    });
    if (!l.equals(t.locale))
      throw new Rt(
        `fromFormatParser called with a locale of ${l}, but the format parser was created for ${t.locale}`
      );
    const { result: i, zone: o, specificOffset: u, invalidReason: c } = t.explainFromTokens(n);
    return c ? Oe.invalid(c) : Oa(
      i,
      o,
      a,
      `format ${t.format}`,
      n,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return gr;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Uu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return Bh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return qu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return ju;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Gu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Ku;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Zu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Xu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return Ju;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Qu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return ec;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return tc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return nc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return ac;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return sc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return rc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return zh;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return lc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return ic;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return oc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return uc;
  }
}
function fs(e) {
  if (Oe.isDateTime(e))
    return e;
  if (e && e.valueOf && Qn(e.valueOf()))
    return Oe.fromJSDate(e);
  if (e && typeof e == "object")
    return Oe.fromObject(e);
  throw new Rt(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const Rv = ["datetime", "title"], Fv = {
  key: 1,
  class: "text-secondaryText"
}, lD = /* @__PURE__ */ Se({
  __name: "VDate",
  props: {
    value: { default: null },
    format: { default: "MM/dd/yyyy, h:mm a" }
  },
  setup(e) {
    const n = M(() => {
      if (!e.value) return null;
      const s = Oe.fromISO(e.value).toLocal();
      return s.isValid ? s : null;
    }), t = M(() => {
      var s;
      return ((s = n.value) == null ? void 0 : s.toFormat(e.format)) ?? "—";
    }), a = M(() => {
      if (!e.value) return;
      const s = Oe.fromISO(e.value, { zone: "utc" });
      return s.isValid ? `${s.toFormat("yyyy-MM-dd HH:mm:ss")} UTC` : e.value;
    });
    return (s, r) => e.value ? (w(), T("time", {
      key: 0,
      datetime: e.value,
      title: a.value
    }, ue(t.value), 9, Rv)) : (w(), T("span", Fv, "—"));
  }
}), Vv = { class: "v-checkbox" }, Lv = ["id", "disabled", "value"], Nv = ["for"], Bv = /* @__PURE__ */ Se({
  __name: "VCheckbox",
  props: {
    modelValue: { type: [Boolean, Array] },
    id: {},
    label: {},
    value: { type: [String, Number, Boolean] },
    disabled: { type: Boolean },
    indeterminate: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Or(), r = M(() => t.id || s), l = M({
      get() {
        return t.modelValue;
      },
      set(o) {
        o !== void 0 && a("update:modelValue", o);
      }
    }), i = ee(null);
    return Ut(() => {
      i.value && (i.value.indeterminate = !!t.indeterminate);
    }), (o, u) => (w(), T("div", Vv, [
      mn(E("input", rt({
        id: r.value,
        ref_key: "inputRef",
        ref: i,
        "onUpdate:modelValue": u[0] || (u[0] = (c) => l.value = c),
        disabled: t.disabled,
        value: e.value,
        class: "v-checkbox__input",
        type: "checkbox"
      }, o.$attrs), null, 16, Lv), [
        [hf, l.value]
      ]),
      e.label || o.$slots.label ? (w(), T("label", {
        key: 0,
        class: ne([
          "v-checkbox__label",
          { "v-checkbox__label--disabled": t.disabled }
        ]),
        for: t.disabled ? void 0 : r.value
      }, [
        U(o.$slots, "label", {}, () => [
          Ue(ue(e.label), 1)
        ], !0)
      ], 10, Nv)) : P("", !0)
    ]));
  }
}), Uc = /* @__PURE__ */ je(Bv, [["__scopeId", "data-v-914acca3"]]), zv = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Wv = Object.prototype.toString, Yv = (e) => Wv.call(e) === "[object Object]", nr = () => {
};
function fl(e) {
  return Array.isArray(e) ? e : [e];
}
function Hv(e, n, t) {
  return We(e, n, {
    ...t,
    immediate: !0
  });
}
const qc = zv ? window : void 0;
function jt(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) !== null && n !== void 0 ? n : t;
}
function Wa(...e) {
  const n = (a, s, r, l) => (a.addEventListener(s, r, l), () => a.removeEventListener(s, r, l)), t = M(() => {
    const a = fl(Qe(e[0])).filter((s) => s != null);
    return a.every((s) => typeof s != "string") ? a : void 0;
  });
  return Hv(() => {
    var a, s;
    return [
      (a = (s = t.value) === null || s === void 0 ? void 0 : s.map((r) => jt(r))) !== null && a !== void 0 ? a : [qc].filter((r) => r != null),
      fl(Qe(t.value ? e[1] : e[0])),
      fl(v(t.value ? e[2] : e[1])),
      Qe(t.value ? e[3] : e[2])
    ];
  }, ([a, s, r, l], i, o) => {
    if (!(a != null && a.length) || !(s != null && s.length) || !(r != null && r.length)) return;
    const u = Yv(l) ? { ...l } : l, c = a.flatMap((f) => s.flatMap((m) => r.map((d) => n(f, m, d, u))));
    o(() => {
      c.forEach((f) => f());
    });
  }, { flush: "post" });
}
function Uv(e, n, t = {}) {
  const { window: a = qc, ignore: s = [], capture: r = !0, detectIframe: l = !1, controls: i = !1 } = t;
  if (!a) return i ? {
    stop: nr,
    cancel: nr,
    trigger: nr
  } : nr;
  let o = !0;
  const u = (k) => Qe(s).some((y) => {
    if (typeof y == "string") return Array.from(a.document.querySelectorAll(y)).some((h) => h === k.target || k.composedPath().includes(h));
    {
      const h = jt(y);
      return h && (k.target === h || k.composedPath().includes(h));
    }
  });
  function c(k) {
    const y = Qe(k);
    return y && y.$.subTree.shapeFlag === 16;
  }
  function f(k, y) {
    const h = Qe(k), b = h.$.subTree && h.$.subTree.children;
    return b == null || !Array.isArray(b) ? !1 : b.some((S) => S.el === y.target || y.composedPath().includes(S.el));
  }
  const m = (k) => {
    const y = jt(e);
    if (k.target != null && !(!(y instanceof Element) && c(e) && f(e, k)) && !(!y || y === k.target || k.composedPath().includes(y))) {
      if ("detail" in k && k.detail === 0 && (o = !u(k)), !o) {
        o = !0;
        return;
      }
      n(k);
    }
  };
  let d = !1;
  const p = [
    Wa(a, "click", (k) => {
      d || (d = !0, setTimeout(() => {
        d = !1;
      }, 0), m(k));
    }, {
      passive: !0,
      capture: r
    }),
    Wa(a, "pointerdown", (k) => {
      const y = jt(e);
      o = !u(k) && !!(y && !k.composedPath().includes(y));
    }, { passive: !0 }),
    l && Wa(a, "blur", (k) => {
      setTimeout(() => {
        var y;
        const h = jt(e);
        ((y = a.document.activeElement) === null || y === void 0 ? void 0 : y.tagName) === "IFRAME" && !(h != null && h.contains(a.document.activeElement)) && n(k);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), g = () => p.forEach((k) => k());
  return i ? {
    stop: g,
    cancel: () => {
      o = !1;
    },
    trigger: (k) => {
      o = !0, m(k), o = !1;
    }
  } : g;
}
function qv(e, n = {}) {
  const { threshold: t = 50, onSwipe: a, onSwipeEnd: s, onSwipeStart: r, passive: l = !0 } = n, i = ga({
    x: 0,
    y: 0
  }), o = ga({
    x: 0,
    y: 0
  }), u = M(() => i.x - o.x), c = M(() => i.y - o.y), { max: f, abs: m } = Math, d = M(() => f(m(u.value), m(c.value)) >= t), p = It(!1), g = M(() => d.value ? m(u.value) > m(c.value) ? u.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), k = ($) => [$.touches[0].clientX, $.touches[0].clientY], y = ($, _) => {
    i.x = $, i.y = _;
  }, h = ($, _) => {
    o.x = $, o.y = _;
  }, b = {
    passive: l,
    capture: !l
  }, S = ($) => {
    p.value && (s == null || s($, g.value)), p.value = !1;
  }, x = [
    Wa(e, "touchstart", ($) => {
      if ($.touches.length !== 1) return;
      const [_, A] = k($);
      y(_, A), h(_, A), r == null || r($);
    }, b),
    Wa(e, "touchmove", ($) => {
      if ($.touches.length !== 1) return;
      const [_, A] = k($);
      h(_, A), b.capture && !b.passive && Math.abs(u.value) > Math.abs(c.value) && $.preventDefault(), !p.value && d.value && (p.value = !0), p.value && (a == null || a($));
    }, b),
    Wa(e, ["touchend", "touchcancel"], S, b)
  ];
  return {
    isSwiping: p,
    direction: g,
    coordsStart: i,
    coordsEnd: o,
    lengthX: u,
    lengthY: c,
    stop: () => x.forEach(($) => $())
  };
}
const Ga = Math.min, va = Math.max, kr = Math.round, ar = Math.floor, $n = (e) => ({
  x: e,
  y: e
}), jv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Gv = {
  start: "end",
  end: "start"
};
function Yl(e, n, t) {
  return va(e, Ga(n, t));
}
function Vs(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function ya(e) {
  return e.split("-")[0];
}
function Ls(e) {
  return e.split("-")[1];
}
function jc(e) {
  return e === "x" ? "y" : "x";
}
function vi(e) {
  return e === "y" ? "height" : "width";
}
const Kv = /* @__PURE__ */ new Set(["top", "bottom"]);
function Jn(e) {
  return Kv.has(ya(e)) ? "y" : "x";
}
function pi(e) {
  return jc(Jn(e));
}
function Zv(e, n, t) {
  t === void 0 && (t = !1);
  const a = Ls(e), s = pi(e), r = vi(s);
  let l = s === "x" ? a === (t ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return n.reference[r] > n.floating[r] && (l = xr(l)), [l, xr(l)];
}
function Xv(e) {
  const n = xr(e);
  return [Hl(e), n, Hl(n)];
}
function Hl(e) {
  return e.replace(/start|end/g, (n) => Gv[n]);
}
const Oo = ["left", "right"], _o = ["right", "left"], Jv = ["top", "bottom"], Qv = ["bottom", "top"];
function ep(e, n, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? _o : Oo : n ? Oo : _o;
    case "left":
    case "right":
      return n ? Jv : Qv;
    default:
      return [];
  }
}
function tp(e, n, t, a) {
  const s = Ls(e);
  let r = ep(ya(e), t === "start", a);
  return s && (r = r.map((l) => l + "-" + s), n && (r = r.concat(r.map(Hl)))), r;
}
function xr(e) {
  return e.replace(/left|right|bottom|top/g, (n) => jv[n]);
}
function np(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Gc(e) {
  return typeof e != "number" ? np(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Sr(e) {
  const {
    x: n,
    y: t,
    width: a,
    height: s
  } = e;
  return {
    width: a,
    height: s,
    top: t,
    left: n,
    right: n + a,
    bottom: t + s,
    x: n,
    y: t
  };
}
function Eo(e, n, t) {
  let {
    reference: a,
    floating: s
  } = e;
  const r = Jn(n), l = pi(n), i = vi(l), o = ya(n), u = r === "y", c = a.x + a.width / 2 - s.width / 2, f = a.y + a.height / 2 - s.height / 2, m = a[i] / 2 - s[i] / 2;
  let d;
  switch (o) {
    case "top":
      d = {
        x: c,
        y: a.y - s.height
      };
      break;
    case "bottom":
      d = {
        x: c,
        y: a.y + a.height
      };
      break;
    case "right":
      d = {
        x: a.x + a.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: a.x - s.width,
        y: f
      };
      break;
    default:
      d = {
        x: a.x,
        y: a.y
      };
  }
  switch (Ls(n)) {
    case "start":
      d[l] -= m * (t && u ? -1 : 1);
      break;
    case "end":
      d[l] += m * (t && u ? -1 : 1);
      break;
  }
  return d;
}
async function ap(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: a,
    y: s,
    platform: r,
    rects: l,
    elements: i,
    strategy: o
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: m = !1,
    padding: d = 0
  } = Vs(n, e), p = Gc(d), k = i[m ? f === "floating" ? "reference" : "floating" : f], y = Sr(await r.getClippingRect({
    element: (t = await (r.isElement == null ? void 0 : r.isElement(k))) == null || t ? k : k.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: o
  })), h = f === "floating" ? {
    x: a,
    y: s,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, b = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(i.floating)), S = await (r.isElement == null ? void 0 : r.isElement(b)) ? await (r.getScale == null ? void 0 : r.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Sr(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: h,
    offsetParent: b,
    strategy: o
  }) : h);
  return {
    top: (y.top - x.top + p.top) / S.y,
    bottom: (x.bottom - y.bottom + p.bottom) / S.y,
    left: (y.left - x.left + p.left) / S.x,
    right: (x.right - y.right + p.right) / S.x
  };
}
const sp = async (e, n, t) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: r = [],
    platform: l
  } = t, i = r.filter(Boolean), o = await (l.isRTL == null ? void 0 : l.isRTL(n));
  let u = await l.getElementRects({
    reference: e,
    floating: n,
    strategy: s
  }), {
    x: c,
    y: f
  } = Eo(u, a, o), m = a, d = {}, p = 0;
  for (let k = 0; k < i.length; k++) {
    var g;
    const {
      name: y,
      fn: h
    } = i[k], {
      x: b,
      y: S,
      data: x,
      reset: C
    } = await h({
      x: c,
      y: f,
      initialPlacement: a,
      placement: m,
      strategy: s,
      middlewareData: d,
      rects: u,
      platform: {
        ...l,
        detectOverflow: (g = l.detectOverflow) != null ? g : ap
      },
      elements: {
        reference: e,
        floating: n
      }
    });
    c = b ?? c, f = S ?? f, d = {
      ...d,
      [y]: {
        ...d[y],
        ...x
      }
    }, C && p <= 50 && (p++, typeof C == "object" && (C.placement && (m = C.placement), C.rects && (u = C.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: n,
      strategy: s
    }) : C.rects), {
      x: c,
      y: f
    } = Eo(u, m, o)), k = -1);
  }
  return {
    x: c,
    y: f,
    placement: m,
    strategy: s,
    middlewareData: d
  };
}, rp = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: a,
      placement: s,
      rects: r,
      platform: l,
      elements: i,
      middlewareData: o
    } = n, {
      element: u,
      padding: c = 0
    } = Vs(e, n) || {};
    if (u == null)
      return {};
    const f = Gc(c), m = {
      x: t,
      y: a
    }, d = pi(s), p = vi(d), g = await l.getDimensions(u), k = d === "y", y = k ? "top" : "left", h = k ? "bottom" : "right", b = k ? "clientHeight" : "clientWidth", S = r.reference[p] + r.reference[d] - m[d] - r.floating[p], x = m[d] - r.reference[d], C = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(u));
    let $ = C ? C[b] : 0;
    (!$ || !await (l.isElement == null ? void 0 : l.isElement(C))) && ($ = i.floating[b] || r.floating[p]);
    const _ = S / 2 - x / 2, A = $ / 2 - g[p] / 2 - 1, D = Ga(f[y], A), Y = Ga(f[h], A), L = D, Z = $ - g[p] - Y, se = $ / 2 - g[p] / 2 + _, ie = Yl(L, se, Z), ce = !o.arrow && Ls(s) != null && se !== ie && r.reference[p] / 2 - (se < L ? D : Y) - g[p] / 2 < 0, G = ce ? se < L ? se - L : se - Z : 0;
    return {
      [d]: m[d] + G,
      data: {
        [d]: ie,
        centerOffset: se - ie - G,
        ...ce && {
          alignmentOffset: G
        }
      },
      reset: ce
    };
  }
}), lp = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, a;
      const {
        placement: s,
        middlewareData: r,
        rects: l,
        initialPlacement: i,
        platform: o,
        elements: u
      } = n, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: m,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...k
      } = Vs(e, n);
      if ((t = r.arrow) != null && t.alignmentOffset)
        return {};
      const y = ya(s), h = Jn(i), b = ya(i) === i, S = await (o.isRTL == null ? void 0 : o.isRTL(u.floating)), x = m || (b || !g ? [xr(i)] : Xv(i)), C = p !== "none";
      !m && C && x.push(...tp(i, g, p, S));
      const $ = [i, ...x], _ = await o.detectOverflow(n, k), A = [];
      let D = ((a = r.flip) == null ? void 0 : a.overflows) || [];
      if (c && A.push(_[y]), f) {
        const se = Zv(s, l, S);
        A.push(_[se[0]], _[se[1]]);
      }
      if (D = [...D, {
        placement: s,
        overflows: A
      }], !A.every((se) => se <= 0)) {
        var Y, L;
        const se = (((Y = r.flip) == null ? void 0 : Y.index) || 0) + 1, ie = $[se];
        if (ie && (!(f === "alignment" ? h !== Jn(ie) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((le) => Jn(le.placement) === h ? le.overflows[0] > 0 : !0)))
          return {
            data: {
              index: se,
              overflows: D
            },
            reset: {
              placement: ie
            }
          };
        let ce = (L = D.filter((G) => G.overflows[0] <= 0).sort((G, le) => G.overflows[1] - le.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!ce)
          switch (d) {
            case "bestFit": {
              var Z;
              const G = (Z = D.filter((le) => {
                if (C) {
                  const q = Jn(le.placement);
                  return q === h || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  q === "y";
                }
                return !0;
              }).map((le) => [le.placement, le.overflows.filter((q) => q > 0).reduce((q, N) => q + N, 0)]).sort((le, q) => le[1] - q[1])[0]) == null ? void 0 : Z[0];
              G && (ce = G);
              break;
            }
            case "initialPlacement":
              ce = i;
              break;
          }
        if (s !== ce)
          return {
            reset: {
              placement: ce
            }
          };
      }
      return {};
    }
  };
}, ip = /* @__PURE__ */ new Set(["left", "top"]);
async function op(e, n) {
  const {
    placement: t,
    platform: a,
    elements: s
  } = e, r = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), l = ya(t), i = Ls(t), o = Jn(t) === "y", u = ip.has(l) ? -1 : 1, c = r && o ? -1 : 1, f = Vs(n, e);
  let {
    mainAxis: m,
    crossAxis: d,
    alignmentAxis: p
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof p == "number" && (d = i === "end" ? p * -1 : p), o ? {
    x: d * c,
    y: m * u
  } : {
    x: m * u,
    y: d * c
  };
}
const up = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, a;
      const {
        x: s,
        y: r,
        placement: l,
        middlewareData: i
      } = n, o = await op(n, e);
      return l === ((t = i.offset) == null ? void 0 : t.placement) && (a = i.arrow) != null && a.alignmentOffset ? {} : {
        x: s + o.x,
        y: r + o.y,
        data: {
          ...o,
          placement: l
        }
      };
    }
  };
}, cp = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: a,
        placement: s,
        platform: r
      } = n, {
        mainAxis: l = !0,
        crossAxis: i = !1,
        limiter: o = {
          fn: (y) => {
            let {
              x: h,
              y: b
            } = y;
            return {
              x: h,
              y: b
            };
          }
        },
        ...u
      } = Vs(e, n), c = {
        x: t,
        y: a
      }, f = await r.detectOverflow(n, u), m = Jn(ya(s)), d = jc(m);
      let p = c[d], g = c[m];
      if (l) {
        const y = d === "y" ? "top" : "left", h = d === "y" ? "bottom" : "right", b = p + f[y], S = p - f[h];
        p = Yl(b, p, S);
      }
      if (i) {
        const y = m === "y" ? "top" : "left", h = m === "y" ? "bottom" : "right", b = g + f[y], S = g - f[h];
        g = Yl(b, g, S);
      }
      const k = o.fn({
        ...n,
        [d]: p,
        [m]: g
      });
      return {
        ...k,
        data: {
          x: k.x - t,
          y: k.y - a,
          enabled: {
            [d]: l,
            [m]: i
          }
        }
      };
    }
  };
};
function Lr() {
  return typeof window < "u";
}
function ka(e) {
  return gi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Kt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function _n(e) {
  var n;
  return (n = (gi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function gi(e) {
  return Lr() ? e instanceof Node || e instanceof Kt(e).Node : !1;
}
function bn(e) {
  return Lr() ? e instanceof Element || e instanceof Kt(e).Element : !1;
}
function Dn(e) {
  return Lr() ? e instanceof HTMLElement || e instanceof Kt(e).HTMLElement : !1;
}
function Io(e) {
  return !Lr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Kt(e).ShadowRoot;
}
const dp = /* @__PURE__ */ new Set(["inline", "contents"]);
function Ns(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: a,
    display: s
  } = wn(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + a + t) && !dp.has(s);
}
const fp = /* @__PURE__ */ new Set(["table", "td", "th"]);
function hp(e) {
  return fp.has(ka(e));
}
const mp = [":popover-open", ":modal"];
function Nr(e) {
  return mp.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
const vp = ["transform", "translate", "scale", "rotate", "perspective"], pp = ["transform", "translate", "scale", "rotate", "perspective", "filter"], gp = ["paint", "layout", "strict", "content"];
function yi(e) {
  const n = bi(), t = bn(e) ? wn(e) : e;
  return vp.some((a) => t[a] ? t[a] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || pp.some((a) => (t.willChange || "").includes(a)) || gp.some((a) => (t.contain || "").includes(a));
}
function yp(e) {
  let n = ta(e);
  for (; Dn(n) && !Ka(n); ) {
    if (yi(n))
      return n;
    if (Nr(n))
      return null;
    n = ta(n);
  }
  return null;
}
function bi() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const bp = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ka(e) {
  return bp.has(ka(e));
}
function wn(e) {
  return Kt(e).getComputedStyle(e);
}
function Br(e) {
  return bn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ta(e) {
  if (ka(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Io(e) && e.host || // Fallback.
    _n(e)
  );
  return Io(n) ? n.host : n;
}
function Kc(e) {
  const n = ta(e);
  return Ka(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : Dn(n) && Ns(n) ? n : Kc(n);
}
function _s(e, n, t) {
  var a;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const s = Kc(e), r = s === ((a = e.ownerDocument) == null ? void 0 : a.body), l = Kt(s);
  if (r) {
    const i = Ul(l);
    return n.concat(l, l.visualViewport || [], Ns(s) ? s : [], i && t ? _s(i) : []);
  }
  return n.concat(s, _s(s, [], t));
}
function Ul(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Zc(e) {
  const n = wn(e);
  let t = parseFloat(n.width) || 0, a = parseFloat(n.height) || 0;
  const s = Dn(e), r = s ? e.offsetWidth : t, l = s ? e.offsetHeight : a, i = kr(t) !== r || kr(a) !== l;
  return i && (t = r, a = l), {
    width: t,
    height: a,
    $: i
  };
}
function wi(e) {
  return bn(e) ? e : e.contextElement;
}
function Ya(e) {
  const n = wi(e);
  if (!Dn(n))
    return $n(1);
  const t = n.getBoundingClientRect(), {
    width: a,
    height: s,
    $: r
  } = Zc(n);
  let l = (r ? kr(t.width) : t.width) / a, i = (r ? kr(t.height) : t.height) / s;
  return (!l || !Number.isFinite(l)) && (l = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: l,
    y: i
  };
}
const wp = /* @__PURE__ */ $n(0);
function Xc(e) {
  const n = Kt(e);
  return !bi() || !n.visualViewport ? wp : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function kp(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== Kt(e) ? !1 : n;
}
function ba(e, n, t, a) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const s = e.getBoundingClientRect(), r = wi(e);
  let l = $n(1);
  n && (a ? bn(a) && (l = Ya(a)) : l = Ya(e));
  const i = kp(r, t, a) ? Xc(r) : $n(0);
  let o = (s.left + i.x) / l.x, u = (s.top + i.y) / l.y, c = s.width / l.x, f = s.height / l.y;
  if (r) {
    const m = Kt(r), d = a && bn(a) ? Kt(a) : a;
    let p = m, g = Ul(p);
    for (; g && a && d !== p; ) {
      const k = Ya(g), y = g.getBoundingClientRect(), h = wn(g), b = y.left + (g.clientLeft + parseFloat(h.paddingLeft)) * k.x, S = y.top + (g.clientTop + parseFloat(h.paddingTop)) * k.y;
      o *= k.x, u *= k.y, c *= k.x, f *= k.y, o += b, u += S, p = Kt(g), g = Ul(p);
    }
  }
  return Sr({
    width: c,
    height: f,
    x: o,
    y: u
  });
}
function zr(e, n) {
  const t = Br(e).scrollLeft;
  return n ? n.left + t : ba(_n(e)).left + t;
}
function Jc(e, n) {
  const t = e.getBoundingClientRect(), a = t.left + n.scrollLeft - zr(e, t), s = t.top + n.scrollTop;
  return {
    x: a,
    y: s
  };
}
function xp(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: a,
    strategy: s
  } = e;
  const r = s === "fixed", l = _n(a), i = n ? Nr(n.floating) : !1;
  if (a === l || i && r)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = $n(1);
  const c = $n(0), f = Dn(a);
  if ((f || !f && !r) && ((ka(a) !== "body" || Ns(l)) && (o = Br(a)), Dn(a))) {
    const d = ba(a);
    u = Ya(a), c.x = d.x + a.clientLeft, c.y = d.y + a.clientTop;
  }
  const m = l && !f && !r ? Jc(l, o) : $n(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - o.scrollLeft * u.x + c.x + m.x,
    y: t.y * u.y - o.scrollTop * u.y + c.y + m.y
  };
}
function Sp(e) {
  return Array.from(e.getClientRects());
}
function Tp(e) {
  const n = _n(e), t = Br(e), a = e.ownerDocument.body, s = va(n.scrollWidth, n.clientWidth, a.scrollWidth, a.clientWidth), r = va(n.scrollHeight, n.clientHeight, a.scrollHeight, a.clientHeight);
  let l = -t.scrollLeft + zr(e);
  const i = -t.scrollTop;
  return wn(a).direction === "rtl" && (l += va(n.clientWidth, a.clientWidth) - s), {
    width: s,
    height: r,
    x: l,
    y: i
  };
}
const Po = 25;
function Mp(e, n) {
  const t = Kt(e), a = _n(e), s = t.visualViewport;
  let r = a.clientWidth, l = a.clientHeight, i = 0, o = 0;
  if (s) {
    r = s.width, l = s.height;
    const c = bi();
    (!c || c && n === "fixed") && (i = s.offsetLeft, o = s.offsetTop);
  }
  const u = zr(a);
  if (u <= 0) {
    const c = a.ownerDocument, f = c.body, m = getComputedStyle(f), d = c.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, p = Math.abs(a.clientWidth - f.clientWidth - d);
    p <= Po && (r -= p);
  } else u <= Po && (r += u);
  return {
    width: r,
    height: l,
    x: i,
    y: o
  };
}
const $p = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Cp(e, n) {
  const t = ba(e, !0, n === "fixed"), a = t.top + e.clientTop, s = t.left + e.clientLeft, r = Dn(e) ? Ya(e) : $n(1), l = e.clientWidth * r.x, i = e.clientHeight * r.y, o = s * r.x, u = a * r.y;
  return {
    width: l,
    height: i,
    x: o,
    y: u
  };
}
function Ao(e, n, t) {
  let a;
  if (n === "viewport")
    a = Mp(e, t);
  else if (n === "document")
    a = Tp(_n(e));
  else if (bn(n))
    a = Cp(n, t);
  else {
    const s = Xc(e);
    a = {
      x: n.x - s.x,
      y: n.y - s.y,
      width: n.width,
      height: n.height
    };
  }
  return Sr(a);
}
function Qc(e, n) {
  const t = ta(e);
  return t === n || !bn(t) || Ka(t) ? !1 : wn(t).position === "fixed" || Qc(t, n);
}
function Dp(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let a = _s(e, [], !1).filter((i) => bn(i) && ka(i) !== "body"), s = null;
  const r = wn(e).position === "fixed";
  let l = r ? ta(e) : e;
  for (; bn(l) && !Ka(l); ) {
    const i = wn(l), o = yi(l);
    !o && i.position === "fixed" && (s = null), (r ? !o && !s : !o && i.position === "static" && !!s && $p.has(s.position) || Ns(l) && !o && Qc(e, l)) ? a = a.filter((c) => c !== l) : s = i, l = ta(l);
  }
  return n.set(e, a), a;
}
function Op(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: a,
    strategy: s
  } = e;
  const l = [...t === "clippingAncestors" ? Nr(n) ? [] : Dp(n, this._c) : [].concat(t), a], i = l[0], o = l.reduce((u, c) => {
    const f = Ao(n, c, s);
    return u.top = va(f.top, u.top), u.right = Ga(f.right, u.right), u.bottom = Ga(f.bottom, u.bottom), u.left = va(f.left, u.left), u;
  }, Ao(n, i, s));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function _p(e) {
  const {
    width: n,
    height: t
  } = Zc(e);
  return {
    width: n,
    height: t
  };
}
function Ep(e, n, t) {
  const a = Dn(n), s = _n(n), r = t === "fixed", l = ba(e, !0, r, n);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const o = $n(0);
  function u() {
    o.x = zr(s);
  }
  if (a || !a && !r)
    if ((ka(n) !== "body" || Ns(s)) && (i = Br(n)), a) {
      const d = ba(n, !0, r, n);
      o.x = d.x + n.clientLeft, o.y = d.y + n.clientTop;
    } else s && u();
  r && !a && s && u();
  const c = s && !a && !r ? Jc(s, i) : $n(0), f = l.left + i.scrollLeft - o.x - c.x, m = l.top + i.scrollTop - o.y - c.y;
  return {
    x: f,
    y: m,
    width: l.width,
    height: l.height
  };
}
function hl(e) {
  return wn(e).position === "static";
}
function Ro(e, n) {
  if (!Dn(e) || wn(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let t = e.offsetParent;
  return _n(e) === t && (t = t.ownerDocument.body), t;
}
function ed(e, n) {
  const t = Kt(e);
  if (Nr(e))
    return t;
  if (!Dn(e)) {
    let s = ta(e);
    for (; s && !Ka(s); ) {
      if (bn(s) && !hl(s))
        return s;
      s = ta(s);
    }
    return t;
  }
  let a = Ro(e, n);
  for (; a && hp(a) && hl(a); )
    a = Ro(a, n);
  return a && Ka(a) && hl(a) && !yi(a) ? t : a || yp(e) || t;
}
const Ip = async function(e) {
  const n = this.getOffsetParent || ed, t = this.getDimensions, a = await t(e.floating);
  return {
    reference: Ep(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function Pp(e) {
  return wn(e).direction === "rtl";
}
const Ap = {
  convertOffsetParentRelativeRectToViewportRelativeRect: xp,
  getDocumentElement: _n,
  getClippingRect: Op,
  getOffsetParent: ed,
  getElementRects: Ip,
  getClientRects: Sp,
  getDimensions: _p,
  getScale: Ya,
  isElement: bn,
  isRTL: Pp
};
function td(e, n) {
  return e.x === n.x && e.y === n.y && e.width === n.width && e.height === n.height;
}
function Rp(e, n) {
  let t = null, a;
  const s = _n(e);
  function r() {
    var i;
    clearTimeout(a), (i = t) == null || i.disconnect(), t = null;
  }
  function l(i, o) {
    i === void 0 && (i = !1), o === void 0 && (o = 1), r();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: m,
      height: d
    } = u;
    if (i || n(), !m || !d)
      return;
    const p = ar(f), g = ar(s.clientWidth - (c + m)), k = ar(s.clientHeight - (f + d)), y = ar(c), b = {
      rootMargin: -p + "px " + -g + "px " + -k + "px " + -y + "px",
      threshold: va(0, Ga(1, o)) || 1
    };
    let S = !0;
    function x(C) {
      const $ = C[0].intersectionRatio;
      if ($ !== o) {
        if (!S)
          return l();
        $ ? l(!1, $) : a = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      $ === 1 && !td(u, e.getBoundingClientRect()) && l(), S = !1;
    }
    try {
      t = new IntersectionObserver(x, {
        ...b,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(x, b);
    }
    t.observe(e);
  }
  return l(!0), r;
}
function Fp(e, n, t, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: r = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = a, u = wi(e), c = s || r ? [...u ? _s(u) : [], ..._s(n)] : [];
  c.forEach((y) => {
    s && y.addEventListener("scroll", t, {
      passive: !0
    }), r && y.addEventListener("resize", t);
  });
  const f = u && i ? Rp(u, t) : null;
  let m = -1, d = null;
  l && (d = new ResizeObserver((y) => {
    let [h] = y;
    h && h.target === u && d && (d.unobserve(n), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var b;
      (b = d) == null || b.observe(n);
    })), t();
  }), u && !o && d.observe(u), d.observe(n));
  let p, g = o ? ba(e) : null;
  o && k();
  function k() {
    const y = ba(e);
    g && !td(g, y) && t(), g = y, p = requestAnimationFrame(k);
  }
  return t(), () => {
    var y;
    c.forEach((h) => {
      s && h.removeEventListener("scroll", t), r && h.removeEventListener("resize", t);
    }), f == null || f(), (y = d) == null || y.disconnect(), d = null, o && cancelAnimationFrame(p);
  };
}
const Vp = up, Lp = cp, Np = lp, Bp = rp, zp = (e, n, t) => {
  const a = /* @__PURE__ */ new Map(), s = {
    platform: Ap,
    ...t
  }, r = {
    ...s.platform,
    _c: a
  };
  return sp(e, n, {
    ...s,
    platform: r
  });
};
function Wp(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function ql(e) {
  if (Wp(e)) {
    const n = e.$el;
    return gi(n) && ka(n) === "#comment" ? null : n;
  }
  return e;
}
function Aa(e) {
  return typeof e == "function" ? e() : v(e);
}
function Yp(e) {
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const t = ql(Aa(e.element));
      return t == null ? {} : Bp({
        element: t,
        padding: e.padding
      }).fn(n);
    }
  };
}
function nd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Fo(e, n) {
  const t = nd(e);
  return Math.round(n * t) / t;
}
function Hp(e, n, t) {
  t === void 0 && (t = {});
  const a = t.whileElementsMounted, s = M(() => {
    var $;
    return ($ = Aa(t.open)) != null ? $ : !0;
  }), r = M(() => Aa(t.middleware)), l = M(() => {
    var $;
    return ($ = Aa(t.placement)) != null ? $ : "bottom";
  }), i = M(() => {
    var $;
    return ($ = Aa(t.strategy)) != null ? $ : "absolute";
  }), o = M(() => {
    var $;
    return ($ = Aa(t.transform)) != null ? $ : !0;
  }), u = M(() => ql(e.value)), c = M(() => ql(n.value)), f = ee(0), m = ee(0), d = ee(i.value), p = ee(l.value), g = It({}), k = ee(!1), y = M(() => {
    const $ = {
      position: d.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return $;
    const _ = Fo(c.value, f.value), A = Fo(c.value, m.value);
    return o.value ? {
      ...$,
      transform: "translate(" + _ + "px, " + A + "px)",
      ...nd(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: d.value,
      left: _ + "px",
      top: A + "px"
    };
  });
  let h;
  function b() {
    if (u.value == null || c.value == null)
      return;
    const $ = s.value;
    zp(u.value, c.value, {
      middleware: r.value,
      placement: l.value,
      strategy: i.value
    }).then((_) => {
      f.value = _.x, m.value = _.y, d.value = _.strategy, p.value = _.placement, g.value = _.middlewareData, k.value = $ !== !1;
    });
  }
  function S() {
    typeof h == "function" && (h(), h = void 0);
  }
  function x() {
    if (S(), a === void 0) {
      b();
      return;
    }
    if (u.value != null && c.value != null) {
      h = a(u.value, c.value, b);
      return;
    }
  }
  function C() {
    s.value || (k.value = !1);
  }
  return We([r, l, i, s], b, {
    flush: "sync"
  }), We([u, c], x, {
    flush: "sync"
  }), We(s, C, {
    flush: "sync"
  }), Su() && _r(S), {
    x: $a(f),
    y: $a(m),
    strategy: $a(d),
    placement: $a(p),
    middlewareData: $a(g),
    isPositioned: $a(k),
    floatingStyles: y,
    update: b
  };
}
const ad = 6048e5, Up = 864e5, qp = 6e4, jp = 36e5, Gp = 1e3, Vo = Symbol.for("constructDateFrom");
function ot(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && Vo in e ? e[Vo](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function Le(e, n) {
  return ot(n || e, e);
}
function tn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return isNaN(n) ? ot((t == null ? void 0 : t.in) || e, NaN) : (n && a.setDate(a.getDate() + n), a);
}
function pn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return ot(e, NaN);
  if (!n)
    return a;
  const s = a.getDate(), r = ot(e, a.getTime());
  r.setMonth(a.getMonth() + n + 1, 0);
  const l = r.getDate();
  return s >= l ? r : (a.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    s
  ), a);
}
function sd(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: r = 0,
    days: l = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = Le(e, t == null ? void 0 : t.in), f = s || a ? pn(c, s + a * 12) : c, m = l || r ? tn(f, l + r * 7) : f, d = o + i * 60, g = (u + d * 60) * 1e3;
  return ot(e, +m + g);
}
let Kp = {};
function xa() {
  return Kp;
}
function sn(e, n) {
  var i, o, u, c;
  const t = xa(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Le(e, n == null ? void 0 : n.in), r = s.getDay(), l = (r < a ? 7 : 0) + r - a;
  return s.setDate(s.getDate() - l), s.setHours(0, 0, 0, 0), s;
}
function Za(e, n) {
  return sn(e, { ...n, weekStartsOn: 1 });
}
function rd(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = ot(t, 0);
  s.setFullYear(a + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const r = Za(s), l = ot(t, 0);
  l.setFullYear(a, 0, 4), l.setHours(0, 0, 0, 0);
  const i = Za(l);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
}
function Tr(e) {
  const n = Le(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Bs(e, ...n) {
  const t = ot.bind(
    null,
    n.find((a) => typeof a == "object")
  );
  return n.map(t);
}
function Lo(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function ld(e, n, t) {
  const [a, s] = Bs(
    t == null ? void 0 : t.in,
    e,
    n
  ), r = Lo(a), l = Lo(s), i = +r - Tr(r), o = +l - Tr(l);
  return Math.round((i - o) / Up);
}
function Zp(e, n) {
  const t = rd(e, n), a = ot(e, 0);
  return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), Za(a);
}
function Xp(e, n, t) {
  return pn(e, n * 3, t);
}
function ki(e, n, t) {
  return pn(e, n * 12, t);
}
function No(e, n) {
  const t = +Le(e) - +Le(n);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function id(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ts(e) {
  return !(!id(e) && typeof e != "number" || isNaN(+Le(e)));
}
function Bo(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function Jp(e, n, t) {
  const [a, s] = Bs(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return a.getFullYear() - s.getFullYear();
}
function Qp(e) {
  return (n) => {
    const a = (e ? Math[e] : Math.trunc)(n);
    return a === 0 ? 0 : a;
  };
}
function eg(e, n, t) {
  const [a, s] = Bs(
    t == null ? void 0 : t.in,
    e,
    n
  ), r = No(a, s), l = Math.abs(Jp(a, s));
  a.setFullYear(1584), s.setFullYear(1584);
  const i = No(a, s) === -r, o = r * (l - +i);
  return o === 0 ? 0 : o;
}
function od(e, n) {
  const [t, a] = Bs(e, n.start, n.end);
  return { start: t, end: a };
}
function xi(e, n) {
  const { start: t, end: a } = od(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const r = s ? +t : +a, l = s ? a : t;
  l.setHours(0, 0, 0, 0);
  let i = 1;
  const o = [];
  for (; +l <= r; )
    o.push(ot(t, l)), l.setDate(l.getDate() + i), l.setHours(0, 0, 0, 0);
  return s ? o.reverse() : o;
}
function ha(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function tg(e, n) {
  const { start: t, end: a } = od(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const r = s ? +ha(t) : +ha(a);
  let l = ha(s ? a : t), i = 1;
  const o = [];
  for (; +l <= r; )
    o.push(ot(t, l)), l = Xp(l, i);
  return s ? o.reverse() : o;
}
function ng(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function ud(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Ha(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Si(e, n) {
  var i, o, u, c;
  const t = xa(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Le(e, n == null ? void 0 : n.in), r = s.getDay(), l = (r < a ? -7 : 0) + 6 - (r - a);
  return s.setDate(s.getDate() + l), s.setHours(23, 59, 59, 999), s;
}
function zo(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
const ag = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, sg = (e, n, t) => {
  let a;
  const s = ag[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
function ml(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const rg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, lg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ig = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, og = {
  date: ml({
    formats: rg,
    defaultWidth: "full"
  }),
  time: ml({
    formats: lg,
    defaultWidth: "full"
  }),
  dateTime: ml({
    formats: ig,
    defaultWidth: "full"
  })
}, ug = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, cg = (e, n, t, a) => ug[e];
function hs(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : l;
      s = e.formattingValues[i] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[l];
    }
    const r = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[r];
  };
}
const dg = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, hg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, mg = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, vg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, pg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, gg = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, yg = {
  ordinalNumber: gg,
  era: hs({
    values: dg,
    defaultWidth: "wide"
  }),
  quarter: hs({
    values: fg,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: hs({
    values: hg,
    defaultWidth: "wide"
  }),
  day: hs({
    values: mg,
    defaultWidth: "wide"
  }),
  dayPeriod: hs({
    values: vg,
    defaultWidth: "wide",
    formattingValues: pg,
    defaultFormattingWidth: "wide"
  })
};
function ms(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], r = n.match(s);
    if (!r)
      return null;
    const l = r[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? wg(i, (f) => f.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      bg(i, (f) => f.test(l))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(l.length);
    return { value: u, rest: c };
  };
}
function bg(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function wg(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function kg(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], r = n.match(e.parsePattern);
    if (!r) return null;
    let l = e.valueCallback ? e.valueCallback(r[0]) : r[0];
    l = t.valueCallback ? t.valueCallback(l) : l;
    const i = n.slice(s.length);
    return { value: l, rest: i };
  };
}
const xg = /^(\d+)(th|st|nd|rd)?/i, Sg = /\d+/i, Tg = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Mg = {
  any: [/^b/i, /^(a|c)/i]
}, $g = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Cg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Dg = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Og = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, _g = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Eg = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ig = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Pg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Ag = {
  ordinalNumber: kg({
    matchPattern: xg,
    parsePattern: Sg,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ms({
    matchPatterns: Tg,
    defaultMatchWidth: "wide",
    parsePatterns: Mg,
    defaultParseWidth: "any"
  }),
  quarter: ms({
    matchPatterns: $g,
    defaultMatchWidth: "wide",
    parsePatterns: Cg,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ms({
    matchPatterns: Dg,
    defaultMatchWidth: "wide",
    parsePatterns: Og,
    defaultParseWidth: "any"
  }),
  day: ms({
    matchPatterns: _g,
    defaultMatchWidth: "wide",
    parsePatterns: Eg,
    defaultParseWidth: "any"
  }),
  dayPeriod: ms({
    matchPatterns: Ig,
    defaultMatchWidth: "any",
    parsePatterns: Pg,
    defaultParseWidth: "any"
  })
}, cd = {
  code: "en-US",
  formatDistance: sg,
  formatLong: og,
  formatRelative: cg,
  localize: yg,
  match: Ag,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Rg(e, n) {
  const t = Le(e, n == null ? void 0 : n.in);
  return ld(t, Ha(t)) + 1;
}
function Ti(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = +Za(t) - +Zp(t);
  return Math.round(a / ad) + 1;
}
function Mi(e, n) {
  var c, f, m, d;
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = xa(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((d = (m = s.locale) == null ? void 0 : m.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, l = ot((n == null ? void 0 : n.in) || e, 0);
  l.setFullYear(a + 1, 0, r), l.setHours(0, 0, 0, 0);
  const i = sn(l, n), o = ot((n == null ? void 0 : n.in) || e, 0);
  o.setFullYear(a, 0, r), o.setHours(0, 0, 0, 0);
  const u = sn(o, n);
  return +t >= +i ? a + 1 : +t >= +u ? a : a - 1;
}
function Fg(e, n) {
  var i, o, u, c;
  const t = xa(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = Mi(e, n), r = ot((n == null ? void 0 : n.in) || e, 0);
  return r.setFullYear(s, 0, a), r.setHours(0, 0, 0, 0), sn(r, n);
}
function $i(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = +sn(t, n) - +Fg(t, n);
  return Math.round(a / ad) + 1;
}
function it(e, n) {
  const t = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(n, "0");
  return t + a;
}
const jn = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), a = t > 0 ? t : 1 - t;
    return it(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : it(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return it(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return it(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return it(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return it(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return it(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, a = e.getMilliseconds(), s = Math.trunc(
      a * Math.pow(10, t - 3)
    );
    return it(s, n.length);
  }
}, _a = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Wo = {
  // Era
  G: function(e, n, t) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const a = e.getFullYear(), s = a > 0 ? a : 1 - a;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return jn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, a) {
    const s = Mi(e, a), r = s > 0 ? s : 1 - s;
    if (n === "YY") {
      const l = r % 100;
      return it(l, 2);
    }
    return n === "Yo" ? t.ordinalNumber(r, { unit: "year" }) : it(r, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = rd(e);
    return it(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return it(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return jn.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return it(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, a) {
    const s = $i(e, a);
    return n === "wo" ? t.ordinalNumber(s, { unit: "week" }) : it(s, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const a = Ti(e);
    return n === "Io" ? t.ordinalNumber(a, { unit: "week" }) : it(a, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : jn.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const a = Rg(e);
    return n === "Do" ? t.ordinalNumber(a, { unit: "dayOfYear" }) : it(a, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const a = e.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, a) {
    const s = e.getDay(), r = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(r);
      // Padded numerical value
      case "ee":
        return it(r, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(r, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, a) {
    const s = e.getDay(), r = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(r);
      // Padded numerical value
      case "cc":
        return it(r, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const a = e.getDay(), s = a === 0 ? 7 : a;
    switch (n) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return it(s, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a === 12 ? s = _a.noon : a === 0 ? s = _a.midnight : s = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a >= 17 ? s = _a.evening : a >= 12 ? s = _a.afternoon : a >= 4 ? s = _a.morning : s = _a.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), t.ordinalNumber(a, { unit: "hour" });
    }
    return jn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : jn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const a = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let a = e.getHours();
    return a === 0 && (a = 24), n === "ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : jn.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : jn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return jn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return Ho(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ca(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ca(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return Ho(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ca(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ca(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Yo(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ca(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Yo(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ca(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const a = Math.trunc(+e / 1e3);
    return it(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return it(+e, n.length);
  }
};
function Yo(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = Math.trunc(a / 60), r = a % 60;
  return r === 0 ? t + String(s) : t + String(s) + n + it(r, 2);
}
function Ho(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + it(Math.abs(e) / 60, 2) : ca(e, n);
}
function ca(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = it(Math.trunc(a / 60), 2), r = it(a % 60, 2);
  return t + s + n + r;
}
const Uo = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, dd = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, Vg = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], a = t[1], s = t[2];
  if (!s)
    return Uo(e, n);
  let r;
  switch (a) {
    case "P":
      r = n.dateTime({ width: "short" });
      break;
    case "PP":
      r = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = n.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", Uo(a, n)).replace("{{time}}", dd(s, n));
}, jl = {
  p: dd,
  P: Vg
}, Lg = /^D+$/, Ng = /^Y+$/, Bg = ["D", "DD", "YY", "YYYY"];
function fd(e) {
  return Lg.test(e);
}
function hd(e) {
  return Ng.test(e);
}
function Gl(e, n, t) {
  const a = zg(e, n, t);
  if (console.warn(a), Bg.includes(e)) throw new RangeError(a);
}
function zg(e, n, t) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${a} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Wg = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Yg = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Hg = /^'([^]*?)'?$/, Ug = /''/g, qg = /[a-zA-Z]/;
function en(e, n, t) {
  var c, f, m, d, p, g, k, y;
  const a = xa(), s = (t == null ? void 0 : t.locale) ?? a.locale ?? cd, r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((d = (m = a.locale) == null ? void 0 : m.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, l = (t == null ? void 0 : t.weekStartsOn) ?? ((g = (p = t == null ? void 0 : t.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? a.weekStartsOn ?? ((y = (k = a.locale) == null ? void 0 : k.options) == null ? void 0 : y.weekStartsOn) ?? 0, i = Le(e, t == null ? void 0 : t.in);
  if (!Ts(i))
    throw new RangeError("Invalid time value");
  let o = n.match(Yg).map((h) => {
    const b = h[0];
    if (b === "p" || b === "P") {
      const S = jl[b];
      return S(h, s.formatLong);
    }
    return h;
  }).join("").match(Wg).map((h) => {
    if (h === "''")
      return { isToken: !1, value: "'" };
    const b = h[0];
    if (b === "'")
      return { isToken: !1, value: jg(h) };
    if (Wo[b])
      return { isToken: !0, value: h };
    if (b.match(qg))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: h };
  });
  s.localize.preprocessor && (o = s.localize.preprocessor(i, o));
  const u = {
    firstWeekContainsDate: r,
    weekStartsOn: l,
    locale: s
  };
  return o.map((h) => {
    if (!h.isToken) return h.value;
    const b = h.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && hd(b) || !(t != null && t.useAdditionalDayOfYearTokens) && fd(b)) && Gl(b, n, String(e));
    const S = Wo[b[0]];
    return S(i, b, s.localize, u);
  }).join("");
}
function jg(e) {
  const n = e.match(Hg);
  return n ? n[1].replace(Ug, "'") : e;
}
function Gg(e, n) {
  return Le(e, n == null ? void 0 : n.in).getDay();
}
function Kg(e, n) {
  const t = Le(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = t.getMonth(), r = ot(t, 0);
  return r.setFullYear(a, s + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function Zg() {
  return Object.assign({}, xa());
}
function On(e, n) {
  return Le(e, n == null ? void 0 : n.in).getHours();
}
function Xg(e, n) {
  const t = Le(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function Bn(e, n) {
  return Le(e, n == null ? void 0 : n.in).getMinutes();
}
function Ke(e, n) {
  return Le(e, n == null ? void 0 : n.in).getMonth();
}
function na(e) {
  return Le(e).getSeconds();
}
function Be(e, n) {
  return Le(e, n == null ? void 0 : n.in).getFullYear();
}
function Tn(e, n) {
  return +Le(e) > +Le(n);
}
function Vn(e, n) {
  return +Le(e) < +Le(n);
}
function Fa(e, n) {
  return +Le(e) == +Le(n);
}
function Jg(e, n) {
  const t = Qg(n) ? new n(0) : ot(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function Qg(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const ey = 10;
class md {
  constructor() {
    xe(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class ty extends md {
  constructor(n, t, a, s, r) {
    super(), this.value = n, this.validateValue = t, this.setValue = a, this.priority = s, r && (this.subPriority = r);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, a) {
    return this.setValue(n, t, this.value, a);
  }
}
class ny extends md {
  constructor(t, a) {
    super();
    xe(this, "priority", ey);
    xe(this, "subPriority", -1);
    this.context = t || ((s) => ot(a, s));
  }
  set(t, a) {
    return a.timestampIsSet ? t : ot(t, Jg(t, this.context));
  }
}
class nt {
  run(n, t, a, s) {
    const r = this.parse(n, t, a, s);
    return r ? {
      setter: new ty(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(n, t, a) {
    return !0;
  }
}
class ay extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 140);
    xe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, a, s) {
    return a.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const wt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, xn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function kt(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function mt(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Sn(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const a = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, r = t[3] ? parseInt(t[3], 10) : 0, l = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (s * jp + r * qp + l * Gp),
    rest: n.slice(t[0].length)
  };
}
function vd(e) {
  return mt(wt.anyDigitsSigned, e);
}
function gt(e, n) {
  switch (e) {
    case 1:
      return mt(wt.singleDigit, n);
    case 2:
      return mt(wt.twoDigits, n);
    case 3:
      return mt(wt.threeDigits, n);
    case 4:
      return mt(wt.fourDigits, n);
    default:
      return mt(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function Mr(e, n) {
  switch (e) {
    case 1:
      return mt(wt.singleDigitSigned, n);
    case 2:
      return mt(wt.twoDigitsSigned, n);
    case 3:
      return mt(wt.threeDigitsSigned, n);
    case 4:
      return mt(wt.fourDigitsSigned, n);
    default:
      return mt(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Ci(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function pd(e, n) {
  const t = n > 0, a = t ? n : 1 - n;
  let s;
  if (a <= 50)
    s = e || 100;
  else {
    const r = a + 50, l = Math.trunc(r / 100) * 100, i = e >= r % 100;
    s = e + l - (i ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function gd(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class sy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    const r = (l) => ({
      year: l,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return kt(gt(4, t), r);
      case "yo":
        return kt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          r
        );
      default:
        return kt(gt(a.length, t), r);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s) {
    const r = t.getFullYear();
    if (s.isTwoDigitYear) {
      const i = pd(
        s.year,
        r
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const l = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(l, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ry extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const r = (l) => ({
      year: l,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return kt(gt(4, t), r);
      case "Yo":
        return kt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          r
        );
      default:
        return kt(gt(a.length, t), r);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s, r) {
    const l = Mi(t, r);
    if (s.isTwoDigitYear) {
      const o = pd(
        s.year,
        l
      );
      return t.setFullYear(
        o,
        0,
        r.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), sn(t, r);
    }
    const i = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(i, 0, r.firstWeekContainsDate), t.setHours(0, 0, 0, 0), sn(t, r);
  }
}
class ly extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a) {
    return Mr(a === "R" ? 4 : a.length, t);
  }
  set(t, a, s) {
    const r = ot(t, 0);
    return r.setFullYear(s, 0, 4), r.setHours(0, 0, 0, 0), Za(r);
  }
}
class iy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a) {
    return Mr(a === "u" ? 4 : a.length, t);
  }
  set(t, a, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class oy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 120);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return gt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class uy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 120);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return gt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class cy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    xe(this, "priority", 110);
  }
  parse(t, a, s) {
    const r = (l) => l - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "M":
        return kt(
          mt(wt.month, t),
          r
        );
      // 01, 02, ..., 12
      case "MM":
        return kt(gt(2, t), r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return kt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class dy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 110);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const r = (l) => l - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return kt(
          mt(wt.month, t),
          r
        );
      // 01, 02, ..., 12
      case "LL":
        return kt(gt(2, t), r);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return kt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function fy(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = $i(a, t) - n;
  return a.setDate(a.getDate() - s * 7), Le(a, t == null ? void 0 : t.in);
}
class hy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 100);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "w":
        return mt(wt.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s, r) {
    return sn(fy(t, s, r), r);
  }
}
function my(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = Ti(a, t) - n;
  return a.setDate(a.getDate() - s * 7), a;
}
class vy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 100);
    xe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "I":
        return mt(wt.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s) {
    return Za(my(t, s));
  }
}
const py = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], gy = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class yy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "subPriority", 1);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "d":
        return mt(wt.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear(), r = gd(s), l = t.getMonth();
    return r ? a >= 1 && a <= gy[l] : a >= 1 && a <= py[l];
  }
  set(t, a, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class by extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "subpriority", 1);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "D":
      case "DD":
        return mt(wt.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear();
    return gd(s) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(t, a, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function Di(e, n, t) {
  var f, m, d, p;
  const a = xa(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : m.weekStartsOn) ?? a.weekStartsOn ?? ((p = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? 0, r = Le(e, t == null ? void 0 : t.in), l = r.getDay(), o = (n % 7 + 7) % 7, u = 7 - s, c = n < 0 || n > 6 ? n - (l + u) % 7 : (o + u) % 7 - (l + u) % 7;
  return tn(r, c, t);
}
class wy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, r) {
    return t = Di(t, s, r), t.setHours(0, 0, 0, 0), t;
  }
}
class ky extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, r) {
    const l = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + r.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "e":
      case "ee":
        return kt(gt(a.length, t), l);
      // 3rd
      case "eo":
        return kt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, r) {
    return t = Di(t, s, r), t.setHours(0, 0, 0, 0), t;
  }
}
class xy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, r) {
    const l = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + r.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "c":
      case "cc":
        return kt(gt(a.length, t), l);
      // 3rd
      case "co":
        return kt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, r) {
    return t = Di(t, s, r), t.setHours(0, 0, 0, 0), t;
  }
}
function Sy(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = Xg(a, t), r = n - s;
  return tn(a, r, t);
}
class Ty extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const r = (l) => l === 0 ? 7 : l;
    switch (a) {
      // 2
      case "i":
      case "ii":
        return gt(a.length, t);
      // 2nd
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return kt(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // T
      case "iiiii":
        return kt(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tu
      case "iiiiii":
        return kt(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tuesday
      case "iiii":
      default:
        return kt(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 7;
  }
  set(t, a, s) {
    return t = Sy(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class My extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Ci(s), 0, 0, 0), t;
  }
}
class $y extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Ci(s), 0, 0, 0), t;
  }
}
class Cy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Ci(s), 0, 0, 0), t;
  }
}
class Dy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "h":
        return mt(wt.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 12;
  }
  set(t, a, s) {
    const r = t.getHours() >= 12;
    return r && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !r && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Oy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "H":
        return mt(wt.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 23;
  }
  set(t, a, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class _y extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "K":
        return mt(wt.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Ey extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "k":
        return mt(wt.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 24;
  }
  set(t, a, s) {
    const r = s <= 24 ? s % 24 : s;
    return t.setHours(r, 0, 0, 0), t;
  }
}
class Iy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 60);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "m":
        return mt(wt.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class Py extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 50);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "s":
        return mt(wt.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return gt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setSeconds(s, 0), t;
  }
}
class Ay extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 30);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a) {
    const s = (r) => Math.trunc(r * Math.pow(10, -a.length + 3));
    return kt(gt(a.length, t), s);
  }
  set(t, a, s) {
    return t.setMilliseconds(s), t;
  }
}
class Ry extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 10);
    xe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, a) {
    switch (a) {
      case "X":
        return Sn(
          xn.basicOptionalMinutes,
          t
        );
      case "XX":
        return Sn(xn.basic, t);
      case "XXXX":
        return Sn(
          xn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Sn(
          xn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Sn(xn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - Tr(t) - s
    );
  }
}
class Fy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 10);
    xe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, a) {
    switch (a) {
      case "x":
        return Sn(
          xn.basicOptionalMinutes,
          t
        );
      case "xx":
        return Sn(xn.basic, t);
      case "xxxx":
        return Sn(
          xn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Sn(
          xn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Sn(xn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - Tr(t) - s
    );
  }
}
class Vy extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 40);
    xe(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return vd(t);
  }
  set(t, a, s) {
    return [ot(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class Ly extends nt {
  constructor() {
    super(...arguments);
    xe(this, "priority", 20);
    xe(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return vd(t);
  }
  set(t, a, s) {
    return [ot(t, s), { timestampIsSet: !0 }];
  }
}
const Ny = {
  G: new ay(),
  y: new sy(),
  Y: new ry(),
  R: new ly(),
  u: new iy(),
  Q: new oy(),
  q: new uy(),
  M: new cy(),
  L: new dy(),
  w: new hy(),
  I: new vy(),
  d: new yy(),
  D: new by(),
  E: new wy(),
  e: new ky(),
  c: new xy(),
  i: new Ty(),
  a: new My(),
  b: new $y(),
  B: new Cy(),
  h: new Dy(),
  H: new Oy(),
  K: new _y(),
  k: new Ey(),
  m: new Iy(),
  s: new Py(),
  S: new Ay(),
  X: new Ry(),
  x: new Fy(),
  t: new Vy(),
  T: new Ly()
}, By = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, zy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Wy = /^'([^]*?)'?$/, Yy = /''/g, Hy = /\S/, Uy = /[a-zA-Z]/;
function Kl(e, n, t, a) {
  var k, y, h, b, S, x, C, $;
  const s = () => ot((a == null ? void 0 : a.in) || t, NaN), r = Zg(), l = (a == null ? void 0 : a.locale) ?? r.locale ?? cd, i = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((y = (k = a == null ? void 0 : a.locale) == null ? void 0 : k.options) == null ? void 0 : y.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((b = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? ((x = (S = a == null ? void 0 : a.locale) == null ? void 0 : S.options) == null ? void 0 : x.weekStartsOn) ?? r.weekStartsOn ?? (($ = (C = r.locale) == null ? void 0 : C.options) == null ? void 0 : $.weekStartsOn) ?? 0;
  if (!n)
    return e ? s() : Le(t, a == null ? void 0 : a.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: l
  }, c = [new ny(a == null ? void 0 : a.in, t)], f = n.match(zy).map((_) => {
    const A = _[0];
    if (A in jl) {
      const D = jl[A];
      return D(_, l.formatLong);
    }
    return _;
  }).join("").match(By), m = [];
  for (let _ of f) {
    !(a != null && a.useAdditionalWeekYearTokens) && hd(_) && Gl(_, n, e), !(a != null && a.useAdditionalDayOfYearTokens) && fd(_) && Gl(_, n, e);
    const A = _[0], D = Ny[A];
    if (D) {
      const { incompatibleTokens: Y } = D;
      if (Array.isArray(Y)) {
        const Z = m.find(
          (se) => Y.includes(se.token) || se.token === A
        );
        if (Z)
          throw new RangeError(
            `The format string mustn't contain \`${Z.fullToken}\` and \`${_}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && m.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${_}\` and any other token at the same time`
        );
      m.push({ token: A, fullToken: _ });
      const L = D.run(
        e,
        _,
        l.match,
        u
      );
      if (!L)
        return s();
      c.push(L.setter), e = L.rest;
    } else {
      if (A.match(Uy))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + A + "`"
        );
      if (_ === "''" ? _ = "'" : A === "'" && (_ = qy(_)), e.indexOf(_) === 0)
        e = e.slice(_.length);
      else
        return s();
    }
  }
  if (e.length > 0 && Hy.test(e))
    return s();
  const d = c.map((_) => _.priority).sort((_, A) => A - _).filter((_, A, D) => D.indexOf(_) === A).map(
    (_) => c.filter((A) => A.priority === _).sort((A, D) => D.subPriority - A.subPriority)
  ).map((_) => _[0]);
  let p = Le(t, a == null ? void 0 : a.in);
  if (isNaN(+p)) return s();
  const g = {};
  for (const _ of d) {
    if (!_.validate(p, u))
      return s();
    const A = _.set(p, g, u);
    Array.isArray(A) ? (p = A[0], Object.assign(g, A[1])) : p = A;
  }
  return p;
}
function qy(e) {
  return e.match(Wy)[1].replace(Yy, "'");
}
function qo(e, n, t) {
  const [a, s] = Bs(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +ha(a) == +ha(s);
}
function yd(e, n, t) {
  return tn(e, -n, t);
}
function jy(e, n) {
  const t = (n == null ? void 0 : n.nearestTo) ?? 1;
  if (t < 1 || t > 30) return ot(e, NaN);
  const a = Le(e, n == null ? void 0 : n.in), s = a.getSeconds() / 60, r = a.getMilliseconds() / 1e3 / 60, l = a.getMinutes() + s + r, i = (n == null ? void 0 : n.roundingMethod) ?? "round", u = Qp(i)(l / t) * t;
  return a.setMinutes(u, 0, 0), a;
}
function bd(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in), s = a.getFullYear(), r = a.getDate(), l = ot(e, 0);
  l.setFullYear(s, n, 15), l.setHours(0, 0, 0, 0);
  const i = Kg(l);
  return a.setMonth(n, Math.min(r, i)), a;
}
function qe(e, n, t) {
  let a = Le(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (n.year != null && a.setFullYear(n.year), n.month != null && (a = bd(a, n.month)), n.date != null && a.setDate(n.date), n.hours != null && a.setHours(n.hours), n.minutes != null && a.setMinutes(n.minutes), n.seconds != null && a.setSeconds(n.seconds), n.milliseconds != null && a.setMilliseconds(n.milliseconds), a);
}
function Gy(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return a.setMilliseconds(n), a;
}
function Ky(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return a.setSeconds(n), a;
}
function hn(e, n, t) {
  const a = Le(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (a.setFullYear(n), a);
}
function Xa(e, n, t) {
  return pn(e, -n, t);
}
function Zy(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: r = 0,
    days: l = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = Xa(e, s + a * 12, t), f = yd(c, l + r * 7, t), m = o + i * 60, p = (u + m * 60) * 1e3;
  return ot(e, +f - p);
}
function wd(e, n, t) {
  return ki(e, -n, t);
}
function Xy(e, n, t = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: t
  }).format(n).split(/\s/g).slice(2).join(" ");
}
const vl = {}, xs = {};
function ma(e, n) {
  try {
    const a = (vl[e] || (vl[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(n).split("GMT")[1];
    return a in xs ? xs[a] : jo(a, a.split(":"));
  } catch {
    if (e in xs) return xs[e];
    const t = e == null ? void 0 : e.match(Jy);
    return t ? jo(e, t.slice(1)) : NaN;
  }
}
const Jy = /([+-]\d\d):?(\d\d)?/;
function jo(e, n) {
  const t = +(n[0] || 0), a = +(n[1] || 0), s = +(n[2] || 0) / 60;
  return xs[e] = t * 60 + a > 0 ? t * 60 + a + s : t * 60 - a - s;
}
class Mn extends Date {
  //#region static
  constructor(...n) {
    super(), n.length > 1 && typeof n[n.length - 1] == "string" && (this.timeZone = n.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(ma(this.timeZone, this)) ? this.setTime(NaN) : n.length ? typeof n[0] == "number" && (n.length === 1 || n.length === 2 && typeof n[1] != "number") ? this.setTime(n[0]) : typeof n[0] == "string" ? this.setTime(+new Date(n[0])) : n[0] instanceof Date ? this.setTime(+n[0]) : (this.setTime(+new Date(...n)), kd(this), Zl(this)) : this.setTime(Date.now());
  }
  static tz(n, ...t) {
    return t.length ? new Mn(...t, n) : new Mn(Date.now(), n);
  }
  //#endregion
  //#region time zone
  withTimeZone(n) {
    return new Mn(+this, n);
  }
  getTimezoneOffset() {
    const n = -ma(this.timeZone, this);
    return n > 0 ? Math.floor(n) : Math.ceil(n);
  }
  //#endregion
  //#region time
  setTime(n) {
    return Date.prototype.setTime.apply(this, arguments), Zl(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Mn(+new Date(n), this.timeZone);
  }
  //#endregion
}
const Go = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Go.test(e)) return;
  const n = e.replace(Go, "$1UTC");
  Mn.prototype[n] && (e.startsWith("get") ? Mn.prototype[e] = function() {
    return this.internal[n]();
  } : (Mn.prototype[e] = function() {
    return Date.prototype[n].apply(this.internal, arguments), Qy(this), +this;
  }, Mn.prototype[n] = function() {
    return Date.prototype[n].apply(this, arguments), Zl(this), +this;
  }));
});
function Zl(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-ma(e.timeZone, e) * 60));
}
function Qy(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), kd(e);
}
function kd(e) {
  const n = ma(e.timeZone, e), t = n > 0 ? Math.floor(n) : Math.ceil(n), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const s = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), r = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), l = s - r, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  l && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + l);
  const o = s - t;
  o && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + o);
  const u = /* @__PURE__ */ new Date(+e);
  u.setUTCSeconds(0);
  const c = s > 0 ? u.getSeconds() : (u.getSeconds() - 60) % 60, f = Math.round(-(ma(e.timeZone, e) * 60)) % 60;
  (f || c) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + f), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + f + c));
  const m = ma(e.timeZone, e), d = m > 0 ? Math.floor(m) : Math.ceil(m), g = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - d, k = d !== t, y = g - o;
  if (k && y) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y);
    const h = ma(e.timeZone, e), b = h > 0 ? Math.floor(h) : Math.ceil(h), S = d - b;
    S && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + S), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + S));
  }
}
class Va extends Mn {
  //#region static
  static tz(n, ...t) {
    return t.length ? new Va(...t, n) : new Va(Date.now(), n);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [n, t, a] = this.tzComponents(), s = `${n}${t}:${a}`;
    return this.internal.toISOString().slice(0, -1) + s;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [n, t, a, s] = this.internal.toUTCString().split(" ");
    return `${n == null ? void 0 : n.slice(0, -1)} ${a} ${t} ${s}`;
  }
  toTimeString() {
    const n = this.internal.toUTCString().split(" ")[4], [t, a, s] = this.tzComponents();
    return `${n} GMT${t}${a}${s} (${Xy(this.timeZone, this)})`;
  }
  toLocaleString(n, t) {
    return Date.prototype.toLocaleString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(n, t) {
    return Date.prototype.toLocaleDateString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(n, t) {
    return Date.prototype.toLocaleTimeString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const n = this.getTimezoneOffset(), t = n > 0 ? "-" : "+", a = String(Math.floor(Math.abs(n) / 60)).padStart(2, "0"), s = String(Math.abs(n) % 60).padStart(2, "0");
    return [t, a, s];
  }
  //#endregion
  withTimeZone(n) {
    return new Va(+this, n);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Va(+new Date(n), this.timeZone);
  }
  //#endregion
}
function zs() {
  return bt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      bt("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      bt("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      bt("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      bt("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function eb() {
  return bt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      bt("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      bt("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function xd() {
  return bt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      bt("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Sd() {
  return bt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      bt("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function Td() {
  return bt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      bt("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      bt("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function Md() {
  return bt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      bt("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function $d() {
  return bt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      bt("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const Cd = Symbol("ContextKey"), tb = (e, n) => {
  const { setTimeModelValue: t } = Ot(), a = Gb(e), s = ee(null), r = ga({
    menuFocused: !1,
    shiftKeyInMenu: !1,
    isInputFocused: !1,
    isTextInputDate: !1,
    arrowNavigationLevel: 0
  }), l = a.getDate(/* @__PURE__ */ new Date()), i = ee(""), o = ee([{ month: Ke(l), year: Be(l) }]), u = ga({ hours: 0, minutes: 0, seconds: 0 });
  t(u, null, l, a.range.value.enabled);
  const c = M({
    get: () => s.value,
    set: (g) => {
      s.value = g;
    }
  }), f = M(
    () => (g) => o.value[g] ? o.value[g].month : 0
  ), m = M(
    () => (g) => o.value[g] ? o.value[g].year : 0
  ), d = (g, k) => {
    r[g] = k;
  }, p = () => {
    t(u, c.value, l, a.range.value.enabled);
  };
  Na(Cd, {
    rootProps: e,
    defaults: a,
    modelValue: c,
    state: ei(r),
    rootEmit: n,
    calendars: o,
    month: f,
    year: m,
    time: u,
    today: l,
    inputValue: i,
    setState: d,
    updateTime: p,
    getDate: a.getDate
  });
}, Ge = () => {
  const e = ea(Cd);
  if (!e)
    throw new Error("Can't use context");
  return e;
};
var dn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(dn || {}), pa = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(pa || {}), Nt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Nt || {});
const nb = ["timestamp", "date", "iso"];
var fn = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(fn || {}), ct = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(ct || {}), La = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(La || {}), Dd = /* @__PURE__ */ ((e) => (e[e.Sunday = 0] = "Sunday", e[e.Monday = 1] = "Monday", e[e.Tuesday = 2] = "Tuesday", e[e.Wednesday = 3] = "Wednesday", e[e.Thursday = 4] = "Thursday", e[e.Friday = 5] = "Friday", e[e.Saturday = 6] = "Saturday", e))(Dd || {});
const ab = () => {
  const { rootProps: e, state: n } = Ge(), t = M(() => n.arrowNavigationLevel), a = ee(-1), s = ee(-1);
  We(t, (h, b) => {
    y(h === 0 && b > 0);
  });
  const r = ee([]), l = ee(/* @__PURE__ */ new Map()), i = () => {
    const h = Array.from(
      document.querySelectorAll(`[data-dp-action-element="${t.value}"]`)
    ), b = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map();
    for (const x of h) {
      const C = x.getBoundingClientRect(), $ = C.top, _ = C.left;
      b.has($) || b.set($, []), b.get($).push(x), S.set(x, { row: $, col: _ });
    }
    r.value = Array.from(b.entries()).sort((x, C) => x[0] - C[0]).map(([x, C]) => o(C, S)), l.value = S;
  }, o = (h, b) => h.sort((S, x) => {
    const C = b.get(S), $ = b.get(x);
    return C.col - $.col;
  }), u = (h, b) => {
    t.value === 0 && (a.value = h, s.value = b);
  }, c = (h) => {
    if (![ct.arrowUp, ct.arrowDown, ct.arrowLeft, ct.arrowRight].includes(h.key))
      return;
    i(), h.preventDefault();
    const b = document.activeElement;
    if (!(b != null && b.hasAttribute("data-dp-action-element")))
      return;
    let S = -1, x = -1;
    for (let C = 0; C < r.value.length; C++) {
      const $ = r.value[C].indexOf(b);
      if ($ !== -1) {
        S = C, x = $;
        break;
      }
    }
    if (S !== -1)
      switch (h.key) {
        case ct.arrowLeft:
          return f(S, x);
        case ct.arrowRight:
          return m(S, x);
        case ct.arrowUp:
          return d(S, x);
        case ct.arrowDown:
          return p(S, x);
        default:
          return;
      }
  }, f = (h, b) => {
    if (b > 0) {
      const S = r.value[h][b - 1];
      u(h, b - 1), S && S.focus();
    }
  }, m = (h, b) => {
    if (b < r.value[h].length - 1) {
      const S = r.value[h][b + 1];
      u(h, b + 1), S && S.focus();
    }
  }, d = (h, b) => {
    if (h > 0) {
      const S = r.value[h - 1], x = Math.min(b, S.length - 1), C = S[x];
      u(h - 1, x), C && C.focus();
    }
  }, p = (h, b) => {
    if (h < r.value.length - 1) {
      const S = r.value[h + 1], x = Math.min(b, S.length - 1), C = S[x];
      u(h + 1, x), C && C.focus();
    }
  }, g = () => {
    Ze().then(() => {
      var b;
      i();
      const h = (b = r.value[a.value]) == null ? void 0 : b[s.value];
      h && k(h);
    });
  }, k = (h) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        h.focus({ preventScroll: !0 });
      });
    });
  }, y = (h) => {
    if (h)
      return g();
    const b = document.querySelector(`[data-dp-element-active="${t.value}"]`);
    if (b && !h)
      k(b);
    else {
      const S = document.querySelector(`[data-dp-action-element="${t.value}"]`);
      S && k(S);
    }
  };
  et(() => {
    e.arrowNavigation && (y(!1), document.addEventListener("keydown", c));
  }), rn(() => {
    e.arrowNavigation && document.removeEventListener("keydown", c);
  });
}, sb = () => {
  const { checkPartialRangeValue: e, checkRangeEnabled: n, isValidDate: t } = ln(), { convertType: a, errorMapper: s } = Ot(), {
    getDate: r,
    rootEmit: l,
    state: i,
    rootProps: o,
    inputValue: u,
    defaults: { textInput: c, range: f, multiDates: m, timeConfig: d, formats: p },
    modelValue: g,
    updateTime: k
  } = Ge(), { setTime: y, getWeekFromDate: h } = Vt(), { formatSelectedDate: b, formatForTextInput: S } = aa();
  We(
    g,
    (F, j) => {
      l("internal-model-change", g.value), JSON.stringify(j ?? {}) !== JSON.stringify(F ?? {}) && k();
    },
    { deep: !0 }
  ), We(f, (F, j) => {
    F.enabled !== j.enabled && (g.value = null);
  }), We(
    () => p.value.input,
    () => {
      he();
    }
  );
  const x = (F) => F ? o.modelType ? ge(F) : {
    hours: On(F),
    minutes: Bn(F),
    seconds: d.value.enableSeconds ? na(F) : 0
  } : null, C = (F) => o.modelType ? ge(F) : { month: Ke(F), year: Be(F) }, $ = (F) => Array.isArray(F) ? m.value.enabled ? F.map((j) => _(j, hn(r(), j))) : n(
    () => [
      hn(r(), F[0]),
      F[1] ? hn(r(), F[1]) : e(f.value.partialRange)
    ],
    f.value.enabled
  ) : hn(r(), +F), _ = (F, j) => (typeof F == "string" || typeof F == "number") && o.modelType ? pe(F) : j, A = (F) => Array.isArray(F) ? [
    _(F[0], y(F[0])),
    _(F[1], y(F[1]))
  ] : _(F, y(F)), D = (F) => {
    const j = qe(r(), { date: 1 });
    return Array.isArray(F) ? m.value.enabled ? F.map(
      (H) => _(H, qe(j, { month: +H.month, year: +H.year }))
    ) : n(
      () => [
        _(F[0], qe(j, { month: +F[0].month, year: +F[0].year })),
        _(
          F[1],
          F[1] ? qe(j, { month: +F[1].month, year: +F[1].year }) : e(f.value.partialRange)
        )
      ],
      f.value.enabled
    ) : _(F, qe(j, { month: +F.month, year: +F.year }));
  }, Y = (F) => {
    if (Array.isArray(F))
      return F.map((j) => pe(j));
    throw new Error(s.dateArr("multi-dates"));
  }, L = (F) => {
    if (Array.isArray(F) && f.value.enabled) {
      const j = F[0], H = F[1];
      return [
        r(Array.isArray(j) ? j[0] : null),
        Array.isArray(H) && H.length ? r(H[0]) : null
      ];
    }
    return r(F[0]);
  }, Z = (F) => o.modelAuto ? Array.isArray(F) ? [pe(F[0]), pe(F[1])] : o.autoApply ? [pe(F)] : [pe(F), null] : Array.isArray(F) ? n(
    () => F[1] ? [
      pe(F[0]),
      F[1] ? pe(F[1]) : e(f.value.partialRange)
    ] : [pe(F[0])],
    f.value.enabled
  ) : pe(F), se = () => {
    Array.isArray(g.value) && f.value.enabled && g.value.length === 1 && g.value.push(e(f.value.partialRange));
  }, ie = () => {
    const F = g.value;
    return [
      ge(F[0]),
      F[1] ? ge(F[1]) : e(f.value.partialRange)
    ];
  }, ce = () => Array.isArray(g.value) ? g.value[1] ? ie() : ge(a(g.value[0])) : [], G = () => (g.value || []).map((F) => ge(F)), le = (F = !1) => (F || se(), o.modelAuto ? ce() : m.value.enabled ? G() : Array.isArray(g.value) ? n(() => ie(), f.value.enabled) : ge(a(g.value))), q = (F) => !F || Array.isArray(F) && !F.length ? null : o.timePicker ? A(a(F)) : o.monthPicker ? D(a(F)) : o.yearPicker ? $(a(F)) : m.value.enabled ? Y(a(F)) : o.weekPicker ? L(a(F)) : Z(a(F)), N = (F) => {
    if (i.isTextInputDate) return;
    const j = q(F);
    t(a(j)) ? (g.value = a(j), he()) : (g.value = null, u.value = "");
  }, Q = () => g.value ? m.value.enabled ? g.value.map((F) => b(F)).join("; ") : c.value.enabled ? S() : b(g.value) : "", he = () => {
    u.value = Q();
  }, pe = (F) => o.modelType ? nb.includes(o.modelType) ? r(F) : o.modelType === "format" && typeof p.value.input == "string" ? Kl(F, p.value.input, r(), { locale: o.locale }) : Kl(F, o.modelType, r(), { locale: o.locale }) : r(F), ge = (F) => F ? o.modelType ? o.modelType === "timestamp" ? +F : o.modelType === "iso" ? F.toISOString() : o.modelType === "format" && typeof p.value.input == "string" ? b(F) : b(F, o.modelType) : F : null, Ce = (F) => {
    l("update:model-value", F);
  }, ye = (F) => Array.isArray(g.value) ? m.value.enabled ? g.value.map((j) => F(j)) : [F(g.value[0]), g.value[1] ? F(g.value[1]) : null] : F(a(g.value)), K = () => {
    if (Array.isArray(g.value)) {
      const F = h(g.value[0], o.weekStart), j = g.value[1] ? h(g.value[1], o.weekStart) : [];
      return [F.map((H) => r(H)), j.map((H) => r(H))];
    }
    return h(g.value, o.weekStart).map((F) => r(F));
  }, be = (F) => Ce(a(ye(F))), Me = () => l("update:model-value", K());
  return {
    checkBeforeEmit: () => g.value ? f.value.enabled ? f.value.partialRange ? g.value.length >= 1 : g.value.length === 2 : !!g.value : !1,
    parseExternalModelValue: N,
    formatInputValue: he,
    emitModelValue: () => (he(), o.monthPicker ? be(C) : o.timePicker ? be(x) : o.yearPicker ? be(Be) : o.weekPicker ? Me() : Ce(le()))
  };
}, Ws = () => {
  const {
    defaults: { transitions: e }
  } = Ge(), n = M(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), t = M(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: n, showTransition: !!e.value, menuTransition: t };
}, Ys = (e) => {
  const {
    today: n,
    time: t,
    modelValue: a,
    defaults: { range: s }
  } = Ge(), { setTimeModelValue: r } = Ot();
  We(
    s,
    (l, i) => {
      l.enabled !== i.enabled && r(t, a.value, n, s.value.enabled);
    },
    { deep: !0 }
  ), We(
    a,
    (l, i) => {
      e && JSON.stringify(l ?? {}) !== JSON.stringify(i ?? {}) && e();
    },
    { deep: !0 }
  );
}, ln = () => {
  const {
    defaults: { safeDates: e, range: n, multiDates: t, filters: a, timeConfig: s },
    rootProps: r,
    getDate: l
  } = Ge(), { getMapKeyType: i, getMapDate: o, errorMapper: u, convertType: c } = Ot(), { isDateBefore: f, isDateAfter: m, isDateEqual: d, resetDate: p, getDaysInBetween: g, setTimeValue: k, getTimeObj: y, setTime: h } = Vt(), b = (I) => e.value.disabledDates ? typeof e.value.disabledDates == "function" ? e.value.disabledDates(l(I)) : !!o(I, e.value.disabledDates) : !1, S = (I) => e.value.maxDate ? r.yearPicker ? Be(I) > Be(e.value.maxDate) : m(I, e.value.maxDate) : !1, x = (I) => e.value.minDate ? r.yearPicker ? Be(I) < Be(e.value.minDate) : f(I, e.value.minDate) : !1, C = (I) => {
    var W;
    if (!I) return !1;
    const B = S(I), X = x(I), R = b(I), te = a.value.months.map((me) => +me).includes(Ke(I)), O = (W = a.value.weekDays) != null && W.length ? a.value.weekDays.some((me) => +me === Gg(I)) : !1, z = Y(I), V = Be(I), re = V < +r.yearRange[0] || V > +r.yearRange[1];
    return !(B || X || R || te || re || O || z);
  }, $ = (I, B) => f(...Me(e.value.minDate, I, B)) || d(...Me(e.value.minDate, I, B)), _ = (I, B) => m(...Me(e.value.maxDate, I, B)) || d(...Me(e.value.maxDate, I, B)), A = (I, B, X) => {
    let R = !1;
    return e.value.maxDate && X && _(I, B) && (R = !0), e.value.minDate && !X && $(I, B) && (R = !0), R;
  }, D = (I, B, X, R) => {
    let te = !1;
    return R && (e.value.minDate || e.value.maxDate) ? e.value.minDate && e.value.maxDate ? te = A(I, B, X) : (e.value.minDate && $(I, B) || e.value.maxDate && _(I, B)) && (te = !0) : te = !0, te;
  }, Y = (I) => Array.isArray(e.value.allowedDates) && !e.value.allowedDates.length ? !0 : e.value.allowedDates ? !o(
    I,
    e.value.allowedDates,
    i(r.monthPicker, r.yearPicker)
  ) : !1, L = (I) => !C(I), Z = (I) => n.value.noDisabledRange ? !xi({ start: I[0], end: I[1] }).some((B) => L(B)) : !0, se = (I) => {
    if (I) {
      const B = Be(I);
      return B >= +r.yearRange[0] && B <= r.yearRange[1];
    }
    return !0;
  }, ie = (I, B) => !!(Array.isArray(I) && I[B] && (n.value.maxRange || n.value.minRange) && se(I[B])), ce = (I, B, X = 0) => {
    if (ie(B, X) && se(I)) {
      const R = ld(I, B[X]), te = g(B[X], I), O = te.length === 1 ? 0 : te.filter((V) => L(V)).length, z = Math.abs(R) - (n.value.minMaxRawRange ? 0 : O);
      if (n.value.minRange && n.value.maxRange)
        return z >= +n.value.minRange && z <= +n.value.maxRange;
      if (n.value.minRange) return z >= +n.value.minRange;
      if (n.value.maxRange) return z <= +n.value.maxRange;
    }
    return !0;
  }, G = () => !s.value.enableTimePicker || r.monthPicker || r.yearPicker || s.value.ignoreTimeValidation, le = (I) => Array.isArray(I) ? [I[0] ? k(I[0]) : null, I[1] ? k(I[1]) : null] : k(I), q = (I, B, X) => B ? I.find(
    (R) => +R.hours === On(B) && R.minutes === "*" ? !0 : +R.minutes === Bn(B) && +R.hours === On(B)
  ) && X : !1, N = (I, B, X) => {
    const [R, te] = I, [O, z] = B;
    return !q(R, O, X) && !q(te, z, X) && X;
  }, Q = (I, B) => {
    const X = Array.isArray(B) ? B : [B];
    return Array.isArray(r.disabledTimes) ? Array.isArray(r.disabledTimes[0]) ? N(r.disabledTimes, X, I) : !X.some((R) => q(r.disabledTimes, R, I)) : I;
  }, he = (I, B) => {
    const X = Array.isArray(B) ? [y(B[0]), B[1] ? y(B[1]) : void 0] : y(B), R = !r.disabledTimes(X);
    return I && R;
  }, pe = (I, B) => r.disabledTimes ? Array.isArray(r.disabledTimes) ? Q(B, I) : he(B, I) : B, ge = (I) => {
    let B = !0;
    if (!I || G()) return !0;
    const X = !e.value.minDate && !e.value.maxDate ? le(I) : I;
    return (r.maxTime || e.value.maxDate) && (B = j(
      r.maxTime,
      e.value.maxDate,
      "max",
      c(X),
      B
    )), (r.minTime || e.value.minDate) && (B = j(
      r.minTime,
      e.value.minDate,
      "min",
      c(X),
      B
    )), pe(I, B);
  }, Ce = (I) => {
    if (!r.monthPicker) return !0;
    let B = !0;
    const X = l(p(I));
    if (e.value.minDate && e.value.maxDate) {
      const R = l(p(e.value.minDate)), te = l(p(e.value.maxDate));
      return m(X, R) && f(X, te) || d(X, R) || d(X, te);
    }
    if (e.value.minDate) {
      const R = l(p(e.value.minDate));
      B = m(X, R) || d(X, R);
    }
    if (e.value.maxDate) {
      const R = l(p(e.value.maxDate));
      B = f(X, R) || d(X, R);
    }
    return B;
  }, ye = M(() => (I) => !s.value.enableTimePicker || s.value.ignoreTimeValidation ? !0 : ge(I)), K = M(() => (I) => r.monthPicker ? Array.isArray(I) && (n.value.enabled || t.value.enabled) ? !I.filter((B) => !Ce(B)).length : Ce(I) : !0), be = (I, B, X) => {
    if (!B || X && !e.value.maxDate || !X && !e.value.minDate) return !1;
    const R = X ? pn(I, 1) : Xa(I, 1), te = [Ke(R), Be(R)];
    return X ? !_(...te) : !$(...te);
  }, Me = (I, B, X) => [qe(l(I), { date: 1 }), qe(l(), { month: B, year: X, date: 1 })], F = (I, B, X, R) => {
    if (!I) return !0;
    if (R) {
      const te = X === "max" ? Vn(I, B) : Tn(I, B), O = { seconds: 0, milliseconds: 0 };
      return te || Fa(qe(I, O), qe(B, O));
    }
    return X === "max" ? I.getTime() <= B.getTime() : I.getTime() >= B.getTime();
  }, j = (I, B, X, R, te) => {
    if (Array.isArray(R)) {
      const z = H(I, R[0], B), V = H(I, R[1], B);
      return F(R[0], z, X, !!B) && F(R[1], V, X, !!B) && te;
    }
    const O = H(I, R, B);
    return F(R, O, X, !!B) && te;
  }, H = (I, B, X) => I ? h(I, B) : l(X ?? B);
  return {
    isDisabled: L,
    validateDate: C,
    validateMonthYearInRange: D,
    isDateRangeAllowed: Z,
    checkMinMaxRange: ce,
    isValidTime: ge,
    validateMonthYear: be,
    validateMinDate: $,
    validateMaxDate: _,
    isValidDate: (I) => Array.isArray(I) ? Ts(I[0]) && (I[1] ? Ts(I[1]) : !0) : I ? Ts(I) : !1,
    checkPartialRangeValue: (I) => {
      if (I) return null;
      throw new Error(u.prop("partial-range"));
    },
    checkRangeEnabled: (I, B) => {
      if (B) return I();
      throw new Error(u.prop("range"));
    },
    checkMinMaxValue: (I, B, X) => {
      const R = X != null, te = B != null;
      if (!R && !te) return !1;
      const O = +X, z = +B;
      return R && te ? +I > O || +I < z : R ? +I > O : te ? +I < z : !1;
    },
    isTimeValid: ye,
    isMonthValid: K
  };
}, rb = (e) => {
  const {
    rootEmit: n,
    rootProps: t,
    defaults: { timeConfig: a, flow: s }
  } = Ge(), r = ee(0), l = ga({
    [pa.timePicker]: !a.value.enableTimePicker || t.timePicker || t.monthPicker,
    [pa.calendar]: !1,
    [pa.header]: !1
  }), i = M(() => t.monthPicker || t.timePicker), o = (d) => {
    var p, g;
    if ((g = (p = s.value) == null ? void 0 : p.steps) != null && g.length) {
      if (!d && i.value) return m();
      l[d] = !0, Object.keys(l).filter((k) => !l[k]).length || m();
    }
  }, u = () => {
    var d, p, g, k;
    (p = (d = s.value) == null ? void 0 : d.steps) != null && p.length && r.value !== -1 && (r.value += 1, n("flow-step", r.value), m()), ((k = (g = s.value) == null ? void 0 : g.steps) == null ? void 0 : k.length) === r.value && Ze().then(() => c());
  }, c = () => {
    r.value = -1;
  }, f = (d, p, ...g) => {
    var k, y, h;
    ((k = s.value) == null ? void 0 : k.steps[r.value]) === d && e.value && ((h = (y = e.value)[p]) == null || h.call(y, ...g));
  }, m = (d = 0) => {
    var g;
    d && (r.value += d), f(Nt.month, "toggleMonthPicker", !0), f(Nt.year, "toggleYearPicker", !0), f(Nt.calendar, "toggleTimePicker", !1, !0), f(Nt.time, "toggleTimePicker", !0, !0);
    const p = (g = s.value) == null ? void 0 : g.steps[r.value];
    (p === Nt.hours || p === Nt.minutes || p === Nt.seconds) && f(p, "toggleTimePicker", !0, !0, p);
  };
  return { childMount: o, updateFlowStep: u, resetFlow: c, handleFlow: m, flowStep: r };
};
function pl(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
function vs(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : l;
      s = e.formattingValues[i] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[l];
    }
    const r = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[r];
  };
}
function ps(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], r = n.match(s);
    if (!r)
      return null;
    const l = r[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? ib(i, (f) => f.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      lb(i, (f) => f.test(l))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(l.length);
    return { value: u, rest: c };
  };
}
function lb(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function ib(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function ob(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], r = n.match(e.parsePattern);
    if (!r) return null;
    let l = e.valueCallback ? e.valueCallback(r[0]) : r[0];
    l = t.valueCallback ? t.valueCallback(l) : l;
    const i = n.slice(s.length);
    return { value: l, rest: i };
  };
}
const ub = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, cb = (e, n, t) => {
  let a;
  const s = ub[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
}, db = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, fb = (e, n, t, a) => db[e], hb = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, mb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, vb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, pb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, gb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, yb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, bb = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, wb = {
  ordinalNumber: bb,
  era: vs({
    values: hb,
    defaultWidth: "wide"
  }),
  quarter: vs({
    values: mb,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: vs({
    values: vb,
    defaultWidth: "wide"
  }),
  day: vs({
    values: pb,
    defaultWidth: "wide"
  }),
  dayPeriod: vs({
    values: gb,
    defaultWidth: "wide",
    formattingValues: yb,
    defaultFormattingWidth: "wide"
  })
}, kb = /^(\d+)(th|st|nd|rd)?/i, xb = /\d+/i, Sb = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Tb = {
  any: [/^b/i, /^(a|c)/i]
}, Mb = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, $b = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Cb = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Db = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ob = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _b = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Eb = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ib = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Pb = {
  ordinalNumber: ob({
    matchPattern: kb,
    parsePattern: xb,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ps({
    matchPatterns: Sb,
    defaultMatchWidth: "wide",
    parsePatterns: Tb,
    defaultParseWidth: "any"
  }),
  quarter: ps({
    matchPatterns: Mb,
    defaultMatchWidth: "wide",
    parsePatterns: $b,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ps({
    matchPatterns: Cb,
    defaultMatchWidth: "wide",
    parsePatterns: Db,
    defaultParseWidth: "any"
  }),
  day: ps({
    matchPatterns: Ob,
    defaultMatchWidth: "wide",
    parsePatterns: _b,
    defaultParseWidth: "any"
  }),
  dayPeriod: ps({
    matchPatterns: Eb,
    defaultMatchWidth: "any",
    parsePatterns: Ib,
    defaultParseWidth: "any"
  })
}, Ab = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Rb = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Fb = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Vb = {
  date: pl({
    formats: Ab,
    defaultWidth: "full"
  }),
  time: pl({
    formats: Rb,
    defaultWidth: "full"
  }),
  dateTime: pl({
    formats: Fb,
    defaultWidth: "full"
  })
}, Lb = {
  code: "en-US",
  formatDistance: cb,
  formatLong: Vb,
  formatRelative: fb,
  localize: wb,
  match: Pb,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Ko = {
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1,
  autoSwitchStartEnd: !0
}, Nb = {
  allowStopPropagation: !0,
  closeOnScroll: !1,
  modeHeight: 255,
  allowPreventDefault: !1,
  closeOnClearValue: !0,
  closeOnAutoApply: !0,
  noSwipe: !1,
  keepActionRow: !1,
  onClickOutside: void 0,
  tabOutClosesMenu: !0,
  arrowLeft: void 0,
  keepViewOnOffsetClick: !1,
  timeArrowHoldThreshold: 0,
  shadowDom: !1,
  mobileBreakpoint: 600,
  setDateOnMenuClose: !1,
  escClose: !0,
  spaceConfirm: !0,
  monthChangeOnArrows: !0,
  monthChangeOnScroll: !0
}, Zo = {
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: "open",
  selectOnFocus: !1,
  rangeSeparator: " - ",
  escClose: !0,
  format: void 0,
  maskFormat: void 0,
  applyOnBlur: !1,
  separators: void 0
}, Bb = {
  dates: [],
  years: [],
  months: [],
  quarters: [],
  weeks: [],
  weekdays: [],
  options: { highlightDisabled: !1 }
}, zb = {
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  selectBtnLabel: "Select",
  cancelBtnLabel: "Cancel",
  nowBtnLabel: "Now",
  nowBtnRound: void 0
}, Wb = {
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`
}, Xo = {
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down"
}, Yb = {
  weekDays: [],
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] }
}, Hb = {
  month: "LLL",
  year: "yyyy",
  weekDay: "EEEEEE",
  quarter: "MMMM",
  day: "d",
  input: void 0,
  preview: void 0
}, Ub = {
  enableTimePicker: !0,
  ignoreTimeValidation: !1,
  enableSeconds: !1,
  enableMinutes: !0,
  is24: !0,
  noHoursOverlay: !1,
  noMinutesOverlay: !1,
  noSecondsOverlay: !1,
  hoursGridIncrement: 1,
  minutesGridIncrement: 5,
  secondsGridIncrement: 5,
  hoursIncrement: 1,
  minutesIncrement: 1,
  secondsIncrement: 1,
  timePickerInline: !1,
  startTime: void 0
}, qb = {
  flowStep: 0,
  menuWrapRef: null,
  collapse: !1
}, jb = {
  weekStart: Dd.Monday,
  yearRange: () => [1900, 2100],
  ui: () => ({}),
  locale: () => Lb,
  dark: !1,
  transitions: !0,
  hideNavigation: () => [],
  vertical: !1,
  hideMonthYearSelect: !1,
  disableYearSelect: !1,
  autoApply: !1,
  disabledDates: () => [],
  hideOffsetDates: !1,
  noToday: !1,
  markers: () => [],
  presetDates: () => [],
  preventMinMaxNavigation: !1,
  reverseYears: !1,
  weekPicker: !1,
  arrowNavigation: !1,
  monthPicker: !1,
  yearPicker: !1,
  quarterPicker: !1,
  timePicker: !1,
  modelAuto: !1,
  multiDates: !1,
  range: !1,
  inline: !1,
  sixWeeks: !1,
  focusStartDate: !1,
  yearFirst: !1,
  loading: !1,
  centered: !1
}, Jo = {
  name: void 0,
  required: !1,
  autocomplete: "off",
  state: void 0,
  clearable: !0,
  alwaysClearable: !1,
  hideInputIcon: !1,
  id: void 0,
  inputmode: "none"
}, sr = {
  type: "local",
  hideOnOffsetDates: !1,
  label: "W"
}, Gb = (e) => {
  const { getMapKey: n, getMapKeyType: t, getTimeObjFromCurrent: a } = Ot();
  function s(G, le) {
    let q;
    return e.timezone ? q = new Va(G ?? /* @__PURE__ */ new Date(), e.timezone) : q = G ? new Date(G) : /* @__PURE__ */ new Date(), le ? qe(q, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }) : q;
  }
  const r = () => {
    const G = Z.value.enableSeconds ? ":ss" : "", le = Z.value.enableMinutes ? ":mm" : "";
    return Z.value.is24 ? `HH${le}${G}` : `hh${le}${G} aa`;
  }, l = () => {
    var G;
    return e.monthPicker ? "MM/yyyy" : e.timePicker ? r() : e.weekPicker ? `${((G = C.value) == null ? void 0 : G.type) === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : Z.value.enableTimePicker ? `MM/dd/yyyy, ${r()}` : "MM/dd/yyyy";
  }, i = (G) => a(s(), G, Z.value.enableSeconds), o = () => A.value.enabled ? Z.value.startTime && Array.isArray(Z.value.startTime) ? [i(Z.value.startTime[0]), i(Z.value.startTime[1])] : null : Z.value.startTime && !Array.isArray(Z.value.startTime) ? i(Z.value.startTime) : null, u = (G) => G ? typeof G == "boolean" ? G ? 2 : 0 : Math.max(+G, 2) : 0, c = (G) => {
    const le = t(e.monthPicker, e.yearPicker);
    return new Map(
      G.map((q) => {
        const N = s(q, f.value);
        return [n(N, le), N];
      })
    );
  }, f = M(() => e.monthPicker || e.yearPicker || e.quarterPicker), m = M(() => {
    const G = typeof e.multiCalendars == "object" && e.multiCalendars, le = {
      static: !0,
      solo: !1
    };
    if (!e.multiCalendars) return { ...le, count: u(!1) };
    const q = G ? e.multiCalendars : {}, N = G ? q.count ?? !0 : e.multiCalendars, Q = u(N);
    return Object.assign(le, q, { count: Q });
  }), d = M(() => o()), p = M(() => ({ ...Wb, ...e.ariaLabels })), g = M(() => ({ ...Yb, ...e.filters })), k = M(() => typeof e.transitions == "boolean" ? e.transitions ? Xo : !1 : { ...Xo, ...e.transitions }), y = M(() => ({ ...zb, ...e.actionRow })), h = M(() => typeof e.textInput == "object" ? {
    ...Zo,
    ...e.textInput,
    format: typeof e.textInput.format == "string" ? e.textInput.format : Y.value.input,
    pattern: e.textInput.format ?? Y.value.input,
    enabled: !0
  } : {
    ...Zo,
    format: Y.value.input,
    pattern: Y.value.input,
    enabled: e.textInput
  }), b = M(() => {
    const G = { input: !1 };
    return typeof e.inline == "object" ? { ...G, ...e.inline, enabled: !0 } : {
      enabled: e.inline,
      ...G
    };
  }), S = M(() => ({ ...Nb, ...e.config })), x = M(() => typeof e.highlight == "function" ? e.highlight : {
    ...Bb,
    ...e.highlight
  }), C = M(() => {
    var G, le;
    return typeof e.weekNumbers == "object" ? {
      type: ((G = e.weekNumbers) == null ? void 0 : G.type) ?? sr.type,
      hideOnOffsetDates: ((le = e.weekNumbers) == null ? void 0 : le.hideOnOffsetDates) ?? sr.hideOnOffsetDates,
      label: e.weekNumbers.label ?? sr.label
    } : e.weekNumbers ? sr : void 0;
  }), $ = M(() => {
    var G, le;
    return typeof e.multiDates == "boolean" ? { enabled: e.multiDates, dragSelect: !0, limit: null } : {
      enabled: !!e.multiDates,
      limit: (G = e.multiDates) != null && G.limit ? +e.multiDates.limit : null,
      dragSelect: ((le = e.multiDates) == null ? void 0 : le.dragSelect) ?? !0
    };
  }), _ = M(() => {
    var G;
    return {
      minDate: e.minDate ? s(e.minDate) : null,
      maxDate: e.maxDate ? s(e.maxDate) : null,
      disabledDates: Array.isArray(e.disabledDates) ? c(e.disabledDates) : e.disabledDates,
      allowedDates: Array.isArray(e.allowedDates) ? c(e.allowedDates) : null,
      highlight: typeof x.value == "object" && Array.isArray(x.value.dates) ? c(x.value.dates) : x.value,
      markers: (G = e.markers) != null && G.length ? new Map(
        e.markers.map((le) => {
          const q = s(le.date);
          return [n(q, La.DATE), le];
        })
      ) : null
    };
  }), A = M(() => typeof e.range == "object" ? { enabled: !0, ...Ko, ...e.range } : {
    enabled: e.range,
    ...Ko
  }), D = M(() => ({
    ...Object.fromEntries(
      Object.keys(e.ui).map((G) => {
        const le = G, q = e.ui[le];
        if (le === "dayClass") return [le, e.ui[le]];
        const N = typeof e.ui[le] == "string" ? { [q]: !0 } : Object.fromEntries(q.map((Q) => [Q, !0]));
        return [G, N];
      })
    )
  })), Y = M(() => {
    var G, le;
    return {
      ...Hb,
      ...e.formats,
      input: ((G = e.formats) == null ? void 0 : G.input) ?? l(),
      preview: ((le = e.formats) == null ? void 0 : le.preview) ?? l()
    };
  }), L = M(() => {
    if (e.teleport)
      return typeof e.teleport == "string" ? e.teleport : typeof e.teleport == "boolean" ? "body" : e.teleport;
  }), Z = M(() => ({ ...Ub, ...e.timeConfig })), se = M(() => {
    if (e.flow)
      return { steps: [], partial: !1, ...e.flow };
  }), ie = M(() => {
    const G = h.value.enabled ? "text" : "none";
    return e.inputAttrs ? { ...Jo, inputmode: G, ...e.inputAttrs } : { ...Jo, inputmode: G };
  }), ce = M(() => {
    var G, le, q, N, Q, he;
    return {
      offset: ((G = e.floating) == null ? void 0 : G.offset) ?? 10,
      arrow: ((le = e.floating) == null ? void 0 : le.arrow) ?? !0,
      strategy: ((q = e.floating) == null ? void 0 : q.strategy) ?? void 0,
      placement: ((N = e.floating) == null ? void 0 : N.placement) ?? void 0,
      flip: ((Q = e.floating) == null ? void 0 : Q.flip) ?? !0,
      shift: ((he = e.floating) == null ? void 0 : he.shift) ?? !0
    };
  });
  return {
    transitions: k,
    multiCalendars: m,
    startTime: d,
    ariaLabels: p,
    filters: g,
    actionRow: y,
    textInput: h,
    inline: b,
    config: S,
    highlight: x,
    weekNumbers: C,
    range: A,
    safeDates: _,
    multiDates: $,
    ui: D,
    formats: Y,
    teleport: L,
    timeConfig: Z,
    flow: se,
    inputAttrs: ie,
    floatingConfig: ce,
    getDate: s
  };
}, Ot = () => {
  const e = (h, b) => en(h, b ?? La.DATE), n = (h, b) => h ? La.MONTH_AND_YEAR : b ? La.YEAR : La.DATE, t = (h, b, S) => b.get(e(h, S)), a = (h) => h, s = (h) => h === 0 ? h : !h || Number.isNaN(+h) ? null : +h, r = () => [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "[data-datepicker-instance]"
  ].join(", "), l = (h, b) => {
    let S = [...document.querySelectorAll(r())];
    S = S.filter((C) => !h.contains(C) || "datepicker-instance" in C.dataset);
    const x = S.indexOf(h);
    if (x >= 0 && (b ? x - 1 >= 0 : x + 1 <= S.length))
      return S[x + (b ? -1 : 1)];
  }, i = (h) => String(h).padStart(2, "0"), o = (h, b) => h == null ? void 0 : h.querySelector(`[data-dp-element="${b}"]`), u = (h, b, S = !1) => {
    h && b.allowStopPropagation && (S && h.stopImmediatePropagation(), h.stopPropagation());
  }, c = (h, b, S = !1, x) => {
    if (h.key === ct.enter || h.key === ct.space)
      return S && h.preventDefault(), b();
    if (x) return x(h);
  }, f = (h, b) => {
    b.allowStopPropagation && h.stopPropagation(), b.allowPreventDefault && h.preventDefault();
  }, m = (h) => {
    if (h)
      return [...h.querySelectorAll("input, button, select, textarea, a[href]")][0];
  }, d = () => "ontouchstart" in globalThis || navigator.maxTouchPoints > 0, p = (h) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][h], g = (h) => {
    const b = [], S = (x) => x.filter((C) => !!C);
    for (let x = 0; x < h.length; x += 3) {
      const C = [h[x], h[x + 1], h[x + 2]];
      b.push(S(C));
    }
    return b;
  }, k = {
    prop: (h) => `"${h}" prop must be enabled!`,
    dateArr: (h) => `You need to use array as "model-value" binding in order to support "${h}"`
  }, y = (h, b, S, x, C) => {
    const $ = {
      hours: On,
      minutes: Bn,
      seconds: na
    };
    if (!b) return x ? [$[h](S), $[h](S)] : $[h](S);
    if (Array.isArray(b) && x) {
      const _ = b[0] ?? S, A = b[1];
      return [$[h](_), A ? $[h](A) : C[h][1] ?? $[h](S)];
    }
    return Array.isArray(b) && !x ? $[h](b[b.length - 1] ?? S) : $[h](b);
  };
  return {
    getMapKey: e,
    getMapKeyType: n,
    getMapDate: t,
    convertType: a,
    getNumVal: s,
    findNextFocusableElement: l,
    padZero: i,
    getElWithin: o,
    checkStopPropagation: u,
    checkKeyDown: c,
    handleEventPropagation: f,
    findFocusableEl: m,
    isTouchDevice: d,
    hoursToAmPmHours: p,
    getGroupedList: g,
    setTimeModelValue: (h, b, S, x) => {
      h.hours = y("hours", b, S, x, h), h.minutes = y("minutes", b, S, x, h), h.seconds = y("seconds", b, S, x, h);
    },
    getTimeObjFromCurrent: (h, b, S) => {
      const x = {
        hours: On(h),
        minutes: Bn(h),
        seconds: S ? na(h) : 0
      };
      return Object.assign(x, b);
    },
    errorMapper: k
  };
}, Vt = () => {
  const { getDate: e } = Ge(), { getMapDate: n, getGroupedList: t } = Ot(), a = (y, h) => {
    if (!y) return e();
    const b = e(y), S = qe(b, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
    return h ? ng(S) : S;
  }, s = (y, h) => {
    const b = e(h);
    return qe(b, {
      hours: +(y.hours ?? On(b)),
      minutes: +(y.minutes ?? Bn(b)),
      seconds: +(y.seconds ?? na(b)),
      milliseconds: 0
    });
  }, r = (y, h) => {
    const b = sn(y, { weekStartsOn: +h }), S = Si(y, { weekStartsOn: +h });
    return [b, S];
  }, l = (y, h) => !y || !h ? !1 : Vn(a(y), a(h)), i = (y, h) => !y || !h ? !1 : Fa(a(y), a(h)), o = (y, h) => !y || !h ? !1 : Tn(a(y), a(h)), u = (y, h, b) => y != null && y[0] && (y != null && y[1]) ? o(b, y[0]) && l(b, y[1]) : y != null && y[0] && h ? o(b, y[0]) && l(b, h) || l(b, y[0]) && o(b, h) : !1, c = (y, h) => {
    const b = o(y, h) ? h : y, S = o(h, y) ? h : y;
    return xi({ start: b, end: S });
  }, f = (y) => `dp-${en(y, "yyyy-MM-dd")}`, m = (y) => a(qe(e(y), { date: 1 })), d = (y, h) => {
    if (h) {
      const b = Be(e(h));
      if (b > y) return 12;
      if (b === y) return Ke(e(h));
    }
  }, p = (y, h) => {
    if (h) {
      const b = Be(e(h));
      return b < y ? -1 : b === y ? Ke(e(h)) : void 0;
    }
  }, g = (y) => {
    if (y) return Be(e(y));
  }, k = (y) => ({
    hours: On(y),
    minutes: Bn(y),
    seconds: na(y)
  });
  return {
    resetDateTime: a,
    groupListAndMap: (y, h) => t(y).map((b) => b.map((S) => {
      const { active: x, disabled: C, isBetween: $, highlighted: _ } = h(S);
      return {
        ...S,
        active: x,
        disabled: C,
        className: {
          dp__overlay_cell_active: x,
          dp__overlay_cell: !x,
          dp__overlay_cell_disabled: C,
          dp__overlay_cell_pad: !0,
          dp__overlay_cell_active_disabled: C && x,
          dp__cell_in_between: $,
          "dp--highlighted": _
        }
      };
    })),
    setTime: s,
    getWeekFromDate: r,
    isDateAfter: o,
    isDateBefore: l,
    isDateBetween: u,
    isDateEqual: i,
    getDaysInBetween: c,
    getCellId: f,
    resetDate: m,
    getMinMonth: d,
    getMaxMonth: p,
    getYearFromDate: g,
    getTimeObj: k,
    setTimeValue: (y) => qe(e(), k(y)),
    sanitizeTime: (y, h, b) => h && (b || b === 0) ? Object.fromEntries(
      ["hours", "minutes", "seconds"].map((S) => S === h ? [S, b] : [S, Number.isNaN(+y[S]) ? void 0 : +y[S]])
    ) : {
      hours: Number.isNaN(+y.hours) ? void 0 : +y.hours,
      minutes: Number.isNaN(+y.minutes) ? void 0 : +y.minutes,
      seconds: Number.isNaN(+(y.seconds ?? "")) ? void 0 : +y.seconds
    },
    getBeforeAndAfterInRange: (y, h) => {
      const b = yd(a(h), y), S = tn(a(h), y);
      return { before: b, after: S };
    },
    isModelAuto: (y) => Array.isArray(y) ? !!y[0] && !!y[1] : !1,
    matchDate: (y, h) => y ? h ? h instanceof Map ? !!n(y, h) : h(e(y)) : !1 : !0,
    checkHighlightMonth: (y, h, b) => typeof y == "function" ? y({ month: h, year: b }) : y.months.some((S) => S.month === h && S.year === b),
    checkHighlightYear: (y, h) => typeof y == "function" ? y(h) : y.years.includes(h)
  };
}, Wr = () => {
  const {
    defaults: { config: e }
  } = Ge(), n = ee(0);
  et(() => {
    t(), globalThis.addEventListener("resize", t, { passive: !0 });
  }), rn(() => {
    globalThis.removeEventListener("resize", t);
  });
  const t = () => {
    n.value = globalThis.document.documentElement.clientWidth;
  };
  return {
    isMobile: M(() => n.value <= e.value.mobileBreakpoint ? !0 : void 0)
  };
}, aa = () => {
  const {
    getDate: e,
    state: n,
    modelValue: t,
    rootProps: a,
    defaults: { formats: s, textInput: r }
  } = Ge(), l = (p) => en(hn(e(), p), s.value.year, { locale: a.locale }), i = (p) => en(bd(e(), p), s.value.month, { locale: a.locale }), o = (p) => en(p, s.value.weekDay, { locale: a.locale }), u = (p) => en(p, s.value.quarter, { locale: a.locale }), c = (p, g) => [p, g].map((k) => u(k)).join("-"), f = (p) => en(p, s.value.day, { locale: a.locale }), m = (p, g, k) => {
    const y = k ? s.value.preview : s.value.input;
    if (!p) return "";
    if (typeof y == "function") return y(p);
    const h = g ?? y, b = { locale: a.locale };
    return Array.isArray(p) ? `${en(p[0], h, b)}${a.modelAuto && !p[1] ? "" : r.value.rangeSeparator}${p[1] ? en(p[1], h, b) : ""}` : en(p, h, b);
  }, d = () => {
    const p = (g) => en(g, r.value.format);
    return Array.isArray(t.value) ? `${p(t.value[0])} ${r.value.rangeSeparator} ${t.value[1] ? p(t.value[1]) : ""}` : "";
  };
  return {
    formatYear: l,
    formatMonth: i,
    formatWeekDay: o,
    formatQuarter: u,
    formatSelectedDate: m,
    formatForTextInput: () => n.isInputFocused && t.value ? Array.isArray(t.value) ? d() : en(t.value, r.value.format) : m(t.value),
    formatPreview: (p) => m(p, void 0, !0),
    formatQuarterText: c,
    formatDay: f
  };
}, Yr = () => {
  const { rootProps: e } = Ge(), { formatYear: n, formatMonth: t } = aa();
  return {
    getMonths: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((a) => ({
      text: t(a),
      value: a
    })),
    getYears: () => {
      const a = [];
      for (let s = +e.yearRange[0]; s <= +e.yearRange[1]; s++)
        a.push({ value: +s, text: n(s) });
      return e.reverseYears ? a.reverse() : a;
    },
    isOutOfYearRange: (a) => a < +e.yearRange[0] || a > +e.yearRange[1]
  };
}, Kb = (e) => ({
  openMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.openMenu();
  },
  closeMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.closeMenu();
  },
  selectDate: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.selectDate();
  },
  clearValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.clearValue();
  },
  formatInputValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.formatInputValue();
  },
  updateInternalModelValue: (n) => {
    var t;
    return (t = e.value) == null ? void 0 : t.updateInternalModelValue(n);
  },
  setMonthYear: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.setMonthYear(n, t);
  },
  parseModel: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.parseModel();
  },
  switchView: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.switchView(n, t);
  },
  handleFlow: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.handleFlow();
  },
  toggleMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.toggleMenu();
  },
  dpMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpMenuRef();
  },
  dpWrapMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpWrapMenuRef();
  },
  inputRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.inputRef();
  }
}), rs = () => ({
  boolHtmlAttribute: (e) => e ? !0 : void 0
}), Zb = () => {
  const {
    getDate: e,
    rootProps: n,
    defaults: { textInput: t, startTime: a, timeConfig: s }
  } = Ge(), { getTimeObjFromCurrent: r } = Ot(), l = ee(!1), i = M(
    () => Array.isArray(a.value) ? a.value[0] : a.value ?? r(e(), {}, s.value.enableSeconds)
  ), o = (c, f) => {
    var b, S;
    const m = /[^a-zA-Z]+/g, d = /\D+/g, p = f.split(d), g = c.split(m), k = c.match(m) || [], y = f.match(d) || [];
    let h = "";
    for (let x = 0; x < p.length && x < g.length; x++) {
      x > 0 && y[x - 1] && (h += k[x - 1] || y[x - 1]);
      const C = (b = p[x]) == null ? void 0 : b.length;
      h += (S = g[x]) == null ? void 0 : S.slice(0, C);
    }
    return h;
  }, u = (c, f, m) => {
    const d = Kl(c, o(f, c), e(), {
      locale: n.locale
    });
    return Ts(d) && id(d) ? m || l.value ? d : qe(d, {
      hours: +i.value.hours,
      minutes: +i.value.minutes,
      seconds: +(i.value.seconds ?? 0),
      milliseconds: 0
    }) : null;
  };
  return {
    textPasted: l,
    parseFreeInput: (c, f) => {
      if (typeof t.value.pattern == "string")
        return u(c, t.value.pattern, f);
      if (Array.isArray(t.value.pattern)) {
        let m = null;
        for (const d of t.value.pattern)
          if (m = u(c, d, f), m)
            break;
        return m;
      }
      return typeof t.value.pattern == "function" ? t.value.pattern(c) : null;
    },
    applyMaxValues: (c, f) => {
      const m = {
        MM: 12,
        DD: 31,
        hh: 23,
        mm: 59,
        ss: 59
      };
      let d = "", p = 0;
      for (let g = 0; g < f.length; g++) {
        const k = f[g], y = k.length, h = c.slice(p, p + y);
        if (!h) break;
        if (h.length < y)
          d += h;
        else {
          let b = Number.parseInt(h, 10);
          m[k] && b > m[k] && (b = m[k]), d += b.toString().padStart(y, "0").slice(0, y);
        }
        p += y;
      }
      return d;
    },
    createMaskedValue: (c, f) => {
      const m = /(YYYY|MM|DD|hh|mm|ss)/g, d = [...f.matchAll(m)].map((h) => h[0]), p = f.replace(m, "|").split("|").filter(Boolean), g = d.map((h) => h.length);
      let k = "", y = 0;
      for (let h = 0; h < d.length; h++) {
        const b = g[h], S = c.slice(y, y + b);
        if (!S) break;
        k += S, S.length === b && p[h] && (k += p[h]), y += b;
      }
      return k;
    }
  };
};
var gn = /* @__PURE__ */ ((e) => (e.Input = "input", e.DatePicker = "date-picker", e.Calendar = "calendar", e.DatePickerHeader = "date-picker-header", e.Menu = "menu", e.ActionRow = "action-row", e.TimePicker = "time-picker", e.TimeInput = "time-input", e.PassTrough = "pass-trough", e.MonthPicker = "month-picker", e.YearMode = "year-mode", e.QuarterPicker = "quarter-picker", e.YearPicker = "year-picker", e))(gn || {});
const Ea = [
  "time-input",
  "time-picker",
  "pass-trough"
  /* PassTrough */
], Od = [
  { name: "trigger", use: [
    "input"
    /* Input */
  ] },
  { name: "input-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "clear-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "dp-input", use: [
    "input"
    /* Input */
  ] },
  { name: "clock-icon", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "arrow-left", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "arrow-right", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  {
    name: "arrow-up",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "arrow-down",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "calendar-icon",
    use: [
      "date-picker-header",
      "time-picker",
      "pass-trough",
      "year-mode"
      /* YearMode */
    ]
  },
  { name: "day", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "month-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker"
      /* MonthPicker */
    ]
  },
  {
    name: "year-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "year-mode",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "year-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "hours-overlay-value",
    use: Ea
  },
  {
    name: "hours-overlay-header",
    use: Ea
  },
  {
    name: "minutes-overlay-value",
    use: Ea
  },
  {
    name: "minutes-overlay-header",
    use: Ea
  },
  {
    name: "seconds-overlay-value",
    use: Ea
  },
  {
    name: "seconds-overlay-header",
    use: Ea
  },
  { name: "hours", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "minutes", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "seconds", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "action-buttons", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "action-preview", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "calendar-header", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "marker-tooltip", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-extra", use: [
    "menu"
    /* Menu */
  ] },
  { name: "time-picker-overlay", use: [
    "time-picker",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "am-pm-button", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "left-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  { name: "right-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  {
    name: "month-year",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "time-picker", use: [
    "date-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-row", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "marker", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "quarter", use: [
    "quarter-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "top-extra",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "quarter-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  {
    name: "tp-inline-arrow-up",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "tp-inline-arrow-down",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  { name: "arrow", use: [
    "menu"
    /* Menu */
  ] },
  { name: "menu-header", use: [
    "menu"
    /* Menu */
  ] }
], Cn = (e, n) => Od.filter((t) => e[t.name] && t.use.includes(n)).map((t) => t.name), _d = (e, n) => Od.map((t) => t.name).concat((n == null ? void 0 : n.filter((t) => t.slot).map((t) => t.slot)) ?? []).filter((t) => !!e[t]), Xb = {
  key: 1,
  class: "dp__input_wrap"
}, Jb = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], Qb = {
  key: 1,
  class: "dp--clear-btn"
}, e0 = ["aria-label"], t0 = /* @__PURE__ */ Se({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 }
  },
  emits: ["clear", "open", "set-input-date", "close", "select-date", "set-empty-date", "toggle", "focus", "blur", "real-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: r,
      inputValue: l,
      rootProps: i,
      defaults: { textInput: o, ariaLabels: u, inline: c, config: f, range: m, multiDates: d, ui: p, inputAttrs: g }
    } = Ge(), { checkMinMaxRange: k, isValidDate: y } = ln(), { parseFreeInput: h, textPasted: b, createMaskedValue: S, applyMaxValues: x } = Zb(), { checkKeyDown: C, checkStopPropagation: $ } = Ot(), { boolHtmlAttribute: _ } = rs(), A = Je("dp-input"), D = ee(null), Y = ee(!1), L = M(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !o.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !o.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !g.value.clearable,
        dp__input_icon_pad: !g.value.hideInputIcon,
        dp__input_valid: typeof g.value.state == "boolean" ? g.value.state : !1,
        dp__input_invalid: typeof g.value.state == "boolean" ? !g.value.state : !1,
        dp__input_focus: Y.value || s.isMenuOpen,
        dp__input_reg: !o.value.enabled,
        ...p.value.input
      })
    ), Z = () => {
      a("set-input-date", null), g && i.autoApply && (a("set-empty-date"), D.value = null);
    }, se = (F) => {
      var j;
      if ((j = o.value.separators) != null && j.length) {
        const H = new RegExp(
          o.value.separators.map((I) => I.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")
        );
        return F.split(H);
      }
      return F.split(o.value.rangeSeparator);
    }, ie = (F) => {
      const [j, H] = se(F);
      if (j) {
        const I = h(j.trim(), l.value), B = H ? h(H.trim(), l.value) : void 0;
        if (Tn(I, B)) return;
        const X = I && B ? [I, B] : [I];
        k(B, X, 0) && (D.value = I ? X : null);
      }
    }, ce = () => {
      b.value = !0;
    }, G = (F) => {
      if (m.value.enabled)
        ie(F);
      else if (d.value.enabled) {
        const j = F.split(";");
        D.value = j.map((H) => h(H.trim())).filter((H) => !!H);
      } else
        D.value = h(F, l.value);
    }, le = (F) => {
      var B, X;
      const j = typeof F == "string" ? F : (B = F.target) == null ? void 0 : B.value, H = (X = o == null ? void 0 : o.value) == null ? void 0 : X.maskFormat;
      let I = j;
      if (typeof H == "string") {
        const R = /(YYYY|MM|DD|hh|mm|ss)/g, te = [...H.matchAll(R)].map((V) => V[0]), O = j.replace(/\D/g, ""), z = x(O, te);
        I = S(z, H);
      }
      I === "" ? Z() : (o.value.openMenu && !s.isMenuOpen && a("open"), G(I), a("set-input-date", D.value)), b.value = !1, l.value = I, r("text-input", F, D.value);
    }, q = (F) => {
      o.value.enabled ? (G(F.target.value), o.value.enterSubmit && y(D.value) && l.value !== "" ? (a("set-input-date", D.value, !0), D.value = null) : o.value.enterSubmit && l.value === "" && (D.value = null, a("clear"))) : he(F);
    }, N = (F, j) => {
      o.value.enabled && o.value.tabSubmit && !j && G(F.target.value), o.value.tabSubmit && y(D.value) && l.value !== "" ? (a("set-input-date", D.value, !0, !0), D.value = null) : o.value.tabSubmit && l.value === "" && (D.value = null, a("clear"));
    }, Q = () => {
      Y.value = !0, a("focus"), Ze().then(() => {
        var F;
        o.value.enabled && o.value.selectOnFocus && ((F = A.value) == null || F.select());
      });
    }, he = (F) => {
      if ($(F, f.value, !0), o.value.enabled && o.value.openMenu && !c.value.input) {
        if (o.value.openMenu === "open" && !s.isMenuOpen) return a("open");
        if (o.value.openMenu === "toggle") return a("toggle");
      } else o.value.enabled || a("toggle");
    }, pe = () => {
      a("real-blur"), Y.value = !1, (!s.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), (i.autoApply && o.value.enabled && D.value && !s.isMenuOpen || o.value.applyOnBlur) && (a("set-input-date", D.value), a("select-date"), D.value = null);
    }, ge = (F) => {
      $(F, f.value, !0), a("clear");
    }, Ce = () => {
      a("close");
    }, ye = (F) => {
      if (F.key === "Tab" && N(F), F.key === "Enter" && q(F), F.key === "Escape" && o.value.escClose && Ce(), !o.value.enabled) {
        if (F.code === "Tab") return;
        F.preventDefault();
      }
    }, K = () => {
      var F;
      (F = A.value) == null || F.focus({ preventScroll: !0 });
    }, be = (F) => {
      D.value = F;
    }, Me = (F) => {
      F.key === ct.tab && N(F, !0);
    };
    return n({
      focusInput: K,
      setParsedDate: be
    }), (F, j) => {
      var H, I;
      return w(), T("div", { onClick: he }, [
        !F.$slots["dp-input"] && !v(c).enabled ? U(F.$slots, "trigger", { key: 0 }) : P("", !0),
        !F.$slots.trigger && (!v(c).enabled || v(c).input) ? (w(), T("div", Xb, [
          !F.$slots.trigger && (!v(c).enabled || v(c).enabled && v(c).input) ? U(F.$slots, "dp-input", {
            key: 0,
            value: v(l),
            isMenuOpen: e.isMenuOpen,
            onInput: le,
            onEnter: q,
            onTab: N,
            onClear: ge,
            onBlur: pe,
            onKeypress: ye,
            onPaste: ce,
            onFocus: Q,
            openMenu: () => F.$emit("open"),
            closeMenu: () => F.$emit("close"),
            toggleMenu: () => F.$emit("toggle")
          }, () => [
            E("input", {
              id: v(g).id,
              ref: "dp-input",
              "data-test-id": "dp-input",
              name: v(g).name,
              class: ne(L.value),
              inputmode: v(g).inputmode,
              placeholder: v(i).placeholder,
              disabled: v(_)(v(i).disabled),
              readonly: v(_)(v(i).readonly),
              required: v(_)(v(g).required),
              value: v(l),
              autocomplete: v(g).autocomplete,
              "aria-label": v(u).input,
              "aria-disabled": v(i).disabled || void 0,
              "aria-invalid": v(g).state === !1 ? !0 : void 0,
              onInput: le,
              onBlur: pe,
              onFocus: Q,
              onKeypress: ye,
              onKeydown: j[0] || (j[0] = (B) => ye(B)),
              onPaste: ce,
              onInvalid: j[1] || (j[1] = (B) => v(r)("invalid", B))
            }, null, 42, Jb)
          ]) : P("", !0),
          E("div", {
            onClick: j[4] || (j[4] = (B) => a("toggle"))
          }, [
            F.$slots["input-icon"] && !v(g).hideInputIcon ? (w(), T("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: j[2] || (j[2] = (B) => a("toggle"))
            }, [
              U(F.$slots, "input-icon")
            ])) : P("", !0),
            !F.$slots["input-icon"] && !v(g).hideInputIcon && !F.$slots["dp-input"] ? (w(), de(v(zs), {
              key: 1,
              "aria-label": (H = v(u)) == null ? void 0 : H.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: j[3] || (j[3] = (B) => a("toggle"))
            }, null, 8, ["aria-label"])) : P("", !0)
          ]),
          F.$slots["clear-icon"] && (v(g).alwaysClearable || v(l) && v(g).clearable && !v(i).disabled && !v(i).readonly) ? (w(), T("span", Qb, [
            U(F.$slots, "clear-icon", { clear: ge })
          ])) : P("", !0),
          !F.$slots["clear-icon"] && (v(g).alwaysClearable || v(g).clearable && v(l) && !v(i).disabled && !v(i).readonly) ? (w(), T("button", {
            key: 2,
            "aria-label": (I = v(u)) == null ? void 0 : I.clearInput,
            class: "dp--clear-btn",
            type: "button",
            "data-test-id": "clear-input-value-btn",
            onKeydown: j[5] || (j[5] = (B) => v(C)(B, () => ge(B), !0, Me)),
            onClick: j[6] || (j[6] = Fe((B) => ge(B), ["prevent"]))
          }, [
            oe(v(eb), { class: "dp__input_icons" })
          ], 40, e0)) : P("", !0)
        ])) : P("", !0)
      ]);
    };
  }
}), n0 = {
  ref: "action-row",
  class: "dp__action_row"
}, a0 = ["title"], s0 = {
  ref: "action-buttons-container",
  class: "dp__action_buttons",
  "data-dp-element": "action-row"
}, r0 = ["disabled"], l0 = /* @__PURE__ */ Se({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { default: 0 }
  },
  emits: ["close-picker", "select-date", "select-now"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      rootEmit: s,
      rootProps: r,
      modelValue: l,
      defaults: { actionRow: i, multiCalendars: o, inline: u, range: c, multiDates: f, formats: m }
    } = Ge(), { isTimeValid: d, isMonthValid: p } = ln(), { formatPreview: g } = aa(), { checkKeyDown: k, convertType: y } = Ot(), { boolHtmlAttribute: h } = rs(), b = Je("action-buttons-container"), S = Je("action-row"), x = ee(!1), C = ee({});
    et(() => {
      $(), globalThis.addEventListener("resize", $);
    }), rn(() => {
      globalThis.removeEventListener("resize", $);
    });
    const $ = () => {
      x.value = !1, setTimeout(() => {
        var le, q;
        const ce = (le = b.value) == null ? void 0 : le.getBoundingClientRect(), G = (q = S.value) == null ? void 0 : q.getBoundingClientRect();
        ce && G && (C.value.maxWidth = `${G.width - ce.width - 20}px`), x.value = !0;
      }, 0);
    }, _ = M(() => c.value.enabled && !c.value.partialRange && l.value ? l.value.length === 2 : !0), A = M(
      () => !d.value(l.value) || !p.value(l.value) || !_.value
    ), D = () => {
      const ce = m.value.preview;
      return r.timePicker || r.monthPicker, ce(y(l.value));
    }, Y = () => {
      const ce = l.value;
      return o.value.count > 0 ? `${g(ce[0])} - ${g(ce[1])}` : [g(ce[0]), g(ce[1])];
    }, L = M(() => !l.value || !a.menuMount ? "" : typeof m.value.preview == "string" ? Array.isArray(l.value) ? l.value.length === 2 && l.value[1] ? Y() : f.value.enabled ? l.value.map((ce) => `${g(ce)}`) : r.modelAuto ? `${g(l.value[0])}` : `${g(l.value[0])} -` : g(l.value) : D()), Z = () => f.value.enabled ? "; " : " - ", se = M(
      () => Array.isArray(L.value) ? L.value.join(Z()) : L.value
    ), ie = () => {
      d.value(l.value) && p.value(l.value) && _.value ? t("select-date") : s("invalid-select");
    };
    return (ce, G) => (w(), T("div", n0, [
      ce.$slots["action-row"] ? U(ce.$slots, "action-row", Mt(rt({ key: 0 }, {
        modelValue: v(l),
        disabled: A.value,
        selectDate: () => ce.$emit("select-date"),
        closePicker: () => ce.$emit("close-picker")
      }))) : (w(), T(Te, { key: 1 }, [
        v(i).showPreview ? (w(), T("div", {
          key: 0,
          class: "dp__selection_preview",
          title: se.value || void 0,
          style: Ve(C.value)
        }, [
          ce.$slots["action-preview"] && x.value ? U(ce.$slots, "action-preview", {
            key: 0,
            value: v(l),
            formatValue: se.value
          }) : P("", !0),
          !ce.$slots["action-preview"] && x.value ? (w(), T(Te, { key: 1 }, [
            Ue(ue(se.value), 1)
          ], 64)) : P("", !0)
        ], 12, a0)) : P("", !0),
        E("div", s0, [
          ce.$slots["action-buttons"] ? U(ce.$slots, "action-buttons", {
            key: 0,
            value: v(l),
            selectDate: ie,
            selectionDisabled: A.value
          }) : P("", !0),
          ce.$slots["action-buttons"] ? P("", !0) : (w(), T(Te, { key: 1 }, [
            !v(u).enabled && v(i).showCancel ? (w(), T("button", {
              key: 0,
              ref: "cancel-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: G[0] || (G[0] = (le) => ce.$emit("close-picker")),
              onKeydown: G[1] || (G[1] = (le) => v(k)(le, () => ce.$emit("close-picker")))
            }, ue(v(i).cancelBtnLabel), 545)) : P("", !0),
            v(i).showNow ? (w(), T("button", {
              key: 1,
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: G[2] || (G[2] = (le) => ce.$emit("select-now")),
              onKeydown: G[3] || (G[3] = (le) => v(k)(le, () => ce.$emit("select-now")))
            }, ue(v(i).nowBtnLabel), 33)) : P("", !0),
            v(i).showSelect ? (w(), T("button", {
              key: 2,
              ref: "select-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_select",
              disabled: v(h)(A.value),
              "data-test-id": "select-button",
              onKeydown: G[4] || (G[4] = (le) => v(k)(le, () => ie())),
              onClick: ie
            }, ue(v(i).selectBtnLabel), 41, r0)) : P("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Hr = () => {
  const {
    rootProps: e,
    defaults: { multiCalendars: n }
  } = Ge(), t = M(() => (r) => {
    var l;
    return (l = e.hideNavigation) == null ? void 0 : l.includes(r);
  }), a = M(() => (r) => n.value.count ? n.value.solo ? !0 : r === 0 : !0), s = M(() => (r) => n.value.count ? n.value.solo ? !0 : r === n.value.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: a, showRightIcon: s };
}, i0 = ["role", "aria-label", "tabindex"], o0 = { class: "dp__selection_grid_header" }, u0 = ["aria-selected", "aria-disabled", "data-dp-action-element", "data-dp-element-active", "data-test-id", "onClick", "onKeydown", "onMouseover"], c0 = ["aria-label", "data-dp-action-element"], Hs = /* @__PURE__ */ Se({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    useRelative: { type: Boolean },
    height: {},
    overlayLabel: {},
    isLast: { type: Boolean },
    level: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      setState: s,
      defaults: { ariaLabels: r, config: l }
    } = Ge(), { hideNavigationButtons: i } = Hr(), { handleEventPropagation: o, checkKeyDown: u } = Ot(), c = Je("toggle-button"), f = Je("overlay-container"), m = Je("grid-wrap"), d = ee(!1), p = ee(null), g = ee(), k = ee(0);
    mf(() => {
      p.value = null;
    }), et(async () => {
      await Ze(), C(), s("arrowNavigationLevel", a.level ?? 1);
    }), rn(() => {
      s("arrowNavigationLevel", (a.level ?? 1) - 1);
    });
    const y = M(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !a.useRelative,
        "dp--overlay-relative": a.useRelative
      })
    ), h = M(
      () => a.useRelative ? { height: `${a.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), b = M(() => ({
      dp__overlay_col: !0
    })), S = M(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: d.value,
        dp__button_bottom: a.isLast
      })
    ), x = M(() => {
      var Z, se;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((Z = a.items) == null ? void 0 : Z.length) <= 6,
        dp__container_block: ((se = a.items) == null ? void 0 : se.length) > 6
      };
    });
    We(
      () => a.items,
      () => C(!1),
      { deep: !0 }
    );
    const C = (Z = !0) => {
      Ze().then(() => {
        const se = document.querySelector(`[data-dp-element-active="${a.level ?? 1}"]`), ie = jt(m), ce = jt(c), G = jt(f), le = ce ? ce.getBoundingClientRect().height : 0;
        ie && (ie.getBoundingClientRect().height ? k.value = ie.getBoundingClientRect().height - le : k.value = l.value.modeHeight - le), se && G && Z && (G.scrollTop = se.offsetTop - G.offsetTop - (k.value / 2 - se.getBoundingClientRect().height) - le);
      });
    }, $ = (Z) => {
      Z.disabled || t("selected", Z.value);
    }, _ = () => {
      t("toggle"), t("reset-flow");
    }, A = (Z) => {
      l.value.escClose && (_(), o(Z, l.value));
    }, D = (Z) => {
      g.value = Z, t("hover-value", Z);
    }, Y = (Z) => {
      if (Z.key === ct.esc) return A(Z);
    }, L = (Z) => {
      if (Z.key === ct.enter) return _();
    };
    return (Z, se) => {
      var ie;
      return w(), T("div", {
        ref: "grid-wrap",
        class: ne(y.value),
        style: Ve(h.value),
        role: e.useRelative ? void 0 : "dialog",
        "aria-label": e.overlayLabel,
        tabindex: e.useRelative ? void 0 : "0",
        onKeydown: Y,
        onClick: se[0] || (se[0] = Fe(() => {
        }, ["prevent"]))
      }, [
        E("div", {
          ref: "overlay-container",
          class: ne(x.value),
          style: Ve({ "--dp-overlay-height": `${k.value}px` }),
          role: "grid"
        }, [
          E("div", o0, [
            U(Z.$slots, "header")
          ]),
          U(Z.$slots, "overlay", {}, () => [
            (w(!0), T(Te, null, Pe(e.items, (ce, G) => (w(), T("div", {
              key: G,
              class: ne(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
              role: "row"
            }, [
              (w(!0), T(Te, null, Pe(ce, (le) => (w(), T("div", {
                key: le.value,
                role: "gridcell",
                class: ne(b.value),
                "aria-selected": le.active || void 0,
                "aria-disabled": le.disabled || void 0,
                "data-dp-action-element": e.level ?? 1,
                "data-dp-element-active": le.active ? e.level ?? 1 : void 0,
                tabindex: "0",
                "data-test-id": le.text,
                onClick: Fe((q) => $(le), ["prevent"]),
                onKeydown: (q) => v(u)(q, () => $(le), !0),
                onMouseover: (q) => D(le.value)
              }, [
                E("div", {
                  class: ne(le.className)
                }, [
                  U(Z.$slots, "item", { item: le }, () => [
                    Ue(ue(le.text), 1)
                  ])
                ], 2)
              ], 42, u0))), 128))
            ], 2))), 128))
          ])
        ], 6),
        Z.$slots["button-icon"] ? mn((w(), T("button", {
          key: 0,
          ref: "toggle-button",
          type: "button",
          "aria-label": (ie = v(r)) == null ? void 0 : ie.toggleOverlay,
          class: ne(S.value),
          tabindex: "0",
          "data-dp-action-element": e.level ?? 1,
          onClick: _,
          onKeydown: L
        }, [
          U(Z.$slots, "button-icon")
        ], 42, c0)), [
          [Fn, !v(i)(e.type)]
        ]) : P("", !0)
      ], 46, i0);
    };
  }
}), d0 = ["data-dp-mobile"], Ur = /* @__PURE__ */ Se({
  __name: "InstanceWrap",
  props: {
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const {
      defaults: { multiCalendars: n }
    } = Ge(), { isMobile: t } = Wr(), a = M(
      () => n.value.count > 0 ? [...new Array(n.value.count).keys()] : [0]
    );
    return (s, r) => (w(), T("div", {
      class: ne({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: v(n).count > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": v(t)
    }, [
      U(s.$slots, "default", {
        instances: a.value,
        wrapClass: { dp__instance_calendar: v(n).count > 0 }
      })
    ], 10, d0));
  }
}), f0 = ["data-dp-element", "aria-label", "aria-disabled"], Ms = /* @__PURE__ */ Se({
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const { checkKeyDown: t } = Ot(), a = n;
    return (s, r) => (w(), T("button", {
      ref: "arrow-btn",
      type: "button",
      "data-dp-element": e.elName,
      "data-dp-action-element": "0",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: r[0] || (r[0] = (l) => a("activate")),
      onKeydown: r[1] || (r[1] = (l) => v(t)(l, () => a("activate"), !0))
    }, [
      E("span", {
        class: ne(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        U(s.$slots, "default")
      ], 2)
    ], 40, f0));
  }
}), h0 = ["aria-label", "data-test-id"], Ed = /* @__PURE__ */ Se({
  __name: "YearModePicker",
  props: {
    items: {},
    instance: {},
    year: {},
    showYearPicker: { type: Boolean, default: !1 },
    isDisabled: {}
  },
  emits: ["handle-year", "year-select", "toggle-year-picker"],
  setup(e, { emit: n }) {
    const t = n, a = e, { showRightIcon: s, showLeftIcon: r } = Hr(), {
      rootProps: l,
      defaults: { config: i, ariaLabels: o, ui: u }
    } = Ge(), { showTransition: c, transitionName: f } = Ws(), { formatYear: m } = aa(), { boolHtmlAttribute: d } = rs(), p = ee(!1), g = M(() => m(a.year)), k = (b = !1, S) => {
      p.value = !p.value, t("toggle-year-picker", { flow: b, show: S });
    }, y = (b) => {
      p.value = !1, t("year-select", b);
    }, h = (b = !1) => {
      t("handle-year", b);
    };
    return (b, S) => {
      var x, C, $, _, A;
      return w(), T(Te, null, [
        E("div", {
          class: ne(["dp--year-mode-picker", { "dp--hidden-el": p.value }])
        }, [
          v(r)(e.instance) ? (w(), de(Ms, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (x = v(o)) == null ? void 0 : x.prevYear,
            disabled: v(d)(e.isDisabled(!1)),
            class: ne((C = v(u)) == null ? void 0 : C.navBtnPrev),
            onActivate: S[0] || (S[0] = (D) => h(!1))
          }, {
            default: fe(() => [
              b.$slots["arrow-left"] ? U(b.$slots, "arrow-left", { key: 0 }) : P("", !0),
              b.$slots["arrow-left"] ? P("", !0) : (w(), de(v(xd), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
          E("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${($ = v(o)) == null ? void 0 : $.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${e.instance}`,
            "data-dp-action-element": "0",
            onClick: S[1] || (S[1] = () => k(!1)),
            onKeydown: S[2] || (S[2] = Pt(Fe(() => k(!1), ["prevent"]), ["enter"]))
          }, [
            b.$slots.year ? U(b.$slots, "year", {
              key: 0,
              text: g.value,
              value: e.year
            }) : P("", !0),
            b.$slots.year ? P("", !0) : (w(), T(Te, { key: 1 }, [
              Ue(ue(e.year), 1)
            ], 64))
          ], 40, h0),
          v(s)(e.instance) ? (w(), de(Ms, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (_ = v(o)) == null ? void 0 : _.nextYear,
            disabled: v(d)(e.isDisabled(!0)),
            class: ne((A = v(u)) == null ? void 0 : A.navBtnNext),
            onActivate: S[3] || (S[3] = (D) => h(!0))
          }, {
            default: fe(() => [
              b.$slots["arrow-right"] ? U(b.$slots, "arrow-right", { key: 0 }) : P("", !0),
              b.$slots["arrow-right"] ? P("", !0) : (w(), de(v(Sd), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : P("", !0)
        ], 2),
        oe(Dt, {
          name: v(f)(e.showYearPicker),
          css: v(c)
        }, {
          default: fe(() => {
            var D, Y;
            return [
              e.showYearPicker ? (w(), de(Hs, {
                key: 0,
                items: e.items,
                config: v(i),
                "is-last": v(l).autoApply && !v(i).keepActionRow,
                "overlay-label": (Y = (D = v(o)) == null ? void 0 : D.yearPicker) == null ? void 0 : Y.call(D, !0),
                type: "year",
                onToggle: k,
                onSelected: S[4] || (S[4] = (L) => y(L))
              }, dt({
                "button-icon": fe(() => [
                  b.$slots["calendar-icon"] ? U(b.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                  b.$slots["calendar-icon"] ? P("", !0) : (w(), de(v(zs), { key: 1 }))
                ]),
                _: 2
              }, [
                b.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: fe(({ item: L }) => [
                    U(b.$slots, "year-overlay-value", {
                      text: L.text,
                      value: L.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "config", "is-last", "overlay-label"])) : P("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Id = (e) => {
  const {
    getDate: n,
    rootEmit: t,
    state: a,
    month: s,
    year: r,
    modelValue: l,
    calendars: i,
    rootProps: o,
    defaults: { multiCalendars: u, range: c, safeDates: f, filters: m, highlight: d }
  } = Ge(), { resetDate: p, getYearFromDate: g, checkHighlightYear: k, groupListAndMap: y } = Vt(), { getYears: h } = Yr(), { validateMonthYear: b, checkMinMaxValue: S } = ln(), x = ee([!1]), C = M(() => h()), $ = M(() => (N, Q) => {
    const he = qe(p(n()), {
      month: s.value(N),
      year: r.value(N)
    }), pe = Q ? ud(he) : Ha(he);
    return b(pe, o.preventMinMaxNavigation, Q);
  }), _ = () => Array.isArray(l.value) && u.value.solo && l.value[1], A = () => {
    for (let N = 0; N < u.value.count; N++)
      if (N === 0)
        i.value[N] = i.value[0];
      else if (N === u.value.count - 1 && _())
        i.value[N] = {
          month: Ke(l.value[1]),
          year: Be(l.value[1])
        };
      else {
        const Q = qe(n(), i.value[N - 1]);
        i.value[N] = { month: Ke(Q), year: Be(ki(Q, 1)) };
      }
  }, D = (N) => {
    if (!N) return A();
    const Q = qe(n(), i.value[N]);
    return i.value[0].year = Be(wd(Q, u.value.count - 1)), A();
  }, Y = (N, Q) => {
    const he = eg(Q, N);
    return c.value.showLastInRange && he > 1 ? Q : N;
  }, L = (N) => o.focusStartDate || u.value.solo ? N[0] : N[1] ? Y(N[0], N[1]) : N[0], Z = () => {
    if (l.value) {
      const N = Array.isArray(l.value) ? L(l.value) : l.value;
      i.value[0] = { month: Ke(N), year: Be(N) };
    }
  }, se = () => {
    Z(), u.value.count && A();
  };
  We(l, (N, Q) => {
    a.isTextInputDate && JSON.stringify(N ?? {}) !== JSON.stringify(Q ?? {}) && se();
  }), et(() => {
    se();
  });
  const ie = (N, Q) => {
    i.value[Q].year = N, t("update-month-year", { instance: Q, year: N, month: i.value[Q].month }), u.value.count && !u.value.solo && D(Q);
  }, ce = M(() => (N) => y(C.value, (Q) => {
    var Ce;
    const he = r.value(N) === Q.value, pe = S(
      Q.value,
      g(f.value.minDate),
      g(f.value.maxDate)
    ) || ((Ce = m.value.years) == null ? void 0 : Ce.includes(r.value(N))), ge = k(d.value, Q.value);
    return { active: he, disabled: pe, highlighted: ge };
  })), G = (N, Q) => {
    ie(N, Q), q(Q);
  }, le = (N, Q = !1) => {
    if (!$.value(N, Q)) {
      const he = Q ? r.value(N) + 1 : r.value(N) - 1;
      ie(he, N);
    }
  }, q = (N, Q = !1, he) => {
    Q || e("reset-flow"), he === void 0 ? x.value[N] = !x.value[N] : x.value[N] = he, x.value[N] ? t("overlay-toggle", { open: !0, overlay: Nt.year }) : t("overlay-toggle", { open: !1, overlay: Nt.year });
  };
  return {
    isDisabled: $,
    groupedYears: ce,
    showYearPicker: x,
    selectYear: ie,
    setStartDate: () => {
      o.startDate && (l.value && o.focusStartDate || !l.value) && ie(Be(n(o.startDate)), 0);
    },
    toggleYearPicker: q,
    handleYearSelect: G,
    handleYear: le
  };
}, qr = () => {
  const { isDateAfter: e, isDateBefore: n, isDateEqual: t } = Vt(), {
    getDate: a,
    rootEmit: s,
    rootProps: r,
    modelValue: l,
    defaults: { range: i }
  } = Ge();
  return {
    getRangeWithFixedDate: (o) => Array.isArray(l.value) && (l.value.length === 2 || l.value.length === 1 && i.value.partialRange) ? i.value.fixedStart && (e(o, l.value[0]) || t(o, l.value[0])) ? [l.value[0], o] : i.value.fixedEnd && (n(o, l.value[1]) || t(o, l.value[1])) ? [o, l.value[1]] : (s("invalid-fixed-range", o), l.value) : [],
    setPresetDate: (o) => {
      Array.isArray(o.value) && o.value.length <= 2 && i.value.enabled ? l.value = o.value.map((u) => a(u)) : Array.isArray(o.value) || (l.value = a(o.value));
    },
    checkRangeAutoApply: (o, u, c) => {
      i && (o[0] && o[1] && r.autoApply && u("auto-apply", c), o[0] && !o[1] && (r.modelAuto || i.value.partialRange) && r.autoApply && u("auto-apply", c));
    },
    setMonthOrYearRange: (o) => {
      let u = l.value ? l.value.slice() : [];
      return u.length === 2 && u[1] !== null && (u = []), u.length ? (n(o, u[0]) ? u.unshift(o) : u[1] = o, s("range-end", o)) : (u = [o], s("range-start", o)), u;
    },
    handleMultiDatesSelect: (o, u) => {
      if (l.value && Array.isArray(l.value))
        if (l.value.some((c) => t(o, c))) {
          const c = l.value.filter((f) => !t(f, o));
          l.value = c.length ? c : null;
        } else (u && +u > l.value.length || !u) && l.value.push(o);
      else
        l.value = [o];
    }
  };
}, m0 = (e, n) => {
  const {
    getDate: t,
    rootEmit: a,
    state: s,
    calendars: r,
    year: l,
    modelValue: i,
    rootProps: o,
    defaults: { range: u, highlight: c, safeDates: f, filters: m, multiDates: d }
  } = Ge();
  Ys(() => {
    s.isTextInputDate && G(Be(t(o.startDate)), 0);
  });
  const { checkMinMaxRange: p, checkMinMaxValue: g } = ln(), { isDateBetween: k, resetDateTime: y, resetDate: h, getMinMonth: b, getMaxMonth: S, checkHighlightMonth: x, groupListAndMap: C } = Vt(), { checkRangeAutoApply: $, getRangeWithFixedDate: _, handleMultiDatesSelect: A, setMonthOrYearRange: D, setPresetDate: Y } = qr(), { padZero: L } = Ot(), { getMonths: Z, isOutOfYearRange: se } = Yr(), ie = M(() => Z()), ce = ee(null), {
    selectYear: G,
    groupedYears: le,
    showYearPicker: q,
    toggleYearPicker: N,
    handleYearSelect: Q,
    handleYear: he,
    isDisabled: pe,
    setStartDate: ge
  } = Id(n);
  et(() => {
    ge();
  });
  const Ce = (W) => W ? { month: Ke(W), year: Be(W) } : { month: null, year: null }, ye = () => i.value ? Array.isArray(i.value) ? i.value.map((W) => Ce(W)) : Ce(i.value) : Ce(), K = (W, me) => {
    const De = r.value[W], Re = ye();
    return Array.isArray(Re) ? Re.some((Ee) => Ee.year === (De == null ? void 0 : De.year) && Ee.month === me) : (De == null ? void 0 : De.year) === Re.year && me === Re.month;
  }, be = (W, me, De) => {
    var Ee, Ye;
    const Re = ye();
    return Array.isArray(Re) ? l.value(me) === ((Ee = Re[De]) == null ? void 0 : Ee.year) && W === ((Ye = Re[De]) == null ? void 0 : Ye.month) : !1;
  }, Me = (W, me) => {
    if (u.value.enabled) {
      const De = ye();
      if (Array.isArray(i.value) && Array.isArray(De)) {
        const Re = be(W, me, 0) || be(W, me, 1), Ee = qe(h(t()), { month: W, year: l.value(me) });
        return k(i.value, ce.value, Ee) && !Re;
      }
      return !1;
    }
    return !1;
  }, F = M(() => (W) => C(ie.value, (me) => {
    var At;
    const De = K(W, me.value), Re = g(
      me.value,
      b(l.value(W), f.value.minDate),
      S(l.value(W), f.value.maxDate)
    ) || V(f.value.disabledDates, l.value(W), me.value) || ((At = m.value.months) == null ? void 0 : At.includes(me.value)) || !re(f.value.allowedDates, l.value(W), me.value) || se(l.value(W)), Ee = Me(me.value, W), Ye = x(c.value, me.value, l.value(W));
    return { active: De, disabled: Re, isBetween: Ee, highlighted: Ye };
  })), j = (W, me) => qe(h(t()), { month: W, year: l.value(me) }), H = (W, me) => {
    const De = i.value ? i.value : h(t());
    i.value = qe(De, { month: W, year: l.value(me) }), n("auto-apply"), n("update-flow-step");
  }, I = (W, me) => {
    const De = j(W, me);
    u.value.fixedEnd || u.value.fixedStart ? i.value = _(De) : i.value ? p(De, i.value) && (i.value = D(j(W, me))) : i.value = [j(W, me)], Ze().then(() => {
      $(i.value, n, i.value.length < 2);
    });
  }, B = (W, me) => {
    A(j(W, me), d.value.limit), n("auto-apply", !0);
  }, X = (W, me) => (r.value[me].month = W, te(me, r.value[me].year, W), d.value.enabled ? B(W, me) : u.value.enabled ? I(W, me) : H(W, me)), R = (W, me) => {
    G(W, me), te(me, W, null);
  }, te = (W, me, De) => {
    let Re = De;
    if (!Re && Re !== 0) {
      const Ee = ye();
      Re = Array.isArray(Ee) ? Ee[W].month : Ee.month;
    }
    a("update-month-year", { instance: W, year: me, month: Re });
  }, O = (W, me) => {
    ce.value = j(W, me);
  }, z = (W) => {
    Y({
      value: W
    }), n("auto-apply");
  }, V = (W, me, De) => {
    if (W instanceof Map) {
      const Re = `${L(De + 1)}-${me}`;
      return W.size ? W.has(Re) : !1;
    }
    return typeof W == "function" ? W(y(qe(t(), { month: De, year: me }), !0)) : !1;
  }, re = (W, me, De) => {
    if (W instanceof Map) {
      const Re = `${L(De + 1)}-${me}`;
      return W.size ? W.has(Re) : !0;
    }
    return !0;
  };
  return {
    groupedMonths: F,
    groupedYears: le,
    year: l,
    isDisabled: pe,
    showYearPicker: q,
    modelValue: i,
    toggleYearPicker: N,
    handleYearSelect: Q,
    handleYear: he,
    presetDate: z,
    setHoverDate: O,
    selectMonth: X,
    selectYear: R,
    getModelMonthYear: ye
  };
}, v0 = /* @__PURE__ */ Se({
  __name: "MonthPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply", "update-flow-step", "mount"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, r = Ht(), {
      rootProps: l,
      defaults: { config: i }
    } = Ge(), o = Cn(r, gn.YearMode);
    et(() => {
      a("mount");
    });
    const {
      groupedMonths: u,
      groupedYears: c,
      year: f,
      isDisabled: m,
      showYearPicker: d,
      modelValue: p,
      presetDate: g,
      setHoverDate: k,
      selectMonth: y,
      selectYear: h,
      toggleYearPicker: b,
      handleYearSelect: S,
      handleYear: x,
      getModelMonthYear: C
    } = m0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: p,
      year: f,
      getModelMonthYear: C,
      selectMonth: y,
      selectYear: h,
      handleYear: x
    }), presetDate: g, toggleYearPicker: ($) => b(0, $) }), ($, _) => (w(), de(Ur, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: fe(({ instances: A, wrapClass: D }) => [
        (w(!0), T(Te, null, Pe(A, (Y) => (w(), T("div", {
          key: Y,
          class: ne(D)
        }, [
          $.$slots["top-extra"] ? U($.$slots, "top-extra", {
            key: 0,
            value: v(p)
          }) : P("", !0),
          U($.$slots, "month-year", rt({ ref_for: !0 }, {
            year: v(f),
            months: v(u)(Y),
            years: v(c)(Y),
            selectMonth: v(y),
            selectYear: v(h),
            instance: Y
          }), () => [
            oe(Hs, {
              items: v(u)(Y),
              "is-last": v(l).autoApply && !v(i).keepActionRow,
              height: v(i).modeHeight,
              "no-overlay-focus": !!(e.noOverlayFocus || v(l).textInput),
              "use-relative": "",
              level: 0,
              type: "month",
              onSelected: (L) => v(y)(L, Y),
              onHoverValue: (L) => v(k)(L, Y)
            }, dt({
              header: fe(() => [
                oe(Ed, {
                  items: v(c)(Y),
                  instance: Y,
                  "show-year-picker": v(d)[Y],
                  year: v(f)(Y),
                  "is-disabled": (L) => v(m)(Y, L),
                  onHandleYear: (L) => v(x)(Y, L),
                  onYearSelect: (L) => v(S)(L, Y),
                  onToggleYearPicker: (L) => v(b)(Y, L == null ? void 0 : L.flow, L == null ? void 0 : L.show)
                }, dt({ _: 2 }, [
                  Pe(v(o), (L, Z) => ({
                    name: L,
                    fn: fe((se) => [
                      U($.$slots, L, rt({ ref_for: !0 }, se))
                    ])
                  }))
                ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
              ]),
              _: 2
            }, [
              $.$slots["month-overlay-value"] ? {
                name: "item",
                fn: fe(({ item: L }) => [
                  U($.$slots, "month-overlay-value", {
                    text: L.text,
                    value: L.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "onSelected", "onHoverValue"])
          ])
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), p0 = (e, n) => {
  const {
    rootEmit: t,
    getDate: a,
    state: s,
    modelValue: r,
    rootProps: l,
    defaults: { highlight: i, multiDates: o, filters: u, range: c, safeDates: f }
  } = Ge(), { getYears: m } = Yr(), { isDateBetween: d, resetDate: p, resetDateTime: g, getYearFromDate: k, checkHighlightYear: y, groupListAndMap: h } = Vt(), { checkRangeAutoApply: b, setMonthOrYearRange: S } = qr(), { checkMinMaxValue: x, checkMinMaxRange: C } = ln();
  Ys(() => {
    s.isTextInputDate && (_.value = Be(a(l.startDate)));
  });
  const $ = ee(null), _ = ee();
  et(() => {
    l.startDate && (r.value && l.focusStartDate || !r.value) && (_.value = Be(a(l.startDate)));
  });
  const A = (ie) => Array.isArray(r.value) ? r.value.some((ce) => Be(ce) === ie) : r.value ? Be(r.value) === ie : !1, D = (ie) => c.value.enabled && Array.isArray(r.value) ? d(r.value, $.value, se(ie)) : !1, Y = (ie) => {
    var ce;
    return (ce = f.value.allowedDates) != null && ce.size ? f.value.allowedDates.has(`${ie}`) : !0;
  }, L = (ie) => f.value.disabledDates instanceof Map ? f.value.disabledDates.size ? f.value.disabledDates.has(`${ie}`) : !1 : typeof f.value.disabledDates == "function" ? f.value.disabledDates(hn(g(Ha(a())), ie)) : !0, Z = M(() => h(m(), (ie) => {
    const ce = A(ie.value), G = x(
      ie.value,
      k(f.value.minDate),
      k(f.value.maxDate)
    ) || u.value.years.includes(ie.value) || !Y(ie.value) || L(ie.value), le = D(ie.value) && !ce, q = y(i.value, ie.value);
    return { active: ce, disabled: G, isBetween: le, highlighted: q };
  })), se = (ie) => hn(p(Ha(a())), ie);
  return {
    groupedYears: Z,
    focusYear: _,
    setHoverValue: (ie) => {
      $.value = hn(p(a()), ie);
    },
    selectYear: (ie) => {
      var ce;
      if (t("update-month-year", { instance: 0, year: ie, month: Number.NaN }), o.value.enabled)
        return r.value ? Array.isArray(r.value) && (((ce = r.value) == null ? void 0 : ce.map((G) => Be(G))).includes(ie) ? r.value = r.value.filter((G) => Be(G) !== ie) : r.value.push(hn(g(a()), ie))) : r.value = [hn(g(Ha(a())), ie)], n("auto-apply", !0);
      c.value.enabled ? C(se(ie), r.value) && (r.value = S(se(ie)), Ze().then(() => {
        b(r.value, n, r.value.length < 2);
      })) : (r.value = se(ie), n("auto-apply"));
    }
  };
}, g0 = /* @__PURE__ */ Se({
  __name: "YearPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      modelValue: r,
      defaults: { config: l },
      rootProps: i
    } = Ge(), { groupedYears: o, focusYear: u, selectYear: c, setHoverValue: f } = p0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: r,
      selectYear: c
    }) }), (m, d) => (w(), T("div", null, [
      m.$slots["top-extra"] ? U(m.$slots, "top-extra", {
        key: 0,
        value: v(r)
      }) : P("", !0),
      m.$slots["month-year"] ? U(m.$slots, "month-year", Mt(rt({ key: 1 }, {
        years: v(o),
        selectYear: v(c)
      }))) : (w(), de(Hs, {
        key: 2,
        items: v(o),
        "is-last": v(i).autoApply && !v(l).keepActionRow,
        height: v(l).modeHeight,
        "no-overlay-focus": !!(e.noOverlayFocus || v(i).textInput),
        "focus-value": v(u),
        type: "year",
        "use-relative": "",
        onSelected: v(c),
        onHoverValue: v(f)
      }, dt({ _: 2 }, [
        m.$slots["year-overlay-value"] ? {
          name: "item",
          fn: fe(({ item: p }) => [
            U(m.$slots, "year-overlay-value", {
              text: p.text,
              value: p.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), y0 = {
  key: 0,
  class: "dp__time_input"
}, b0 = ["data-compact", "data-collapsed"], w0 = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], k0 = ["aria-label", "disabled", "data-dp-action-element", "data-test-id", "onKeydown", "onClick"], x0 = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], S0 = { key: 0 }, T0 = ["aria-label", "data-dp-action-element", "data-compact"], M0 = /* @__PURE__ */ Se({
  __name: "TimeInput",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    order: {},
    closeTimePickerBtn: {},
    disabledTimesConfig: {},
    validateTime: {}
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "overlay-opened", "overlay-closed", "set-hours", "set-minutes", "reset-flow", "mounted"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: r,
      rootEmit: l,
      rootProps: i,
      defaults: { ariaLabels: o, filters: u, config: c, range: f, multiCalendars: m, timeConfig: d }
    } = Ge(), { checkKeyDown: p, hoursToAmPmHours: g } = Ot(), { boolHtmlAttribute: k } = rs(), { sanitizeTime: y, groupListAndMap: h } = Vt(), { transitionName: b, showTransition: S } = Ws(), x = ga({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), C = ee("AM"), $ = ee(null), _ = ee(), A = ee(!1);
    et(() => {
      a("mounted");
    });
    const D = (V) => qe(r(), {
      hours: V.hours,
      minutes: V.minutes,
      seconds: d.value.enableSeconds ? V.seconds : 0,
      milliseconds: 0
    }), Y = M(() => i.timePicker || d.value.timePickerInline ? 0 : 1), L = M(
      () => (V) => Ce(V, s[V]) || se(V, s[V])
    ), Z = M(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), se = (V, re) => f.value.enabled && !f.value.disableTimeRangeValidation ? !s.validateTime(V, re) : !1, ie = (V, re) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const W = re ? +d.value[`${V}Increment`] : -+d.value[`${V}Increment`], me = s[V] + W;
        return !s.validateTime(V, me);
      }
      return !1;
    }, ce = M(() => (V) => !F(+s[V] + +d.value[`${V}Increment`], V) || ie(V, !0)), G = M(() => (V) => !F(+s[V] - +d.value[`${V}Increment`], V) || ie(V, !1)), le = (V, re) => sd(qe(r(), V), re), q = (V, re) => Zy(qe(r(), V), re), N = M(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !d.value.timePickerInline,
        dp__time_col_reg_block: !d.value.enableSeconds && d.value.is24 && !d.value.timePickerInline,
        dp__time_col_reg_inline: !d.value.enableSeconds && d.value.is24 && d.value.timePickerInline,
        dp__time_col_reg_with_button: !d.value.enableSeconds && !d.value.is24,
        dp__time_col_sec: d.value.enableSeconds && d.value.is24,
        dp__time_col_sec_with_button: d.value.enableSeconds && !d.value.is24
      })
    ), Q = M(
      () => d.value.timePickerInline && f.value.enabled && !m.value.count
    ), he = M(() => {
      const V = [{ type: "hours" }];
      return d.value.enableMinutes && V.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), d.value.enableSeconds && V.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), V;
    }), pe = M(() => he.value.filter((V) => !V.separator)), ge = M(() => (V) => {
      if (V === "hours") {
        const re = R(+s.hours);
        return { text: re < 10 ? `0${re}` : `${re}`, value: re };
      }
      return { text: s[V] < 10 ? `0${s[V]}` : `${s[V]}`, value: s[V] };
    }), Ce = (V, re) => {
      var me;
      if (!s.disabledTimesConfig) return !1;
      const W = s.disabledTimesConfig(s.order, V === "hours" ? re : void 0);
      return W[V] ? !!((me = W[V]) != null && me.includes(re)) : !0;
    }, ye = (V, re) => re !== "hours" || C.value === "AM" ? V : V + 12, K = (V) => {
      const re = d.value.is24 ? 24 : 12, W = V === "hours" ? re : 60, me = +d.value[`${V}GridIncrement`], De = V === "hours" && !d.value.is24 ? me : 0, Re = [];
      for (let Ee = De; Ee < W; Ee += me)
        Re.push({
          value: d.value.is24 ? Ee : ye(Ee, V),
          text: Ee < 10 ? `0${Ee}` : `${Ee}`
        });
      return V === "hours" && !d.value.is24 && Re.unshift({ value: C.value === "PM" ? 12 : 0, text: "12" }), h(Re, (Ee) => ({ active: !1, disabled: u.value.times[V].includes(Ee.value) || !F(Ee.value, V) || Ce(V, Ee.value) || se(V, Ee.value) }));
    }, be = (V) => V >= 0 ? V : 59, Me = (V) => V >= 0 ? V : 23, F = (V, re) => {
      const W = i.minTime ? D(y(i.minTime)) : null, me = i.maxTime ? D(y(i.maxTime)) : null, De = D(
        y(
          Z.value,
          re,
          re === "minutes" || re === "seconds" ? be(V) : Me(V)
        )
      );
      return W && me ? (Vn(De, me) || Fa(De, me)) && (Tn(De, W) || Fa(De, W)) : W ? Tn(De, W) || Fa(De, W) : me ? Vn(De, me) || Fa(De, me) : !0;
    }, j = (V) => d.value[`no${V[0].toUpperCase() + V.slice(1)}Overlay`], H = (V) => {
      j(V) || (x[V] = !x[V], x[V] ? (A.value = !0, a("overlay-opened", V)) : (A.value = !1, a("overlay-closed", V)));
    }, I = (V) => V === "hours" ? On : V === "minutes" ? Bn : na, B = () => {
      _.value && clearTimeout(_.value);
    }, X = (V, re = !0, W) => {
      const me = re ? le : q, De = re ? +d.value[`${V}Increment`] : -+d.value[`${V}Increment`];
      F(+s[V] + De, V) && a(
        `update:${V}`,
        I(V)(
          me({ [V]: +s[V] }, { [V]: +d.value[`${V}Increment`] })
        )
      ), !(W != null && W.keyboard) && c.value.timeArrowHoldThreshold && (_.value = setTimeout(() => {
        X(V, re);
      }, c.value.timeArrowHoldThreshold));
    }, R = (V) => d.value.is24 ? V : (V >= 12 ? C.value = "PM" : C.value = "AM", g(V)), te = () => {
      C.value === "PM" ? (C.value = "AM", a("update:hours", s.hours - 12)) : (C.value = "PM", a("update:hours", s.hours + 12)), l("am-pm-change", C.value);
    }, O = (V) => {
      x[V] = !0;
    }, z = (V, re) => (H(V), a(`update:${V}`, re));
    return n({ openChildCmp: O }), (V, re) => v(i).disabled ? P("", !0) : (w(), T("div", y0, [
      (w(!0), T(Te, null, Pe(he.value, (W, me) => {
        var De, Re, Ee;
        return w(), T("div", {
          key: me,
          class: ne(N.value),
          "data-compact": Q.value && !v(d).enableSeconds,
          "data-collapsed": Q.value && v(d).enableSeconds
        }, [
          W.separator ? (w(), T(Te, { key: 0 }, [
            A.value ? P("", !0) : (w(), T(Te, { key: 0 }, [
              Ue(":")
            ], 64))
          ], 64)) : (w(), T(Te, { key: 1 }, [
            E("button", {
              type: "button",
              class: ne({
                dp__btn: !0,
                dp__inc_dec_button: !v(d).timePickerInline,
                dp__inc_dec_button_inline: v(d).timePickerInline,
                dp__tp_inline_btn_top: v(d).timePickerInline,
                dp__inc_dec_button_disabled: ce.value(W.type),
                "dp--hidden-el": A.value
              }),
              "data-test-id": `${W.type}-time-inc-btn-${s.order}`,
              "aria-label": (De = v(o)) == null ? void 0 : De.incrementValue(W.type),
              tabindex: "0",
              "data-dp-action-element": Y.value,
              onKeydown: (Ye) => v(p)(Ye, () => X(W.type, !0, { keyboard: !0 }), !0),
              onClick: (Ye) => v(c).timeArrowHoldThreshold ? void 0 : X(W.type, !0),
              onMousedown: (Ye) => v(c).timeArrowHoldThreshold ? X(W.type, !0) : void 0,
              onMouseup: B
            }, [
              v(d).timePickerInline ? U(V.$slots, "tp-inline-arrow-up", { key: 1 }, () => [
                re[2] || (re[2] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                re[3] || (re[3] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : U(V.$slots, "arrow-up", { key: 0 }, () => [
                oe(v(Md))
              ])
            ], 42, w0),
            E("button", {
              type: "button",
              "aria-label": `${ge.value(W.type).text}-${(Re = v(o)) == null ? void 0 : Re.openTpOverlay(W.type)}`,
              class: ne({
                dp__time_display: !0,
                dp__time_display_block: !v(d).timePickerInline,
                dp__time_display_inline: v(d).timePickerInline,
                "dp--time-invalid": L.value(W.type),
                "dp--time-overlay-btn": !L.value(W.type),
                "dp--hidden-el": A.value
              }),
              disabled: v(k)(j(W.type)),
              tabindex: "0",
              "data-dp-action-element": Y.value,
              "data-test-id": `${W.type}-toggle-overlay-btn-${s.order}`,
              onKeydown: (Ye) => v(p)(Ye, () => H(W.type), !0),
              onClick: (Ye) => H(W.type)
            }, [
              U(V.$slots, W.type, {
                text: ge.value(W.type).text,
                value: ge.value(W.type).value
              }, () => [
                Ue(ue(ge.value(W.type).text), 1)
              ])
            ], 42, k0),
            E("button", {
              type: "button",
              class: ne({
                dp__btn: !0,
                dp__inc_dec_button: !v(d).timePickerInline,
                dp__inc_dec_button_inline: v(d).timePickerInline,
                dp__tp_inline_btn_bottom: v(d).timePickerInline,
                dp__inc_dec_button_disabled: G.value(W.type),
                "dp--hidden-el": A.value
              }),
              "data-test-id": `${W.type}-time-dec-btn-${s.order}`,
              "aria-label": (Ee = v(o)) == null ? void 0 : Ee.decrementValue(W.type),
              tabindex: "0",
              "data-dp-action-element": Y.value,
              onKeydown: (Ye) => v(p)(Ye, () => X(W.type, !1, { keyboard: !0 }), !0),
              onClick: (Ye) => v(c).timeArrowHoldThreshold ? void 0 : X(W.type, !1),
              onMousedown: (Ye) => v(c).timeArrowHoldThreshold ? X(W.type, !1) : void 0,
              onMouseup: B
            }, [
              v(d).timePickerInline ? U(V.$slots, "tp-inline-arrow-down", { key: 1 }, () => [
                re[4] || (re[4] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                re[5] || (re[5] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : U(V.$slots, "arrow-down", { key: 0 }, () => [
                oe(v($d))
              ])
            ], 42, x0)
          ], 64))
        ], 10, b0);
      }), 128)),
      v(d).is24 ? P("", !0) : (w(), T("div", S0, [
        U(V.$slots, "am-pm-button", {
          toggle: te,
          value: C.value
        }, () => {
          var W;
          return [
            E("button", {
              ref_key: "amPmButton",
              ref: $,
              type: "button",
              class: "dp__pm_am_button",
              role: "button",
              "aria-label": (W = v(o)) == null ? void 0 : W.amPmButton,
              tabindex: "0",
              "data-dp-action-element": Y.value,
              "data-compact": Q.value,
              onClick: te,
              onKeydown: re[0] || (re[0] = (me) => v(p)(me, () => te(), !0))
            }, ue(C.value), 41, T0)
          ];
        })
      ])),
      (w(!0), T(Te, null, Pe(pe.value, (W, me) => (w(), de(Dt, {
        key: me,
        name: v(b)(x[W.type]),
        css: v(S)
      }, {
        default: fe(() => {
          var De, Re;
          return [
            x[W.type] ? (w(), de(Hs, {
              key: 0,
              items: K(W.type),
              "is-last": v(i).autoApply && !v(c).keepActionRow,
              type: W.type,
              "aria-labels": v(o),
              level: v(d).timePickerInline || v(i).timePicker ? 1 : 2,
              "overlay-label": (Re = (De = v(o)).timeOverlay) == null ? void 0 : Re.call(De, W.type),
              onSelected: (Ee) => z(W.type, Ee),
              onToggle: (Ee) => H(W.type),
              onResetFlow: re[1] || (re[1] = (Ee) => V.$emit("reset-flow"))
            }, dt({
              "button-icon": fe(() => [
                U(V.$slots, "clock-icon", {}, () => [
                  V.$slots["clock-icon"] ? P("", !0) : (w(), de(ht(v(d).timePickerInline ? v(zs) : v(Td)), { key: 0 }))
                ])
              ]),
              _: 2
            }, [
              V.$slots[`${W.type}-overlay-value`] ? {
                name: "item",
                fn: fe(({ item: Ee }) => [
                  U(V.$slots, `${W.type}-overlay-value`, {
                    text: Ee.text,
                    value: Ee.value
                  })
                ]),
                key: "0"
              } : void 0,
              V.$slots[`${W.type}-overlay-header`] ? {
                name: "header",
                fn: fe(() => [
                  U(V.$slots, `${W.type}-overlay-header`, {
                    toggle: () => H(W.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "type", "aria-labels", "level", "overlay-label", "onSelected", "onToggle"])) : P("", !0)
          ];
        }),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), $0 = ["data-dp-mobile"], C0 = ["aria-label", "tabindex"], D0 = ["role", "aria-label", "tabindex"], O0 = ["aria-label"], Pd = /* @__PURE__ */ Se({
  __name: "TimePicker",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    disabledTimesConfig: { type: [Function, null] },
    noOverlayFocus: { type: Boolean },
    validateTime: { type: Function }
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "mount", "reset-flow"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: r,
      setState: l,
      modelValue: i,
      rootProps: o,
      defaults: { ariaLabels: u, textInput: c, config: f, range: m, timeConfig: d }
    } = Ge(), { isModelAuto: p } = Vt(), { checkKeyDown: g, findFocusableEl: k } = Ot(), { transitionName: y, showTransition: h } = Ws(), { hideNavigationButtons: b } = Hr(), { isMobile: S } = Wr(), x = Ht(), C = Je("overlay"), $ = Je("close-tp-btn"), _ = Je("tp-input"), A = ee(!1);
    et(() => {
      a("mount");
    });
    const D = M(() => m.value.enabled && o.modelAuto ? p(i.value) : !0), Y = ee(!1), L = (ge) => ({
      hours: Array.isArray(s.hours) ? s.hours[ge] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[ge] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[ge] : s.seconds
    }), Z = M(() => {
      const ge = [];
      if (m.value.enabled)
        for (let Ce = 0; Ce < 2; Ce++)
          ge.push(L(Ce));
      else
        ge.push(L(0));
      return ge;
    }), se = (ge, Ce = !1, ye = "") => {
      Ce || a("reset-flow"), Y.value = ge, l("arrowNavigationLevel", ge ? 1 : 0), r("overlay-toggle", { open: ge, overlay: Nt.time }), Ze(() => {
        var K;
        ye !== "" && ((K = _.value) != null && K[0]) && _.value[0].openChildCmp(ye);
      });
    }, ie = M(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: o.autoApply && !f.value.keepActionRow
    })), ce = Cn(x, gn.TimeInput), G = (ge, Ce, ye) => m.value.enabled ? Ce === 0 ? [ge, Z.value[1][ye]] : [Z.value[0][ye], ge] : ge, le = (ge) => {
      a("update:hours", ge);
    }, q = (ge) => {
      a("update:minutes", ge);
    }, N = (ge) => {
      a("update:seconds", ge);
    }, Q = () => {
      if (C.value && !c.value.enabled && !s.noOverlayFocus) {
        const ge = k(C.value);
        ge && ge.focus({ preventScroll: !0 });
      }
    }, he = (ge) => {
      A.value = !1, r("overlay-toggle", { open: !1, overlay: ge });
    }, pe = (ge) => {
      A.value = !0, r("overlay-toggle", { open: !0, overlay: ge });
    };
    return n({ toggleTimePicker: se }), (ge, Ce) => {
      var ye;
      return w(), T("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": v(S)
      }, [
        !v(o).timePicker && !v(d).timePickerInline ? mn((w(), T("button", {
          key: 0,
          ref: "open-tp-btn",
          type: "button",
          "data-dp-action-element": "0",
          class: ne({ ...ie.value, "dp--hidden-el": Y.value }),
          "aria-label": (ye = v(u)) == null ? void 0 : ye.openTimePicker,
          tabindex: e.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: Ce[0] || (Ce[0] = (K) => v(g)(K, () => se(!0))),
          onClick: Ce[1] || (Ce[1] = (K) => se(!0))
        }, [
          U(ge.$slots, "clock-icon", {}, () => [
            oe(v(Td))
          ])
        ], 42, C0)), [
          [Fn, !v(b)("time")]
        ]) : P("", !0),
        oe(Dt, {
          name: v(y)(Y.value),
          css: v(h) && !v(d).timePickerInline
        }, {
          default: fe(() => {
            var K, be;
            return [
              Y.value || v(o).timePicker || v(d).timePickerInline ? (w(), T("div", {
                key: 0,
                ref: "overlay",
                role: v(d).timePickerInline ? void 0 : "dialog",
                class: ne({
                  dp__overlay: !v(d).timePickerInline,
                  "dp--overlay-absolute": !v(o).timePicker && !v(d).timePickerInline,
                  "dp--overlay-relative": v(o).timePicker
                }),
                style: Ve(v(o).timePicker ? { height: `${v(f).modeHeight}px` } : void 0),
                "aria-label": (K = v(u)) == null ? void 0 : K.timePicker,
                tabindex: v(d).timePickerInline ? void 0 : 0
              }, [
                E("div", {
                  class: ne(
                    v(d).timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  U(ge.$slots, "time-picker-overlay", {
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: le,
                    setMinutes: q,
                    setSeconds: N
                  }, () => [
                    E("div", {
                      class: ne(v(d).timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                    }, [
                      (w(!0), T(Te, null, Pe(Z.value, (Me, F) => mn((w(), de(M0, rt({ key: F }, { ref_for: !0 }, {
                        order: F,
                        hours: Me.hours,
                        minutes: Me.minutes,
                        seconds: Me.seconds,
                        closeTimePickerBtn: $.value,
                        disabledTimesConfig: e.disabledTimesConfig,
                        disabled: F === 0 ? v(m).fixedStart : v(m).fixedEnd
                      }, {
                        ref_for: !0,
                        ref: "tp-input",
                        "validate-time": (j, H) => e.validateTime(j, G(H, F, j)),
                        "onUpdate:hours": (j) => le(G(j, F, "hours")),
                        "onUpdate:minutes": (j) => q(G(j, F, "minutes")),
                        "onUpdate:seconds": (j) => N(G(j, F, "seconds")),
                        onMounted: Q,
                        onOverlayClosed: he,
                        onOverlayOpened: pe
                      }), dt({ _: 2 }, [
                        Pe(v(ce), (j, H) => ({
                          name: j,
                          fn: fe((I) => [
                            U(ge.$slots, j, rt({ ref_for: !0 }, I))
                          ])
                        }))
                      ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                        [Fn, F === 0 ? !0 : D.value]
                      ])), 128))
                    ], 2)
                  ]),
                  !v(o).timePicker && !v(d).timePickerInline ? mn((w(), T("button", {
                    key: 0,
                    ref: "close-tp-btn",
                    "data-dp-action-element": "1",
                    type: "button",
                    class: ne({ ...ie.value, "dp--hidden-el": A.value }),
                    "aria-label": (be = v(u)) == null ? void 0 : be.closeTimePicker,
                    tabindex: "0",
                    onKeydown: Ce[2] || (Ce[2] = (Me) => v(g)(Me, () => se(!1))),
                    onClick: Ce[3] || (Ce[3] = (Me) => se(!1))
                  }, [
                    U(ge.$slots, "calendar-icon", {}, () => [
                      oe(v(zs))
                    ])
                  ], 42, O0)), [
                    [Fn, !v(b)("time")]
                  ]) : P("", !0)
                ], 2)
              ], 14, D0)) : P("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, $0);
    };
  }
}), Ad = (e) => {
  const {
    getDate: n,
    modelValue: t,
    time: a,
    rootProps: s,
    defaults: { range: r, timeConfig: l }
  } = Ge(), { isDateEqual: i, setTime: o } = Vt(), u = ($, _) => Array.isArray(a[$]) ? a[$][_] : a[$], c = ($) => l.value.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[$] : a.seconds : 0, f = ($, _) => $ ? o(
    _ !== void 0 ? { hours: u("hours", _), minutes: u("minutes", _), seconds: c(_) } : { hours: a.hours, minutes: a.minutes, seconds: c() },
    $
  ) : Ky(n(), c(_)), m = ($, _) => {
    a[$] = _;
  }, d = M(() => s.modelAuto && r.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : r.value.enabled), p = ($, _) => {
    const A = Object.fromEntries(
      Object.keys(a).map((D) => D === $ ? [D, _] : [D, a[D]].slice())
    );
    if (d.value && !r.value.disableTimeRangeValidation) {
      const D = (L) => t.value ? o(
        {
          hours: A.hours[L],
          minutes: A.minutes[L],
          seconds: A.seconds[L]
        },
        t.value[L]
      ) : null, Y = (L) => Gy(t.value[L], 0);
      return !(i(D(0), D(1)) && (Tn(D(0), Y(1)) || Vn(D(1), Y(0))));
    }
    return !0;
  }, g = ($, _) => {
    p($, _) && (m($, _), e && e());
  }, k = ($) => {
    g("hours", $);
  }, y = ($) => {
    g("minutes", $);
  }, h = ($) => {
    g("seconds", $);
  }, b = ($, _) => {
    k($.hours), y($.minutes), h($.seconds), t.value && _(t.value);
  }, S = ($) => {
    if ($) {
      const _ = Array.isArray($), A = _ ? [+$[0].hours, +$[1].hours] : +$.hours, D = _ ? [+$[0].minutes, +$[1].minutes] : +$.minutes, Y = _ ? [+($[0].seconds ?? 0), +($[1].seconds ?? 0)] : +($.seconds ?? 0);
      m("hours", A), m("minutes", D), l.value.enableSeconds && m("seconds", Y);
    }
  }, x = ($, _) => {
    const A = {
      hours: Array.isArray(a.hours) ? a.hours[$] : a.hours,
      disabledArr: []
    };
    return (_ || _ === 0) && (A.hours = _), Array.isArray(s.disabledTimes) && (A.disabledArr = r.value.enabled && Array.isArray(s.disabledTimes[$]) ? s.disabledTimes[$] : s.disabledTimes), A;
  }, C = M(() => ($, _) => {
    var A;
    if (Array.isArray(s.disabledTimes)) {
      const { disabledArr: D, hours: Y } = x($, _), L = D.filter((Z) => +Z.hours === Y);
      return ((A = L[0]) == null ? void 0 : A.minutes) === "*" ? { hours: [Y], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (L == null ? void 0 : L.map((Z) => +Z.minutes)) ?? [],
        seconds: (L == null ? void 0 : L.map((Z) => Z.seconds ? +Z.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    assignTime: m,
    updateHours: k,
    updateMinutes: y,
    updateSeconds: h,
    getSetDateTime: f,
    updateTimeValues: b,
    getSecondsValue: c,
    assignStartTime: S,
    validateTime: p,
    disabledTimesConfig: C
  };
}, _0 = (e) => {
  const {
    getDate: n,
    time: t,
    modelValue: a,
    state: s,
    defaults: { startTime: r, range: l, timeConfig: i }
  } = Ge(), { getTimeObj: o } = Vt();
  Ys(() => {
    s.isTextInputDate && x();
  });
  const { updateTimeValues: u, getSetDateTime: c, assignTime: f, assignStartTime: m, disabledTimesConfig: d, validateTime: p } = Ad(g);
  function g() {
    e("update-flow-step");
  }
  const k = ($) => {
    const { hours: _, minutes: A, seconds: D } = $;
    return { hours: +_, minutes: +A, seconds: D ? +D : 0 };
  }, y = () => {
    if (i.value.startTime) {
      if (Array.isArray(i.value.startTime)) {
        const _ = k(i.value.startTime[0]), A = k(i.value.startTime[1]);
        return [qe(n(), _), qe(n(), A)];
      }
      const $ = k(i.value.startTime);
      return qe(n(), $);
    }
    return l.value.enabled ? [null, null] : null;
  }, h = () => {
    if (l.value.enabled) {
      const [$, _] = y();
      a.value = [c($, 0), c(_, 1)];
    } else
      a.value = c(y());
  }, b = ($) => Array.isArray($) ? [o(n($[0])), o(n($[1]))] : [o($ ?? n())], S = ($, _, A) => {
    f("hours", $), f("minutes", _), f("seconds", i.value.enableSeconds ? A : 0);
  }, x = () => {
    const [$, _] = b(a.value);
    return l.value.enabled ? S(
      [$.hours, _.hours],
      [$.minutes, _.minutes],
      [$.seconds, _.seconds]
    ) : S($.hours, $.minutes, $.seconds);
  };
  et(() => (m(r.value), a.value ? x() : h()));
  const C = () => {
    Array.isArray(a.value) ? a.value = a.value.map(($, _) => $ && c($, _)) : a.value = c(a.value), e("time-update");
  };
  return {
    modelValue: a,
    time: t,
    disabledTimesConfig: d,
    validateTime: p,
    updateTime: ($) => {
      u($, C);
    }
  };
}, E0 = /* @__PURE__ */ Se({
  __name: "TimePickerSolo",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["time-update", "mount", "reset-flow", "update-flow-step"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ht(), r = Cn(s, gn.TimePicker), l = Je("time-input"), { time: i, modelValue: o, disabledTimesConfig: u, updateTime: c, validateTime: f } = _0(a);
    return et(() => {
      a("mount");
    }), n({ getSidebarProps: () => ({
      modelValue: o,
      time: i,
      updateTime: c
    }), toggleTimePicker: (m, d = !1, p = "") => {
      var g;
      (g = l.value) == null || g.toggleTimePicker(m, d, p);
    } }), (m, d) => (w(), de(Ur, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: fe(({ wrapClass: p }) => [
        E("div", {
          class: ne(p)
        }, [
          oe(Pd, rt({ ref: "time-input" }, m.$props, {
            hours: v(i).hours,
            minutes: v(i).minutes,
            seconds: v(i).seconds,
            "disabled-times-config": v(u),
            "validate-time": v(f),
            "onUpdate:hours": d[0] || (d[0] = (g) => v(c)({ hours: g, minutes: v(i).minutes, seconds: v(i).seconds })),
            "onUpdate:minutes": d[1] || (d[1] = (g) => v(c)({ hours: v(i).hours, minutes: g, seconds: v(i).seconds })),
            "onUpdate:seconds": d[2] || (d[2] = (g) => v(c)({ hours: v(i).hours, minutes: v(i).minutes, seconds: g })),
            onResetFlow: d[3] || (d[3] = (g) => m.$emit("reset-flow"))
          }), dt({ _: 2 }, [
            Pe(v(r), (g, k) => ({
              name: g,
              fn: fe((y) => [
                U(m.$slots, g, Mt(Bt(y)))
              ])
            }))
          ]), 1040, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time"])
        ], 2)
      ]),
      _: 3
    }));
  }
}), I0 = (e, n) => {
  const {
    getDate: t,
    rootProps: a,
    defaults: { filters: s }
  } = Ge(), { validateMonthYearInRange: r, validateMonthYear: l } = ln(), i = (m, d) => {
    let p = m;
    return s.value.months.includes(Ke(p)) ? (p = d ? pn(m, 1) : Xa(m, 1), i(p, d)) : p;
  }, o = (m, d) => {
    let p = m;
    return s.value.years.includes(Be(p)) ? (p = d ? ki(m, 1) : wd(m, 1), o(p, d)) : p;
  }, u = (m, d = !1) => {
    const p = qe(t(), { month: e.month, year: e.year });
    let g = m ? pn(p, 1) : Xa(p, 1);
    a.disableYearSelect && (g = hn(g, e.year));
    let k = Ke(g), y = Be(g);
    s.value.months.includes(k) && (g = i(g, m), k = Ke(g), y = Be(g)), s.value.years.includes(y) && (g = o(g, m), y = Be(g)), r(k, y, m, a.preventMinMaxNavigation) && c(k, y, d);
  }, c = (m, d, p = !1) => {
    n("update-month-year", { month: m, year: d, fromNav: p });
  }, f = M(() => (m) => l(
    qe(t(), { month: e.month, year: e.year }),
    a.preventMinMaxNavigation,
    m
  ));
  return { handleMonthYearChange: u, isDisabled: f, updateMonthYear: c };
}, P0 = { class: "dp--header-wrap" }, A0 = {
  key: 0,
  class: "dp__month_year_wrap"
}, R0 = { key: 0 }, F0 = { class: "dp__month_year_wrap" }, V0 = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], L0 = /* @__PURE__ */ Se({
  __name: "DpHeader",
  props: {
    month: {},
    year: {},
    instance: {},
    years: {},
    months: {},
    menuWrapRef: {}
  },
  emits: ["mount", "reset-flow", "update-month-year"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: r,
      rootProps: l,
      modelValue: i,
      defaults: { ariaLabels: o, filters: u, config: c, highlight: f, safeDates: m, ui: d }
    } = Ge(), { transitionName: p, showTransition: g } = Ws(), { showLeftIcon: k, showRightIcon: y } = Hr(), { handleMonthYearChange: h, isDisabled: b, updateMonthYear: S } = I0(s, a), { getMaxMonth: x, getMinMonth: C, getYearFromDate: $, groupListAndMap: _, checkHighlightYear: A, checkHighlightMonth: D } = Vt(), { checkKeyDown: Y } = Ot(), { formatYear: L } = aa(), { checkMinMaxValue: Z } = ln(), { boolHtmlAttribute: se } = rs(), ie = ee(!1), ce = ee(!1), G = ee(!1);
    et(() => {
      a("mount");
    });
    const le = (j) => ({
      get: () => s[j],
      set: (H) => {
        const I = j === dn.month ? dn.year : dn.month;
        a("update-month-year", { [j]: H, [I]: s[I] }), j === dn.month ? ye(!0) : K(!0);
      }
    }), q = M(le(dn.month)), N = M(le(dn.year)), Q = M(() => (j) => ({
      month: s.month,
      year: s.year,
      items: j === dn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: S,
      toggle: j === dn.month ? ye : K
    })), he = M(() => s.months.find((H) => H.value === s.month) || { text: "", value: 0 }), pe = M(() => _(s.months, (j) => {
      const H = s.month === j.value, I = Z(
        j.value,
        C(s.year, m.value.minDate),
        x(s.year, m.value.maxDate)
      ) || u.value.months.includes(j.value), B = D(f.value, j.value, s.year);
      return { active: H, disabled: I, highlighted: B };
    })), ge = M(() => _(s.years, (j) => {
      const H = s.year === j.value, I = Z(
        j.value,
        $(m.value.minDate),
        $(m.value.maxDate)
      ) || u.value.years.includes(j.value), B = A(f.value, j.value);
      return { active: H, disabled: I, highlighted: B };
    })), Ce = (j, H, I) => {
      I === void 0 ? j.value = !j.value : j.value = I, j.value ? (G.value = !0, r("overlay-toggle", { open: !0, overlay: H })) : (G.value = !1, r("overlay-toggle", { open: !1, overlay: H }));
    }, ye = (j = !1, H) => {
      be(j), Ce(ie, Nt.month, H);
    }, K = (j = !1, H) => {
      be(j), Ce(ce, Nt.year, H);
    }, be = (j) => {
      j || a("reset-flow");
    }, Me = M(() => {
      var j, H, I, B, X, R;
      return [
        {
          type: dn.month,
          index: 1,
          toggle: ye,
          modelValue: q.value,
          updateModelValue: (te) => q.value = te,
          text: he.value.text,
          showSelectionGrid: ie.value,
          items: pe.value,
          ariaLabel: (j = o.value) == null ? void 0 : j.openMonthsOverlay,
          overlayLabel: ((I = (H = o.value).monthPicker) == null ? void 0 : I.call(H, !0)) ?? void 0
        },
        {
          type: dn.year,
          index: 2,
          toggle: K,
          modelValue: N.value,
          updateModelValue: (te) => N.value = te,
          text: L(s.year),
          showSelectionGrid: ce.value,
          items: ge.value,
          ariaLabel: (B = o.value) == null ? void 0 : B.openYearsOverlay,
          overlayLabel: ((R = (X = o.value).yearPicker) == null ? void 0 : R.call(X, !0)) ?? void 0
        }
      ];
    }), F = M(() => l.disableYearSelect ? [Me.value[0]] : l.yearFirst ? [...Me.value].reverse() : Me.value);
    return n({
      toggleMonthPicker: ye,
      toggleYearPicker: K,
      handleMonthYearChange: h
    }), (j, H) => {
      var I, B, X, R, te, O;
      return w(), T("div", P0, [
        j.$slots["month-year"] ? (w(), T("div", A0, [
          U(j.$slots, "month-year", Mt(Bt({
            month: e.month,
            year: e.year,
            months: e.months,
            years: e.years,
            updateMonthYear: v(S),
            handleMonthYearChange: v(h),
            instance: e.instance,
            isDisabled: v(b)
          })))
        ])) : (w(), T(Te, { key: 1 }, [
          j.$slots["top-extra"] ? (w(), T("div", R0, [
            U(j.$slots, "top-extra", { value: v(i) })
          ])) : P("", !0),
          E("div", F0, [
            v(k)(e.instance) && !v(l).vertical ? (w(), de(Ms, {
              key: 0,
              "aria-label": (I = v(o)) == null ? void 0 : I.prevMonth,
              disabled: v(se)(v(b)(!1)),
              class: ne((B = v(d)) == null ? void 0 : B.navBtnPrev),
              "el-name": "action-prev",
              onActivate: H[0] || (H[0] = (z) => v(h)(!1, !0))
            }, {
              default: fe(() => [
                j.$slots["arrow-left"] ? U(j.$slots, "arrow-left", { key: 0 }) : P("", !0),
                j.$slots["arrow-left"] ? P("", !0) : (w(), de(v(xd), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
            E("div", {
              class: ne(["dp__month_year_wrap", {
                dp__year_disable_select: v(l).disableYearSelect
              }])
            }, [
              (w(!0), T(Te, null, Pe(F.value, (z) => (w(), T(Te, {
                key: z.type
              }, [
                E("button", {
                  type: "button",
                  "data-dp-element": `overlay-${z.type}`,
                  class: ne(["dp__btn dp__month_year_select", { "dp--hidden-el": G.value }]),
                  "aria-label": `${z.text}-${z.ariaLabel}`,
                  "data-test-id": `${z.type}-toggle-overlay-${e.instance}`,
                  tabindex: "0",
                  "data-dp-action-element": "0",
                  onClick: (V) => z.toggle(!1),
                  onKeydown: (V) => v(Y)(V, () => z.toggle(), !0)
                }, [
                  j.$slots[z.type] ? U(j.$slots, z.type, {
                    key: 0,
                    text: z.text,
                    value: s[z.type]
                  }) : P("", !0),
                  j.$slots[z.type] ? P("", !0) : (w(), T(Te, { key: 1 }, [
                    Ue(ue(z.text), 1)
                  ], 64))
                ], 42, V0),
                oe(Dt, {
                  name: v(p)(z.showSelectionGrid),
                  css: v(g)
                }, {
                  default: fe(() => [
                    z.showSelectionGrid ? (w(), de(Hs, {
                      key: 0,
                      items: z.items,
                      "is-last": v(l).autoApply && !v(c).keepActionRow,
                      "skip-button-ref": !1,
                      type: z.type,
                      "header-refs": [],
                      "menu-wrap-ref": e.menuWrapRef,
                      "overlay-label": z.overlayLabel,
                      onSelected: z.updateModelValue,
                      onToggle: z.toggle
                    }, dt({
                      "button-icon": fe(() => [
                        j.$slots["calendar-icon"] ? U(j.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                        j.$slots["calendar-icon"] ? P("", !0) : (w(), de(v(zs), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      j.$slots[`${z.type}-overlay-value`] ? {
                        name: "item",
                        fn: fe(({ item: V }) => [
                          U(j.$slots, `${z.type}-overlay-value`, {
                            text: V.text,
                            value: V.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      j.$slots[`${z.type}-overlay`] ? {
                        name: "overlay",
                        fn: fe(() => [
                          U(j.$slots, `${z.type}-overlay`, rt({ ref_for: !0 }, Q.value(z.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      j.$slots[`${z.type}-overlay-header`] ? {
                        name: "header",
                        fn: fe(() => [
                          U(j.$slots, `${z.type}-overlay-header`, {
                            toggle: z.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "is-last", "type", "menu-wrap-ref", "overlay-label", "onSelected", "onToggle"])) : P("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            v(k)(e.instance) && v(l).vertical ? (w(), de(Ms, {
              key: 1,
              "aria-label": (X = v(o)) == null ? void 0 : X.prevMonth,
              "el-name": "action-prev",
              disabled: v(se)(v(b)(!1)),
              class: ne((R = v(d)) == null ? void 0 : R.navBtnPrev),
              onActivate: H[1] || (H[1] = (z) => v(h)(!1, !0))
            }, {
              default: fe(() => [
                j.$slots["arrow-up"] ? U(j.$slots, "arrow-up", { key: 0 }) : P("", !0),
                j.$slots["arrow-up"] ? P("", !0) : (w(), de(v(Md), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
            v(y)(e.instance) ? (w(), de(Ms, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: v(se)(v(b)(!0)),
              "aria-label": (te = v(o)) == null ? void 0 : te.nextMonth,
              class: ne((O = v(d)) == null ? void 0 : O.navBtnNext),
              onActivate: H[2] || (H[2] = (z) => v(h)(!0, !0))
            }, {
              default: fe(() => [
                j.$slots[v(l).vertical ? "arrow-down" : "arrow-right"] ? U(j.$slots, v(l).vertical ? "arrow-down" : "arrow-right", { key: 0 }) : P("", !0),
                j.$slots[v(l).vertical ? "arrow-down" : "arrow-right"] ? P("", !0) : (w(), de(ht(v(l).vertical ? v($d) : v(Sd)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : P("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), N0 = {
  class: "dp__calendar_header",
  role: "row"
}, B0 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, z0 = ["aria-label"], W0 = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, Y0 = { class: "dp__cell_inner" }, H0 = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "data-dp-element-active", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], U0 = /* @__PURE__ */ Se({
  __name: "DpCalendar",
  props: {
    instance: {},
    mappedDates: {},
    month: {},
    year: {}
  },
  emits: ["mount", "select-date", "set-hover-date", "handle-scroll", "handle-swipe"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: r,
      rootEmit: l,
      rootProps: i,
      defaults: { transitions: o, config: u, ariaLabels: c, multiCalendars: f, weekNumbers: m, multiDates: d, ui: p }
    } = Ge(), { isDateAfter: g, isDateEqual: k, resetDateTime: y, getCellId: h } = Vt(), { checkKeyDown: b, checkStopPropagation: S, isTouchDevice: x } = Ot(), { formatWeekDay: C } = aa(), $ = Je("calendar-wrap"), _ = Je("active-tooltip"), A = ee([]), D = ee(null), Y = ee(!0), L = ee(!1), Z = ee(""), se = ee({
      bottom: "",
      left: "",
      transform: ""
    }), ie = ee({ left: "50%" });
    qv($, {
      onSwipeEnd: (O, z) => {
        u.value.noSwipe || (i.vertical ? (z === "up" || z === "down") && a("handle-swipe", z === "up" ? "left" : "right") : (z === "left" || z === "right") && a("handle-swipe", z === "right" ? "left" : "right"));
      }
    });
    const ce = M(() => i.calendar ? i.calendar(s.mappedDates) : s.mappedDates), G = M(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames() : te());
    et(() => {
      a("mount", { cmp: "calendar", dayRefs: A.value }), u.value.monthChangeOnScroll && $.value && $.value.addEventListener("wheel", j, { passive: !1 });
    }), rn(() => {
      u.value.monthChangeOnScroll && $.value && $.value.removeEventListener("wheel", j);
    });
    const le = (O) => O ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", q = (O, z) => {
      if (i.transitions) {
        const V = y(qe(r(), { month: s.month, year: s.year }));
        Z.value = g(y(qe(r(), { month: O, year: z })), V) ? o.value[le(!0)] : o.value[le(!1)], Y.value = !1, Ze(() => {
          Y.value = !0;
        });
      }
    }, N = M(
      () => ({
        ...p.value.calendar
      })
    ), Q = (O) => ({ type: "dot", ...O }), he = M(() => (O) => {
      const z = Q(O);
      return {
        dp__marker_dot: z.type === "dot",
        dp__marker_line: z.type === "line"
      };
    }), pe = M(() => (O) => k(O, D.value)), ge = M(() => ({
      dp__calendar: !0,
      dp__calendar_next: f.value.count > 0 && s.instance !== 0
    })), Ce = M(() => (O) => i.hideOffsetDates ? O.current : !0), ye = async (O, z) => {
      var De;
      const { width: V, height: re } = O.getBoundingClientRect();
      D.value = z.value;
      let W = { left: `${V / 2}px` }, me = -50;
      if (await Ze(), (De = _.value) == null ? void 0 : De[0]) {
        const { left: Re, width: Ee } = _.value[0].getBoundingClientRect();
        Re < 0 && (W = { left: "0" }, me = 0, ie.value.left = `${V / 2}px`), globalThis.innerWidth < Re + Ee && (W = { right: "0" }, me = 0, ie.value.left = `${Ee - V / 2}px`);
      }
      se.value = {
        bottom: `${re}px`,
        ...W,
        transform: `translateX(${me}%)`
      };
    }, K = async (O, z, V) => {
      var W, me, De, Re, Ee;
      const re = jt((me = (W = A.value) == null ? void 0 : W[z]) == null ? void 0 : me[V]);
      re && ((De = O.marker) != null && De.customPosition && ((Ee = (Re = O.marker) == null ? void 0 : Re.tooltip) != null && Ee.length) ? se.value = O.marker.customPosition(re) : await ye(re, O), l("tooltip-open", O.marker));
    }, be = async (O, z, V) => {
      var re, W;
      if (L.value && d.value.enabled && d.value.dragSelect)
        return a("select-date", O);
      if (a("set-hover-date", O), (W = (re = O.marker) == null ? void 0 : re.tooltip) == null ? void 0 : W.length) {
        if (i.hideOffsetDates && !O.current) return;
        await K(O, z, V);
      }
    }, Me = (O) => {
      D.value && (D.value = null, se.value = structuredClone({ bottom: "", left: "", transform: "" }), l("tooltip-close", O.marker));
    }, F = (O, z, V) => {
      O && (Array.isArray(A.value[z]) ? A.value[z][V] = O : A.value[z] = [O]);
    }, j = (O) => {
      u.value.monthChangeOnScroll && (O.preventDefault(), a("handle-scroll", O));
    }, H = (O) => m.value ? m.value.type === "local" ? $i(O.value, {
      weekStartsOn: +i.weekStart,
      locale: i.locale
    }) : m.value.type === "iso" ? Ti(O.value) : typeof m.value.type == "function" ? m.value.type(O.value) : "" : "", I = (O) => {
      var V;
      const z = O[0];
      return (V = m.value) != null && V.hideOnOffsetDates ? O.some((re) => re.current) ? H(z) : "" : H(z);
    }, B = (O, z, V = !0) => {
      !V && x() || (!d.value.enabled || u.value.allowPreventDefault) && (S(O, u.value), a("select-date", z));
    }, X = (O) => {
      S(O, u.value);
    }, R = (O) => {
      d.value.enabled && d.value.dragSelect ? (L.value = !0, a("select-date", O)) : d.value.enabled && a("select-date", O);
    }, te = () => {
      const O = r(), z = sn(O, { locale: i.locale, weekStartsOn: +i.weekStart }), V = Si(O, { locale: i.locale, weekStartsOn: +i.weekStart });
      return xi({ start: z, end: V }).map((re) => C(re));
    };
    return n({ triggerTransition: q }), (O, z) => (w(), T("div", {
      class: ne(ge.value)
    }, [
      E("div", {
        ref: "calendar-wrap",
        class: ne(N.value),
        role: "grid"
      }, [
        E("div", N0, [
          v(m) ? (w(), T("div", B0, ue(v(m).label), 1)) : P("", !0),
          (w(!0), T(Te, null, Pe(G.value, (V, re) => {
            var W, me;
            return w(), T("div", {
              key: re,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (me = (W = v(c)) == null ? void 0 : W.weekDay) == null ? void 0 : me.call(W, re)
            }, [
              U(O.$slots, "calendar-header", {
                day: V,
                index: re
              }, () => [
                Ue(ue(V), 1)
              ])
            ], 8, z0);
          }), 128))
        ]),
        z[2] || (z[2] = E("div", { class: "dp__calendar_header_separator" }, null, -1)),
        oe(Dt, {
          name: Z.value,
          css: !!v(o)
        }, {
          default: fe(() => [
            Y.value ? (w(), T("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: z[1] || (z[1] = (V) => L.value = !1)
            }, [
              (w(!0), T(Te, null, Pe(ce.value, (V, re) => (w(), T("div", {
                key: re,
                class: "dp__calendar_row",
                role: "row"
              }, [
                v(m) ? (w(), T("div", W0, [
                  E("div", Y0, ue(I(V.days)), 1)
                ])) : P("", !0),
                (w(!0), T(Te, null, Pe(V.days, (W, me) => {
                  var De, Re, Ee;
                  return w(), T("div", {
                    id: v(h)(W.value),
                    ref_for: !0,
                    ref: (Ye) => F(Ye, re, me),
                    key: me + re,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-selected": (W.classData.dp__active_date || W.classData.dp__range_start || W.classData.dp__range_end) ?? void 0,
                    "aria-disabled": W.classData.dp__cell_disabled || void 0,
                    "aria-label": (Re = (De = v(c)) == null ? void 0 : De.day) == null ? void 0 : Re.call(De, W),
                    tabindex: !W.current && v(i).hideOffsetDates ? void 0 : 0,
                    "data-test-id": v(h)(W.value),
                    "data-dp-element-active": W.classData.dp__active_date ? 0 : void 0,
                    "data-dp-action-element": "0",
                    onClick: Fe((Ye) => B(Ye, W), ["prevent"]),
                    onTouchend: (Ye) => B(Ye, W, !1),
                    onKeydown: (Ye) => v(b)(Ye, () => O.$emit("select-date", W)),
                    onMouseenter: (Ye) => be(W, re, me),
                    onMouseleave: (Ye) => Me(W),
                    onMousedown: (Ye) => R(W),
                    onMouseup: z[0] || (z[0] = (Ye) => L.value = !1)
                  }, [
                    E("div", {
                      class: ne(["dp__cell_inner", W.classData])
                    }, [
                      O.$slots.day && Ce.value(W) ? U(O.$slots, "day", {
                        key: 0,
                        day: +W.text,
                        date: W.value
                      }) : P("", !0),
                      O.$slots.day ? P("", !0) : (w(), T(Te, { key: 1 }, [
                        Ue(ue(W.text), 1)
                      ], 64)),
                      W.marker && Ce.value(W) ? U(O.$slots, "marker", {
                        key: 2,
                        marker: W.marker,
                        day: +W.text,
                        date: W.value
                      }, () => [
                        E("div", {
                          class: ne(he.value(W.marker)),
                          style: Ve(W.marker.color ? { backgroundColor: W.marker.color } : {})
                        }, null, 6)
                      ]) : P("", !0),
                      pe.value(W.value) ? (w(), T("div", {
                        key: 3,
                        ref_for: !0,
                        ref: "active-tooltip",
                        class: "dp__marker_tooltip",
                        style: Ve(se.value)
                      }, [
                        (Ee = W.marker) != null && Ee.tooltip ? (w(), T("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: X
                        }, [
                          (w(!0), T(Te, null, Pe(W.marker.tooltip, (Ye, At) => (w(), T("div", {
                            key: At,
                            class: "dp__tooltip_text"
                          }, [
                            U(O.$slots, "marker-tooltip", {
                              tooltip: Ye,
                              day: W.value
                            }, () => [
                              E("div", {
                                class: "dp__tooltip_mark",
                                style: Ve(Ye.color ? { backgroundColor: Ye.color } : {})
                              }, null, 4),
                              E("div", null, ue(Ye.text), 1)
                            ])
                          ]))), 128)),
                          E("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Ve(ie.value)
                          }, null, 4)
                        ])) : P("", !0)
                      ], 4)) : P("", !0)
                    ], 2)
                  ], 40, H0);
                }), 128))
              ]))), 128))
            ], 32)) : P("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), q0 = (e, n, t, a) => {
  const s = ee([]), r = ee(/* @__PURE__ */ new Date()), l = ee(), {
    getDate: i,
    rootEmit: o,
    calendars: u,
    month: c,
    year: f,
    time: m,
    modelValue: d,
    rootProps: p,
    today: g,
    state: k,
    defaults: { multiCalendars: y, startTime: h, range: b, config: S, safeDates: x, multiDates: C, timeConfig: $, flow: _ }
  } = Ge(), { validateMonthYearInRange: A, isDisabled: D, isDateRangeAllowed: Y, checkMinMaxRange: L } = ln(), { updateTimeValues: Z, getSetDateTime: se, assignTime: ie, assignStartTime: ce, validateTime: G, disabledTimesConfig: le } = Ad(a), { formatDay: q } = aa(), { resetDateTime: N, setTime: Q, isDateBefore: he, isDateEqual: pe, getDaysInBetween: ge } = Vt(), { checkRangeAutoApply: Ce, getRangeWithFixedDate: ye, handleMultiDatesSelect: K, setPresetDate: be } = qr(), { getMapDate: Me } = Ot();
  Ys(() => R(k.isTextInputDate));
  const F = (J) => !S.value.keepViewOnOffsetClick || J ? !0 : !l.value, j = (J, ve, Ae, ze = !1) => {
    var at, Lt, on;
    F(ze) && ((at = u.value)[J] ?? (at[J] = u.value[J] = { month: 0, year: 0 }), u.value[J].month = ve ?? ((Lt = u.value[J]) == null ? void 0 : Lt.month), u.value[J].year = Ae ?? ((on = u.value[J]) == null ? void 0 : on.year));
  }, H = () => {
    p.autoApply && n("select-date");
  }, I = () => {
    h.value && ce(h.value);
  };
  et(() => {
    d.value || (At(), I()), R(!0), p.focusStartDate && p.startDate && At();
  });
  const B = M(() => {
    var J, ve, Ae;
    return (ve = (J = _.value) == null ? void 0 : J.steps) != null && ve.length && !((Ae = _.value) != null && Ae.partial) ? e.flowStep === _.value.steps.length : !0;
  }), X = () => {
    var J, ve, Ae;
    p.autoApply && B.value && n("auto-apply", (J = _.value) != null && J.partial ? e.flowStep !== ((Ae = (ve = _.value) == null ? void 0 : ve.steps) == null ? void 0 : Ae.length) : !1);
  }, R = (J = !1) => {
    if (d.value)
      return Array.isArray(d.value) ? (s.value = d.value, De(J)) : V(d.value, J);
    if (y.value.count && J && !p.startDate)
      return z(i(), J);
  }, te = () => Array.isArray(d.value) && b.value.enabled ? Ke(d.value[0]) === Ke(d.value[1] ?? d.value[0]) : !1, O = (J) => {
    const ve = pn(J, 1);
    return { month: Ke(ve), year: Be(ve) };
  }, z = (J = i(), ve = !1) => {
    if ((!y.value.count || !y.value.static || ve) && j(0, Ke(J), Be(J)), y.value.count && (!d.value || te() || !y.value.solo) && (!y.value.solo || ve))
      for (let Ae = 1; Ae < y.value.count; Ae++) {
        const ze = qe(i(), { month: c.value(Ae - 1), year: f.value(Ae - 1) }), at = sd(ze, { months: 1 });
        u.value[Ae] = { month: Ke(at), year: Be(at) };
      }
  }, V = (J, ve) => {
    z(J), ie("hours", On(J)), ie("minutes", Bn(J)), ie("seconds", na(J)), y.value.count && ve && Ye();
  }, re = (J) => {
    if (y.value.count) {
      if (y.value.solo) return 0;
      const ve = Ke(J[0]), Ae = Ke(J[1]);
      return Math.abs(Ae - ve) < y.value.count ? 0 : 1;
    }
    return 1;
  }, W = (J, ve) => {
    J[1] && b.value.showLastInRange ? z(J[re(J)], ve) : z(J[0], ve);
    const Ae = (ze, at) => [
      ze(J[0]),
      J != null && J[1] ? ze(J[1]) : m[at][1]
    ];
    ie("hours", Ae(On, "hours")), ie("minutes", Ae(Bn, "minutes")), ie("seconds", Ae(na, "seconds"));
  }, me = (J, ve) => {
    if ((b.value.enabled || p.weekPicker) && !C.value.enabled)
      return W(J, ve);
    if (C.value.enabled && ve) {
      const Ae = J[J.length - 1];
      return V(Ae, ve);
    }
  }, De = (J) => {
    const ve = d.value;
    me(ve, J), y.value.count && y.value.solo && Ye();
  }, Re = (J, ve) => {
    const Ae = qe(i(), { month: c.value(ve), year: f.value(ve) }), ze = J < 0 ? pn(Ae, 1) : Xa(Ae, 1);
    A(Ke(ze), Be(ze), J < 0, p.preventMinMaxNavigation) && (j(ve, Ke(ze), Be(ze)), o("update-month-year", { instance: ve, month: Ke(ze), year: Be(ze) }), y.value.count && !y.value.solo && Ee(ve), t());
  }, Ee = (J) => {
    for (let ve = J - 1; ve >= 0; ve--) {
      const Ae = Xa(qe(i(), { month: c.value(ve + 1), year: f.value(ve + 1) }), 1);
      j(ve, Ke(Ae), Be(Ae));
    }
    for (let ve = J + 1; ve <= y.value.count - 1; ve++) {
      const Ae = pn(qe(i(), { month: c.value(ve - 1), year: f.value(ve - 1) }), 1);
      j(ve, Ke(Ae), Be(Ae));
    }
  }, Ye = () => {
    if (Array.isArray(d.value) && d.value.length === 2) {
      const J = i(i(d.value[1] ?? pn(d.value[0], 1))), [ve, Ae] = [Ke(d.value[0]), Be(d.value[0])], [ze, at] = [Ke(d.value[1]), Be(d.value[1])];
      (ve !== ze || ve === ze && Ae !== at) && y.value.solo && j(1, Ke(J), Be(J));
    } else d.value && !Array.isArray(d.value) && (j(0, Ke(d.value), Be(d.value)), z(i()));
  }, At = () => {
    p.startDate && (j(0, Ke(i(p.startDate)), Be(i(p.startDate))), y.value.count && Ee(0));
  }, Zt = (J, ve) => {
    if (S.value.monthChangeOnScroll) {
      const Ae = Date.now() - r.value.getTime(), ze = Math.abs(J.deltaY);
      let at = 500;
      ze > 1 && (at = 100), ze > 100 && (at = 0), Ae > at && (r.value = /* @__PURE__ */ new Date(), Re(
        S.value.monthChangeOnScroll === "inverse" ? J.deltaY : -J.deltaY,
        ve
      ));
    }
  }, Wn = (J, ve, Ae = !1) => {
    S.value.monthChangeOnArrows && p.vertical === Ae && _t(J, ve);
  }, _t = (J, ve) => {
    Re(J === "right" ? -1 : 1, ve);
  }, Wt = (J) => {
    if (x.value.markers)
      return Me(J.value, x.value.markers);
  }, En = (J, ve) => {
    switch (p.sixWeeks === !0 ? "append" : p.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [J == 0, !0];
      case "fair":
        return [J == 0 || ve > J, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Yn = (J, ve, Ae, ze) => {
    if (p.sixWeeks && J.length < 6) {
      const at = 6 - J.length, Lt = (ve.getDay() + 7 - ze) % 7, on = 6 - (Ae.getDay() + 7 - ze) % 7, [ra, Ma] = En(Lt, on);
      for (let ae = 1; ae <= at; ae++)
        if (Ma ? !!(ae % 2) == ra : ra) {
          const we = J[0].days[0], He = xt(tn(we.value, -7), Ke(ve));
          J.unshift({ days: He });
        } else {
          const we = J[J.length - 1], He = we.days[we.days.length - 1], Ie = xt(tn(He.value, 1), Ke(ve));
          J.push({ days: Ie });
        }
    }
    return J;
  }, xt = (J, ve) => {
    const Ae = i(J), ze = [];
    for (let at = 0; at < 7; at++) {
      const Lt = tn(Ae, at), on = Ke(Lt) !== ve;
      ze.push({
        text: p.hideOffsetDates && on ? "" : q(Lt),
        value: Lt,
        current: !on,
        classData: {}
      });
    }
    return ze;
  }, $t = (J, ve) => {
    const Ae = [], ze = i(new Date(ve, J)), at = i(new Date(ve, J + 1, 0)), Lt = p.weekStart, on = sn(ze, { weekStartsOn: Lt }), ra = (Ma) => {
      const ae = xt(Ma, J);
      if (Ae.push({ days: ae }), !Ae[Ae.length - 1].days.some((we) => pe(i(we.value), N(at)))) {
        const we = tn(Ma, 7);
        ra(we);
      }
    };
    return ra(on), Yn(Ae, ze, at, Lt);
  }, St = (J) => {
    const ve = Q(
      { hours: m.hours, minutes: m.minutes, seconds: Sa() },
      i(J.value)
    );
    o("date-click", ve), C.value.enabled ? K(ve, C.value.limit) : d.value = ve, a(), Ze().then(() => {
      X();
    });
  }, Xt = (J) => b.value.noDisabledRange ? ge(s.value[0], J).some((ve) => D(ve)) : !1, _e = () => {
    s.value = d.value ? d.value.slice().filter((J) => !!J) : [], s.value.length === 2 && !(b.value.fixedStart || b.value.fixedEnd) && (s.value = []);
  }, ut = (J, ve) => {
    const Ae = [i(J.value), tn(i(J.value), +b.value.autoRange)];
    Y(Ae) ? (ve && Ct(J.value), s.value = Ae) : o("invalid-date", J.value);
  }, Ct = (J) => {
    const ve = Ke(i(J)), Ae = Be(i(J));
    if (j(0, ve, Ae), y.value.count > 0)
      for (let ze = 1; ze < y.value.count; ze++) {
        const at = O(
          qe(i(J), { year: f.value(ze - 1), month: c.value(ze - 1) })
        );
        j(ze, at.month, at.year);
      }
  }, kn = (J) => {
    if (Xt(J.value) || !L(J.value, d.value, b.value.fixedStart ? 0 : 1))
      return o("invalid-date", J.value);
    s.value = ye(i(J.value));
  }, In = (J, ve) => {
    if (_e(), b.value.autoRange) return ut(J, ve);
    if (b.value.fixedStart || b.value.fixedEnd) return kn(J);
    s.value[0] ? L(i(J.value), d.value) && !Xt(J.value) ? he(i(J.value), i(s.value[0])) ? b.value.autoSwitchStartEnd ? (s.value.unshift(i(J.value)), o("range-end", s.value[0])) : (s.value[0] = i(J.value), o("range-start", s.value[0])) : (s.value[1] = i(J.value), o("range-end", s.value[1])) : o("invalid-date", J.value) : (s.value[0] = i(J.value), o("range-start", s.value[0]));
  }, Sa = (J = !0) => $.value.enableSeconds ? Array.isArray(m.seconds) ? J ? m.seconds[0] : m.seconds[1] : m.seconds : 0, Ta = (J) => {
    s.value[J] = Q(
      {
        hours: m.hours[J],
        minutes: m.minutes[J],
        seconds: Sa(J !== 1)
      },
      s.value[J]
    );
  }, Xr = () => {
    var J, ve;
    s.value[0] && s.value[1] && +((J = s.value) == null ? void 0 : J[0]) > +((ve = s.value) == null ? void 0 : ve[1]) && (s.value.reverse(), o("range-start", s.value[0]), o("range-end", s.value[1]));
  }, Jr = () => {
    var J, ve, Ae;
    s.value.length && (s.value[0] && !s.value[1] ? Ta(0) : (Ta(0), Ta(1), a()), Xr(), d.value = s.value.slice(), Ce(
      s.value,
      n,
      s.value.length < 2 || (J = _.value) != null && J.steps.length ? e.flowStep !== ((Ae = (ve = _.value) == null ? void 0 : ve.steps) == null ? void 0 : Ae.length) : !1
    ));
  }, Qr = (J, ve = !1) => {
    if (D(J.value) || !J.current && p.hideOffsetDates)
      return o("invalid-date", J.value);
    if (l.value = structuredClone(J), !b.value.enabled) return St(J);
    Array.isArray(m.hours) && Array.isArray(m.minutes) && !C.value.enabled && (In(J, ve), Jr());
  }, js = (J, ve) => {
    var ze, at;
    j(J, ve.month, ve.year, !0), y.value.count && !y.value.solo && Ee(J), o("update-month-year", { instance: J, month: ve.month, year: ve.year }), t(y.value.solo ? J : void 0);
    const Ae = (at = (ze = _.value) == null ? void 0 : ze.steps) != null && at.length ? _.value.steps[e.flowStep] : void 0;
    !ve.fromNav && (Ae === Nt.month || Ae === Nt.year) && a();
  }, Hn = (J) => {
    be({
      value: J
    }), H(), p.multiCalendars && Ze().then(() => R(!0));
  }, Gs = () => {
    var ve;
    let J = i();
    return (ve = p.actionRow) != null && ve.nowBtnRound && (J = jy(J, {
      roundingMethod: p.actionRow.nowBtnRound.rounding ?? "ceil",
      nearestTo: p.actionRow.nowBtnRound.roundTo ?? 15
    })), J;
  }, Li = () => {
    const J = Gs();
    !b.value.enabled && !C.value.enabled ? d.value = J : d.value && Array.isArray(d.value) && d.value[0] ? C.value.enabled ? d.value = [...d.value, J] : d.value = he(J, d.value[0]) ? [J, d.value[0]] : [d.value[0], J] : d.value = [J], H();
  }, yt = () => {
    if (Array.isArray(d.value))
      if (C.value.enabled) {
        const J = el();
        d.value[d.value.length - 1] = se(J);
      } else
        d.value = d.value.map((J, ve) => J && se(J, ve));
    else
      d.value = se(d.value);
    n("time-update");
  }, el = () => Array.isArray(d.value) && d.value.length ? d.value[d.value.length - 1] : null, Ks = (J) => {
    let ve = "";
    if (b.value.enabled && Array.isArray(d.value))
      for (const Ae of Object.keys(J)) {
        const ze = J[Ae];
        Array.isArray(ze) && (m[Ae][0] !== ze[0] && (ve = "range-start"), m[Ae][1] !== ze[1] && (ve = "range-start"));
      }
    return ve;
  };
  return {
    calendars: u,
    modelValue: d,
    month: c,
    year: f,
    time: m,
    disabledTimesConfig: le,
    today: g,
    validateTime: G,
    getCalendarDays: $t,
    getMarker: Wt,
    handleScroll: Zt,
    handleSwipe: _t,
    handleArrow: Wn,
    selectDate: Qr,
    updateMonthYear: js,
    presetDate: Hn,
    selectCurrentDate: Li,
    updateTime: (J) => {
      const ve = Ks(J);
      Z(J, yt), ve && o(ve, d.value[ve === "range-start" ? 0 : 1]);
    },
    assignMonthAndYear: z,
    setStartTime: I
  };
}, j0 = () => {
  const {
    isModelAuto: e,
    matchDate: n,
    isDateAfter: t,
    isDateBefore: a,
    isDateBetween: s,
    isDateEqual: r,
    getWeekFromDate: l,
    getBeforeAndAfterInRange: i
  } = Vt(), {
    getDate: o,
    today: u,
    rootProps: c,
    defaults: { multiCalendars: f, multiDates: m, ui: d, highlight: p, safeDates: g, range: k },
    modelValue: y
  } = Ge(), { isDisabled: h } = ln(), b = ee(null), S = (O) => {
    !O.current && c.hideOffsetDates || (b.value = O.value);
  }, x = () => {
    b.value = null;
  }, C = (O) => Array.isArray(y.value) && k.value.enabled && y.value[0] && b.value ? O ? t(b.value, y.value[0]) : a(b.value, y.value[0]) : !0, $ = (O, z) => {
    const V = () => y.value ? z ? y.value[0] || null : y.value[1] : null, re = y.value && Array.isArray(y.value) ? V() : null;
    return r(o(O.value), re);
  }, _ = (O) => {
    const z = Array.isArray(y.value) ? y.value[0] : null;
    return O ? !a(b.value, z) : !0;
  }, A = (O, z = !0) => (k.value.enabled || c.weekPicker) && Array.isArray(y.value) && y.value.length === 2 ? c.hideOffsetDates && !O.current ? !1 : r(o(O.value), y.value[z ? 0 : 1]) : k.value.enabled ? $(O, z) && _(z) || r(O.value, Array.isArray(y.value) ? y.value[0] : null) && C(z) : !1, D = (O, z) => {
    if (Array.isArray(y.value) && y.value[0] && y.value.length === 1) {
      const V = r(O.value, b.value);
      return z ? t(y.value[0], O.value) && V : a(y.value[0], O.value) && V;
    }
    return !1;
  }, Y = (O) => !y.value || c.hideOffsetDates && !O.current ? !1 : k.value.enabled ? c.modelAuto && Array.isArray(y.value) ? r(O.value, y.value[0] ?? u) : !1 : m.value.enabled && Array.isArray(y.value) ? y.value.some((z) => r(z, O.value)) : r(O.value, y.value ? y.value : u), L = (O) => {
    if (k.value.autoRange || c.weekPicker) {
      if (b.value) {
        if (c.hideOffsetDates && !O.current) return !1;
        const z = tn(b.value, +k.value.autoRange), V = l(o(b.value), c.weekStart);
        return c.weekPicker ? r(V[1], o(O.value)) : r(z, o(O.value));
      }
      return !1;
    }
    return !1;
  }, Z = (O) => {
    if (k.value.autoRange || c.weekPicker) {
      if (b.value) {
        const z = tn(b.value, +k.value.autoRange);
        if (c.hideOffsetDates && !O.current) return !1;
        const V = l(o(b.value), c.weekStart);
        return c.weekPicker ? t(O.value, V[0]) && a(O.value, V[1]) : t(O.value, b.value) && a(O.value, z);
      }
      return !1;
    }
    return !1;
  }, se = (O) => {
    if (k.value.autoRange || c.weekPicker) {
      if (b.value) {
        if (c.hideOffsetDates && !O.current) return !1;
        const z = l(o(b.value), c.weekStart);
        return c.weekPicker ? r(z[0], O.value) : r(b.value, O.value);
      }
      return !1;
    }
    return !1;
  }, ie = (O) => s(y.value, b.value, O.value), ce = () => c.modelAuto && Array.isArray(y.value) ? !!y.value[0] : !1, G = () => c.modelAuto ? e(y.value) : !0, le = (O) => {
    if (c.weekPicker) return !1;
    const z = k.value.enabled ? !A(O) && !A(O, !1) : !0;
    return !h(O.value) && !Y(O) && !(!O.current && c.hideOffsetDates) && z;
  }, q = (O) => k.value.enabled ? c.modelAuto ? ce() && Y(O) : !1 : Y(O), N = (O) => p.value ? n(O.value, g.value.highlight) : !1, Q = (O) => {
    const z = h(O.value);
    return z && (typeof p.value == "function" ? !p.value(O.value, z) : !p.value.options.highlightDisabled);
  }, he = (O) => {
    var z;
    return typeof p.value == "function" ? p.value(O.value) : (z = p.value.weekdays) == null ? void 0 : z.includes(O.value.getDay());
  }, pe = (O) => (k.value.enabled || c.weekPicker) && (!(f.value.count > 0) || O.current) && G() && !(!O.current && c.hideOffsetDates) && !Y(O) ? ie(O) : !1, ge = (O) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: z, after: V } = i(+k.value.maxRange, y.value[0]);
      return Vn(O.value, z) || Tn(O.value, V);
    }
    return !1;
  }, Ce = (O) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: z, after: V } = i(+k.value.minRange, y.value[0]);
      return s([z, V], y.value[0], O.value);
    }
    return !1;
  }, ye = (O) => k.value.enabled && (k.value.maxRange || k.value.minRange) ? k.value.maxRange && k.value.minRange ? ge(O) || Ce(O) : k.value.maxRange ? ge(O) : Ce(O) : !1, K = (O) => {
    const { isRangeStart: z, isRangeEnd: V } = j(O), re = k.value.enabled ? z || V : !1;
    return {
      dp__cell_offset: !O.current,
      dp__pointer: !c.disabled && !(!O.current && c.hideOffsetDates) && !h(O.value) && !ye(O),
      dp__cell_disabled: h(O.value) || ye(O),
      dp__cell_highlight: !Q(O) && (N(O) || he(O)) && !q(O) && !re && !se(O) && !(pe(O) && c.weekPicker) && !V,
      dp__cell_highlight_active: !Q(O) && (N(O) || he(O)) && q(O),
      dp__today: !c.noToday && r(O.value, u) && O.current,
      "dp--past": a(O.value, u),
      "dp--future": t(O.value, u)
    };
  }, be = (O) => ({
    dp__active_date: q(O),
    dp__date_hover: le(O)
  }), Me = (O) => {
    if (y.value && !Array.isArray(y.value)) {
      const z = l(y.value, c.weekStart);
      return {
        ...R(O),
        dp__range_start: r(z[0], O.value),
        dp__range_end: r(z[1], O.value),
        dp__range_between_week: t(O.value, z[0]) && a(O.value, z[1])
      };
    }
    return {
      ...R(O)
    };
  }, F = (O) => {
    if (y.value && Array.isArray(y.value)) {
      const z = l(y.value[0], c.weekStart), V = y.value[1] ? l(y.value[1], c.weekStart) : [];
      return {
        ...R(O),
        dp__range_start: r(z[0], O.value) || r(V[0], O.value),
        dp__range_end: r(z[1], O.value) || r(V[1], O.value),
        dp__range_between_week: t(O.value, z[0]) && a(O.value, z[1]) || t(O.value, V[0]) && a(O.value, V[1]),
        dp__range_between: t(O.value, z[1]) && a(O.value, V[0])
      };
    }
    return {
      ...R(O)
    };
  }, j = (O) => {
    const z = f.value.count > 0 ? O.current && A(O) && G() : A(O) && G(), V = f.value.count > 0 ? O.current && A(O, !1) && G() : A(O, !1) && G();
    return { isRangeStart: z, isRangeEnd: V };
  }, H = (O) => k.value.enabled && (k.value.fixedStart || k.value.fixedEnd) && Array.isArray(y.value) && y.value.length === 2, I = (O, z, V, re) => !H(y.value) || !b.value ? !1 : z ? k.value.fixedEnd && r(O.value, b.value) && Vn(O.value, y.value[0]) && !V : k.value.fixedStart && r(O.value, b.value) && Tn(O.value, y.value[1]) && !re, B = (O, z) => !H(y.value) || !b.value ? !1 : z ? k.value.fixedEnd && Tn(O.value, b.value) && Vn(O.value, y.value[0]) : k.value.fixedStart && Vn(O.value, b.value) && Tn(O.value, y.value[1]), X = (O) => {
    const { isRangeStart: z, isRangeEnd: V } = j(O);
    return {
      dp__range_start: z,
      dp__range_end: V,
      dp__range_between: pe(O),
      dp__date_hover: r(O.value, b.value) && !z && !V && !c.weekPicker,
      dp__date_hover_start: D(O, !0) || I(O, !0, z, V),
      dp__date_hover_end: D(O, !1) || I(O, !1, z, V),
      "dp--extended-fixed-start": B(O, !0),
      "dp--extended-fixed-end": B(O, !1)
    };
  }, R = (O) => ({
    ...X(O),
    dp__cell_auto_range: Z(O),
    dp__cell_auto_range_start: se(O),
    dp__cell_auto_range_end: L(O)
  }), te = (O) => k.value.enabled ? k.value.autoRange ? R(O) : c.modelAuto ? { ...be(O), ...X(O) } : c.weekPicker ? F(O) : X(O) : c.weekPicker ? Me(O) : be(O);
  return {
    setHoverDate: S,
    clearHoverDate: x,
    getDayClassData: (O) => c.hideOffsetDates && !O.current ? {} : {
      ...K(O),
      ...te(O),
      [d.value.dayClass ? d.value.dayClass(O.value, y.value) : ""]: !0,
      ...d.value.calendarCell
    }
  };
}, G0 = { key: 0 }, K0 = /* @__PURE__ */ Se({
  __name: "DatePicker",
  props: /* @__PURE__ */ Tu({
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  }, qb),
  emits: ["mount", "update-flow-step", "reset-flow", "focus-menu", "select-date", "time-update", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      month: r,
      year: l,
      modelValue: i,
      time: o,
      disabledTimesConfig: u,
      today: c,
      validateTime: f,
      getCalendarDays: m,
      getMarker: d,
      handleArrow: p,
      handleScroll: g,
      handleSwipe: k,
      selectDate: y,
      updateMonthYear: h,
      presetDate: b,
      selectCurrentDate: S,
      updateTime: x,
      assignMonthAndYear: C,
      setStartTime: $
    } = q0(s, a, be, Me), _ = Ht(), { setHoverDate: A, getDayClassData: D, clearHoverDate: Y } = j0(), {
      getDate: L,
      rootEmit: Z,
      rootProps: se,
      defaults: { multiCalendars: ie, timeConfig: ce }
    } = Ge(), { getYears: G, getMonths: le } = Yr(), { getCellId: q } = Vt(), N = Je("calendar-header"), Q = Je("calendar"), he = Je("time-picker"), pe = Cn(_, gn.Calendar), ge = Cn(_, gn.DatePickerHeader), Ce = Cn(_, gn.TimePicker), ye = (te) => {
      a("mount", te);
    };
    We(
      ie,
      (te, O) => {
        te.count - O.count > 0 && C();
      },
      { deep: !0 }
    );
    const K = M(() => (te) => m(r.value(te), l.value(te)).map((O) => ({
      ...O,
      days: O.days.map((z) => (z.marker = d(z), z.classData = D(z), z))
    })));
    function be(te) {
      var O, z, V;
      te || te === 0 ? (z = (O = Q.value) == null ? void 0 : O[te]) == null || z.triggerTransition(r.value(te), l.value(te)) : (V = Q.value) == null || V.forEach((re, W) => re == null ? void 0 : re.triggerTransition(r.value(W), l.value(W)));
    }
    function Me() {
      a("update-flow-step");
    }
    const F = (te, O, z = 0) => {
      var V, re;
      (re = (V = N.value) == null ? void 0 : V[z]) == null || re.toggleMonthPicker(te, O);
    }, j = (te, O, z = 0) => {
      var V, re;
      (re = (V = N.value) == null ? void 0 : V[z]) == null || re.toggleYearPicker(te, O);
    }, H = (te, O, z) => {
      var V;
      (V = he.value) == null || V.toggleTimePicker(te, O, z);
    }, I = (te, O) => {
      var z;
      if (!se.range) {
        const V = i.value ? i.value : c, re = O ? L(O) : V, W = te ? sn(re, { weekStartsOn: 1 }) : Si(re, { weekStartsOn: 1 });
        y({
          value: W,
          current: Ke(re) === r.value(0),
          text: "",
          classData: {}
        }), (z = document.getElementById(q(W))) == null || z.focus();
      }
    }, B = (te) => {
      var O, z;
      (z = (O = N.value) == null ? void 0 : O[0]) == null || z.handleMonthYearChange(te, !0);
    }, X = (te) => {
      h(0, { month: r.value(0), year: l.value(0) + (te ? 1 : -1), fromNav: !0 });
    }, R = (te) => {
      Z("overlay-toggle", { open: !1, overlay: te }), a("focus-menu");
    };
    return n({
      clearHoverDate: Y,
      presetDate: b,
      selectCurrentDate: S,
      handleArrow: p,
      updateMonthYear: h,
      setStartTime: $,
      toggleMonthPicker: F,
      toggleYearPicker: j,
      toggleTimePicker: H,
      getSidebarProps: () => ({
        modelValue: i,
        month: r,
        year: l,
        time: o,
        updateTime: x,
        updateMonthYear: h,
        selectDate: y,
        presetDate: b
      }),
      changeMonth: B,
      changeYear: X,
      selectWeekDate: I
    }), (te, O) => (w(), T(Te, null, [
      oe(Ur, { collapse: e.collapse }, {
        default: fe(({ instances: z, wrapClass: V }) => [
          (w(!0), T(Te, null, Pe(z, (re) => (w(), T("div", {
            key: re,
            class: ne(V)
          }, [
            v(se).hideMonthYearSelect ? P("", !0) : (w(), de(L0, {
              key: 0,
              ref_for: !0,
              ref: "calendar-header",
              months: v(le)(),
              years: v(G)(),
              month: v(r)(re),
              year: v(l)(re),
              instance: re,
              "menu-wrap-ref": e.menuWrapRef,
              onMount: O[0] || (O[0] = (W) => ye(v(pa).header)),
              onResetFlow: O[1] || (O[1] = (W) => te.$emit("reset-flow")),
              onUpdateMonthYear: (W) => v(h)(re, W),
              onOverlayClosed: R
            }, dt({ _: 2 }, [
              Pe(v(ge), (W, me) => ({
                name: W,
                fn: fe((De) => [
                  U(te.$slots, W, rt({ ref_for: !0 }, De))
                ])
              }))
            ]), 1032, ["months", "years", "month", "year", "instance", "menu-wrap-ref", "onUpdateMonthYear"])),
            oe(U0, {
              ref_for: !0,
              ref: "calendar",
              "mapped-dates": K.value(re),
              instance: re,
              month: v(r)(re),
              year: v(l)(re),
              onSelectDate: (W) => v(y)(W, re !== 1),
              onSetHoverDate: O[2] || (O[2] = (W) => v(A)(W)),
              onHandleScroll: (W) => v(g)(W, re),
              onHandleSwipe: (W) => v(k)(W, re),
              onMount: O[3] || (O[3] = (W) => ye(v(pa).calendar))
            }, dt({ _: 2 }, [
              Pe(v(pe), (W, me) => ({
                name: W,
                fn: fe((De) => [
                  U(te.$slots, W, rt({ ref_for: !0 }, De))
                ])
              }))
            ]), 1032, ["mapped-dates", "instance", "month", "year", "onSelectDate", "onHandleScroll", "onHandleSwipe"])
          ], 2))), 128))
        ]),
        _: 3
      }, 8, ["collapse"]),
      v(ce).enableTimePicker ? (w(), T("div", G0, [
        U(te.$slots, "time-picker", Mt(Bt({ time: v(o), updateTime: v(x) })), () => [
          oe(Pd, {
            ref: "time-picker",
            hours: v(o).hours,
            minutes: v(o).minutes,
            seconds: v(o).seconds,
            "disabled-times-config": v(u),
            "validate-time": v(f),
            "no-overlay-focus": e.noOverlayFocus,
            onMount: O[4] || (O[4] = (z) => ye(v(pa).timePicker)),
            "onUpdate:hours": O[5] || (O[5] = (z) => v(x)({ hours: z, minutes: v(o).minutes, seconds: v(o).seconds })),
            "onUpdate:minutes": O[6] || (O[6] = (z) => v(x)({ hours: v(o).hours, minutes: z, seconds: v(o).seconds })),
            "onUpdate:seconds": O[7] || (O[7] = (z) => v(x)({ hours: v(o).hours, minutes: v(o).minutes, seconds: z })),
            onResetFlow: O[8] || (O[8] = (z) => te.$emit("reset-flow"))
          }, dt({ _: 2 }, [
            Pe(v(Ce), (z, V) => ({
              name: z,
              fn: fe((re) => [
                U(te.$slots, z, Mt(Bt(re)))
              ])
            }))
          ]), 1032, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time", "no-overlay-focus"])
        ])
      ])) : P("", !0)
    ], 64));
  }
}), Z0 = (e, n) => {
  const {
    getDate: t,
    modelValue: a,
    year: s,
    calendars: r,
    defaults: { highlight: l, range: i, multiDates: o }
  } = Ge(), { isDateBetween: u, isDateEqual: c } = Vt(), { checkRangeAutoApply: f, handleMultiDatesSelect: m, setMonthOrYearRange: d } = qr();
  Ys();
  const { isDisabled: p } = ln(), { formatQuarterText: g } = aa(), {
    selectYear: k,
    groupedYears: y,
    showYearPicker: h,
    isDisabled: b,
    toggleYearPicker: S,
    handleYearSelect: x,
    handleYear: C,
    setStartDate: $
  } = Id(n), _ = ee();
  et(() => {
    $();
  });
  const A = M(() => (G) => a.value ? Array.isArray(a.value) ? a.value.some((le) => qo(G, le)) : qo(a.value, G) : !1), D = (G) => {
    if (i.value.enabled) {
      if (Array.isArray(a.value)) {
        const le = c(G, a.value[0]) || c(G, a.value[1]);
        return u(a.value, _.value, G) && !le;
      }
      return !1;
    }
    return !1;
  }, Y = (G, le) => G.quarter === Bo(le) && G.year === Be(le), L = (G) => typeof l.value == "function" ? l.value({ quarter: Bo(G), year: Be(G) }) : l.value.quarters.some((le) => Y(le, G)), Z = M(() => (G) => {
    const le = qe(t(), { year: s.value(G) });
    return tg({
      start: Ha(le),
      end: ud(le)
    }).map((q) => {
      const N = ha(q), Q = zo(q), he = p(q), pe = D(N), ge = L(N);
      return {
        text: g(N, Q),
        value: N,
        active: A.value(N),
        highlighted: ge,
        disabled: he,
        isBetween: pe
      };
    });
  }), se = (G) => {
    m(G, o.value.limit), n("auto-apply", !0);
  }, ie = (G) => {
    a.value = d(G), f(a.value, n, a.value.length < 2);
  }, ce = (G) => {
    a.value = G, n("auto-apply");
  };
  return {
    groupedYears: y,
    year: s,
    isDisabled: b,
    quarters: Z,
    showYearPicker: h,
    modelValue: a,
    selectYear: k,
    toggleYearPicker: S,
    handleYearSelect: x,
    handleYear: C,
    setHoverDate: (G) => {
      _.value = G;
    },
    selectQuarter: (G, le, q) => {
      if (!q)
        return r.value[le].month = Ke(zo(G)), o.value.enabled ? se(G) : i.value.enabled ? ie(G) : ce(G);
    }
  };
}, X0 = { class: "dp--quarter-items" }, J0 = ["data-test-id", "disabled", "onClick", "onMouseover"], Q0 = /* @__PURE__ */ Se({
  __name: "QuarterPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      defaults: { config: r }
    } = Ge(), l = Ht(), { boolHtmlAttribute: i } = rs(), o = Cn(l, gn.YearMode), {
      groupedYears: u,
      year: c,
      isDisabled: f,
      quarters: m,
      modelValue: d,
      showYearPicker: p,
      setHoverDate: g,
      selectQuarter: k,
      toggleYearPicker: y,
      handleYearSelect: h,
      handleYear: b
    } = Z0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: d,
      year: c,
      selectQuarter: k,
      handleYearSelect: h,
      handleYear: b
    }) }), (S, x) => (w(), de(Ur, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: fe(({ instances: C, wrapClass: $ }) => [
        (w(!0), T(Te, null, Pe(C, (_) => (w(), T("div", {
          key: _,
          class: ne($)
        }, [
          E("div", {
            class: "dp-quarter-picker-wrap",
            style: Ve({ minHeight: `${v(r).modeHeight}px` })
          }, [
            S.$slots["top-extra"] ? U(S.$slots, "top-extra", {
              key: 0,
              value: v(d)
            }) : P("", !0),
            E("div", null, [
              oe(Ed, {
                items: v(u)(_),
                instance: _,
                "show-year-picker": v(p)[_],
                year: v(c)(_),
                "is-disabled": (A) => v(f)(_, A),
                onHandleYear: (A) => v(b)(_, A),
                onYearSelect: (A) => v(h)(A, _),
                onToggleYearPicker: (A) => v(y)(_, A == null ? void 0 : A.flow, A == null ? void 0 : A.show)
              }, dt({ _: 2 }, [
                Pe(v(o), (A, D) => ({
                  name: A,
                  fn: fe((Y) => [
                    U(S.$slots, A, rt({ ref_for: !0 }, Y))
                  ])
                }))
              ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
            ]),
            E("div", X0, [
              (w(!0), T(Te, null, Pe(v(m)(_), (A, D) => (w(), T("div", { key: D }, [
                E("button", {
                  type: "button",
                  class: ne(["dp--qr-btn", {
                    "dp--qr-btn-active": A.active,
                    "dp--qr-btn-between": A.isBetween,
                    "dp--qr-btn-disabled": A.disabled,
                    "dp--highlighted": A.highlighted
                  }]),
                  "data-dp-action-element": "0",
                  "data-test-id": A.value,
                  disabled: v(i)(A.disabled),
                  onClick: (Y) => v(k)(A.value, _, A.disabled),
                  onMouseover: (Y) => v(g)(A.value)
                }, [
                  U(S.$slots, "quarter", {
                    value: A.value,
                    text: A.text
                  }, () => [
                    Ue(ue(A.text), 1)
                  ])
                ], 42, J0)
              ]))), 128))
            ])
          ], 4)
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), ew = ["id", "tabindex", "role", "aria-label"], tw = {
  key: 0,
  class: "dp--menu-load-container"
}, nw = {
  key: 1,
  class: "dp--menu-header"
}, aw = ["data-dp-mobile"], sw = {
  key: 0,
  class: "dp__sidebar_left"
}, rw = ["data-dp-mobile"], lw = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], iw = { class: "dp__instance_calendar" }, ow = {
  key: 2,
  class: "dp__sidebar_right"
}, uw = {
  key: 2,
  class: "dp__action_extra"
}, cw = /* @__PURE__ */ Se({
  __name: "DatepickerMenu",
  props: {
    collapse: { type: Boolean },
    noOverlayFocus: { type: Boolean },
    getInputRect: { type: Function }
  },
  emits: ["close-picker", "select-date", "auto-apply", "time-update", "menu-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ht(), {
      state: r,
      rootProps: l,
      defaults: { textInput: i, inline: o, config: u, ui: c, ariaLabels: f },
      setState: m
    } = Ge(), { isMobile: d } = Wr(), { handleEventPropagation: p, getElWithin: g, checkStopPropagation: k, checkKeyDown: y } = Ot();
    ab();
    const h = Je("inner-menu"), b = Je("dp-menu"), S = Je("dyn-cmp"), x = ee(0), C = ee(!1), $ = ee(!1), { flowStep: _, updateFlowStep: A, childMount: D, resetFlow: Y, handleFlow: L } = rb(S), Z = (R) => {
      $.value = !0, u.value.allowPreventDefault && R.preventDefault(), k(R, u.value, !0);
    };
    et(() => {
      C.value = !0, se(), globalThis.addEventListener("resize", se);
      const R = jt(b);
      R && !i.value.enabled && !o.value.enabled && m("menuFocused", !0), R && (R.addEventListener("pointerdown", Z), R.addEventListener("mousedown", Z)), document.addEventListener("mousedown", X);
    }), rn(() => {
      globalThis.removeEventListener("resize", se), document.removeEventListener("mousedown", X);
      const R = jt(b);
      R && (R.removeEventListener("pointerdown", Z), R.removeEventListener("mousedown", Z));
    });
    const se = () => {
      const R = jt(h);
      R && (x.value = R.getBoundingClientRect().width);
    }, ie = M(() => l.monthPicker ? v0 : l.yearPicker ? g0 : l.timePicker ? E0 : l.quarterPicker ? Q0 : K0), ce = () => {
      const R = jt(b);
      R && R.focus({ preventScroll: !0 });
    }, G = M(() => {
      var R;
      return ((R = S.value) == null ? void 0 : R.getSidebarProps()) || {};
    }), le = Cn(s, gn.ActionRow), q = Cn(s, gn.PassTrough), N = M(() => ({
      dp__menu_disabled: l.disabled,
      dp__menu_readonly: l.readonly,
      "dp-menu-loading": l.loading
    })), Q = M(
      () => ({
        dp__menu: !0,
        dp__menu_index: !o.value.enabled,
        dp__relative: o.value.enabled,
        ...c.value.menu
      })
    ), he = (R) => {
      k(R, u.value, !0);
    }, pe = (R) => {
      u.value.escClose && (a("close-picker"), p(R, u.value));
    }, ge = (R) => {
      l.arrowNavigation || (R === fn.left || R === fn.up ? be("handleArrow", fn.left, 0, R === fn.up) : be("handleArrow", fn.right, 0, R === fn.down));
    }, Ce = (R) => {
      m("shiftKeyInMenu", R.shiftKey), !l.hideMonthYearSelect && R.code === ct.tab && R.target.classList.contains("dp__menu") && r.shiftKeyInMenu && (R.preventDefault(), k(R, u.value, !0), a("close-picker"));
    }, ye = (R) => {
      var te, O, z;
      (te = S.value) == null || te.toggleTimePicker(!1, !1), (O = S.value) == null || O.toggleMonthPicker(!1, !1, R), (z = S.value) == null || z.toggleYearPicker(!1, !1, R);
    }, K = (R, te = 0) => {
      var O, z, V;
      return R === "month" ? (O = S.value) == null ? void 0 : O.toggleMonthPicker(!1, !0, te) : R === "year" ? (z = S.value) == null ? void 0 : z.toggleYearPicker(!1, !0, te) : R === "time" ? (V = S.value) == null ? void 0 : V.toggleTimePicker(!0, !1) : ye(te);
    }, be = (R, ...te) => {
      var O, z;
      (O = S.value) != null && O[R] && ((z = S.value) == null || z[R](...te));
    }, Me = () => {
      be("selectCurrentDate");
    }, F = (R) => {
      be("presetDate", Qe(R));
    }, j = () => {
      be("clearHoverDate");
    }, H = (R, te) => {
      be("updateMonthYear", R, te);
    }, I = (R, te) => {
      R.preventDefault(), ge(te);
    }, B = (R) => {
      var te, O, z;
      if (Ce(R), R.key === ct.home || R.key === ct.end)
        return be(
          "selectWeekDate",
          R.key === ct.home,
          R.target.getAttribute("id")
        );
      switch ((R.key === ct.pageUp || R.key === ct.pageDown) && (R.shiftKey ? (be("changeYear", R.key === ct.pageUp), (te = g(b.value, "overlay-year")) == null || te.focus()) : (be("changeMonth", R.key === ct.pageUp), (O = g(b.value, R.key === ct.pageUp ? "action-prev" : "action-next")) == null || O.focus()), R.target.getAttribute("id") && ((z = b.value) == null || z.focus({ preventScroll: !0 }))), R.key) {
        case ct.esc:
          return pe(R);
        case ct.arrowLeft:
          return I(R, fn.left);
        case ct.arrowRight:
          return I(R, fn.right);
        case ct.arrowUp:
          return I(R, fn.up);
        case ct.arrowDown:
          return I(R, fn.down);
        default:
          return;
      }
    }, X = (R) => {
      var te;
      o.value.enabled && !o.value.input && !((te = b.value) != null && te.contains(R.target)) && $.value && ($.value = !1, a("menu-blur"));
    };
    return n({
      updateMonthYear: H,
      switchView: K,
      onValueCleared: () => {
        var R, te;
        (te = (R = S.value) == null ? void 0 : R.setStartTime) == null || te.call(R);
      },
      handleFlow: L
    }), (R, te) => {
      var O, z, V;
      return w(), T("div", {
        id: v(l).menuId,
        ref: "dp-menu",
        tabindex: v(o).enabled ? void 0 : "0",
        role: v(o).enabled ? void 0 : "dialog",
        "aria-label": (O = v(f)) == null ? void 0 : O.menu,
        class: ne(Q.value),
        onMouseleave: j,
        onClick: he,
        onKeydown: B
      }, [
        (v(l).disabled || v(l).readonly) && v(o).enabled || v(l).loading ? (w(), T("div", {
          key: 0,
          class: ne(N.value)
        }, [
          v(l).loading ? (w(), T("div", tw, [...te[5] || (te[5] = [
            E("span", { class: "dp--menu-loader" }, null, -1)
          ])])) : P("", !0)
        ], 2)) : P("", !0),
        R.$slots["menu-header"] ? (w(), T("div", nw, [
          U(R.$slots, "menu-header")
        ])) : P("", !0),
        U(R.$slots, "arrow"),
        E("div", {
          ref: "inner-menu",
          class: ne({
            dp__menu_content_wrapper: ((z = v(l).presetDates) == null ? void 0 : z.length) || !!R.$slots["left-sidebar"] || !!R.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((V = v(l).presetDates) == null ? void 0 : V.length) || !!R.$slots["left-sidebar"] || !!R.$slots["right-sidebar"])
          }),
          "data-dp-mobile": v(d),
          style: Ve({ "--dp-menu-width": `${x.value}px` })
        }, [
          R.$slots["left-sidebar"] ? (w(), T("div", sw, [
            U(R.$slots, "left-sidebar", Mt(Bt(G.value)))
          ])) : P("", !0),
          v(l).presetDates.length ? (w(), T("div", {
            key: 1,
            class: ne({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": v(d)
          }, [
            (w(!0), T(Te, null, Pe(v(l).presetDates, (re, W) => (w(), T(Te, { key: W }, [
              re.slot ? U(R.$slots, re.slot, {
                key: 0,
                presetDate: F,
                label: re.label,
                value: re.value
              }) : (w(), T("button", {
                key: 1,
                type: "button",
                style: Ve(re.style || {}),
                class: ne(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test-id": re.testId ?? void 0,
                "data-dp-mobile": v(d),
                onClick: Fe((me) => F(re.value), ["prevent"]),
                onKeydown: (me) => v(y)(me, () => F(re.value), !0)
              }, ue(re.label), 47, lw))
            ], 64))), 128))
          ], 10, rw)) : P("", !0),
          E("div", iw, [
            (w(), de(ht(ie.value), {
              ref: "dyn-cmp",
              "flow-step": v(_),
              collapse: e.collapse,
              "no-overlay-focus": e.noOverlayFocus,
              "menu-wrap-ref": b.value,
              onMount: v(D),
              onUpdateFlowStep: v(A),
              onResetFlow: v(Y),
              onFocusMenu: ce,
              onSelectDate: te[0] || (te[0] = (re) => R.$emit("select-date")),
              onAutoApply: te[1] || (te[1] = (re) => R.$emit("auto-apply", re)),
              onTimeUpdate: te[2] || (te[2] = (re) => R.$emit("time-update"))
            }, dt({ _: 2 }, [
              Pe(v(q), (re, W) => ({
                name: re,
                fn: fe((me) => [
                  U(R.$slots, re, Mt(Bt({ ...me })))
                ])
              }))
            ]), 1064, ["flow-step", "collapse", "no-overlay-focus", "menu-wrap-ref", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ]),
          R.$slots["right-sidebar"] ? (w(), T("div", ow, [
            U(R.$slots, "right-sidebar", Mt(Bt(G.value)))
          ])) : P("", !0)
        ], 14, aw),
        R.$slots["action-extra"] ? (w(), T("div", uw, [
          R.$slots["action-extra"] ? U(R.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: Me
          }) : P("", !0)
        ])) : P("", !0),
        !v(l).autoApply || v(u).keepActionRow ? (w(), de(l0, {
          key: 3,
          "menu-mount": C.value,
          "calendar-width": x.value,
          onClosePicker: te[3] || (te[3] = (re) => R.$emit("close-picker")),
          onSelectDate: te[4] || (te[4] = (re) => R.$emit("select-date")),
          onSelectNow: Me
        }, dt({ _: 2 }, [
          Pe(v(le), (re, W) => ({
            name: re,
            fn: fe((me) => [
              U(R.$slots, re, Mt(Bt(me)))
            ])
          }))
        ]), 1032, ["menu-mount", "calendar-width"])) : P("", !0)
      ], 42, ew);
    };
  }
}), dw = ["data-dp-mobile"], fw = /* @__PURE__ */ Se({
  __name: "VueDatePicker",
  setup(e, { expose: n }) {
    const {
      rootEmit: t,
      setState: a,
      inputValue: s,
      modelValue: r,
      rootProps: l,
      defaults: { inline: i, config: o, textInput: u, range: c, multiDates: f, teleport: m, floatingConfig: d }
    } = Ge(), { validateDate: p, isValidTime: g } = ln(), { menuTransition: k, showTransition: y } = Ws(), { isMobile: h } = Wr(), { findNextFocusableElement: b, getNumVal: S } = Ot(), x = Ht(), C = ee(!1), $ = ee(i.value.enabled || l.centered), _ = vr(l, "modelValue"), A = vr(l, "timezone"), D = Je("dp-menu-wrap"), Y = Je("dp-menu"), L = Je("input-cmp"), Z = Je("picker-wrapper"), se = Je("menu-arrow"), ie = ee(!1), ce = ee(!1), G = ee(!1), le = ee(!0), q = (_e) => (d.value.arrow && _e.push(
      Yp({ element: d.value.arrow === !0 ? se : d.value.arrow })
    ), d.value.flip && _e.push(Np(typeof d.value.flip == "object" ? d.value.flip : {})), d.value.shift && _e.push(Lp(typeof d.value.shift == "object" ? d.value.shift : {})), _e), { floatingStyles: N, middlewareData: Q, placement: he, y: pe } = Hp(
      L,
      D,
      {
        strategy: d.value.strategy,
        placement: d.value.placement,
        middleware: q([Vp(d.value.offset)]),
        whileElementsMounted: Fp
      }
    );
    et(() => {
      ye(l.modelValue), Ze().then(() => {
        i.value.enabled || globalThis.addEventListener("resize", X);
      }), i.value.enabled && (C.value = !0), globalThis.addEventListener("keyup", R), globalThis.addEventListener("keydown", te);
    }), rn(() => {
      i.value.enabled || globalThis.removeEventListener("resize", X), globalThis.removeEventListener("keyup", R), globalThis.removeEventListener("keydown", te);
    });
    const ge = _d(x, l.presetDates), Ce = Cn(x, gn.Input);
    We(
      [_, A],
      () => {
        ye(_.value);
      },
      { deep: !0 }
    ), We([he, pe], () => {
      !i.value.enabled && !l.centered && le.value && ($.value = !1, Ze().then(() => {
        le.value = !1, $.value = !0;
      }));
    });
    const { parseExternalModelValue: ye, emitModelValue: K, formatInputValue: be, checkBeforeEmit: Me } = sb(), F = M(
      () => ({
        dp__main: !0,
        dp__theme_dark: l.dark,
        dp__theme_light: !l.dark,
        dp__flex_display: i.value.enabled,
        "dp--flex-display-collapsed": G.value,
        dp__flex_display_with_input: i.value.input
      })
    ), j = M(() => l.dark ? "dp__theme_dark" : "dp__theme_light"), H = M(() => i.value.enabled && (l.timePicker || l.monthPicker || l.yearPicker || l.quarterPicker)), I = () => {
      var _e, ut;
      return ((ut = (_e = L.value) == null ? void 0 : _e.$el) == null ? void 0 : ut.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, B = () => {
      C.value && o.value.closeOnScroll && Ee();
    }, X = () => {
      var ut;
      const _e = ((ut = Y.value) == null ? void 0 : ut.$el.getBoundingClientRect().width) ?? 0;
      G.value = document.body.offsetWidth <= _e;
    }, R = (_e) => {
      _e.key === "Tab" && !i.value.enabled && !l.teleport && o.value.tabOutClosesMenu && (Z.value.contains(document.activeElement) || Ee()), ce.value = _e.shiftKey;
    }, te = (_e) => {
      ce.value = _e.shiftKey;
    }, O = () => {
      !l.disabled && !l.readonly && (le.value = !0, C.value = !0, C.value && t("open"), C.value || Re(), ye(l.modelValue));
    }, z = () => {
      var _e, ut;
      s.value = "", Re(), (_e = Y.value) == null || _e.onValueCleared(), (ut = L.value) == null || ut.setParsedDate(null), t("update:model-value", null), t("cleared"), o.value.closeOnClearValue && Ee();
    }, V = () => {
      const _e = r.value;
      return !_e || !Array.isArray(_e) && p(_e) ? !0 : Array.isArray(_e) ? f.value.enabled || _e.length === 2 && p(_e[0]) && p(_e[1]) ? !0 : c.value.partialRange && !l.timePicker ? p(_e[0]) : !1 : !1;
    }, re = () => {
      Me() && V() ? (K(), Ee()) : t("invalid-select");
    }, W = (_e) => {
      me(), K(), o.value.closeOnAutoApply && !_e && Ee();
    }, me = () => {
      L.value && u.value.enabled && L.value.setParsedDate(r.value);
    }, De = (_e = !1) => {
      l.autoApply && g(r.value) && V() && (c.value.enabled && Array.isArray(r.value) ? (c.value.partialRange || r.value.length === 2) && W(_e) : W(_e));
    }, Re = () => {
      u.value.enabled || (r.value = null);
    }, Ee = (_e = !1) => {
      le.value = !0, _e && r.value && o.value.setDateOnMenuClose && re(), i.value.enabled || (C.value && (C.value = !1, a("menuFocused", !1), a("shiftKeyInMenu", !1), t("closed"), s.value && ye(_.value)), Re(), t("blur"));
    }, Ye = (_e, ut, Ct = !1) => {
      if (!_e) {
        r.value = null;
        return;
      }
      const kn = Array.isArray(_e) ? _e.every((Sa) => p(Sa)) : p(_e), In = g(_e);
      kn && In ? (a("isTextInputDate", !0), r.value = _e, ut ? (ie.value = Ct, re(), t("text-submit")) : l.autoApply && De(!0), Ze().then(() => {
        a("isTextInputDate", !1);
      })) : t("invalid-date", _e);
    }, At = () => {
      l.autoApply && g(r.value) && K(), me();
    }, Zt = () => C.value ? Ee() : O(), Wn = (_e) => {
      r.value = _e;
    }, _t = () => {
      u.value.enabled && (a("isInputFocused", !0), be()), t("focus");
    }, Wt = () => {
      var _e;
      u.value.enabled && (a("isInputFocused", !1), ye(l.modelValue), ie.value && ((_e = b(Z.value, ce.value)) == null || _e.focus())), t("blur");
    }, En = (_e, ut) => {
      Y.value && Y.value.updateMonthYear(ut ?? 0, {
        month: S(_e.month),
        year: S(_e.year)
      });
    }, Yn = (_e) => {
      ye(_e ?? l.modelValue);
    }, xt = (_e, ut) => {
      var Ct;
      (Ct = Y.value) == null || Ct.switchView(_e, ut);
    }, $t = (_e, ut) => {
      if (C.value)
        return o.value.onClickOutside ? o.value.onClickOutside(_e, ut) : Ee(!0);
    }, St = (_e = 0) => {
      var ut;
      (ut = Y.value) == null || ut.handleFlow(_e);
    }, Xt = () => D;
    return Uv(D, (_e) => $t(V, _e), {
      ignore: [L]
    }), n({
      closeMenu: Ee,
      selectDate: re,
      clearValue: z,
      openMenu: O,
      onScroll: B,
      formatInputValue: be,
      // exposed for testing purposes
      updateInternalModelValue: Wn,
      // modify internal modelValue
      setMonthYear: En,
      parseModel: Yn,
      switchView: xt,
      toggleMenu: Zt,
      handleFlow: St,
      getDpWrapMenuRef: Xt,
      dpMenuRef: () => Y,
      dpWrapMenuRef: () => D,
      inputRef: () => L
    }), (_e, ut) => (w(), T("div", {
      ref: "picker-wrapper",
      class: ne(F.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": v(h)
    }, [
      oe(t0, {
        ref: "input-cmp",
        "is-menu-open": C.value,
        onClear: z,
        onOpen: O,
        onSetInputDate: Ye,
        onSetEmptyDate: v(K),
        onSelectDate: re,
        onToggle: Zt,
        onClose: Ee,
        onFocus: _t,
        onBlur: Wt,
        onRealBlur: ut[0] || (ut[0] = (Ct) => v(a)("isInputFocused", !1))
      }, dt({ _: 2 }, [
        Pe(v(Ce), (Ct, kn) => ({
          name: Ct,
          fn: fe((In) => [
            U(_e.$slots, Ct, Mt(Bt(In)))
          ])
        }))
      ]), 1032, ["is-menu-open", "onSetEmptyDate"]),
      oe(zn, {
        to: v(m),
        disabled: !v(m)
      }, {
        default: fe(() => [
          E("div", {
            ref: "dp-menu-wrap",
            class: ne({
              "dp--menu-wrapper": !v(i).enabled,
              dp__outer_menu_wrap: !0,
              "dp--centered": v(l).centered
            }),
            style: Ve(!v(i).enabled && !v(l).centered ? v(N) : void 0)
          }, [
            oe(Dt, {
              name: v(k)(v(he).startsWith("top")),
              css: v(y) && !v(i).enabled && !v(l).centered && $.value
            }, {
              default: fe(() => [
                C.value && $.value ? (w(), de(cw, {
                  key: 0,
                  ref: "dp-menu",
                  class: ne({ [j.value]: !0 }),
                  "no-overlay-focus": H.value,
                  collapse: G.value,
                  "get-input-rect": I,
                  onClosePicker: Ee,
                  onSelectDate: re,
                  onAutoApply: De,
                  onTimeUpdate: At,
                  onMenuBlur: ut[1] || (ut[1] = (Ct) => v(t)("blur"))
                }, dt({ _: 2 }, [
                  Pe(v(ge), (Ct, kn) => ({
                    name: Ct,
                    fn: fe((In) => [
                      U(_e.$slots, Ct, Mt(Bt({ ...In })))
                    ])
                  })),
                  !v(i).enabled && !v(l).centered && v(d).arrow === !0 ? {
                    name: "arrow",
                    fn: fe(() => {
                      var Ct, kn;
                      return [
                        E("div", {
                          ref: "menu-arrow",
                          class: ne({
                            dp__arrow_top: v(he) === "bottom",
                            dp__arrow_bottom: v(he) === "top"
                          }),
                          style: Ve({
                            left: ((Ct = v(Q).arrow) == null ? void 0 : Ct.x) != null ? `${v(Q).arrow.x}px` : "",
                            top: ((kn = v(Q).arrow) == null ? void 0 : kn.y) != null ? `${v(Q).arrow.y}px` : ""
                          })
                        }, null, 6)
                      ];
                    }),
                    key: "0"
                  } : void 0
                ]), 1032, ["class", "no-overlay-focus", "collapse"])) : P("", !0)
              ]),
              _: 3
            }, 8, ["name", "css"])
          ], 6)
        ]),
        _: 3
      }, 8, ["to", "disabled"])
    ], 10, dw));
  }
}), hw = /* @__PURE__ */ Se({
  __name: "VueDatePickerRoot",
  props: /* @__PURE__ */ Tu({
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    modelType: {},
    dark: { type: Boolean },
    transitions: { type: [Boolean, Object] },
    ariaLabels: {},
    hideNavigation: {},
    timezone: {},
    vertical: { type: Boolean },
    hideMonthYearSelect: { type: Boolean },
    disableYearSelect: { type: Boolean },
    yearRange: {},
    autoApply: { type: Boolean },
    disabledDates: { type: [Array, Function] },
    startDate: {},
    hideOffsetDates: { type: Boolean },
    noToday: { type: Boolean },
    allowedDates: {},
    markers: {},
    presetDates: {},
    flow: {},
    preventMinMaxNavigation: { type: Boolean },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    filters: {},
    arrowNavigation: { type: Boolean },
    highlight: { type: [Function, Object] },
    teleport: { type: [String, Boolean] },
    centered: { type: Boolean },
    locale: {},
    weekStart: {},
    weekNumbers: { type: [Boolean, Object] },
    dayNames: { type: [Function, Array] },
    monthPicker: { type: Boolean },
    yearPicker: { type: Boolean },
    modelAuto: { type: Boolean },
    formats: {},
    multiDates: { type: [Boolean, Object] },
    minDate: {},
    maxDate: {},
    minTime: {},
    maxTime: {},
    inputAttrs: {},
    timeConfig: {},
    placeholder: {},
    timePicker: { type: Boolean },
    range: { type: [Boolean, Object] },
    menuId: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    inline: { type: [Boolean, Object] },
    textInput: { type: [Boolean, Object] },
    sixWeeks: { type: [Boolean, String] },
    actionRow: {},
    focusStartDate: { type: Boolean },
    disabledTimes: { type: [Function, Array] },
    calendar: { type: Function },
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    ui: {},
    floating: {}
  }, jb),
  emits: ["update:model-value", "internal-model-change", "text-submit", "text-input", "open", "closed", "focus", "blur", "cleared", "flow-step", "update-month-year", "invalid-select", "invalid-fixed-range", "invalid-date", "tooltip-open", "tooltip-close", "am-pm-change", "range-start", "range-end", "date-click", "overlay-toggle", "invalid"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e;
    tb(s, a);
    const r = Ht(), l = _d(r, s.presetDates), i = Je("date-picker");
    return n(Kb(i)), (o, u) => (w(), de(fw, { ref: "date-picker" }, dt({ _: 2 }, [
      Pe(v(l), (c, f) => ({
        name: c,
        fn: fe((m) => [
          U(o.$slots, c, Mt(Bt(m)))
        ])
      }))
    ]), 1536));
  }
}), Qo = "theme-mode", mw = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", Rd = kf("theme", () => {
  const e = ee("light"), n = ee("light"), t = M(() => n.value === "dark"), a = M(() => n.value === "light"), s = (o) => {
    document.documentElement.setAttribute("data-theme", o);
  }, r = (o) => {
    e.value = o, n.value = o, s(o), localStorage.setItem(Qo, o);
  };
  return {
    themeMode: e,
    resolvedTheme: n,
    isDark: t,
    isLight: a,
    setThemeMode: r,
    toggleTheme: () => {
      r(e.value === "dark" ? "light" : "dark");
    },
    initTheme: () => {
      const o = localStorage.getItem(Qo);
      r(o === "light" || o === "dark" ? o : mw());
    }
  };
}), vw = {
  key: 0,
  class: "v-datepicker-label"
}, pw = { class: "v-datepicker-icon-wrapper" }, gw = { class: "v-datepicker-clear-wrapper" }, yw = {
  key: 1,
  class: "v-datepicker-helper-text"
}, bw = {
  key: 0,
  class: "form-error"
}, ww = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "VDatepicker",
  props: /* @__PURE__ */ Ln({
    name: { default: "" },
    helperText: { default: "" },
    validation: { default: void 0 },
    size: { default: "md" },
    icon: { default: "lucide:calendar" },
    autoApply: { type: Boolean, default: !0 },
    clearable: { type: Boolean, default: !1 },
    width: { default: "100%" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Rd(), t = es(e, "modelValue"), a = Ht(), s = [
      "input-icon",
      "clear-icon",
      "arrow-left",
      "arrow-right",
      "arrow-up",
      "arrow-down",
      "clock-icon",
      "calendar-icon"
    ], r = e;
    return (l, i) => {
      var o, u, c, f;
      return w(), T("div", {
        class: ne([`v-datepicker--${e.size}`, "v-datepicker-wrapper"]),
        style: Ve({ width: r.width })
      }, [
        r.name ? (w(), T("label", vw, ue(r.name), 1)) : P("", !0),
        oe(v(hw), rt({
          modelValue: t.value,
          "onUpdate:modelValue": i[0] || (i[0] = (m) => t.value = m),
          "auto-apply": r.autoApply,
          "calendar-class-name": "v-datepicker-calendar",
          class: [
            "v-datepicker",
            {
              "v-datepicker-error": (o = e.validation) == null ? void 0 : o.$error,
              "v-datepicker-no-clear": !r.clearable
            }
          ],
          dark: v(n).isDark,
          "input-class-name": [
            "v-datepicker-input",
            {
              "v-datepicker-input-error": (u = e.validation) == null ? void 0 : u.$error
            }
          ],
          "menu-class-name": "v-datepicker-menu",
          timezone: "UTC",
          "week-start": 0
        }, l.$attrs), dt({ _: 2 }, [
          v(a)["input-icon"] ? {
            name: "input-icon",
            fn: fe(() => [
              U(l.$slots, "input-icon", {}, void 0, !0)
            ]),
            key: "0"
          } : {
            name: "input-icon",
            fn: fe(() => [
              E("div", pw, [
                oe(ke, {
                  icon: e.icon,
                  class: "v-datepicker-icon"
                }, null, 8, ["icon"])
              ])
            ]),
            key: "1"
          },
          r.clearable ? r.clearable && v(a)["clear-icon"] ? {
            name: "clear-icon",
            fn: fe((m) => [
              U(l.$slots, "clear-icon", Mt(Bt(m)), void 0, !0)
            ]),
            key: "3"
          } : {
            name: "clear-icon",
            fn: fe(({ clear: m }) => [
              E("div", gw, [
                oe(ke, {
                  class: "v-datepicker-clear-icon",
                  icon: "lucide:x",
                  onClick: m
                }, null, 8, ["onClick"])
              ])
            ]),
            key: "4"
          } : {
            name: "clear-icon",
            fn: fe(() => []),
            key: "2"
          },
          v(a)["arrow-left"] ? {
            name: "arrow-left",
            fn: fe(() => [
              U(l.$slots, "arrow-left", {}, void 0, !0)
            ]),
            key: "5"
          } : {
            name: "arrow-left",
            fn: fe(() => [
              oe(ke, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-left"
              })
            ]),
            key: "6"
          },
          v(a)["arrow-right"] ? {
            name: "arrow-right",
            fn: fe(() => [
              U(l.$slots, "arrow-right", {}, void 0, !0)
            ]),
            key: "7"
          } : {
            name: "arrow-right",
            fn: fe(() => [
              oe(ke, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-right"
              })
            ]),
            key: "8"
          },
          v(a)["arrow-up"] ? {
            name: "arrow-up",
            fn: fe(() => [
              U(l.$slots, "arrow-up", {}, void 0, !0)
            ]),
            key: "9"
          } : {
            name: "arrow-up",
            fn: fe(() => [
              oe(ke, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-up"
              })
            ]),
            key: "10"
          },
          v(a)["arrow-down"] ? {
            name: "arrow-down",
            fn: fe(() => [
              U(l.$slots, "arrow-down", {}, void 0, !0)
            ]),
            key: "11"
          } : {
            name: "arrow-down",
            fn: fe(() => [
              oe(ke, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-down"
              })
            ]),
            key: "12"
          },
          v(a)["clock-icon"] ? {
            name: "clock-icon",
            fn: fe(() => [
              U(l.$slots, "clock-icon", {}, void 0, !0)
            ]),
            key: "13"
          } : {
            name: "clock-icon",
            fn: fe(() => [
              oe(ke, {
                class: "v-datepicker-clock-icon",
                icon: "lucide:clock"
              })
            ]),
            key: "14"
          },
          v(a)["calendar-icon"] ? {
            name: "calendar-icon",
            fn: fe(() => [
              U(l.$slots, "calendar-icon", {}, void 0, !0)
            ]),
            key: "15"
          } : {
            name: "calendar-icon",
            fn: fe(() => [
              oe(ke, {
                icon: e.icon,
                class: "v-datepicker-calendar-icon"
              }, null, 8, ["icon"])
            ]),
            key: "16"
          },
          Pe(v(a), (m, d) => ({
            name: d,
            fn: fe((p) => [
              s.includes(d) ? P("", !0) : U(l.$slots, d, Mt(rt({ key: 0 }, p)), void 0, !0)
            ])
          }))
        ]), 1040, ["modelValue", "auto-apply", "class", "dark", "input-class-name"]),
        E("fieldset", {
          class: ne([{ "v-datepicker-fieldset--error": (c = e.validation) == null ? void 0 : c.$error }, "v-datepicker-fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: ne([{ "v-datepicker-legend--visible": !!r.name }, "v-datepicker-legend"])
          }, [
            E("span", null, ue(r.name), 1)
          ], 2)
        ], 2),
        e.helperText && !((f = e.validation) != null && f.$error) ? (w(), T("p", yw, ue(e.helperText), 1)) : P("", !0),
        oe(Dt, {
          mode: "out-in",
          name: "error-slide"
        }, {
          default: fe(() => {
            var m, d, p, g;
            return [
              (m = e.validation) != null && m.$error ? (w(), T("p", bw, ue((g = (p = (d = e.validation) == null ? void 0 : d.$errors) == null ? void 0 : p[0]) == null ? void 0 : g.$message), 1)) : P("", !0)
            ];
          }),
          _: 1
        })
      ], 6);
    };
  }
}), iD = /* @__PURE__ */ je(ww, [["__scopeId", "data-v-7925760e"]]), Us = (e) => e == null, Fd = (e, n) => e.length <= n ? e : `${e.slice(0, n)}...`, $s = (e, n = 2) => {
  if (e === 0) return "0 Bytes";
  const t = 1024, a = n < 0 ? 0 : n, s = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], r = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, r)).toFixed(a))} ${s[r]}`;
}, Vd = (e) => e.slice((e.lastIndexOf(".") - 1 >>> 0) + 2), oD = (e) => {
  const n = Vd(e).toLowerCase();
  return [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "svg",
    "bmp"
  ].includes(n);
}, kw = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  UAH: "₴",
  JPY: "¥",
  CNY: "¥"
}, Cs = (e, n = "USD") => {
  if (Us(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  let a, s, r;
  typeof n == "string" ? n === "compact" || n === "chart" || n === "default" ? (r = n, a = "USD") : a = n : (a = n.code ?? "USD", s = n.decimals, r = n.format);
  const l = kw[a] || a, i = t < 0, o = Math.abs(t);
  if (r === "compact") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 0,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${l}${c}` : `${l}${c}`;
  }
  if (r === "chart") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 1,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${l}${c}` : `${l}${c}`;
  }
  const u = o.toLocaleString("en-US", {
    minimumFractionDigits: s ?? 0,
    maximumFractionDigits: s ?? 0
  });
  return i ? `-${l}${u}` : `${l}${u}`;
}, Ld = (e, n) => {
  if (Us(e)) return { text: "" };
  const t = !!e, a = (n == null ? void 0 : n.trueText) ?? "Yes", s = (n == null ? void 0 : n.falseText) ?? "No", r = (n == null ? void 0 : n.colored) ?? !0, l = t ? a : s;
  return r ? { text: l, class: t ? "text-success" : "text-negative" } : { text: l };
}, Oi = (e, n) => {
  if (Us(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  return `${((typeof n == "object" ? n.multiplier ?? !1 : !1) ? t * 100 : t).toLocaleString("en-US", {
    minimumFractionDigits: a,
    maximumFractionDigits: a
  })}%`;
}, Ua = (e, n) => {
  if (Us(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.type) ?? "default", s = typeof n == "object" ? n.decimals : void 0, r = typeof n == "object" ? n.multiply : void 0, l = r !== void 0 ? t * r : t;
  switch (a) {
    case "compact":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 1
      }).format(l);
    case "chart":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 1,
        maximumFractionDigits: s ?? 1
      }).format(l);
    case "percent":
      return `${l.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      })}%`;
    case "decimal":
      return l.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      });
    case "default":
    default:
      return l.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 0
      });
  }
}, Nd = (e, n) => {
  if (!e) return "";
  let t;
  if (e instanceof Date)
    t = Oe.fromJSDate(e).toUTC();
  else if (typeof e == "string") {
    const s = Oe.fromISO(e, { zone: "utc" });
    if (s.isValid)
      t = s;
    else {
      const r = new Date(e);
      if (isNaN(r.getTime())) return String(e);
      t = Oe.fromJSDate(r).toUTC();
    }
  } else if (typeof e == "number")
    t = Oe.fromMillis(e).toUTC();
  else
    return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.format) ?? "short";
  switch (a) {
    case "short":
      return t.toFormat("MM/dd/yyyy");
    case "long":
      return t.toFormat("MMMM dd, yyyy");
    case "time":
      return t.toFormat("h:mm:ss a");
    case "datetime":
      return t.toFormat("MM/dd/yyyy h:mm:ss a");
    default:
      return t.toFormat(a);
  }
}, Bd = (e, n) => {
  if (Us(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  if (t === 0) return "0 Bytes";
  const s = 1024, r = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], l = Math.floor(Math.log(t) / Math.log(s));
  return `${parseFloat((t / Math.pow(s, l)).toFixed(a))} ${r[l]}`;
}, uD = (e) => typeof e != "string" ? String(e || "") : e.replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().toLowerCase().split(" ").map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join(" "), xw = {
  key: 0,
  class: "loader-message"
}, Sw = /* @__PURE__ */ Se({
  __name: "VLoader",
  props: {
    size: { default: "medium" },
    message: { default: "" },
    fullscreen: { type: Boolean, default: !1 },
    variant: { default: "primary" }
  },
  setup(e) {
    const n = e, t = M(() => `loader-${n.size}`), a = M(() => `loader-${n.variant}`), s = M(() => ({
      "loader-fullscreen": n.fullscreen
    }));
    return (r, l) => (w(), T("div", {
      class: ne([s.value, "loader-container"]),
      role: "status"
    }, [
      E("div", {
        class: ne([[t.value, a.value], "loader"])
      }, [...l[0] || (l[0] = [
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1)
      ])], 2),
      e.message ? (w(), T("span", xw, ue(e.message), 1)) : P("", !0),
      l[1] || (l[1] = E("span", { class: "sr-only" }, "Loading...", -1))
    ], 2));
  }
}), jr = /* @__PURE__ */ je(Sw, [["__scopeId", "data-v-6ca9fde0"]]), Tw = { class: "drag-n-drop" }, Mw = ["id", "accept", "disabled", "multiple"], $w = {
  key: 0,
  class: "drag-n-drop__loading"
}, Cw = {
  key: 1,
  class: "drag-n-drop__content"
}, Dw = { class: "drag-n-drop__icon-wrapper" }, Ow = { class: "drag-n-drop__text" }, _w = {
  key: 0,
  class: "text-primary font-medium text-base"
}, Ew = { class: "text-secondaryText text-sm" }, Iw = { key: 0 }, Pw = { key: 1 }, Aw = { key: 2 }, Rw = {
  key: 2,
  class: "drag-n-drop__preview"
}, Fw = { class: "drag-n-drop__preview-header" }, Vw = { class: "text-mainText font-medium" }, Lw = { class: "text-secondaryText text-xs mt-1" }, Nw = { class: "drag-n-drop__file-icon" }, Bw = { class: "drag-n-drop__file-info" }, zw = ["title"], Ww = { class: "drag-n-drop__file-size" }, Yw = ["disabled", "onClick"], Hw = {
  key: 1,
  class: "drag-n-drop__actions"
}, Uw = /* @__PURE__ */ Se({
  __name: "DragNDrop",
  props: {
    loading: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    id: { default: "drag-n-drop" },
    accept: { default: "" },
    maxSize: { default: 10 * 1024 * 1024 },
    maxFiles: { default: 10 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["upload", "submit", "error"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(!1), r = ee([]), l = ee(null), i = M(() => r.value.length > 0), o = M(() => !t.multiple || r.value.length < t.maxFiles), u = (S) => {
      const x = Vd(S).toLowerCase();
      return {
        pdf: "mdi:file-pdf-box",
        doc: "mdi:file-word-box",
        docx: "mdi:file-word-box",
        xls: "mdi:file-excel-box",
        xlsx: "mdi:file-excel-box",
        ppt: "mdi:file-powerpoint-box",
        pptx: "mdi:file-powerpoint-box",
        zip: "mdi:folder-zip",
        rar: "mdi:folder-zip",
        jpg: "mdi:file-image",
        jpeg: "mdi:file-image",
        png: "mdi:file-image",
        gif: "mdi:file-image",
        svg: "mdi:file-image",
        txt: "mdi:file-document",
        csv: "mdi:file-delimited"
      }[x] || "mdi:file-document-outline";
    }, c = (S) => t.maxSize && S.size > t.maxSize ? `File "${S.name}" exceeds maximum size of ${$s(t.maxSize)}` : null, f = () => {
      r.value = [];
    }, m = (S) => {
      r.value.splice(S, 1), a("upload", r.value, () => {
      });
    }, d = (S) => {
      const x = [];
      for (const C of S) {
        const $ = c(C);
        if ($) {
          a("error", $);
          continue;
        }
        x.push(C);
      }
      if (x.length !== 0) {
        if (!t.multiple)
          r.value = [x[0]];
        else {
          const C = t.maxFiles - r.value.length, $ = x.slice(0, C);
          x.length > C && a("error", `Maximum ${t.maxFiles} files allowed`), r.value = [...r.value, ...$];
        }
        console.log("Files added:", r.value), console.log("hasFiles:", i.value), a("upload", r.value, () => {
        });
      }
    }, p = (S) => {
      t.disabled || t.loading || (S.preventDefault(), s.value = !0);
    }, g = (S) => {
      S.preventDefault(), s.value = !1;
    }, k = (S) => {
      var C;
      if (S.preventDefault(), s.value = !1, t.disabled || t.loading || !o.value) return;
      const x = Array.from(((C = S.dataTransfer) == null ? void 0 : C.files) || []);
      d(x);
    }, y = (S) => {
      const x = S.target, C = Array.from(x.files || []);
      d(C), l.value && (l.value.value = "");
    }, h = () => {
      r.value.length !== 0 && a("submit", r.value, f);
    }, b = () => {
      var S;
      t.disabled || t.loading || !o.value || (S = l.value) == null || S.click();
    };
    return (S, x) => (w(), T("div", Tw, [
      E("input", rt({
        id: `fileInput-${t.id}`,
        ref_key: "fileRef",
        ref: l,
        accept: t.accept,
        disabled: t.disabled || t.loading,
        multiple: t.multiple,
        class: "drag-n-drop__input",
        name: "file",
        type: "file"
      }, S.$attrs, { onChange: y }), null, 16, Mw),
      E("div", {
        class: ne([{
          "drag-n-drop__dropzone--dragging": s.value,
          "drag-n-drop__dropzone--disabled": t.disabled || t.loading,
          "drag-n-drop__dropzone--has-files": i.value
        }, "drag-n-drop__dropzone"]),
        onClick: b,
        onDragleave: g,
        onDragover: p,
        onDrop: k
      }, [
        t.loading ? (w(), T("div", $w, [
          oe(jr, { class: "w-8 h-8" }),
          x[0] || (x[0] = E("p", { class: "text-secondaryText text-sm mt-2" }, " Processing files... ", -1))
        ])) : i.value ? (w(), T("div", Rw, [
          E("div", Fw, [
            oe(ke, {
              size: 24,
              class: "text-primary",
              icon: "mdi:file-multiple-outline"
            }),
            E("span", Vw, ue(r.value.length) + " file" + ue(r.value.length > 1 ? "s" : "") + " selected ", 1)
          ]),
          E("p", Lw, " Click to add " + ue(t.multiple ? "more" : "another") + " file" + ue(t.multiple ? "s" : ""), 1)
        ])) : (w(), T("div", Cw, [
          E("div", Dw, [
            oe(ke, {
              icon: s.value ? "mdi:cloud-download" : "mdi:cloud-upload-outline",
              size: 48,
              class: "drag-n-drop__icon"
            }, null, 8, ["icon"])
          ]),
          E("div", Ow, [
            s.value ? (w(), T("p", _w, " Release to drop files here ")) : (w(), T(Te, { key: 1 }, [
              U(S.$slots, "title", {}, () => [
                x[1] || (x[1] = E("p", { class: "text-mainText font-medium text-base mb-1" }, " Drop files here or click to browse ", -1))
              ], !0),
              U(S.$slots, "subtitle", {}, () => [
                E("p", Ew, [
                  t.accept ? (w(), T("span", Iw, "Supported: " + ue(t.accept), 1)) : P("", !0),
                  t.accept && t.maxSize ? (w(), T("span", Pw, " • ")) : P("", !0),
                  t.maxSize ? (w(), T("span", Aw, "Max: " + ue(v($s)(t.maxSize)), 1)) : P("", !0)
                ])
              ], !0)
            ], 64))
          ]),
          U(S.$slots, "action", {}, () => [
            oe(qt, {
              class: "mt-2",
              icon: "mdi:folder-open-outline",
              text: "Browse Files",
              variant: "primary",
              onClick: Fe(b, ["stop"])
            })
          ], !0)
        ]))
      ], 34),
      i.value && !t.loading ? (w(), de($l, {
        key: 0,
        class: "drag-n-drop__files",
        name: "file-list",
        tag: "div"
      }, {
        default: fe(() => [
          (w(!0), T(Te, null, Pe(r.value, (C, $) => (w(), T("div", {
            key: `${C.name}-${C.size}-${$}`,
            class: "drag-n-drop__file-item"
          }, [
            E("div", Nw, [
              oe(ke, {
                icon: u(C.name),
                size: 20,
                class: "text-primary"
              }, null, 8, ["icon"])
            ]),
            E("div", Bw, [
              E("p", {
                title: C.name,
                class: "drag-n-drop__file-name"
              }, ue(v(Fd)(C.name, 40)), 9, zw),
              E("p", Ww, ue(v($s)(C.size)), 1)
            ]),
            E("button", {
              disabled: t.loading,
              class: "drag-n-drop__file-remove",
              type: "button",
              onClick: Fe((_) => m($), ["stop"])
            }, [
              oe(ke, {
                size: 20,
                icon: "mdi:close-circle"
              })
            ], 8, Yw)
          ]))), 128))
        ]),
        _: 1
      })) : P("", !0),
      i.value && t.button && !t.loading ? (w(), T("div", Hw, [
        oe(qt, {
          class: "w-full",
          icon: "mdi:check-circle-outline",
          text: "Submit Files",
          variant: "primary",
          onClick: h
        })
      ])) : P("", !0)
    ]));
  }
}), cD = /* @__PURE__ */ je(Uw, [["__scopeId", "data-v-3b9bd88e"]]), qw = { class: "v-file-upload w-full" }, jw = ["accept", "disabled", "multiple"], Gw = { class: "v-file-upload__icon-wrapper" }, Kw = { class: "v-file-upload__text-container" }, Zw = {
  key: 0,
  class: "v-file-upload__loading"
}, Xw = {
  key: 0,
  class: "v-file-upload__list"
}, Jw = { class: "flex items-center gap-3 overflow-hidden" }, Qw = { class: "v-file-upload__item-icon" }, e1 = { class: "flex flex-col min-w-0" }, t1 = ["title"], n1 = { class: "text-xs text-secondaryText" }, a1 = ["disabled", "onClick"], s1 = /* @__PURE__ */ Se({
  __name: "VFileUpload",
  props: {
    modelValue: { default: () => [] },
    accept: { default: "*" },
    multiple: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    maxSize: { default: void 0 },
    label: { default: "Click to upload or drag and drop" },
    subLabel: { default: "SVG, PNG, JPG or GIF (max. 800x400px)" },
    showList: { type: Boolean, default: !0 },
    variant: { default: "default" },
    immediate: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "upload", "error", "file-select"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(!1), r = ee(null), l = ee(t.modelValue), i = M({
      get: () => t.modelValue.length ? t.modelValue : l.value,
      set: (p) => {
        l.value = p, a("update:modelValue", p);
      }
    }), o = () => {
      i.value = [], r.value && (r.value.value = "");
    }, u = (p) => {
      if (!(t.loading || t.disabled)) {
        if (t.maxSize && p.filter((k) => k.size > t.maxSize).length) {
          a("error", `File size exceeds limit of ${$s(t.maxSize)}`);
          return;
        }
        if (t.immediate) {
          const g = p[0] || null;
          a("file-select", g), a("upload", p, o);
          return;
        }
        t.multiple ? i.value = [...i.value, ...p] : i.value = p.slice(0, 1), a("change", i.value), a("upload", i.value, o);
      }
    }, c = (p) => {
      var k;
      s.value = !1;
      const g = Array.from(((k = p.dataTransfer) == null ? void 0 : k.files) || []);
      g.length && u(g);
    }, f = (p) => {
      const g = p.target, k = Array.from(g.files || []);
      k.length && u(k);
    }, m = (p) => {
      if (t.loading || t.disabled) return;
      const g = [...i.value];
      g.splice(p, 1), i.value = g, a("change", g);
    }, d = () => {
      var p;
      !t.loading && !t.disabled && ((p = r.value) == null || p.click());
    };
    return (p, g) => (w(), T("div", qw, [
      E("div", {
        class: ne([{
          "v-file-upload__dropzone--dragging": s.value,
          "v-file-upload__dropzone--loading": e.loading,
          "v-file-upload__dropzone--disabled": e.disabled,
          "v-file-upload__dropzone--compact": e.variant === "compact"
        }, "v-file-upload__dropzone"]),
        onClick: d,
        onDragenter: g[0] || (g[0] = Fe((k) => s.value = !0, ["prevent"])),
        onDragleave: g[1] || (g[1] = Fe((k) => s.value = !1, ["prevent"])),
        onDragover: g[2] || (g[2] = Fe((k) => s.value = !0, ["prevent"])),
        onDrop: Fe(c, ["prevent"])
      }, [
        E("input", {
          ref_key: "inputRef",
          ref: r,
          accept: e.accept,
          disabled: e.disabled || e.loading,
          multiple: e.multiple,
          class: "hidden",
          type: "file",
          onChange: f
        }, null, 40, jw),
        E("div", {
          class: ne([{ "v-file-upload__content--loading": e.loading }, "v-file-upload__content"])
        }, [
          E("div", Gw, [
            U(p.$slots, "icon", {}, () => [
              oe(ke, {
                size: e.variant === "compact" ? 20 : 28,
                class: "text-secondaryText",
                icon: "lucide:cloud-upload"
              }, null, 8, ["size"])
            ], !0)
          ]),
          E("div", Kw, [
            g[3] || (g[3] = E("div", { class: "v-file-upload__text" }, [
              E("span", { class: "font-medium text-primary hover:text-primary-dark transition-colors" }, " Click to upload "),
              E("span", { class: "text-secondaryText" }, " or drag and drop ")
            ], -1)),
            e.subLabel ? (w(), T("p", {
              key: 0,
              class: ne([{ "mt-1": e.variant !== "compact" }, "text-xs text-secondaryText"])
            }, ue(e.subLabel), 3)) : P("", !0)
          ])
        ], 2),
        e.loading ? (w(), T("div", Zw, [
          oe(jr, {
            size: e.variant === "compact" ? "small" : "medium",
            variant: "primary"
          }, null, 8, ["size"]),
          g[4] || (g[4] = E("p", { class: "text-secondaryText text-sm" }, " Uploading... ", -1))
        ])) : P("", !0)
      ], 34),
      e.showList && i.value.length > 0 && !e.immediate ? (w(), T("div", Xw, [
        (w(!0), T(Te, null, Pe(i.value, (k, y) => (w(), T("div", {
          key: y,
          class: "v-file-upload__item"
        }, [
          E("div", Jw, [
            E("div", Qw, [
              oe(ke, {
                class: "text-primary",
                icon: "lucide:file"
              })
            ]),
            E("div", e1, [
              E("span", {
                title: k.name,
                class: "text-sm font-medium text-mainText truncate"
              }, ue(v(Fd)(k.name, 30)), 9, t1),
              E("span", n1, ue(v($s)(k.size)), 1)
            ])
          ]),
          E("button", {
            disabled: e.loading || e.disabled,
            class: "v-file-upload__remove",
            onClick: Fe((h) => m(y), ["stop"])
          }, [
            oe(ke, {
              icon: "lucide:trash-2",
              size: 20
            })
          ], 8, a1)
        ]))), 128))
      ])) : P("", !0)
    ]));
  }
}), dD = /* @__PURE__ */ je(s1, [["__scopeId", "data-v-d0ec926d"]]);
function zd(e) {
  return Su() ? (_r(e), !0) : !1;
}
const gl = /* @__PURE__ */ new WeakMap(), r1 = (...e) => {
  var n;
  const t = e[0], a = (n = ti()) == null ? void 0 : n.proxy;
  if (a == null && !Mu())
    throw new Error("injectLocal must be called in setup");
  return a && gl.has(a) && t in gl.get(a) ? gl.get(a)[t] : ea(...e);
}, _i = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const l1 = Object.prototype.toString, i1 = (e) => l1.call(e) === "[object Object]", eu = () => {
};
function o1(e, n) {
  function t(...a) {
    return new Promise((s, r) => {
      Promise.resolve(e(() => n.apply(this, a), { fn: n, thisArg: this, args: a })).then(s).catch(r);
    });
  }
  return t;
}
function u1(e, n = {}) {
  let t, a, s = eu;
  const r = (o) => {
    clearTimeout(o), s(), s = eu;
  };
  let l;
  return (o) => {
    const u = Qe(e), c = Qe(n.maxWait);
    return t && r(t), u <= 0 || c !== void 0 && c <= 0 ? (a && (r(a), a = null), Promise.resolve(o())) : new Promise((f, m) => {
      s = n.rejectOnCancel ? m : f, l = o, c && !a && (a = setTimeout(() => {
        t && r(t), a = null, f(l());
      }, c)), t = setTimeout(() => {
        a && r(a), a = null, f(o());
      }, u);
    });
  };
}
function c1(e) {
  let n;
  function t() {
    return n || (n = e()), n;
  }
  return t.reset = async () => {
    const a = n;
    n = void 0, a && await a;
  }, t;
}
function tu(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function d1(e) {
  return ti();
}
function yl(e) {
  return Array.isArray(e) ? e : [e];
}
function f1(e, n = 200, t = {}) {
  return o1(
    u1(n, t),
    e
  );
}
function h1(e, n = !0, t) {
  d1() ? et(e, t) : n ? e() : Ze(e);
}
function Xl(e, n, t = {}) {
  const {
    immediate: a = !0,
    immediateCallback: s = !1
  } = t, r = It(!1);
  let l = null;
  function i() {
    l && (clearTimeout(l), l = null);
  }
  function o() {
    r.value = !1, i();
  }
  function u(...c) {
    s && e(), i(), r.value = !0, l = setTimeout(() => {
      r.value = !1, l = null, e(...c);
    }, Qe(n));
  }
  return a && (r.value = !0, _i && u()), zd(o), {
    isPending: ei(r),
    start: u,
    stop: o
  };
}
function m1(e, n, t) {
  return We(
    e,
    n,
    {
      ...t,
      immediate: !0
    }
  );
}
const Ei = _i ? window : void 0, Wd = _i ? window.navigator : void 0;
function v1(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
function Es(...e) {
  const n = [], t = () => {
    n.forEach((i) => i()), n.length = 0;
  }, a = (i, o, u, c) => (i.addEventListener(o, u, c), () => i.removeEventListener(o, u, c)), s = M(() => {
    const i = yl(Qe(e[0])).filter((o) => o != null);
    return i.every((o) => typeof o != "string") ? i : void 0;
  }), r = m1(
    () => {
      var i, o;
      return [
        (o = (i = s.value) == null ? void 0 : i.map((u) => v1(u))) != null ? o : [Ei].filter((u) => u != null),
        yl(Qe(s.value ? e[1] : e[0])),
        yl(v(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Qe(s.value ? e[3] : e[2])
      ];
    },
    ([i, o, u, c]) => {
      if (t(), !(i != null && i.length) || !(o != null && o.length) || !(u != null && u.length))
        return;
      const f = i1(c) ? { ...c } : c;
      n.push(
        ...i.flatMap(
          (m) => o.flatMap(
            (d) => u.map((p) => a(m, d, p, f))
          )
        )
      );
    },
    { flush: "post" }
  ), l = () => {
    r(), t();
  };
  return zd(t), l;
}
function p1() {
  const e = It(!1), n = ti();
  return n && et(() => {
    e.value = !0;
  }, n), e;
}
function Ii(e) {
  const n = p1();
  return M(() => (n.value, !!e()));
}
const g1 = Symbol("vueuse-ssr-width");
function y1() {
  const e = Mu() ? r1(g1, null) : null;
  return typeof e == "number" ? e : void 0;
}
function b1(e, n = {}) {
  const { window: t = Ei, ssrWidth: a = y1() } = n, s = Ii(() => t && "matchMedia" in t && typeof t.matchMedia == "function"), r = It(typeof a == "number"), l = It(), i = It(!1), o = (u) => {
    i.value = u.matches;
  };
  return Ut(() => {
    if (r.value) {
      r.value = !s.value;
      const u = Qe(e).split(",");
      i.value = u.some((c) => {
        const f = c.includes("not all"), m = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), d = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let p = !!(m || d);
        return m && p && (p = a >= tu(m[1])), d && p && (p = a <= tu(d[1])), f ? !p : p;
      });
      return;
    }
    s.value && (l.value = t.matchMedia(Qe(e)), i.value = l.value.matches);
  }), Es(l, "change", o, { passive: !0 }), M(() => i.value);
}
function nu(e, n = {}) {
  const {
    controls: t = !1,
    navigator: a = Wd
  } = n, s = Ii(() => a && "permissions" in a), r = It(), l = typeof e == "string" ? { name: e } : e, i = It(), o = () => {
    var c, f;
    i.value = (f = (c = r.value) == null ? void 0 : c.state) != null ? f : "prompt";
  };
  Es(r, "change", o, { passive: !0 });
  const u = c1(async () => {
    if (s.value) {
      if (!r.value)
        try {
          r.value = await a.permissions.query(l);
        } catch {
          r.value = void 0;
        } finally {
          o();
        }
      if (t)
        return $u(r.value);
    }
  });
  return u(), t ? {
    state: i,
    isSupported: s,
    query: u
  } : i;
}
function w1(e = {}) {
  const {
    navigator: n = Wd,
    read: t = !1,
    source: a,
    copiedDuring: s = 1500,
    legacy: r = !1
  } = e, l = Ii(() => n && "clipboard" in n), i = nu("clipboard-read"), o = nu("clipboard-write"), u = M(() => l.value || r), c = It(""), f = It(!1), m = Xl(() => f.value = !1, s, { immediate: !1 });
  async function d() {
    let h = !(l.value && y(i.value));
    if (!h)
      try {
        c.value = await n.clipboard.readText();
      } catch {
        h = !0;
      }
    h && (c.value = k());
  }
  u.value && t && Es(["copy", "cut"], d, { passive: !0 });
  async function p(h = Qe(a)) {
    if (u.value && h != null) {
      let b = !(l.value && y(o.value));
      if (!b)
        try {
          await n.clipboard.writeText(h);
        } catch {
          b = !0;
        }
      b && g(h), c.value = h, f.value = !0, m.start();
    }
  }
  function g(h) {
    const b = document.createElement("textarea");
    b.value = h ?? "", b.style.position = "absolute", b.style.opacity = "0", document.body.appendChild(b), b.select(), document.execCommand("copy"), b.remove();
  }
  function k() {
    var h, b, S;
    return (S = (b = (h = document == null ? void 0 : document.getSelection) == null ? void 0 : h.call(document)) == null ? void 0 : b.toString()) != null ? S : "";
  }
  function y(h) {
    return h === "granted" || h === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: f,
    copy: p
  };
}
function k1(e = {}) {
  const {
    window: n = Ei,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: r = !0,
    type: l = "inner"
  } = e, i = It(t), o = It(a), u = () => {
    if (n)
      if (l === "outer")
        i.value = n.outerWidth, o.value = n.outerHeight;
      else if (l === "visual" && n.visualViewport) {
        const { width: f, height: m, scale: d } = n.visualViewport;
        i.value = Math.round(f * d), o.value = Math.round(m * d);
      } else r ? (i.value = n.innerWidth, o.value = n.innerHeight) : (i.value = n.document.documentElement.clientWidth, o.value = n.document.documentElement.clientHeight);
  };
  u(), h1(u);
  const c = { passive: !0 };
  if (Es("resize", u, c), n && l === "visual" && n.visualViewport && Es(n.visualViewport, "resize", u, c), s) {
    const f = b1("(orientation: portrait)");
    We(f, () => u());
  }
  return { width: i, height: o };
}
const x1 = { class: "v-input-wrapper" }, S1 = { class: "v-input-container" }, T1 = ["for"], M1 = {
  key: 0,
  class: "v-input-helper-text"
}, $1 = {
  key: 0,
  class: "v-input-error-message"
}, C1 = /* @__PURE__ */ Se({
  __name: "VInput",
  props: /* @__PURE__ */ Ln({
    name: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    helperText: { default: "" },
    validation: {},
    error: { default: void 0 },
    icon: { default: "" },
    size: { default: "md" },
    id: {},
    debounce: { type: [Boolean, Number], default: !1 },
    loading: { type: Boolean, default: !1 },
    textarea: { type: Boolean, default: !1 },
    rows: { default: 4 },
    showClearButton: { type: Boolean, default: !0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ln(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = M(() => {
      var L;
      return !!((L = t.validation) != null && L.$error || t.error);
    }), s = M(() => {
      var L, Z;
      return ((Z = (L = t.validation) == null ? void 0 : L.$errors[0]) == null ? void 0 : Z.$message) ?? t.error ?? "";
    }), r = es(e, "modelValue"), l = n, i = Ht(), o = Or(), u = ee(!1), c = ee(!1), f = ee(null), m = M(() => t.id || `v-input-${o}`), d = typeof t.debounce == "number" ? t.debounce : t.debounce ? 800 : 0, p = ee(r.value ?? "");
    We(r, (L) => {
      L !== p.value && (p.value = L ?? "");
    });
    const g = f1((L) => {
      r.value = L;
    }, d), k = (L) => {
      const Z = L.target.value;
      p.value = Z;
      let se = Z;
      if (t.type === "number" && Z !== "") {
        const ie = Number(Z);
        isNaN(ie) || (se = ie);
      }
      g(se);
    }, y = () => {
      var L;
      p.value = "", r.value = t.type === "number" ? void 0 : "", l("clear"), (L = f.value) == null || L.focus();
    }, h = M(() => t.type === "password" ? u.value ? "text" : "password" : t.type), b = () => {
      u.value = !u.value;
    }, S = M(() => ({
      sm: "v-input-field--sm",
      md: "v-input-field--md",
      lg: "v-input-field--lg"
    })[t.size]), x = M(() => t.type === "search"), C = M(() => t.icon || x.value || !!i["icon-left"] || t.loading), $ = M(() => t.type === "password" || _.value || !!i["icon-right"]), _ = M(
      () => t.type !== "password" && p.value !== "" && t.showClearButton
    ), A = M(() => t.icon ? t.icon : x.value ? "mdi:search" : ""), D = M(
      () => p.value !== "" && p.value !== null && p.value !== void 0
    ), Y = M(() => t.name ? c.value ? t.placeholder : "" : t.placeholder);
    return (L, Z) => (w(), T("div", x1, [
      E("div", S1, [
        t.name ? (w(), T("label", {
          key: 0,
          class: ne([
            "v-label",
            {
              "v-label--active": c.value || D.value,
              "v-label--error": a.value,
              "v-label--with-icon": C.value && !(c.value || D.value),
              "v-label--textarea": e.textarea
            }
          ]),
          for: m.value
        }, ue(t.name), 11, T1)) : P("", !0),
        C.value ? (w(), T("div", {
          key: 1,
          class: ne([
            "v-input-icon v-input-icon-left",
            {
              "v-input-icon-textarea": e.textarea,
              "v-input-icon--active": c.value && x.value || e.loading
            }
          ])
        }, [
          U(L.$slots, "icon-left", {}, () => [
            A.value || e.loading ? (w(), de(ke, {
              key: 0,
              icon: A.value,
              loading: e.loading,
              class: "v-input-icon-svg"
            }, null, 8, ["icon", "loading"])) : P("", !0)
          ], !0)
        ], 2)) : P("", !0),
        (w(), de(ht(e.textarea ? "textarea" : "input"), rt({
          id: m.value,
          key: `${e.textarea ? "textarea" : "input"}-${m.value}`,
          ref_key: "inputRef",
          ref: f,
          class: [
            "v-input-field",
            S.value,
            {
              "v-input-field--textarea": e.textarea,
              "v-input-field--with-left-icon": C.value,
              "v-input-field--with-right-icon": $.value,
              "v-input-field--date": e.type === "date" && !e.textarea,
              "v-input-field--disabled": e.disabled
            }
          ],
          disabled: e.disabled,
          placeholder: Y.value,
          value: p.value
        }, {
          ...L.$attrs,
          type: e.textarea ? void 0 : h.value,
          rows: e.textarea ? e.rows : void 0
        }, {
          onBlur: Z[0] || (Z[0] = (se) => c.value = !1),
          onFocus: Z[1] || (Z[1] = (se) => c.value = !0),
          onInput: k
        }), null, 16, ["id", "class", "disabled", "placeholder", "value"])),
        $.value ? (w(), T("div", {
          key: 2,
          class: ne([
            "v-input-icon v-input-icon-right",
            { "v-input-icon-textarea": e.textarea }
          ])
        }, [
          U(L.$slots, "icon-right", {}, () => [
            _.value ? (w(), T("button", {
              key: 0,
              class: "v-input-clear-btn",
              title: "Clear",
              type: "button",
              onClick: y
            }, [
              oe(ke, {
                class: "v-input-icon-svg v-input-icon-svg--sm",
                icon: "lucide:x"
              })
            ])) : t.type === "password" ? (w(), T("div", {
              key: 1,
              class: "v-input-password-toggle",
              role: "button",
              tabindex: "0",
              onClick: b,
              onKeydown: Pt(b, ["enter", "space"])
            }, [
              oe(ke, {
                icon: h.value === "text" ? "lucide:eye-off" : "lucide:eye",
                class: "v-input-icon-svg"
              }, null, 8, ["icon"])
            ], 32)) : P("", !0)
          ], !0)
        ], 2)) : P("", !0),
        E("fieldset", {
          class: ne([
            "v-fieldset",
            {
              "v-fieldset--active": c.value,
              "v-fieldset--error": a.value,
              "v-fieldset--disabled": e.disabled
            }
          ]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: ne(["v-legend", { "v-legend--visible": t.name && (D.value || c.value) }])
          }, [
            E("span", null, ue(t.name), 1)
          ], 2)
        ], 2)
      ]),
      U(L.$slots, "helper-text", {}, () => [
        e.helperText && !a.value ? (w(), T("p", M1, ue(e.helperText), 1)) : P("", !0)
      ], !0),
      oe(Dt, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: fe(() => [
          U(L.$slots, "error-message", {}, () => [
            a.value ? (w(), T("p", $1, ue(s.value), 1)) : P("", !0)
          ], !0)
        ]),
        _: 3
      })
    ]));
  }
}), $r = /* @__PURE__ */ je(C1, [["__scopeId", "data-v-36ea8981"]]), D1 = ["innerHTML"], O1 = { key: 1 }, Rn = 12, Gn = 8, _1 = 200, Ja = /* @__PURE__ */ Se({
  __name: "VTooltip",
  props: {
    text: {},
    allowHtml: { type: Boolean, default: !1 },
    placement: { default: "right" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    tooltipClass: { default: "" },
    wrapperClass: { default: "" },
    maxWidth: { default: "800px" }
  },
  setup(e) {
    const n = e, t = ee(!1), a = ee(null), s = ee(null), r = ee(null), l = ee({ top: 0, left: 0 }), i = ee(n.placement), o = ee(null), u = (p, g, k, y, h, b) => {
      const S = p.top, x = h - p.bottom, C = p.left, $ = y - p.right, _ = S >= k + Gn + Rn, A = x >= k + Gn + Rn, D = C >= g + Gn + Rn, Y = $ >= g + Gn + Rn;
      if (b === "top" && _) return "top";
      if (b === "bottom" && A) return "bottom";
      if (b === "left" && D) return "left";
      if (b === "right" && Y) return "right";
      const L = [
        { placement: "right", fits: Y, space: $ },
        { placement: "left", fits: D, space: C },
        { placement: "bottom", fits: A, space: x },
        { placement: "top", fits: _, space: S }
      ], Z = L.find((se) => se.fits);
      return Z ? Z.placement : (L.sort((se, ie) => ie.space - se.space), L[0].placement);
    }, c = async () => {
      if (!s.value) return;
      const p = s.value.getBoundingClientRect(), g = window.innerWidth, k = window.innerHeight;
      if (o.value = null, l.value = { top: -9999, left: -9999 }, i.value = n.placement, await Ze(), !r.value) return;
      const y = r.value.getBoundingClientRect(), h = Math.max(y.width, _1), b = y.height, S = u(
        p,
        h,
        b,
        g,
        k,
        n.placement
      );
      let x, C;
      switch (S) {
        case "top":
          x = p.top - Gn - b, C = p.left + p.width / 2 - h / 2;
          break;
        case "bottom":
          x = p.bottom + Gn, C = p.left + p.width / 2 - h / 2;
          break;
        case "left":
          x = p.top + p.height / 2 - b / 2, C = p.left - Gn - h;
          break;
        case "right":
        default:
          x = p.top + p.height / 2 - b / 2, C = p.right + Gn;
          break;
      }
      const $ = g - h - Rn;
      C = Math.max(Rn, Math.min(C, $));
      const _ = k - b - Rn;
      x = Math.max(Rn, Math.min(x, _));
      const A = g - Rn * 2;
      h > A && (o.value = `${A}px`), l.value = { top: x, left: C }, S && (i.value = S);
    }, f = () => {
      n.disabled || !n.text || (a.value = setTimeout(async () => {
        t.value = !0, await Ze(), c();
      }, n.delay));
    }, m = () => {
      a.value && (clearTimeout(a.value), a.value = null), t.value = !1, i.value = n.placement;
    }, d = M(() => ({
      top: `${l.value.top}px`,
      left: `${l.value.left}px`,
      maxWidth: o.value ?? n.maxWidth
    }));
    return (p, g) => (w(), T("div", {
      ref_key: "triggerRef",
      ref: s,
      class: ne(["relative inline-block cursor-pointer", e.wrapperClass]),
      onBlur: m,
      onFocus: f,
      onMouseenter: f,
      onMouseleave: m
    }, [
      U(p.$slots, "default"),
      (w(), de(zn, { to: "body" }, [
        oe(Dt, {
          "enter-active-class": "transition-opacity duration-200 ease-out",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "transition-opacity duration-150 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: fe(() => [
            t.value && e.text ? (w(), T("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: r,
              style: Ve(d.value),
              class: "fixed z-[10001] pointer-events-none"
            }, [
              E("div", {
                class: ne([
                  "bg-base-100/100 text-mainText text-sm font-medium px-3 py-1.5 rounded-lg shadow-lg break-words w-fit min-w-[200px] card",
                  e.tooltipClass
                ])
              }, [
                n.allowHtml ? (w(), T("span", {
                  key: 0,
                  innerHTML: e.text
                }, null, 8, D1)) : (w(), T("span", O1, ue(e.text), 1))
              ], 2)
            ], 4)) : P("", !0)
          ]),
          _: 1
        })
      ]))
    ], 34));
  }
}), E1 = (e) => e.map((n) => n.text.trim()).filter((n) => n.length > 0), fD = (e) => e.map((n) => ({ text: n })), I1 = { class: "inline-flex items-center gap-1 bg-base-200 rounded-lg p-1 shadow-md border border-base-400" }, P1 = ["disabled", "onClick"], A1 = /* @__PURE__ */ Se({
  __name: "VToggleGroup",
  props: {
    modelValue: {},
    options: {},
    size: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = {
      sm: "px-2 py-1 text-xs gap-1",
      md: "px-3 py-1.5 text-sm gap-1.5",
      lg: "px-4 py-2 text-base gap-2"
    }, s = {
      sm: "w-3 h-3",
      md: "w-4 h-4",
      lg: "w-5 h-5"
    }, r = (l) => {
      l.disabled || t("update:modelValue", l.value);
    };
    return (l, i) => (w(), T("div", I1, [
      (w(!0), T(Te, null, Pe(e.options, (o) => (w(), de(Ja, {
        key: String(o.value),
        "allow-html": !0,
        text: o.tooltip || "",
        class: "flex items-center"
      }, {
        default: fe(() => [
          E("button", {
            class: ne([[
              a[e.size],
              e.modelValue === o.value ? "bg-primary text-white shadow-sm" : "text-secondaryText hover:text-mainText hover:bg-base-300",
              o.disabled && "opacity-50 cursor-not-allowed"
            ], "flex items-center rounded-md font-medium transition-all whitespace-nowrap"]),
            disabled: o.disabled,
            type: "button",
            onClick: (u) => r(o)
          }, [
            o.icon ? (w(), de(ke, {
              key: 0,
              class: ne(s[e.size]),
              icon: o.icon
            }, null, 8, ["class", "icon"])) : P("", !0),
            E("span", null, ue(o.label), 1)
          ], 10, P1)
        ]),
        _: 2
      }, 1032, ["text"]))), 128))
    ]));
  }
}), R1 = { class: "v-list-editor" }, F1 = { class: "v-list-editor__header" }, V1 = {
  key: 0,
  class: "v-list-editor__label"
}, L1 = { class: "v-list-editor__tools" }, N1 = ["disabled"], B1 = {
  key: 0,
  class: "v-list-editor__manual"
}, z1 = ["onClick"], W1 = {
  key: 0,
  class: "v-list-editor__error"
}, Y1 = {
  key: 1,
  class: "v-list-editor__bulk"
}, H1 = { class: "v-list-editor__hint" }, U1 = { class: "v-list-editor__hint-detected" }, q1 = { class: "v-list-editor__summary" }, j1 = { class: "v-list-editor__count" }, G1 = ["onClick"], K1 = /* @__PURE__ */ Se({
  __name: "VListEditor",
  props: /* @__PURE__ */ Ln({
    label: { default: () => {
    } },
    itemLabel: { default: "Item" },
    itemLabelPlural: { default: () => {
    } },
    placeholder: { default: () => {
    } },
    markerClass: { default: () => {
    } },
    maxItems: { default: () => {
    } },
    maxLength: { default: () => {
    } },
    modes: { default: "both" },
    validation: { default: () => {
    } },
    itemError: { type: Function, default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: n }) {
    const t = es(e, "modelValue"), a = Je("inputs"), s = e.modes === "both", r = ee(e.modes === "bulk" ? "bulk" : "manual"), l = ee(""), i = [
      { value: "manual", label: "Manual", icon: "lucide:plus" },
      { value: "bulk", label: "Bulk", icon: "lucide:list" }
    ], o = /* @__PURE__ */ new WeakMap();
    let u = 0;
    const c = (q) => {
      const N = $u(q);
      let Q = o.get(N);
      return Q || (Q = `item-${++u}`, o.set(N, Q)), Q;
    }, f = M(() => e.maxItems === void 0 || t.value.length < e.maxItems), m = M(() => `Add ${e.itemLabel.toLowerCase()}`), d = M(() => e.itemLabelPlural ?? `${e.itemLabel}s`), p = (q) => q === 0 ? e.placeholder ?? `${e.itemLabel} 1` : `${e.itemLabel} ${q + 1}`, g = M(() => {
      var q;
      return !!((q = e.validation) != null && q.$error);
    }), k = M(() => {
      var q, N, Q;
      return ((Q = (N = (q = e.validation) == null ? void 0 : q.$errors) == null ? void 0 : N[0]) == null ? void 0 : Q.$message) ?? "";
    }), y = () => {
      var q, N;
      (N = (q = e.validation) == null ? void 0 : q.$touch) == null || N.call(q);
    }, h = (q, N) => {
      var Q;
      return ((Q = e.itemError) == null ? void 0 : Q.call(e, q, N)) ?? void 0;
    }, b = async (q) => {
      var Q, he, pe;
      await Ze();
      const N = (Q = a.value) == null ? void 0 : Q[q];
      (pe = (he = N == null ? void 0 : N.$el) == null ? void 0 : he.querySelector("textarea, input")) == null || pe.focus();
    }, S = (q) => {
      if (!f.value) return;
      const N = q === void 0 ? t.value.length : q + 1;
      t.value.splice(N, 0, { text: "" }), b(N);
    }, x = (q) => {
      t.value.length <= 1 || (t.value.splice(q, 1), y(), b(Math.max(0, q - 1)));
    }, C = (q) => {
      S(q);
    }, $ = (q, N) => {
      N.length > 0 || x(q);
    }, _ = () => {
      S();
    }, A = [
      { char: `
`, label: "newline", regex: /\n/ },
      { char: ",", label: "comma", regex: /,/ },
      { char: ";", label: "semicolon", regex: /;/ },
      { char: "|", label: "pipe", regex: /\|/ },
      { char: "/", label: "slash", regex: /\// },
      { char: "	", label: "tab", regex: /\t/ }
    ], D = M(() => A.filter((q) => q.regex.test(l.value))), Y = M(() => {
      const q = l.value.trim();
      if (!q) return [];
      const N = D.value.length ? new RegExp(D.value.map((he) => he.regex.source).join("|")) : /\s+/, Q = [...new Set(q.split(N).map((he) => he.trim()).filter(Boolean))].map((he) => e.maxLength ? he.slice(0, e.maxLength) : he);
      return e.maxItems ? Q.slice(0, e.maxItems) : Q;
    }), L = (q) => {
      const N = [...t.value];
      return q.map((Q) => {
        const he = N.findIndex((pe) => pe.text === Q);
        if (he !== -1) {
          const [pe] = N.splice(he, 1);
          return pe;
        }
        return { text: Q };
      });
    }, Z = M(() => {
      if (!e.itemError) return {};
      const q = {};
      return Y.value.forEach((N) => {
        const Q = t.value.findIndex((he) => he.text === N);
        Q !== -1 && (q[N] = e.itemError(t.value[Q], Q) ?? void 0);
      }), q;
    }), se = (q) => {
      l.value = q, t.value = L(Y.value);
    }, ie = (q) => {
      se(String(q ?? ""));
    }, ce = () => {
      se("");
    }, G = (q) => {
      se(Y.value.filter((N) => N !== q).join(`
`));
    }, le = (q) => {
      if (q !== r.value) {
        if (q === "bulk")
          l.value = E1(t.value).join(`
`);
        else {
          const N = L(Y.value);
          t.value = N.length ? N : [{ text: "" }], l.value = "";
        }
        r.value = q;
      }
    };
    return n({ focusRow: b }), (q, N) => (w(), T("div", R1, [
      E("div", F1, [
        e.label ? (w(), T("span", V1, ue(e.label), 1)) : P("", !0),
        E("div", L1, [
          r.value === "manual" ? (w(), de(Ja, {
            key: 0,
            placement: "top",
            text: f.value ? "" : `Up to ${e.maxItems} ${d.value.toLowerCase()}`
          }, {
            default: fe(() => [
              E("button", {
                disabled: !f.value,
                class: "v-list-editor__add",
                type: "button",
                onClick: _
              }, [
                oe(ke, {
                  icon: "lucide:plus",
                  size: "14"
                }),
                Ue(" " + ue(m.value), 1)
              ], 8, N1)
            ]),
            _: 1
          }, 8, ["text"])) : P("", !0),
          s ? (w(), de(A1, {
            key: 1,
            "model-value": r.value,
            options: i,
            size: "sm",
            "onUpdate:modelValue": le
          }, null, 8, ["model-value"])) : P("", !0)
        ])
      ]),
      r.value === "manual" ? (w(), T("div", B1, [
        E("div", {
          class: ne([{ "v-list-editor__box--error": g.value }, "v-list-editor__box"])
        }, [
          oe($l, {
            class: "v-list-editor__rows",
            name: "v-list-editor-row",
            tag: "div"
          }, {
            default: fe(() => [
              (w(!0), T(Te, null, Pe(t.value, (Q, he) => (w(), T("div", {
                key: c(Q),
                class: "v-list-editor__row"
              }, [
                e.markerClass ? (w(), T("span", {
                  key: 0,
                  class: ne([e.markerClass, "v-list-editor__marker"])
                }, null, 2)) : P("", !0),
                oe($r, {
                  ref_for: !0,
                  ref: "inputs",
                  modelValue: Q.text,
                  "onUpdate:modelValue": (pe) => Q.text = pe,
                  error: h(Q, he),
                  maxlength: e.maxLength,
                  placeholder: p(he),
                  "show-clear-button": !1,
                  class: "flex-1 min-w-0",
                  name: "",
                  onBlur: y,
                  onKeydown: [
                    Pt(Fe((pe) => C(he), ["exact", "prevent", "stop"]), ["enter"]),
                    Pt(Fe((pe) => $(he, Q.text), ["stop"]), ["backspace"])
                  ]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "maxlength", "placeholder", "onKeydown"]),
                t.value.length > 1 ? (w(), T("button", {
                  key: 1,
                  "aria-label": "Remove",
                  class: "v-list-editor__remove",
                  type: "button",
                  onClick: (pe) => x(he)
                }, [
                  oe(ke, {
                    icon: "lucide:x",
                    size: "14"
                  })
                ], 8, z1)) : P("", !0)
              ]))), 128))
            ]),
            _: 1
          })
        ], 2),
        g.value ? (w(), T("p", W1, ue(k.value), 1)) : P("", !0)
      ])) : (w(), T("div", Y1, [
        oe($r, {
          error: g.value ? k.value : void 0,
          "model-value": l.value,
          placeholder: `Enter ${d.value.toLowerCase()}, one per line or comma-separated`,
          rows: 4,
          textarea: !0,
          name: "",
          onBlur: y,
          "onUpdate:modelValue": ie
        }, null, 8, ["error", "model-value", "placeholder"]),
        E("p", H1, [
          N[1] || (N[1] = Ue(" Separate by: newline · , · ; · | · / · tab ", -1)),
          D.value.length ? (w(), T(Te, { key: 0 }, [
            N[0] || (N[0] = Ue(" · ", -1)),
            E("span", U1, " Detected: " + ue(D.value.map((Q) => Q.label).join(", ")), 1)
          ], 64)) : P("", !0)
        ]),
        Y.value.length > 0 ? (w(), T(Te, { key: 0 }, [
          E("div", q1, [
            E("span", j1, ue(Y.value.length) + " " + ue(Y.value.length === 1 ? "item" : "items") + " detected ", 1),
            E("button", {
              class: "v-list-editor__clear",
              type: "button",
              onClick: ce
            }, " Clear all ")
          ]),
          oe($l, {
            class: "v-list-editor__preview",
            name: "v-list-editor-chip",
            tag: "div"
          }, {
            default: fe(() => [
              (w(!0), T(Te, null, Pe(Y.value, (Q) => (w(), de(Ja, {
                key: Q,
                placement: "top",
                text: Z.value[Q] ?? ""
              }, {
                default: fe(() => [
                  oe(Yu, {
                    color: Z.value[Q] ? "error" : "primary",
                    label: Q,
                    class: "v-list-editor__chip",
                    size: "md",
                    variant: "outline"
                  }, {
                    "icon-right": fe(() => [
                      E("button", {
                        class: "v-list-editor__chip-remove",
                        type: "button",
                        onClick: (he) => G(Q)
                      }, [
                        oe(ke, {
                          class: "size-2.5",
                          icon: "lucide:x"
                        })
                      ], 8, G1)
                    ]),
                    _: 2
                  }, 1032, ["color", "label"])
                ]),
                _: 2
              }, 1032, ["text"]))), 128))
            ]),
            _: 1
          })
        ], 64)) : P("", !0)
      ]))
    ]));
  }
}), hD = /* @__PURE__ */ je(K1, [["__scopeId", "data-v-c9ecd31d"]]), Z1 = {
  ref: "pill",
  class: "sliding-pill absolute left-0 top-1 rounded-md pointer-events-none bg-primary/15 ring-1 ring-inset ring-primary/40 shadow-sm"
}, X1 = ["aria-label", "aria-pressed", "title", "disabled", "onClick"], J1 = { key: 1 }, Q1 = /* @__PURE__ */ Se({
  __name: "VSegmentedControl",
  props: {
    modelValue: {},
    options: {},
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Je("container"), s = Je("pill"), r = (c) => {
      const f = !!(c.icon && !c.label);
      switch (e.size) {
        case "sm":
          return f ? "p-1" : "text-xs px-2 py-1";
        case "lg":
          return f ? "p-2.5" : "text-base px-4 py-2.5";
        default:
          return f ? "p-2" : "text-sm px-3 py-2";
      }
    }, l = M(() => {
      switch (e.size) {
        case "sm":
          return 14;
        case "lg":
          return 20;
        default:
          return 16;
      }
    }), i = (c) => c.value === e.modelValue, o = () => {
      const c = a.value, f = s.value;
      if (!c || !f) return;
      const m = c.querySelectorAll("button"), d = e.options.findIndex((g) => g.value === e.modelValue), p = m[d];
      p && (f.style.transform = `translateX(${p.offsetLeft}px)`, f.style.width = `${p.offsetWidth}px`);
    }, u = (c) => {
      c.disabled || e.disabled || t("update:modelValue", c.value);
    };
    return et(() => Ze(o)), vf(o), (c, f) => (w(), T("div", {
      ref: "container",
      class: ne([{ "w-full": e.fullWidth, "opacity-50 pointer-events-none": e.disabled }, "v-segmented-control relative inline-flex items-center rounded-lg bg-base-200 p-1 border-[1px] border-base-400 shadow-md gap-1"])
    }, [
      E("span", Z1, null, 512),
      (w(!0), T(Te, null, Pe(e.options, (m) => (w(), T("button", {
        key: m.value,
        "aria-label": m.ariaLabel,
        "aria-pressed": i(m),
        title: m.ariaLabel,
        class: ne([[
          r(m),
          e.fullWidth ? "flex-1" : "",
          i(m) ? "text-primary" : "text-secondaryText hover:text-mainText",
          m.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        ], "relative z-10 flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-base-200"]),
        disabled: m.disabled || e.disabled,
        type: "button",
        onClick: (d) => u(m)
      }, [
        m.icon ? (w(), de(ke, {
          key: 0,
          icon: m.icon,
          size: l.value
        }, null, 8, ["icon", "size"])) : P("", !0),
        m.label ? (w(), T("span", J1, ue(m.label), 1)) : P("", !0)
      ], 10, X1))), 128))
    ], 2));
  }
}), mD = /* @__PURE__ */ je(Q1, [["__scopeId", "data-v-17ac3d6e"]]);
function bl(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function ek(e) {
  return (...n) => !e(...n);
}
function tk(e, n) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(n.trim()) !== -1;
}
function nk(e) {
  return e.filter((n) => !n.$isLabel);
}
function wl(e, n) {
  return (t) => t.reduce((a, s) => s[e] && s[e].length ? (a.push({
    $groupLabel: s[n],
    $isLabel: !0
  }), a.concat(s[e])) : a, []);
}
const au = (...e) => (n) => e.reduce((t, a) => a(t), n);
var ak = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, n) {
        return bl(e) ? "" : n ? e[n] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", n = e.toLowerCase().trim();
      let t = this.options.concat();
      return this.internalSearch ? t = this.groupValues ? this.filterAndFlat(t, n, this.label) : this.filterOptions(t, n, this.label, this.customLabel) : t = this.groupValues ? wl(this.groupValues, this.groupLabel)(t) : t, t = this.hideSelected ? t.filter(ek(this.isSelected)) : t, this.taggable && n.length && !this.isExistingOption(n) && (this.tagPosition === "bottom" ? t.push({ isTag: !0, label: e }) : t.unshift({ isTag: !0, label: e })), t.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((n) => this.customLabel(n, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, n, t) {
      return au(
        this.filterGroups(n, t, this.groupValues, this.groupLabel, this.customLabel),
        wl(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return au(
        wl(this.groupValues, this.groupLabel),
        nk
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const n = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(n) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (bl(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const n = this.customLabel(e, this.label);
      return bl(n) ? "" : n;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, n) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(n) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(n === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            n !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const n = this.options.find((t) => t[this.groupLabel] === e.$groupLabel);
      if (n) {
        if (this.wholeGroupSelected(n)) {
          this.$emit("remove", n[this.groupValues], this.id);
          const t = this.trackBy ? n[this.groupValues].map((s) => s[this.trackBy]) : n[this.groupValues], a = this.internalValue.filter(
            (s) => t.indexOf(this.trackBy ? s[this.trackBy] : s) === -1
          );
          this.$emit("update:modelValue", a);
        } else {
          const t = n[this.groupValues].filter(
            (a) => !(this.isOptionDisabled(a) || this.isSelected(a))
          );
          this.max && t.splice(this.max - this.internalValue.length), this.$emit("select", t, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(t)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (n) => this.isSelected(n) || this.isOptionDisabled(n)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, n = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const t = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const a = this.internalValue.slice(0, t).concat(this.internalValue.slice(t + 1));
        this.$emit("update:modelValue", a);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && n && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, n = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      n > this.maxHeight || n > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(n - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, n, t, a) {
      return n ? e.filter((s) => tk(a(s, t), n)).sort((s, r) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(s, r) : a(s, t).length - a(r, t).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, n, t, a, s) {
      return (r) => r.map((l) => {
        if (!l[t])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const i = this.filterOptions(l[t], e, n, s);
        return i.length ? {
          [a]: l[a],
          [t]: i
        } : [];
      });
    }
  }
}, sk = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, n) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(n)
      };
    },
    groupHighlight(e, n) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": n.$isLabel }
        ];
      const t = this.options.find((a) => a[this.groupLabel] === n.$groupLabel);
      return t && !this.wholeGroupDisabled(t) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(t) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      var e;
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      var e;
      this.pointer > 0 ? (this.pointer--, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, Yd = {
  name: "vue-multiselect",
  mixins: [ak, sk],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Uses Vue Teleport's feature. Teleports the open dropdown to the bottom of the body element
     * @default false
     * @type {Boolean}
     */
    useTeleport: {
      type: Boolean,
      default: !1
    },
    /**
     * Classes to apply to the `multiselect__content-wrapper` element. This element is a teleport element (when enabled), so can be used to specifically target
     * the teleported element
     */
    contentWrapperClass: {
      type: [String, Array, Object],
      default: ""
    }
  },
  data() {
    return {
      dropdownStyles: {},
      ready: !1
    };
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  },
  watch: {
    isOpen(e) {
      e && (this.useTeleport ? (this.ready = !1, this.$nextTick(() => {
        const n = this.$el.getBoundingClientRect();
        this.dropdownStyles = {
          position: "absolute",
          top: `${n.bottom + window.scrollY}px`,
          left: `${n.left + window.scrollX}px`,
          width: `${n.width}px`,
          zIndex: 9999
        }, this.ready = !0;
      })) : this.ready = !0);
    }
  }
};
const rk = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], lk = {
  ref: "tags",
  class: "multiselect__tags"
}, ik = { class: "multiselect__tags-wrap" }, ok = ["textContent"], uk = ["onKeydown", "onMousedown"], ck = ["textContent"], dk = { class: "multiselect__spinner" }, fk = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], hk = ["id", "aria-multiselectable"], mk = { key: 0 }, vk = { class: "multiselect__option" }, pk = ["aria-selected", "id", "role"], gk = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], yk = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], bk = { class: "multiselect__option" }, wk = { class: "multiselect__option" };
function kk(e, n, t, a, s, r) {
  return w(), T("div", {
    tabindex: e.searchable ? -1 : t.tabindex,
    class: ne([{ "multiselect--active": e.isOpen, "multiselect--disabled": t.disabled, "multiselect--above": r.isAbove, "multiselect--has-options-group": r.hasOptionGroup }, "multiselect"]),
    onFocus: n[14] || (n[14] = (l) => e.activate()),
    onBlur: n[15] || (n[15] = (l) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      n[16] || (n[16] = Pt(Fe((l) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      n[17] || (n[17] = Pt(Fe((l) => e.pointerBackward(), ["self", "prevent"]), ["up"])),
      n[18] || (n[18] = Pt(Fe((l) => e.addPointerElement(l), ["stop", "self"]), ["enter", "tab"]))
    ],
    onKeyup: n[19] || (n[19] = Pt((l) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    U(e.$slots, "caret", { toggle: e.toggle }, () => [
      E(
        "div",
        {
          onMousedown: n[0] || (n[0] = Fe((l) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    U(e.$slots, "clear", { search: e.search }),
    E(
      "div",
      lk,
      [
        U(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: r.visibleValues,
          isOpen: e.isOpen
        }, () => [
          mn(E(
            "div",
            ik,
            [
              (w(!0), T(
                Te,
                null,
                Pe(r.visibleValues, (l, i) => U(e.$slots, "tag", {
                  option: l,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (w(), T(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: i,
                      onMousedown: n[1] || (n[1] = Fe(() => {
                      }, ["prevent"]))
                    },
                    [
                      E("span", {
                        textContent: ue(e.getOptionLabel(l))
                      }, null, 8, ok),
                      E("i", {
                        tabindex: "1",
                        onKeydown: Pt(Fe((o) => e.removeElement(l), ["prevent"]), ["enter"]),
                        onMousedown: Fe((o) => e.removeElement(l), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, uk)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [Fn, r.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > t.limit ? U(e.$slots, "limit", { key: 0 }, () => [
            E("strong", {
              class: "multiselect__strong",
              textContent: ue(t.limitText(e.internalValue.length - t.limit))
            }, null, 8, ck)
          ]) : P("v-if", !0)
        ]),
        oe(Dt, { name: "multiselect__loading" }, {
          default: fe(() => [
            U(e.$slots, "loading", {}, () => [
              mn(E(
                "div",
                dk,
                null,
                512
                /* NEED_PATCH */
              ), [
                [Fn, t.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (w(), T("input", {
          key: 0,
          ref: "search",
          name: t.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: t.spellcheck,
          placeholder: e.placeholder,
          required: r.isRequired,
          style: Ve(r.inputStyle),
          value: e.search,
          disabled: t.disabled,
          tabindex: t.tabindex,
          "aria-label": t.name + "-searchbox",
          onInput: n[2] || (n[2] = (l) => e.updateSearch(l.target.value)),
          onFocus: n[3] || (n[3] = Fe((l) => e.activate(), ["prevent"])),
          onBlur: n[4] || (n[4] = Fe((l) => e.deactivate(), ["prevent"])),
          onKeyup: n[5] || (n[5] = Pt((l) => e.deactivate(), ["esc"])),
          onKeydown: [
            n[6] || (n[6] = Pt(Fe((l) => e.pointerForward(), ["prevent"]), ["down"])),
            n[7] || (n[7] = Pt(Fe((l) => e.pointerBackward(), ["prevent"]), ["up"])),
            n[8] || (n[8] = Pt(Fe((l) => e.addPointerElement(l), ["prevent", "stop", "self"]), ["enter"])),
            n[9] || (n[9] = Pt(Fe((l) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, fk)) : P("v-if", !0),
        r.isSingleLabelVisible ? (w(), T(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: n[10] || (n[10] = Fe((...l) => e.toggle && e.toggle(...l), ["prevent"]))
          },
          [
            U(e.$slots, "singleLabel", { option: r.singleValue }, () => [
              Ue(
                ue(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : P("v-if", !0),
        r.isPlaceholderVisible ? (w(), T(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: n[11] || (n[11] = Fe((...l) => e.toggle && e.toggle(...l), ["prevent"]))
          },
          [
            U(e.$slots, "placeholder", {}, () => [
              Ue(
                ue(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : P("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    (w(), de(zn, {
      to: "body",
      disabled: !t.useTeleport
    }, [
      oe(Dt, { name: "multiselect" }, {
        default: fe(() => [
          e.isOpen && s.ready ? (w(), T(
            "div",
            {
              key: 0,
              class: ne(["multiselect__content-wrapper", t.contentWrapperClass]),
              onFocus: n[12] || (n[12] = (...l) => e.activate && e.activate(...l)),
              tabindex: "-1",
              onMousedown: n[13] || (n[13] = Fe(() => {
              }, ["prevent"])),
              style: Ve([s.dropdownStyles, { maxHeight: e.optimizedHeight + "px" }]),
              ref: "list"
            },
            [
              E("ul", {
                class: "multiselect__content",
                style: Ve(r.contentStyle),
                role: "listbox",
                id: "listbox-" + e.id,
                "aria-multiselectable": e.multiple
              }, [
                U(e.$slots, "beforeList"),
                e.multiple && e.max === e.internalValue.length ? (w(), T("li", mk, [
                  E("span", vk, [
                    U(e.$slots, "maxElements", {}, () => [
                      Ue(
                        "Maximum of " + ue(e.max) + " options selected. First remove a selected option to select another.",
                        1
                        /* TEXT */
                      )
                    ])
                  ])
                ])) : P("v-if", !0),
                !e.max || e.internalValue.length < e.max ? (w(!0), T(
                  Te,
                  { key: 1 },
                  Pe(e.filteredOptions, (l, i) => (w(), T("li", {
                    class: "multiselect__element",
                    key: i,
                    "aria-selected": e.isSelected(l),
                    id: e.id + "-" + i,
                    role: l && (l.$isLabel || l.$isDisabled) ? null : "option"
                  }, [
                    l && (l.$isLabel || l.$isDisabled) ? P("v-if", !0) : (w(), T("span", {
                      key: 0,
                      class: ne([e.optionHighlight(i, l), "multiselect__option"]),
                      onClick: Fe((o) => e.select(l), ["stop"]),
                      onMouseenter: Fe((o) => e.pointerSet(i), ["self"]),
                      "data-select": l && l.isTag ? e.tagPlaceholder : r.selectLabelText,
                      "data-selected": r.selectedLabelText,
                      "data-deselect": r.deselectLabelText
                    }, [
                      U(e.$slots, "option", {
                        option: l,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          ue(e.getOptionLabel(l)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, gk)),
                    l && (l.$isLabel || l.$isDisabled) ? (w(), T("span", {
                      key: 1,
                      "data-select": e.groupSelect && r.selectGroupLabelText,
                      "data-deselect": e.groupSelect && r.deselectGroupLabelText,
                      class: ne([e.groupHighlight(i, l), "multiselect__option"]),
                      onMouseenter: Fe((o) => e.groupSelect && e.pointerSet(i), ["self"]),
                      onMousedown: Fe((o) => e.selectGroup(l), ["prevent"])
                    }, [
                      U(e.$slots, "option", {
                        option: l,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          ue(e.getOptionLabel(l)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, yk)) : P("v-if", !0)
                  ], 8, pk))),
                  128
                  /* KEYED_FRAGMENT */
                )) : P("v-if", !0),
                mn(E(
                  "li",
                  null,
                  [
                    E("span", bk, [
                      U(e.$slots, "noResult", { search: e.search }, () => [
                        n[20] || (n[20] = Ue("No elements found. Consider changing the search query."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Fn, t.showNoResults && e.filteredOptions.length === 0 && e.search && !t.loading]
                ]),
                mn(E(
                  "li",
                  null,
                  [
                    E("span", wk, [
                      U(e.$slots, "noOptions", {}, () => [
                        n[21] || (n[21] = Ue("List is empty."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Fn, t.showNoOptions && (e.options.length === 0 || r.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !t.loading]
                ]),
                U(e.$slots, "afterList")
              ], 12, hk)
            ],
            38
            /* CLASS, STYLE, NEED_HYDRATION */
          )) : P("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      })
    ], 8, ["disabled"]))
  ], 42, rk);
}
Yd.render = kk;
const xk = { class: "v-select" }, Sk = { class: "multiselect__select" }, Tk = /* @__PURE__ */ Se({
  __name: "VSelect",
  props: {
    modelValue: { default: null },
    options: { default: () => [] },
    placeholder: { default: "Select option" },
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !0 },
    clearOnSelect: { type: Boolean, default: !0 },
    closeOnSelect: { type: Boolean, default: !0 },
    label: { default: "label" },
    trackBy: { default: "value" },
    loading: { type: Boolean, default: !1 },
    taggable: { type: Boolean, default: !1 },
    maxHeight: { default: 300 },
    optionsLimit: { default: 1e3 },
    teleportToBody: { type: Boolean, default: !0 },
    name: { default: "" },
    allowEmpty: { type: Boolean, default: !1 },
    noResultsText: { default: "No results found" }
  },
  emits: ["update:modelValue", "select", "remove", "search-change", "open", "close"],
  setup(e, { emit: n }) {
    const t = e, a = M(() => t.name ? s.value ? t.placeholder : "" : t.placeholder), s = ee(!1), r = M(() => Array.isArray(t.modelValue) ? t.modelValue.length > 0 : t.modelValue && typeof t.modelValue == "object" ? !0 : t.modelValue !== null && t.modelValue !== void 0), l = n, i = (x) => {
      l("update:modelValue", x);
    }, o = (x) => {
      l("select", x);
    }, u = (x) => {
      l("remove", x);
    }, c = (x) => {
      l("search-change", x);
    }, f = ee(null);
    let m = null, d = null, p = null;
    const g = () => {
      var Y;
      if (!m || !f.value) return;
      const x = (Y = f.value.$el) == null ? void 0 : Y.querySelector(".multiselect__tags");
      if (!x) return;
      const C = x.getBoundingClientRect(), $ = window.innerHeight - C.bottom, _ = Math.min(m.scrollHeight, t.maxHeight), A = $ < _ && C.top > $, D = A ? Math.max(4, C.top - _ - 4) : Math.min(window.innerHeight - _ - 4, C.bottom + 4);
      Object.assign(m.style, {
        position: "fixed",
        top: `${D}px`,
        left: `${C.left}px`,
        width: `${C.width}px`,
        maxHeight: `${t.maxHeight}px`,
        zIndex: "10000"
      }), m.classList.toggle("opened-above", A);
    }, k = () => requestAnimationFrame(g), y = () => {
      t.teleportToBody && Ze(() => {
        var x, C;
        m = (C = (x = f.value) == null ? void 0 : x.$el) == null ? void 0 : C.querySelector(".multiselect__content-wrapper"), m && (d || (p = m.parentElement, d = document.createComment("v-multiselect-anchor"), p == null || p.replaceChild(d, m), document.body.appendChild(m)), m.classList.add("v-ms-floating"), g(), window.addEventListener("scroll", k, { passive: !0 }), window.addEventListener("resize", k, { passive: !0 }));
      });
    }, h = () => {
      m && (window.removeEventListener("scroll", k), window.removeEventListener("resize", k), m.classList.remove("v-ms-floating", "opened-above"), m.removeAttribute("style"), d && p && p.replaceChild(m, d), d = null, p = null, m = null);
    }, b = () => {
      y(), s.value = !0, l("open");
    }, S = () => {
      h(), s.value = !1, l("close");
    };
    return Is(() => h()), (x, C) => (w(), T("div", xk, [
      t.name ? (w(), T("label", {
        key: 0,
        class: ne([{ "v-select__label--active": s.value || r.value }, "v-select__label"])
      }, ue(t.name), 3)) : P("", !0),
      oe(v(Yd), rt({
        ref_key: "msRef",
        ref: f,
        "allow-empty": t.allowEmpty,
        "clear-on-select": t.clearOnSelect,
        "close-on-select": t.closeOnSelect,
        disabled: t.disabled,
        label: t.label,
        loading: t.loading,
        "max-height": t.maxHeight,
        "model-value": t.modelValue,
        multiple: t.multiple,
        options: t.options,
        "options-limit": t.optionsLimit,
        placeholder: a.value,
        searchable: t.searchable,
        "show-labels": !1,
        taggable: t.taggable,
        "track-by": t.trackBy
      }, x.$attrs, {
        onClose: S,
        onOpen: b,
        onRemove: u,
        onSelect: o,
        "onUpdate:modelValue": i,
        onSearchChange: c
      }), dt({
        caret: fe(() => [
          E("div", Sk, [
            oe(ke, {
              loading: t.loading,
              class: "v-select__caret-icon",
              icon: "mdi:chevron-down"
            }, null, 8, ["loading"])
          ])
        ]),
        noResult: fe(() => [
          U(x.$slots, "noResult", {}, () => [
            Ue(ue(t.noResultsText || "No results found"), 1)
          ], !0)
        ]),
        _: 2
      }, [
        Pe(Object.keys(x.$slots).filter(($) => $ !== "noResult"), ($, _) => ({
          name: $,
          fn: fe((A) => [
            U(x.$slots, $, Mt(Bt(A)), void 0, !0)
          ])
        }))
      ]), 1040, ["allow-empty", "clear-on-select", "close-on-select", "disabled", "label", "loading", "max-height", "model-value", "multiple", "options", "options-limit", "placeholder", "searchable", "taggable", "track-by"]),
      E("fieldset", {
        class: ne([{ "v-select__fieldset--active": s.value }, "v-select__fieldset"]),
        "aria-hidden": "true"
      }, [
        E("legend", {
          class: ne([{ "v-select__legend--visible": t.name && (r.value || s.value) }, "v-select__legend"])
        }, [
          E("span", null, ue(t.name), 1)
        ], 2)
      ], 2)
    ]));
  }
}), Mk = /* @__PURE__ */ je(Tk, [["__scopeId", "data-v-9bb5c30c"]]), $k = ["for"], Ck = { class: "v-switch__container" }, Dk = ["id", "checked", "disabled"], Ok = { class: "v-switch__label" }, _k = /* @__PURE__ */ Se({
  __name: "VSwitch",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    trueIcon: {},
    falseIcon: {},
    trueLabel: {},
    falseLabel: {},
    color: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ni(), r = M(() => t.id || `v-switch-${Or()}`), l = M({
      get: () => !!t.modelValue,
      set: (c) => a("update:modelValue", c)
    }), i = {
      positive: "success",
      negative: "error"
    }, o = (c) => /^#|^rgb|^hsl|^oklch|^color/.test(c) ? c : `rgb(var(--color-${i[c] ?? c}) / 1)`, u = M(() => {
      if (t.disabled)
        return {
          backgroundColor: "#d1d5db",
          borderColor: "#d1d5db"
        };
      if (t.color && l.value) {
        const c = o(t.color);
        return {
          backgroundColor: c,
          borderColor: c
        };
      }
      return {};
    });
    return (c, f) => (w(), T("label", {
      class: ne([{
        "v-switch--disabled": t.disabled,
        "v-switch--loading": t.loading && !t.disabled
      }, "v-switch"]),
      for: r.value
    }, [
      E("span", Ck, [
        E("input", rt({
          id: r.value,
          checked: l.value,
          disabled: t.disabled || t.loading,
          class: "v-switch__input",
          type: "checkbox"
        }, v(s), {
          onChange: f[0] || (f[0] = (m) => l.value = m.target.checked)
        }), null, 16, Dk),
        E("span", {
          class: ne([
            "v-switch__track",
            { "v-switch__track--checked": l.value },
            { "v-switch__track--disabled": t.disabled },
            { "v-switch__track--custom-color": t.color && l.value }
          ]),
          style: Ve(u.value)
        }, [
          E("span", {
            class: ne(["v-switch__thumb", { "v-switch__thumb--checked": l.value }])
          }, [
            t.loading ? (w(), de(ke, {
              key: 0,
              loading: !0,
              size: 12,
              class: "v-switch__spinner",
              icon: "lucide:loading"
            })) : c.$slots.icon ? U(c.$slots, "icon", { key: 1 }, () => [
              U(c.$slots, l.value ? "true-icon" : "false-icon", {}, void 0, !0)
            ], !0) : (w(), T(Te, { key: 2 }, [
              l.value && t.trueIcon ? (w(), de(ke, {
                key: 0,
                icon: t.trueIcon,
                size: 16
              }, null, 8, ["icon"])) : !l.value && t.falseIcon ? (w(), de(ke, {
                key: 1,
                icon: t.falseIcon,
                size: 16
              }, null, 8, ["icon"])) : P("", !0)
            ], 64))
          ], 2)
        ], 6)
      ]),
      E("span", Ok, [
        U(c.$slots, "default", {}, () => [
          Ue(ue(l.value ? t.trueLabel : t.falseLabel), 1)
        ], !0)
      ])
    ], 10, $k));
  }
}), vD = /* @__PURE__ */ je(_k, [["__scopeId", "data-v-851e4181"]]), Qt = ee(/* @__PURE__ */ new Map());
let su = 1e3;
const Hd = () => {
  const e = M(() => (f) => Qt.value.get(f)), n = M(() => (f) => {
    const m = Qt.value.get(f);
    return m ? m.isOpen : !1;
  }), t = M(() => (f) => {
    const m = Qt.value.get(f);
    return m ? m.zIndex : 1e3;
  }), a = M(() => Array.from(Qt.value.values()).filter((f) => f.isOpen)), s = M(() => a.value.length > 0), r = (f) => {
    Qt.value.has(f) || Qt.value.set(f, {
      id: f,
      isOpen: !1,
      zIndex: 1e3
    });
  }, l = (f) => {
    Qt.value.delete(f);
  }, i = (f) => {
    r(f);
    const m = Qt.value.get(f);
    m && (su += 10, m.zIndex = su, m.isOpen = !0);
  }, o = (f) => {
    const m = Qt.value.get(f);
    m && (m.isOpen = !1);
  };
  return {
    modals: Qt,
    getModal: e,
    isOpen: n,
    getZIndex: t,
    openModals: a,
    hasOpenModals: s,
    register: r,
    unregister: l,
    open: i,
    close: o,
    toggle: (f) => {
      const m = Qt.value.get(f);
      m && (m.isOpen ? o(f) : i(f));
    },
    closeAll: () => {
      Qt.value.forEach((f) => {
        f.isOpen = !1;
      });
    }
  };
}, Pi = (e, n = !0) => {
  const t = Hd();
  t.register(e);
  const a = M(() => t.isOpen.value(e)), s = M(() => t.getZIndex.value(e)), r = M(() => t.getModal.value(e)), l = () => t.open(e), i = () => t.close(e), o = () => t.toggle(e);
  return n && Is(() => {
    t.unregister(e);
  }), {
    isOpen: a,
    zIndex: s,
    modal: r,
    open: l,
    close: i,
    toggle: o
  };
}, Ek = ["data-overlay-open"], Ik = {
  key: 0,
  class: "v-drawer__header"
}, Pk = {
  key: 0,
  class: "v-drawer__title"
}, Ak = { class: "v-drawer__content" }, Rk = {
  key: 1,
  class: "v-drawer__footer"
}, Fk = /* @__PURE__ */ Se({
  __name: "VDrawer",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    position: { default: "right" },
    width: { default: "md" },
    backdropBlur: { default: "xs" },
    keepAlive: { type: Boolean, default: !1 }
  },
  emits: ["close", "open"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: r, zIndex: l } = Pi(t.id), i = M(() => `v-drawer__container--width-${t.width}`), o = M(() => `v-drawer__container--${t.position}`), u = M(() => t.backdropBlur === "none" ? "" : `v-drawer__backdrop--blur-${t.backdropBlur}`), c = () => {
      r(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, m = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, p) => (w(), de(zn, { to: "body" }, [
      oe(Dt, {
        name: "v-drawer",
        onAfterEnter: p[1] || (p[1] = (g) => a("open"))
      }, {
        default: fe(() => [
          e.keepAlive || v(s) ? mn((w(), T("div", {
            key: 0,
            class: ne([u.value, "v-drawer__backdrop"]),
            "data-overlay-open": v(s) || void 0,
            style: Ve({ zIndex: v(l) }),
            onClick: f,
            onKeydown: m
          }, [
            E("div", {
              class: ne([[i.value, o.value], "v-drawer__container"]),
              onClick: p[0] || (p[0] = Fe(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (w(), T("div", Ik, [
                U(d.$slots, "header", {}, () => [
                  e.title ? (w(), T("h3", Pk, ue(e.title), 1)) : P("", !0)
                ], !0),
                e.showCloseButton ? (w(), T("button", {
                  key: 0,
                  "aria-label": "Close drawer",
                  class: "v-drawer__close-btn",
                  type: "button",
                  onClick: c
                }, [...p[2] || (p[2] = [
                  E("svg", {
                    fill: "none",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    })
                  ], -1)
                ])])) : P("", !0)
              ])) : P("", !0),
              E("div", Ak, [
                U(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer ? (w(), T("div", Rk, [
                U(d.$slots, "footer", {}, void 0, !0)
              ])) : P("", !0)
            ], 2)
          ], 46, Ek)), [
            [Fn, e.keepAlive ? v(s) : !0]
          ]) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), pD = /* @__PURE__ */ je(Fk, [["__scopeId", "data-v-fa565216"]]), Vk = { class: "v-floating" }, Lk = ["disabled", "onClick"], Nk = {
  key: 0,
  class: "v-floating-item-icon"
}, Bk = { class: "v-floating-item-label" }, zk = 120, Wk = /* @__PURE__ */ Se({
  __name: "VFloating",
  props: {
    placement: { default: "bottom-right" },
    teleport: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    offset: { default: 8 },
    openOnHover: { type: Boolean, default: !1 },
    hoverDelay: { default: 200 },
    items: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    closeOnSelect: { type: Boolean, default: !0 },
    unstyled: { type: Boolean, default: !1 },
    contentClass: { default: "" }
  },
  emits: ["select"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, r = ee(!1), l = ee(null), i = ee(null), o = ee({ top: 0, left: 0, right: 0 }), u = ee(!1);
    let c = !1, f = null;
    function m() {
      !r.value || !i.value || c || (c = !0, requestAnimationFrame(() => {
        c = !1, y();
      }));
    }
    const d = M(() => a.items.length > 0), p = M(() => a.disabled), g = M(() => {
      const ye = a.placement, K = {
        "v-floating--bottom-left": ye === "bottom-left",
        "v-floating--bottom-right": ye === "bottom-right",
        "v-floating--top-left": ye === "top-left",
        "v-floating--top-right": ye === "top-right",
        "v-floating--teleported": a.teleport
      };
      return a.unstyled ? {
        ...K,
        "v-floating--unstyled": !0,
        [a.contentClass]: !!a.contentClass
      } : {
        ...K,
        "v-floating--dropdown": d.value,
        "v-floating--popover": !d.value,
        "v-floating--styled": !0,
        [a.contentClass]: !!a.contentClass
      };
    }), k = M(() => a.teleport ? u.value ? {
      position: "fixed",
      zIndex: "9999",
      top: `${o.value.top}px`,
      left: o.value.left !== void 0 ? `${o.value.left}px` : void 0,
      right: o.value.right !== void 0 ? `${o.value.right}px` : void 0
      // Prevent following scroll by using fixed positioning as-is
      // The dropdown will stay in place relative to viewport, not following the trigger
    } : {} : {}), y = () => {
      if (!(!l.value || !i.value)) {
        if (a.teleport) {
          const ye = l.value.getBoundingClientRect(), K = i.value.offsetWidth, be = i.value.offsetHeight, [Me, F] = a.placement.split("-"), j = a.offset;
          let H;
          Me === "bottom" ? H = ye.bottom + j : H = ye.top - be - j;
          let I;
          F === "left" ? I = ye.left : I = ye.right - K, o.value.top = H, o.value.left = I, o.value.right = void 0;
        } else
          o.value.top = 0, o.value.left = 0;
        u.value = !0;
      }
    }, h = () => {
      p.value || (r.value = !r.value, r.value ? (u.value = !1, Ze(() => {
        i.value && l.value && (y(), ge());
      })) : Ce());
    }, b = () => {
      r.value && (r.value = !1, u.value = !1, Ce());
    }, S = () => {
      p.value || r.value || (r.value = !0, u.value = !1, Ze(() => {
        i.value && l.value && (y(), ge());
      }));
    }, x = typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    let C = null, $ = null;
    const _ = () => {
      C && (clearTimeout(C), C = null);
    }, A = () => {
      $ && (clearTimeout($), $ = null);
    }, D = () => {
      _(), A();
    }, Y = () => {
      A(), !r.value && (_(), C = setTimeout(() => {
        C = null, S();
      }, a.hoverDelay));
    }, L = () => {
      D(), $ = setTimeout(() => {
        $ = null, b();
      }, zk);
    }, Z = () => {
      !a.openOnHover || !x || Y();
    }, se = () => {
      !a.openOnHover || !x || L();
    }, ie = () => {
      !a.openOnHover || !x || A();
    }, ce = () => {
      !a.openOnHover || !x || L();
    }, G = () => {
      a.openOnHover && (D(), S());
    }, le = () => {
      a.openOnHover && (D(), b());
    }, q = (ye) => {
      ye.disabled || ye.loading || (s("select", ye.value), a.closeOnSelect && !ye.loading && b());
    }, N = (ye) => {
      ye.key === "Escape" && r.value && b();
    }, Q = (ye) => {
      if (!a.closeOnClickOutside || !r.value) return;
      const K = ye.composedPath(), be = l.value && K.includes(l.value), Me = i.value && K.includes(i.value);
      !be && !Me && b();
    };
    et(() => {
      document.addEventListener("click", Q, !0);
    }), Is(() => {
      document.removeEventListener("click", Q, !0), Ce(), D();
    });
    const he = () => {
      !r.value || !a.teleport || m();
    }, pe = () => {
      !r.value || !a.teleport || m();
    };
    function ge() {
      a.teleport && (window.addEventListener("scroll", he, {
        passive: !0,
        capture: !0
      }), window.addEventListener("resize", pe, { passive: !0 }), l.value && (f = new ResizeObserver(() => m()), f.observe(l.value)), document.addEventListener("keydown", N));
    }
    function Ce() {
      window.removeEventListener("scroll", he, { capture: !0 }), window.removeEventListener("resize", pe), document.removeEventListener("keydown", N), f && (f.disconnect(), f = null);
    }
    return n({
      isOpen: r,
      open: S,
      close: b,
      toggle: h
    }), (ye, K) => (w(), T("div", Vk, [
      E("div", {
        ref_key: "triggerRef",
        ref: l,
        class: ne([{ "v-floating-trigger--disabled": p.value }, "v-floating-trigger"]),
        onClick: h,
        onFocusin: G,
        onFocusout: le,
        onMouseenter: Z,
        onMouseleave: se
      }, [
        U(ye.$slots, "trigger", {
          isDisabled: p.value,
          isOpen: r.value
        }, void 0, !0)
      ], 34),
      (w(), de(zn, {
        disabled: !e.teleport,
        to: "body"
      }, [
        r.value ? (w(), T("div", {
          key: 0,
          ref_key: "floatingRef",
          ref: i,
          class: ne([[
            g.value,
            { "v-floating--positioning": !u.value }
          ], "v-floating-content"]),
          style: Ve(k.value),
          onMouseenter: ie,
          onMouseleave: ce
        }, [
          U(ye.$slots, "content", { close: b }, () => [
            d.value ? (w(!0), T(Te, { key: 0 }, Pe(e.items, (be) => (w(), T("button", {
              key: be.value,
              class: ne([{
                "v-floating-item--loading": be.loading,
                "v-floating-item--active": be.active,
                "v-floating-item--disabled": be.disabled
              }, "v-floating-item"]),
              disabled: be.disabled || be.loading,
              onClick: (Me) => q(be)
            }, [
              U(ye.$slots, "item-icon", { item: be }, () => [
                be.icon ? (w(), T("span", Nk, [
                  oe(ke, {
                    icon: be.icon,
                    loading: be.loading,
                    size: 16
                  }, null, 8, ["icon", "loading"])
                ])) : P("", !0)
              ], !0),
              E("span", Bk, ue(be.label), 1)
            ], 10, Lk))), 128)) : P("", !0)
          ], !0)
        ], 38)) : P("", !0)
      ], 8, ["disabled"]))
    ]));
  }
}), Cr = /* @__PURE__ */ je(Wk, [["__scopeId", "data-v-66563b51"]]), Yk = ["data-overlay-open"], Hk = {
  key: 0,
  class: "modal-header"
}, Uk = {
  key: 0,
  class: "modal-title"
}, qk = { class: "modal-content" }, jk = {
  key: 1,
  class: "modal-footer"
}, Gk = {
  key: 0,
  class: "modal-footer-actions"
}, Kk = /* @__PURE__ */ Se({
  __name: "VModal",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    maxWidth: { default: "md" },
    footerActions: { type: [Boolean, Object], default: void 0 },
    loading: { type: Boolean }
  },
  emits: ["close", "open", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: r, zIndex: l } = Pi(t.id), i = M(() => `modal-container--${t.maxWidth}`), o = {
      confirmText: "Confirm",
      cancelText: "Cancel",
      confirmVariant: "primary",
      cancelVariant: "default",
      showConfirm: !0,
      showCancel: !0
    }, u = M(() => t.footerActions ? t.footerActions === !0 ? o : { ...o, ...t.footerActions } : null), c = () => {
      r(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, m = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, p) => (w(), de(zn, { to: "body" }, [
      oe(Dt, {
        name: "modal",
        onAfterEnter: p[2] || (p[2] = (g) => a("open"))
      }, {
        default: fe(() => [
          v(s) ? (w(), T("div", {
            key: 0,
            "data-overlay-open": v(s) || void 0,
            style: Ve({ zIndex: v(l) }),
            class: "modal-backdrop",
            onClick: f,
            onKeydown: m
          }, [
            E("div", {
              class: ne([i.value, "modal-container"]),
              onClick: p[1] || (p[1] = Fe(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (w(), T("div", Hk, [
                U(d.$slots, "header", {}, () => [
                  e.title ? (w(), T("h3", Uk, ue(e.title), 1)) : P("", !0)
                ], !0),
                e.showCloseButton ? (w(), T("button", {
                  key: 0,
                  "aria-label": "Close modal",
                  class: "modal-close-btn",
                  type: "button",
                  onClick: c
                }, [...p[3] || (p[3] = [
                  E("svg", {
                    fill: "none",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    })
                  ], -1)
                ])])) : P("", !0)
              ])) : P("", !0),
              E("div", qk, [
                U(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer || u.value ? (w(), T("div", jk, [
                U(d.$slots, "footer", {}, () => [
                  u.value ? (w(), T("div", Gk, [
                    u.value.showCancel ? (w(), de(qt, {
                      key: 0,
                      disabled: t.loading,
                      variant: u.value.cancelVariant,
                      type: "button",
                      onClick: c
                    }, {
                      default: fe(() => [
                        Ue(ue(u.value.cancelText), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "variant"])) : P("", !0),
                    u.value.showConfirm ? (w(), de(qt, {
                      key: 1,
                      loading: t.loading,
                      variant: u.value.confirmVariant,
                      type: "button",
                      onClick: p[0] || (p[0] = (g) => a("confirm"))
                    }, {
                      default: fe(() => [
                        Ue(ue(u.value.confirmText), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "variant"])) : P("", !0)
                  ])) : P("", !0)
                ], !0)
              ])) : P("", !0)
            ], 2)
          ], 44, Yk)) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), gD = /* @__PURE__ */ je(Kk, [["__scopeId", "data-v-431e5fe3"]]), Zk = (e) => {
  const n = Eu(), t = ee(!0), a = ee(!1), s = ee(null), r = () => t.value && Qe((e == null ? void 0 : e.when) ?? !0);
  wf((c) => c.meta.requiresAuth === !1 || !r() ? !0 : (a.value = !0, s.value = c, !1)), We(
    [() => Qe((e == null ? void 0 : e.when) ?? !0), t],
    ([c, f]) => {
      (!c || !f) && a.value && i();
    }
  );
  const l = () => {
    if (!s.value) return;
    const c = s.value;
    t.value = !1, a.value = !1, s.value = null, n.push(c).finally(() => {
      t.value = !0;
    });
  }, i = () => {
    a.value = !1, s.value = null;
  };
  return { isPending: a, pendingTo: s, isEnabled: t, confirm: l, cancel: i, enable: () => {
    t.value = !0;
  }, disable: () => {
    t.value = !1;
  } };
}, Xk = ["aria-label"], Jk = {
  key: 0,
  class: "unsaved-changes__card mx-4 flex w-full max-w-sm overflow-hidden rounded-xl"
}, Qk = { class: "flex flex-1 flex-col p-5" }, ex = { class: "flex items-start gap-3" }, tx = { class: "min-w-0 flex-1" }, nx = { class: "mb-1 text-sm font-semibold leading-snug text-mainText" }, ax = { class: "text-xs leading-relaxed text-secondaryText" }, sx = { class: "mt-4 flex items-center justify-end gap-2 border-t border-base-300 pt-4" }, rx = /* @__PURE__ */ Se({
  __name: "VUnsavedChangesModal",
  props: {
    open: { type: Boolean, default: !1 },
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" },
    zIndex: { default: 50 }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = n, a = Je("dialog");
    return We(() => e.open, (s) => {
      s && Ze(() => {
        var r;
        return (r = a.value) == null ? void 0 : r.focus();
      });
    }), (s, r) => (w(), de(zn, { to: "body" }, [
      oe(Dt, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: fe(() => [
          e.open ? (w(), T("div", {
            key: 0,
            ref: "dialog",
            "aria-label": e.title,
            style: Ve({ "--_z-index": e.zIndex }),
            "aria-modal": "true",
            class: "unsaved-changes__backdrop fixed inset-0 flex items-center justify-center",
            role: "dialog",
            tabindex: "-1",
            onClick: r[3] || (r[3] = Fe((l) => t("cancel"), ["self"])),
            onKeydown: r[4] || (r[4] = Pt((l) => t("cancel"), ["esc"]))
          }, [
            oe(Dt, {
              appear: "",
              "enter-active-class": "transition duration-200 ease-out",
              "enter-from-class": "opacity-0 scale-95 -translate-y-2",
              "enter-to-class": "opacity-100 scale-100 translate-y-0",
              "leave-active-class": "transition duration-150 ease-in",
              "leave-from-class": "opacity-100 scale-100 translate-y-0",
              "leave-to-class": "opacity-0 scale-95 -translate-y-2"
            }, {
              default: fe(() => [
                e.open ? (w(), T("div", Jk, [
                  r[7] || (r[7] = E("div", { class: "w-1 flex-shrink-0 bg-gradient-to-b from-warning via-warning/60 to-warning/10" }, null, -1)),
                  E("div", Qk, [
                    E("div", ex, [
                      r[6] || (r[6] = E("div", { class: "mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-warning-200 bg-warning-50" }, [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-4 w-4 text-warning",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.2",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }),
                          E("path", { d: "M12 9v4" }),
                          E("path", { d: "M12 17h.01" })
                        ])
                      ], -1)),
                      E("div", tx, [
                        E("h2", nx, ue(e.title), 1),
                        E("div", ax, [
                          U(s.$slots, "description", {}, () => [
                            Ue(ue(e.description), 1)
                          ], !0)
                        ])
                      ]),
                      E("button", {
                        "aria-label": "Cancel and keep editing",
                        class: "-mr-1 -mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-secondaryText transition-colors hover:bg-base-200",
                        type: "button",
                        onClick: r[0] || (r[0] = (l) => t("cancel"))
                      }, [...r[5] || (r[5] = [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-3.5 w-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "M18 6 6 18M6 6l12 12" })
                        ], -1)
                      ])])
                    ]),
                    E("div", sx, [
                      E("button", {
                        class: "h-8 rounded-md border border-error/25 bg-transparent px-3 text-xs text-error transition-all hover:border-error/40 hover:bg-error/5 active:scale-95",
                        type: "button",
                        onClick: r[1] || (r[1] = (l) => t("confirm"))
                      }, ue(e.leaveLabel), 1),
                      E("button", {
                        class: "h-8 rounded-md border-2 border-primary bg-primary px-4 text-xs text-white shadow-sm transition-all hover:border-primary-dark hover:bg-primary-dark active:scale-95",
                        type: "button",
                        onClick: r[2] || (r[2] = (l) => t("cancel"))
                      }, ue(e.confirmLabel), 1)
                    ])
                  ])
                ])) : P("", !0)
              ]),
              _: 3
            })
          ], 44, Xk)) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), lx = /* @__PURE__ */ je(rx, [["__scopeId", "data-v-4050f9cd"]]), yD = /* @__PURE__ */ Se({
  __name: "NavigationGuardModal",
  props: {
    when: {},
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" }
  },
  setup(e) {
    const { isPending: n, confirm: t, cancel: a } = Zk({ when: () => Qe(e.when) });
    return (s, r) => (w(), de(lx, {
      "confirm-label": e.confirmLabel,
      description: e.description,
      "leave-label": e.leaveLabel,
      open: v(n),
      title: e.title,
      onCancel: v(a),
      onConfirm: v(t)
    }, dt({ _: 2 }, [
      s.$slots.description ? {
        name: "description",
        fn: fe(() => [
          U(s.$slots, "description")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["confirm-label", "description", "leave-label", "open", "title", "onCancel", "onConfirm"]));
  }
}), ix = { class: "v-meter" }, ox = ["aria-valuemax", "aria-valuenow"], ux = /* @__PURE__ */ Se({
  __name: "VMeter",
  props: {
    value: {},
    max: {},
    goal: { default: "reach" },
    label: {},
    hint: {},
    pending: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  setup(e) {
    const n = M(() => e.value !== null), t = M(() => e.value === null ? !1 : e.goal === "reach" ? e.value >= e.max : e.value <= e.max), a = M(() => e.value === null || e.max <= 0 ? 0 : Math.min(1, e.value / e.max)), s = M(() => e.value === null ? "Not measured" : `${e.value.toLocaleString("en-US")} / ${e.max.toLocaleString("en-US")}`), r = M(() => n.value ? t.value ? "lucide:circle-check" : "lucide:triangle-alert" : "lucide:circle-help");
    return (l, i) => (w(), T("div", ix, [
      n.value || e.pending ? (w(), T("div", {
        key: 0,
        class: ne([`v-meter__track--${e.size}`, "v-meter__track"])
      }, [
        E("div", {
          "aria-valuemax": e.max,
          "aria-valuenow": e.value ?? void 0,
          class: ne([t.value ? "v-meter__fill--met" : "v-meter__fill--unmet", "v-meter__fill"]),
          style: Ve({ "--v-meter-fill": a.value }),
          "aria-valuemin": "0",
          role: "meter"
        }, null, 14, ox)
      ], 2)) : P("", !0),
      oe(Ja, {
        disabled: !e.hint,
        text: e.hint ?? ""
      }, {
        default: fe(() => [
          E("span", {
            class: ne([{ "v-meter__value--pending": e.pending, "v-meter__value--help": !!e.hint }, "v-meter__value"])
          }, [
            e.pending ? (w(), de(ke, {
              key: 0,
              loading: !0,
              size: 14,
              icon: "lucide:loading"
            })) : (w(), de(ke, {
              key: 1,
              class: ne(n.value ? t.value ? "v-meter__icon--met" : "v-meter__icon--unmet" : ""),
              icon: r.value,
              size: 14
            }, null, 8, ["class", "icon"])),
            U(l.$slots, "label", {}, () => [
              Ue(ue(e.label ?? s.value), 1)
            ], !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["disabled", "text"])
    ]));
  }
}), bD = /* @__PURE__ */ je(ux, [["__scopeId", "data-v-f009ff9b"]]), cx = { class: "v-progress-bar" }, dx = {
  key: 0,
  class: "v-progress-bar__header"
}, fx = {
  key: 0,
  class: "v-progress-bar__step"
}, hx = { key: 1 }, mx = {
  key: 2,
  class: "v-progress-bar__percentage"
}, vx = {
  key: 0,
  class: "v-progress-bar__shine"
}, px = /* @__PURE__ */ Se({
  __name: "VProgressBar",
  props: {
    percentage: {},
    step: { default: null },
    size: { default: "md" },
    showPercentage: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = M(() => Math.max(0, Math.min(100, n.percentage))), a = M(() => t.value >= 100), s = M(() => ({ sm: "4px", md: "6px", lg: "8px" })[n.size]);
    return (r, l) => (w(), T("div", cx, [
      e.step || e.showPercentage ? (w(), T("div", dx, [
        e.step ? (w(), T("span", fx, ue(e.step), 1)) : (w(), T("span", hx)),
        e.showPercentage ? (w(), T("div", mx, [
          E("span", {
            class: ne({ "text-success": a.value })
          }, ue(Math.round(t.value)) + "% ", 3),
          a.value ? (w(), de(ke, {
            key: 0,
            size: 14,
            class: "text-success ml-1",
            icon: "lucide:check-circle"
          })) : P("", !0)
        ])) : P("", !0)
      ])) : P("", !0),
      E("div", {
        style: Ve({ height: s.value }),
        class: "v-progress-bar__track"
      }, [
        E("div", {
          class: ne([{ "v-progress-bar__fill--completed": a.value }, "v-progress-bar__fill"]),
          style: Ve({ width: `${t.value}%` })
        }, [
          a.value ? P("", !0) : (w(), T("div", vx))
        ], 6)
      ], 4)
    ]));
  }
}), wD = /* @__PURE__ */ je(px, [["__scopeId", "data-v-d74c8912"]]), gx = ["aria-checked", "aria-label", "title", "onClick"], yx = /* @__PURE__ */ Se({
  __name: "VThemeToggle",
  props: /* @__PURE__ */ Ln({
    compact: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = es(e, "modelValue"), t = [
      { value: "light", icon: "lucide:sun", label: "Light theme" },
      { value: "dark", icon: "lucide:moon", label: "Dark theme" }
    ], a = (s) => {
      n.value !== s && (n.value = s);
    };
    return (s, r) => (w(), T("div", {
      class: ne([{ "theme-toggle--compact": e.compact, "theme-toggle--dark": n.value === "dark" }, "theme-toggle"]),
      "aria-label": "Theme",
      role: "radiogroup"
    }, [
      r[0] || (r[0] = E("span", {
        "aria-hidden": "true",
        class: "theme-toggle__thumb"
      }, null, -1)),
      (w(), T(Te, null, Pe(t, (l) => E("button", {
        key: l.value,
        "aria-checked": n.value === l.value,
        "aria-label": l.label,
        class: ne([{ "theme-toggle__option--active": n.value === l.value }, "theme-toggle__option"]),
        title: l.label,
        role: "radio",
        type: "button",
        onClick: (i) => a(l.value)
      }, [
        oe(ke, {
          icon: l.icon,
          size: 14
        }, null, 8, ["icon"])
      ], 10, gx)), 64))
    ], 2));
  }
}), kD = /* @__PURE__ */ je(yx, [["__scopeId", "data-v-d8fdb503"]]);
let Jl = 1;
var bx = class {
  constructor() {
    xe(this, "subscribers");
    xe(this, "toasts");
    xe(this, "dismissedToasts");
    xe(this, "subscribe", (e) => (this.subscribers.push(e), () => {
      const n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }));
    xe(this, "publish", (e) => {
      this.subscribers.forEach((n) => n(e));
    });
    xe(this, "addToast", (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    });
    xe(this, "create", (e) => {
      var l;
      const { message: n, ...t } = e, a = typeof e.id == "number" || e.id && ((l = e.id) == null ? void 0 : l.length) > 0 ? e.id : Jl++, s = this.toasts.find((i) => i.id === a), r = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((i) => i.id === a ? (this.publish({
        ...i,
        ...e,
        id: a,
        title: n
      }), {
        ...i,
        ...e,
        id: a,
        dismissible: r,
        title: n
      }) : i) : this.addToast({
        title: n,
        ...t,
        dismissible: r,
        id: a
      }), a;
    });
    xe(this, "dismiss", (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((t) => t({
        id: n.id,
        dismiss: !0
      }));
    }), e));
    xe(this, "message", (e, n) => this.create({
      ...n,
      message: e,
      type: "default"
    }));
    xe(this, "error", (e, n) => this.create({
      ...n,
      type: "error",
      message: e
    }));
    xe(this, "success", (e, n) => this.create({
      ...n,
      type: "success",
      message: e
    }));
    xe(this, "info", (e, n) => this.create({
      ...n,
      type: "info",
      message: e
    }));
    xe(this, "warning", (e, n) => this.create({
      ...n,
      type: "warning",
      message: e
    }));
    xe(this, "loading", (e, n) => this.create({
      ...n,
      type: "loading",
      message: e
    }));
    xe(this, "promise", (e, n) => {
      if (!n) return;
      let t;
      n.loading !== void 0 && (t = this.create({
        ...n,
        promise: e,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const a = Promise.resolve(e instanceof Function ? e() : e);
      let s = t !== void 0, r;
      const l = a.then(async (o) => {
        if (r = ["resolve", o], us(o))
          s = !1, this.create({
            id: t,
            type: "default",
            message: o
          });
        else if (kx(o) && !o.ok) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(`HTTP error! status: ${o.status}`) : n.error, f = typeof n.description == "function" ? await n.description(`HTTP error! status: ${o.status}`) : n.description, d = typeof c == "object" && !us(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (o instanceof Error) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(o) : n.error, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !us(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (n.success !== void 0) {
          s = !1;
          const c = typeof n.success == "function" ? await n.success(o) : n.success, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !us(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "success",
            description: f,
            ...d
          });
        }
      }).catch(async (o) => {
        if (r = ["reject", o], n.error !== void 0) {
          s = !1;
          const u = typeof n.error == "function" ? await n.error(o) : n.error, c = typeof n.description == "function" ? await n.description(o) : n.description, m = typeof u == "object" && !us(u) ? u : {
            message: u || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: c,
            ...m
          });
        }
      }).finally(() => {
        var o;
        s && (this.dismiss(t), t = void 0), (o = n.finally) == null || o.call(n);
      }), i = () => new Promise((o, u) => l.then(() => r[0] === "reject" ? u(r[1]) : o(r[1])).catch(u));
      return typeof t != "string" && typeof t != "number" ? { unwrap: i } : Object.assign(t, { unwrap: i });
    });
    xe(this, "custom", (e, n) => {
      const t = (n == null ? void 0 : n.id) || Jl++, a = this.toasts.find((r) => r.id === t), s = (n == null ? void 0 : n.dismissible) === void 0 ? !0 : n.dismissible;
      return this.dismissedToasts.has(t) && this.dismissedToasts.delete(t), a ? this.toasts = this.toasts.map((r) => r.id === t ? (this.publish({
        ...r,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), {
        ...r,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }) : r) : this.addToast({
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), t;
    });
    xe(this, "getActiveToasts", () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)));
    this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
};
const Yt = new bx();
function wx(e, n) {
  const t = (n == null ? void 0 : n.id) || Jl++;
  return Yt.create({
    message: e,
    id: t,
    type: "default",
    ...n
  }), t;
}
const kx = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", xx = wx, Sx = () => Yt.toasts, Tx = () => Yt.getActiveToasts(), oa = Object.assign(xx, {
  success: Yt.success,
  info: Yt.info,
  warning: Yt.warning,
  error: Yt.error,
  custom: Yt.custom,
  message: Yt.message,
  promise: Yt.promise,
  dismiss: Yt.dismiss,
  loading: Yt.loading
}, {
  getHistory: Sx,
  getToasts: Tx
});
function rr(e) {
  return e.label !== void 0;
}
const Mx = 3, Ud = "24px", qd = "16px", ru = 4e3, $x = 356, Cx = 14, Dx = 45, jd = 200;
function Ox() {
  const e = ee(!1);
  return Ut(() => {
    const n = () => {
      e.value = document.hidden;
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }), { isDocumentHidden: e };
}
function Kn(...e) {
  return e.filter(Boolean).join(" ");
}
function _x(e) {
  const [n, t] = e.split("-"), a = [];
  return n && a.push(n), t && a.push(t), a;
}
function Ex(e, n) {
  const t = {};
  return [e, n].forEach((a, s) => {
    const r = s === 1, l = r ? "--mobile-offset" : "--offset", i = r ? qd : Ud;
    function o(u) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((c) => {
        t[`${l}-${c}`] = typeof u == "number" ? `${u}px` : u;
      });
    }
    typeof a == "number" || typeof a == "string" ? o(a) : typeof a == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((u) => {
      a[u] === void 0 ? t[`${l}-${u}`] = i : t[`${l}-${u}`] = typeof a[u] == "number" ? `${a[u]}px` : a[u];
    }) : o(i);
  }), t;
}
const Ix = [
  "data-rich-colors",
  "data-styled",
  "data-mounted",
  "data-promise",
  "data-swiped",
  "data-removed",
  "data-visible",
  "data-y-position",
  "data-x-position",
  "data-index",
  "data-front",
  "data-swiping",
  "data-dismissible",
  "data-type",
  "data-invert",
  "data-swipe-out",
  "data-swipe-direction",
  "data-expanded",
  "data-testid"
], Px = [
  "aria-label",
  "data-disabled",
  "data-close-button-position"
];
var Ax = /* @__PURE__ */ Se({
  __name: "Toast",
  props: {
    toast: {},
    toasts: {},
    index: {},
    swipeDirections: {},
    expanded: { type: Boolean },
    invert: { type: Boolean },
    heights: {},
    gap: {},
    position: {},
    closeButtonPosition: {},
    visibleToasts: {},
    expandByDefault: { type: Boolean },
    closeButton: { type: Boolean },
    interacting: { type: Boolean },
    style: {},
    cancelButtonStyle: {},
    actionButtonStyle: {},
    duration: {},
    class: {},
    unstyled: { type: Boolean },
    descriptionClass: {},
    loadingIcon: {},
    classes: {},
    icons: {},
    closeButtonAriaLabel: {},
    defaultRichColors: { type: Boolean }
  },
  emits: [
    "update:heights",
    "update:height",
    "removeToast"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(null), r = ee(null), l = ee(!1), i = ee(!1), o = ee(!1), u = ee(!1), c = ee(!1), f = ee(0), m = ee(0), d = ee(t.toast.duration || t.duration || ru), p = ee(null), g = ee(null), k = M(() => t.index === 0), y = M(() => t.index + 1 <= t.visibleToasts), h = M(() => t.toast.type), b = M(() => t.toast.dismissible !== !1), S = M(() => t.toast.class || ""), x = M(() => t.descriptionClass || ""), C = M(() => {
      const K = t.toast.position || t.position, Me = t.heights.filter((F) => F.position === K).findIndex((F) => F.toastId === t.toast.id);
      return Me >= 0 ? Me : 0;
    }), $ = M(() => {
      const K = t.toast.position || t.position;
      return t.heights.filter((Me) => Me.position === K).reduce((Me, F, j) => j >= C.value ? Me : Me + F.height, 0);
    }), _ = M(() => C.value * t.gap + $.value || 0), A = M(() => t.toast.closeButton ?? t.closeButton), D = M(() => t.toast.duration || t.duration || ru), Y = ee(0), L = ee(0), Z = ee(null), se = M(() => t.position.split("-")), ie = M(() => se.value[0]), ce = M(() => se.value[1]), G = M(() => typeof t.toast.title != "string"), le = M(() => typeof t.toast.description != "string"), { isDocumentHidden: q } = Ox(), N = M(() => h.value && h.value === "loading");
    et(() => {
      l.value = !0, d.value = D.value;
    }), Ut(async () => {
      if (!l.value || !g.value) return;
      await Ze();
      const K = g.value, be = K.style.height;
      K.style.height = "auto";
      const Me = K.getBoundingClientRect().height;
      K.style.height = be, m.value = Me, a("update:height", {
        toastId: t.toast.id,
        height: Me,
        position: t.toast.position || t.position
      });
    });
    function Q() {
      i.value = !0, f.value = _.value, setTimeout(() => {
        a("removeToast", t.toast);
      }, jd);
    }
    function he() {
      var K, be;
      if (N.value || !b.value) return {};
      Q(), (be = (K = t.toast).onDismiss) == null || be.call(K, t.toast);
    }
    function pe(K) {
      K.button !== 2 && (N.value || !b.value || (p.value = /* @__PURE__ */ new Date(), f.value = _.value, K.target.setPointerCapture(K.pointerId), K.target.tagName !== "BUTTON" && (o.value = !0, Z.value = {
        x: K.clientX,
        y: K.clientY
      })));
    }
    function ge() {
      var H, I, B, X, R, te, O;
      if (u.value || !b.value) return;
      Z.value = null;
      const K = Number(((H = g.value) == null ? void 0 : H.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), be = Number(((I = g.value) == null ? void 0 : I.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Me = (/* @__PURE__ */ new Date()).getTime() - (((B = p.value) == null ? void 0 : B.getTime()) || 0), F = s.value === "x" ? K : be, j = Math.abs(F) / Me;
      if (Math.abs(F) >= Dx || j > 0.11) {
        f.value = _.value, (R = (X = t.toast).onDismiss) == null || R.call(X, t.toast), s.value === "x" ? r.value = K > 0 ? "right" : "left" : r.value = be > 0 ? "down" : "up", Q(), u.value = !0;
        return;
      } else
        (te = g.value) == null || te.style.setProperty("--swipe-amount-x", "0px"), (O = g.value) == null || O.style.setProperty("--swipe-amount-y", "0px");
      c.value = !1, o.value = !1, s.value = null;
    }
    function Ce(K) {
      var B, X, R, te;
      if (!Z.value || !b.value || (((X = (B = window == null ? void 0 : window.getSelection()) == null ? void 0 : B.toString()) == null ? void 0 : X.length) ?? !1)) return;
      const Me = K.clientY - Z.value.y, F = K.clientX - Z.value.x, j = t.swipeDirections ?? _x(t.position);
      !s.value && (Math.abs(F) > 1 || Math.abs(Me) > 1) && (s.value = Math.abs(F) > Math.abs(Me) ? "x" : "y");
      let H = {
        x: 0,
        y: 0
      };
      const I = (O) => 1 / (1.5 + Math.abs(O) / 20);
      if (s.value === "y") {
        if (j.includes("top") || j.includes("bottom")) if (j.includes("top") && Me < 0 || j.includes("bottom") && Me > 0) H.y = Me;
        else {
          const O = Me * I(Me);
          H.y = Math.abs(O) < Math.abs(Me) ? O : Me;
        }
      } else if (s.value === "x" && (j.includes("left") || j.includes("right")))
        if (j.includes("left") && F < 0 || j.includes("right") && F > 0) H.x = F;
        else {
          const O = F * I(F);
          H.x = Math.abs(O) < Math.abs(F) ? O : F;
        }
      (Math.abs(H.x) > 0 || Math.abs(H.y) > 0) && (c.value = !0), (R = g.value) == null || R.style.setProperty("--swipe-amount-x", `${H.x}px`), (te = g.value) == null || te.style.setProperty("--swipe-amount-y", `${H.y}px`);
    }
    et(() => {
      if (l.value = !0, !g.value) return;
      const K = g.value.getBoundingClientRect().height;
      m.value = K;
      const be = [{
        toastId: t.toast.id,
        height: K,
        position: t.toast.position
      }, ...t.heights];
      a("update:heights", be);
    }), Is(() => {
      g.value && a("removeToast", t.toast);
    }), Ut((K) => {
      if (t.toast.promise && h.value === "loading" || t.toast.duration === 1 / 0 || t.toast.type === "loading") return;
      let be;
      const Me = () => {
        if (L.value < Y.value) {
          const j = (/* @__PURE__ */ new Date()).getTime() - Y.value;
          d.value = d.value - j;
        }
        L.value = (/* @__PURE__ */ new Date()).getTime();
      }, F = () => {
        d.value !== 1 / 0 && (Y.value = (/* @__PURE__ */ new Date()).getTime(), be = setTimeout(() => {
          var j, H;
          (H = (j = t.toast).onAutoClose) == null || H.call(j, t.toast), Q();
        }, d.value));
      };
      t.expanded || t.interacting || q.value ? Me() : F(), K(() => {
        clearTimeout(be);
      });
    }), We(() => t.toast.delete, (K) => {
      var be, Me;
      K !== void 0 && K && (Q(), (Me = (be = t.toast).onDismiss) == null || Me.call(be, t.toast));
    }, { deep: !0 });
    function ye() {
      o.value = !1, s.value = null, Z.value = null;
    }
    return (K, be) => {
      var Me, F, j, H, I, B, X, R, te, O, z, V, re, W, me, De, Re, Ee, Ye, At, Zt, Wn, _t, Wt, En, Yn, xt;
      return w(), T("li", {
        tabindex: "0",
        ref_key: "toastRef",
        ref: g,
        class: ne(v(Kn)(t.class, S.value, (Me = K.classes) == null ? void 0 : Me.toast, (F = K.toast.classes) == null ? void 0 : F.toast, (j = K.classes) == null ? void 0 : j[h.value], (I = (H = K.toast) == null ? void 0 : H.classes) == null ? void 0 : I[h.value])),
        "data-sonner-toast": "",
        "data-rich-colors": K.toast.richColors ?? K.defaultRichColors,
        "data-styled": !(K.toast.component || (B = K.toast) != null && B.unstyled || K.unstyled),
        "data-mounted": l.value,
        "data-promise": !!K.toast.promise,
        "data-swiped": c.value,
        "data-removed": i.value,
        "data-visible": y.value,
        "data-y-position": ie.value,
        "data-x-position": ce.value,
        "data-index": K.index,
        "data-front": k.value,
        "data-swiping": o.value,
        "data-dismissible": b.value,
        "data-type": h.value,
        "data-invert": K.toast.invert || K.invert,
        "data-swipe-out": u.value,
        "data-swipe-direction": r.value,
        "data-expanded": !!(K.expanded || K.expandByDefault && l.value),
        "data-testid": K.toast.testId,
        style: Ve({
          "--index": K.index,
          "--toasts-before": K.index,
          "--z-index": K.toasts.length - K.index,
          "--offset": `${i.value ? f.value : _.value}px`,
          "--initial-height": K.expandByDefault ? "auto" : `${m.value}px`,
          ...K.style,
          ...t.toast.style
        }),
        onDragend: ye,
        onPointerdown: pe,
        onPointerup: ge,
        onPointermove: Ce
      }, [A.value && !K.toast.component && h.value !== "loading" ? (w(), T("button", {
        key: 0,
        "aria-label": K.closeButtonAriaLabel || "Close toast",
        "data-disabled": N.value,
        "data-close-button": "true",
        "data-close-button-position": K.closeButtonPosition,
        class: ne(v(Kn)((X = K.classes) == null ? void 0 : X.closeButton, (te = (R = K.toast) == null ? void 0 : R.classes) == null ? void 0 : te.closeButton)),
        onClick: he
      }, [(O = K.icons) != null && O.close ? (w(), de(ht((z = K.icons) == null ? void 0 : z.close), { key: 0 })) : U(K.$slots, "close-icon", { key: 1 })], 10, Px)) : P("v-if", !0), K.toast.component ? (w(), de(ht(K.toast.component), rt({ key: 1 }, K.toast.componentProps, {
        onCloseToast: he,
        isPaused: K.$props.expanded || K.$props.interacting || v(q)
      }), null, 16, ["isPaused"])) : (w(), T(Te, { key: 2 }, [
        h.value !== "default" || K.toast.icon || K.toast.promise ? (w(), T("div", {
          key: 0,
          "data-icon": "",
          class: ne(v(Kn)((V = K.classes) == null ? void 0 : V.icon, (W = (re = K.toast) == null ? void 0 : re.classes) == null ? void 0 : W.icon))
        }, [K.toast.icon ? (w(), de(ht(K.toast.icon), { key: 0 })) : (w(), T(Te, { key: 1 }, [h.value === "loading" ? U(K.$slots, "loading-icon", { key: 0 }) : h.value === "success" ? U(K.$slots, "success-icon", { key: 1 }) : h.value === "error" ? U(K.$slots, "error-icon", { key: 2 }) : h.value === "warning" ? U(K.$slots, "warning-icon", { key: 3 }) : h.value === "info" ? U(K.$slots, "info-icon", { key: 4 }) : P("v-if", !0)], 64))], 2)) : P("v-if", !0),
        E("div", {
          "data-content": "",
          class: ne(v(Kn)((me = K.classes) == null ? void 0 : me.content, (Re = (De = K.toast) == null ? void 0 : De.classes) == null ? void 0 : Re.content))
        }, [E("div", {
          "data-title": "",
          class: ne(v(Kn)((Ee = K.classes) == null ? void 0 : Ee.title, (Ye = K.toast.classes) == null ? void 0 : Ye.title))
        }, [G.value ? (w(), de(ht(K.toast.title), Mt(rt({ key: 0 }, K.toast.componentProps)), null, 16)) : (w(), T(Te, { key: 1 }, [Ue(ue(K.toast.title), 1)], 64))], 2), K.toast.description ? (w(), T("div", {
          key: 0,
          "data-description": "",
          class: ne(v(Kn)(K.descriptionClass, x.value, (At = K.classes) == null ? void 0 : At.description, (Zt = K.toast.classes) == null ? void 0 : Zt.description))
        }, [le.value ? (w(), de(ht(K.toast.description), Mt(rt({ key: 0 }, K.toast.componentProps)), null, 16)) : (w(), T(Te, { key: 1 }, [Ue(ue(K.toast.description), 1)], 64))], 2)) : P("v-if", !0)], 2),
        K.toast.cancel ? (w(), T("button", {
          key: 1,
          style: Ve(K.toast.cancelButtonStyle || K.cancelButtonStyle),
          class: ne(v(Kn)((Wn = K.classes) == null ? void 0 : Wn.cancelButton, (_t = K.toast.classes) == null ? void 0 : _t.cancelButton)),
          "data-button": "",
          "data-cancel": "",
          onClick: be[0] || (be[0] = ($t) => {
            var St, Xt;
            v(rr)(K.toast.cancel) && b.value && ((Xt = (St = K.toast.cancel).onClick) == null || Xt.call(St, $t), Q());
          })
        }, ue(v(rr)(K.toast.cancel) ? (Wt = K.toast.cancel) == null ? void 0 : Wt.label : K.toast.cancel), 7)) : P("v-if", !0),
        K.toast.action ? (w(), T("button", {
          key: 2,
          style: Ve(K.toast.actionButtonStyle || K.actionButtonStyle),
          class: ne(v(Kn)((En = K.classes) == null ? void 0 : En.actionButton, (Yn = K.toast.classes) == null ? void 0 : Yn.actionButton)),
          "data-button": "",
          "data-action": "",
          onClick: be[1] || (be[1] = ($t) => {
            var St, Xt;
            v(rr)(K.toast.action) && ((Xt = (St = K.toast.action).onClick) == null || Xt.call(St, $t), !$t.defaultPrevented && Q());
          })
        }, ue(v(rr)(K.toast.action) ? (xt = K.toast.action) == null ? void 0 : xt.label : K.toast.action), 7)) : P("v-if", !0)
      ], 64))], 46, Ix);
    };
  }
}), Rx = Ax, qs = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n) t[a] = s;
  return t;
};
const Fx = {}, Vx = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stoke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Lx(e, n) {
  return w(), T("svg", Vx, n[0] || (n[0] = [E("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }, null, -1), E("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }, null, -1)]));
}
var Nx = /* @__PURE__ */ qs(Fx, [["render", Lx]]);
const Bx = ["data-visible"], zx = { class: "sonner-spinner" };
var Wx = /* @__PURE__ */ Se({
  __name: "Loader",
  props: { visible: { type: Boolean } },
  setup(e) {
    const n = Array(12).fill(0);
    return (t, a) => (w(), T("div", {
      class: "sonner-loading-wrapper",
      "data-visible": t.visible
    }, [E("div", zx, [(w(!0), T(Te, null, Pe(v(n), (s) => (w(), T("div", {
      key: `spinner-bar-${s}`,
      class: "sonner-loading-bar"
    }))), 128))])], 8, Bx));
  }
}), Yx = Wx;
const Hx = {}, Ux = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function qx(e, n) {
  return w(), T("svg", Ux, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var jx = /* @__PURE__ */ qs(Hx, [["render", qx]]);
const Gx = {}, Kx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function Zx(e, n) {
  return w(), T("svg", Kx, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var Xx = /* @__PURE__ */ qs(Gx, [["render", Zx]]);
const Jx = {}, Qx = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function eS(e, n) {
  return w(), T("svg", Qx, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var tS = /* @__PURE__ */ qs(Jx, [["render", eS]]);
const nS = {}, aS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function sS(e, n) {
  return w(), T("svg", aS, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var rS = /* @__PURE__ */ qs(nS, [["render", sS]]);
const lS = ["aria-label"], iS = [
  "data-sonner-theme",
  "dir",
  "data-theme",
  "data-rich-colors",
  "data-y-position",
  "data-x-position"
], oS = typeof window < "u" && typeof document < "u";
function uS() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
var cS = /* @__PURE__ */ Se({
  name: "Toaster",
  inheritAttrs: !1,
  __name: "Toaster",
  props: {
    id: {},
    invert: {
      type: Boolean,
      default: !1
    },
    theme: { default: "light" },
    position: { default: "bottom-right" },
    closeButtonPosition: { default: "top-left" },
    hotkey: { default: () => ["altKey", "KeyT"] },
    richColors: {
      type: Boolean,
      default: !1
    },
    expand: {
      type: Boolean,
      default: !1
    },
    duration: {},
    gap: { default: Cx },
    visibleToasts: { default: Mx },
    closeButton: {
      type: Boolean,
      default: !1
    },
    toastOptions: { default: () => ({}) },
    class: { default: "" },
    style: {},
    offset: { default: Ud },
    mobileOffset: { default: qd },
    dir: { default: "auto" },
    swipeDirections: {},
    icons: {},
    containerAriaLabel: { default: "Notifications" }
  },
  setup(e) {
    const n = e, t = ni(), a = ee([]), s = M(() => n.id ? a.value.filter((D) => D.toasterId === n.id) : a.value.filter((D) => !D.toasterId));
    function r(D, Y) {
      return s.value.filter((L) => !L.position && Y === 0 || L.position === D);
    }
    const l = M(() => {
      const D = s.value.filter((Y) => Y.position).map((Y) => Y.position);
      return D.length > 0 ? Array.from(new Set([n.position].concat(D))) : [n.position];
    }), i = M(() => {
      const D = {};
      return l.value.forEach((Y) => {
        D[Y] = a.value.filter((L) => L.position === Y);
      }), D;
    }), o = ee([]), u = ee({}), c = ee(!1);
    Ut(() => {
      l.value.forEach((D) => {
        D in u.value || (u.value[D] = !1);
      });
    });
    const f = ee(n.theme !== "system" ? n.theme : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), m = ee(null), d = ee(null), p = ee(!1), g = n.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    function k(D) {
      var Y;
      (Y = a.value.find((L) => L.id === D.id)) != null && Y.delete || Yt.dismiss(D.id), a.value = a.value.filter(({ id: L }) => L !== D.id), setTimeout(() => {
        a.value.find((L) => L.id === D.id) || (o.value = o.value.filter((L) => L.toastId !== D.id));
      }, jd + 50);
    }
    function y(D) {
      var Y, L;
      p.value && !((L = (Y = D.currentTarget) == null ? void 0 : Y.contains) != null && L.call(Y, D.relatedTarget)) && (p.value = !1, d.value && (d.value.focus({ preventScroll: !0 }), d.value = null));
    }
    function h(D) {
      D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || p.value || (p.value = !0, d.value = D.relatedTarget);
    }
    function b(D) {
      D.target && D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || (c.value = !0);
    }
    Ut((D) => {
      const Y = Yt.subscribe((L) => {
        if (L.dismiss) {
          requestAnimationFrame(() => {
            a.value = a.value.map((Z) => Z.id === L.id ? {
              ...Z,
              delete: !0
            } : Z);
          });
          return;
        }
        Ze(() => {
          const Z = a.value.findIndex((se) => se.id === L.id);
          Z !== -1 ? a.value = [
            ...a.value.slice(0, Z),
            {
              ...a.value[Z],
              ...L
            },
            ...a.value.slice(Z + 1)
          ] : a.value = [L, ...a.value];
        });
      });
      D(Y);
    }), Ut((D) => {
      if (typeof window > "u") return;
      if (n.theme !== "system") {
        f.value = n.theme;
        return;
      }
      const Y = window.matchMedia("(prefers-color-scheme: dark)"), L = (se) => {
        f.value = se ? "dark" : "light";
      };
      L(Y.matches);
      const Z = (se) => {
        L(se.matches);
      };
      try {
        Y.addEventListener("change", Z);
      } catch {
        Y.addListener(Z);
      }
      D(() => {
        try {
          Y.removeEventListener("change", Z);
        } catch {
          Y.removeListener(Z);
        }
      });
    }), Ut(() => {
      m.value && d.value && (d.value.focus({ preventScroll: !0 }), d.value = null, p.value = !1);
    }), Ut(() => {
      a.value.length <= 1 && Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }), Ut((D) => {
      function Y(L) {
        const Z = n.hotkey.every((ce) => L[ce] || L.code === ce), se = Array.isArray(m.value) ? m.value[0] : m.value;
        Z && (l.value.forEach((ce) => {
          u.value[ce] = !0;
        }), se == null || se.focus());
        const ie = document.activeElement === m.value || (se == null ? void 0 : se.contains(document.activeElement));
        L.code === "Escape" && ie && l.value.forEach((ce) => {
          u.value[ce] = !1;
        });
      }
      oS && (document.addEventListener("keydown", Y), D(() => {
        document.removeEventListener("keydown", Y);
      }));
    });
    function S(D) {
      const Y = D.currentTarget, L = Y.getAttribute("data-y-position") + "-" + Y.getAttribute("data-x-position");
      u.value[L] = !0;
    }
    function x(D) {
      if (!c.value) {
        const Y = D.currentTarget, L = Y.getAttribute("data-y-position") + "-" + Y.getAttribute("data-x-position");
        u.value[L] = !1;
      }
    }
    function C() {
      Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }
    function $() {
      c.value = !1;
    }
    function _(D) {
      o.value = D;
    }
    function A(D) {
      const Y = o.value.findIndex((L) => L.toastId === D.toastId);
      if (Y !== -1) o.value[Y] = D;
      else {
        const L = o.value.findIndex((Z) => Z.position === D.position);
        L !== -1 ? o.value.splice(L, 0, D) : o.value.unshift(D);
      }
    }
    return (D, Y) => (w(), T(Te, null, [P(" Remove item from normal navigation flow, only available via hotkey "), E("section", {
      "aria-label": `${D.containerAriaLabel} ${v(g)}`,
      tabIndex: -1,
      "aria-live": "polite",
      "aria-relevant": "additions text",
      "aria-atomic": "false"
    }, [(w(!0), T(Te, null, Pe(l.value, (L, Z) => {
      var se;
      return w(), T("ol", rt({
        key: L,
        ref_for: !0,
        ref_key: "listRef",
        ref: m,
        "data-sonner-toaster": "",
        "data-sonner-theme": f.value,
        class: n.class,
        dir: D.dir === "auto" ? uS() : D.dir,
        tabIndex: -1,
        "data-theme": D.theme,
        "data-rich-colors": D.richColors,
        "data-y-position": L.split("-")[0],
        "data-x-position": L.split("-")[1],
        style: {
          "--front-toast-height": `${((se = o.value[0]) == null ? void 0 : se.height) || 0}px`,
          "--width": `${v($x)}px`,
          "--gap": `${D.gap}px`,
          ...D.style,
          ...v(t).style,
          ...v(Ex)(D.offset, D.mobileOffset)
        }
      }, { ref_for: !0 }, D.$attrs, {
        onBlur: y,
        onFocus: h,
        onMouseenter: S,
        onMousemove: S,
        onMouseleave: x,
        onDragend: C,
        onPointerdown: b,
        onPointerup: $
      }), [(w(!0), T(Te, null, Pe(r(L, Z), (ie, ce) => {
        var G, le, q, N, Q, he, pe, ge, Ce, ye, K;
        return w(), de(Rx, {
          key: ie.id,
          heights: o.value,
          icons: D.icons,
          index: ce,
          toast: ie,
          defaultRichColors: D.richColors,
          duration: ((G = D.toastOptions) == null ? void 0 : G.duration) ?? D.duration,
          class: ne(((le = D.toastOptions) == null ? void 0 : le.class) ?? ""),
          descriptionClass: (q = D.toastOptions) == null ? void 0 : q.descriptionClass,
          invert: D.invert,
          visibleToasts: D.visibleToasts,
          closeButton: ((N = D.toastOptions) == null ? void 0 : N.closeButton) ?? D.closeButton,
          interacting: c.value,
          position: L,
          closeButtonPosition: ((Q = D.toastOptions) == null ? void 0 : Q.closeButtonPosition) ?? D.closeButtonPosition,
          style: Ve((he = D.toastOptions) == null ? void 0 : he.style),
          unstyled: (pe = D.toastOptions) == null ? void 0 : pe.unstyled,
          classes: (ge = D.toastOptions) == null ? void 0 : ge.classes,
          cancelButtonStyle: (Ce = D.toastOptions) == null ? void 0 : Ce.cancelButtonStyle,
          actionButtonStyle: (ye = D.toastOptions) == null ? void 0 : ye.actionButtonStyle,
          "close-button-aria-label": (K = D.toastOptions) == null ? void 0 : K.closeButtonAriaLabel,
          toasts: i.value[L],
          expandByDefault: D.expand,
          gap: D.gap,
          expanded: u.value[L] || !1,
          swipeDirections: n.swipeDirections,
          "onUpdate:heights": _,
          "onUpdate:height": A,
          onRemoveToast: k
        }, {
          "close-icon": fe(() => [U(D.$slots, "close-icon", {}, () => [oe(Nx)])]),
          "loading-icon": fe(() => [U(D.$slots, "loading-icon", {}, () => [oe(Yx, { visible: ie.type === "loading" }, null, 8, ["visible"])])]),
          "success-icon": fe(() => [U(D.$slots, "success-icon", {}, () => [oe(jx)])]),
          "error-icon": fe(() => [U(D.$slots, "error-icon", {}, () => [oe(rS)])]),
          "warning-icon": fe(() => [U(D.$slots, "warning-icon", {}, () => [oe(tS)])]),
          "info-icon": fe(() => [U(D.$slots, "info-icon", {}, () => [oe(Xx)])]),
          _: 2
        }, 1032, [
          "heights",
          "icons",
          "index",
          "toast",
          "defaultRichColors",
          "duration",
          "class",
          "descriptionClass",
          "invert",
          "visibleToasts",
          "closeButton",
          "interacting",
          "position",
          "closeButtonPosition",
          "style",
          "unstyled",
          "classes",
          "cancelButtonStyle",
          "actionButtonStyle",
          "close-button-aria-label",
          "toasts",
          "expandByDefault",
          "gap",
          "expanded",
          "swipeDirections"
        ]);
      }), 128))], 16, iS);
    }), 128))], 8, lS)], 2112));
  }
}), dS = cS;
const fS = /* @__PURE__ */ Se({
  __name: "VToaster",
  setup(e) {
    const n = Rd(), t = M(() => n.resolvedTheme);
    return (a, s) => (w(), de(v(dS), {
      duration: 4e3,
      theme: t.value,
      "toast-options": {
        unstyled: !0,
        classes: {
          toast: "toast-custom",
          title: "toast-title",
          description: "toast-description",
          actionButton: "toast-action",
          cancelButton: "toast-cancel",
          closeButton: "toast-close",
          error: "toast-error",
          success: "toast-success",
          warning: "toast-warning",
          info: "toast-info"
        }
      },
      "close-button": "",
      position: "top-right"
    }, null, 8, ["theme"]));
  }
}), xD = /* @__PURE__ */ je(fS, [["__scopeId", "data-v-9305e752"]]), hS = ["id"], mS = ["id", "aria-controls", "aria-expanded", "disabled", "onClick"], vS = { class: "v-expansion-panel-header__content" }, pS = { class: "v-expansion-panel-title" }, gS = {
  key: 0,
  class: "v-expansion-panel-subtitle"
}, yS = { class: "v-expansion-panel-header__icon-wrapper" }, bS = ["id", "aria-hidden", "aria-labelledby"], wS = { class: "v-expansion-panel-content__wrap" }, kS = { class: "v-expansion-panel-text" }, xS = /* @__PURE__ */ Se({
  __name: "VAccordion",
  props: /* @__PURE__ */ Ln({
    items: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !1 },
    accordion: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ln(["change"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = n, s = Or(), r = es(e, "modelValue"), l = (u) => r.value.includes(u), i = (u) => {
      r.value = u, a("change", u);
    }, o = (u, c) => {
      if (t.disabled || c) return;
      const f = l(u);
      if (t.accordion || !t.multiple) {
        i(f ? [] : [u]);
        return;
      }
      i(
        f ? r.value.filter((m) => m !== u) : [...r.value, u]
      );
    };
    return et(() => {
      if (r.value.length) return;
      const u = t.items.filter((c) => c.defaultOpen).map((c) => c.id);
      u.length && (r.value = t.accordion || !t.multiple ? [u[0]] : u);
    }), (u, c) => (w(), T("div", {
      id: v(s),
      class: ne([[
        `v-expansion-panels--${e.variant}`,
        {
          "v-expansion-panels--flat": e.flat,
          "v-expansion-panels--disabled": e.disabled
        }
      ], "v-expansion-panels"])
    }, [
      (w(!0), T(Te, null, Pe(e.items, (f, m) => (w(), T("div", {
        key: f.id,
        class: ne([{
          "v-expansion-panel--active": l(f.id),
          "v-expansion-panel--disabled": f.disabled || e.disabled
        }, "v-expansion-panel"])
      }, [
        E("button", {
          id: `${v(s)}-header-${f.id}`,
          "aria-controls": `${v(s)}-content-${f.id}`,
          "aria-expanded": l(f.id),
          disabled: f.disabled || e.disabled,
          class: "v-expansion-panel-header",
          type: "button",
          onClick: (d) => o(f.id, f.disabled)
        }, [
          U(u.$slots, `header-${f.id}`, {
            index: m,
            isOpen: l(f.id),
            item: f
          }, () => [
            U(u.$slots, "header", {
              index: m,
              isOpen: l(f.id),
              item: f
            }, () => [
              f.icon ? (w(), de(ke, {
                key: 0,
                icon: f.icon,
                class: "v-expansion-panel-header__icon"
              }, null, 8, ["icon"])) : P("", !0),
              E("div", vS, [
                E("div", pS, ue(f.title), 1),
                f.subtitle ? (w(), T("div", gS, ue(f.subtitle), 1)) : P("", !0)
              ]),
              E("div", yS, [
                oe(ke, {
                  class: ne(
                    l(f.id) ? "v-expansion-panel-header__expand-icon v-expansion-panel-header__expand-icon--active" : "v-expansion-panel-header__expand-icon"
                  ),
                  icon: "mdi:chevron-down"
                }, null, 8, ["class"])
              ])
            ], !0)
          ], !0)
        ], 8, mS),
        E("div", {
          id: `${v(s)}-content-${f.id}`,
          "aria-hidden": !l(f.id),
          "aria-labelledby": `${v(s)}-header-${f.id}`,
          class: "v-expansion-panel-content",
          role: "region"
        }, [
          E("div", wS, [
            U(u.$slots, `content-${f.id}`, {
              index: m,
              item: f
            }, () => [
              U(u.$slots, "content", {
                index: m,
                item: f
              }, () => [
                E("div", kS, ue(f.content), 1)
              ], !0)
            ], !0)
          ])
        ], 8, bS)
      ], 2))), 128))
    ], 10, hS));
  }
}), SD = /* @__PURE__ */ je(xS, [["__scopeId", "data-v-e6564450"]]), TD = /* @__PURE__ */ Se({
  __name: "VAnimatedBackground",
  setup(e) {
    const n = ee(null);
    let t, a = null;
    const s = [], r = (i) => {
      s.length = 0;
      const o = [
        "rgba(37, 99, 235, 0.3)",
        // primary
        "rgba(251, 191, 36, 0.3)",
        // accent
        "rgba(14, 165, 233, 0.3)",
        // info
        "rgba(34, 197, 94, 0.3)"
        // success
      ];
      for (let u = 0; u < 15; u++)
        s.push({
          x: Math.random() * i.width,
          y: Math.random() * i.height,
          radius: Math.random() * 200 + 100,
          vx: Math.random() - 0.5,
          vy: Math.random() - 0.5,
          color: o[u % o.length]
        });
    }, l = (i, o) => {
      o.clearRect(0, 0, i.width, i.height), s.forEach((u) => {
        u.x += u.vx, u.y += u.vy, (u.x < -u.radius || u.x > i.width + u.radius) && (u.vx *= -1), (u.y < -u.radius || u.y > i.height + u.radius) && (u.vy *= -1);
        const c = o.createRadialGradient(
          u.x,
          u.y,
          0,
          u.x,
          u.y,
          u.radius * 0.7
        ), f = u.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (f) {
          const [, m, d, p] = f;
          c.addColorStop(0, `rgba(${m}, ${d}, ${p}, 0.5)`), c.addColorStop(0.5, `rgba(${m}, ${d}, ${p}, 0.25)`), c.addColorStop(1, `rgba(${m}, ${d}, ${p}, 0)`);
        }
        o.fillStyle = c, o.beginPath(), o.arc(u.x, u.y, u.radius, 0, Math.PI * 2), o.fill();
      }), t = requestAnimationFrame(() => l(i, o));
    };
    return et(() => {
      const i = n.value;
      if (!i) return;
      const o = i.getContext("2d");
      if (!o) return;
      const u = () => {
        i && (i.width = window.innerWidth, i.height = window.innerHeight, s.length === 0 && r(i));
      };
      a = u, u(), window.addEventListener("resize", u), l(i, o);
    }), rn(() => {
      a && window.removeEventListener("resize", a), t && cancelAnimationFrame(t), s.length = 0;
    }), (i, o) => (w(), T(Te, null, [
      E("canvas", {
        ref_key: "canvasRef",
        ref: n,
        class: "fixed inset-0 z-10 pointer-events-none"
      }, null, 512),
      o[0] || (o[0] = E("div", { class: "fixed inset-0 z-10 bg-gradient-to-br from-primary/5 via-accent/5 to-info/5" }, null, -1))
    ], 64));
  }
}), SS = {
  key: 0,
  class: "v-card__loading"
}, TS = {
  key: 0,
  class: "v-card__header"
}, MS = { class: "v-card__header-content" }, $S = {
  key: 2,
  class: "v-card__header-text"
}, CS = {
  key: 0,
  class: "v-card__title"
}, DS = {
  key: 1,
  class: "v-card__subtitle"
}, OS = {
  key: 0,
  class: "v-card__description"
}, _S = { class: "v-card__content" }, ES = {
  key: 1,
  class: "v-card__footer"
}, IS = /* @__PURE__ */ Se({
  __name: "VCard",
  props: {
    title: { default: "" },
    subtitle: { default: "" },
    description: { default: "" },
    variant: { default: "default" },
    size: { default: "full" },
    radius: { default: "xl" },
    padding: { default: "sm" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    clickable: { type: Boolean },
    icon: { default: "" },
    as: { default: "div" },
    href: { default: "" },
    target: { default: "_self" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = M(() => t.title || t.subtitle || t.icon || !!c.header), r = M(() => !!c.footer), l = M(() => t.clickable || t.href || t.as === "button"), i = M(() => t.href ? "a" : t.as), o = M(() => {
      const m = ["v-card"];
      return m.push(`v-card--${t.variant}`), m.push(`v-card--${t.size}`), m.push(`v-card--radius-${t.radius}`), t.padding && m.push(`v-card--padding-${t.padding}`), t.disabled && m.push("v-card--disabled"), t.loading && m.push("v-card--loading"), l.value && m.push("v-card--interactive"), m;
    }), u = M(() => t.href ? {
      href: t.href,
      target: t.target,
      rel: t.target === "_blank" ? "noopener noreferrer" : void 0
    } : {}), c = Ht(), f = (m) => {
      if (t.disabled || t.loading) {
        m.preventDefault();
        return;
      }
      a("click", m);
    };
    return (m, d) => (w(), de(ht(i.value), rt({ class: o.value }, u.value, { onClick: f }), {
      default: fe(() => [
        e.loading ? (w(), T("div", SS, [
          U(m.$slots, "loading", {}, () => [
            oe(jr)
          ], !0)
        ])) : (w(), T(Te, { key: 1 }, [
          s.value ? (w(), T("header", TS, [
            U(m.$slots, "header", {}, () => [
              E("div", MS, [
                t.icon ? (w(), de(ke, {
                  key: 0,
                  icon: t.icon,
                  class: "v-card__icon"
                }, null, 8, ["icon"])) : e.icon && typeof e.icon != "string" ? (w(), de(ht(e.icon), {
                  key: 1,
                  class: "v-card__icon"
                })) : P("", !0),
                e.title || e.subtitle ? (w(), T("div", $S, [
                  e.title ? (w(), T("h3", CS, ue(e.title), 1)) : P("", !0),
                  e.subtitle ? (w(), T("p", DS, ue(e.subtitle), 1)) : P("", !0)
                ])) : P("", !0)
              ]),
              e.description ? (w(), T("p", OS, ue(e.description), 1)) : P("", !0)
            ], !0)
          ])) : P("", !0),
          E("main", _S, [
            U(m.$slots, "default", {}, void 0, !0)
          ]),
          r.value ? (w(), T("footer", ES, [
            U(m.$slots, "footer", {}, void 0, !0)
          ])) : P("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), PS = /* @__PURE__ */ je(IS, [["__scopeId", "data-v-6a462504"]]), AS = {
  key: 0,
  class: "space-y-4"
}, RS = {
  key: 0,
  class: "flex gap-3 items-start"
}, FS = { class: "flex-1" }, VS = {
  key: 0,
  class: "font-semibold text-mainText"
}, LS = {
  key: 1,
  class: "text-sm text-secondaryText mt-0.5"
}, NS = { class: "grid grid-cols-2 md:grid-cols-4 gap-3" }, BS = { class: "min-w-0" }, zS = { class: "font-medium text-sm text-mainText truncate" }, WS = {
  key: 0,
  class: "text-xs text-secondaryText truncate"
}, YS = {
  key: 1,
  class: "flex items-center gap-2 text-sm text-secondaryText pt-2 border-t border-base-400/30"
}, HS = {
  key: 1,
  class: "flex gap-3 items-start"
}, US = { class: "flex-1 text-sm leading-relaxed" }, qS = {
  key: 0,
  class: "font-semibold mb-1 text-mainText"
}, jS = {
  key: 1,
  class: "text-secondaryText"
}, GS = {
  key: 2,
  class: "text-secondaryText"
}, KS = {
  key: 0,
  class: "flex-shrink-0"
}, MD = /* @__PURE__ */ Se({
  __name: "VInfoNotice",
  props: {
    icon: { default: "lucide:info" },
    iconColor: { default: "primary" },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    card: { type: Boolean, default: !0 },
    size: { default: "50px" },
    features: { default: void 0 },
    hint: { default: void 0 }
  },
  setup(e) {
    const n = e, t = M(() => {
      const l = {
        primary: "text-primary",
        success: "text-success",
        warning: "text-warning",
        error: "text-error",
        info: "text-info",
        muted: "text-secondaryText"
      };
      return l[n.iconColor] || l.primary;
    }), a = (l) => ({
      primary: "bg-primary/10",
      success: "bg-success/10",
      warning: "bg-warning/10",
      error: "bg-error/10",
      info: "bg-info/10",
      muted: "bg-muted/10"
    })[l || "primary"], s = (l) => ({
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
      info: "text-info",
      muted: "text-secondaryText"
    })[l || "primary"], r = M(() => n.features && n.features.length > 0);
    return (l, i) => (w(), de(ht(e.card ? PS : "div"), {
      class: ne({ "p-4": !e.card })
    }, {
      default: fe(() => [
        r.value ? (w(), T("div", AS, [
          e.title || e.subtitle || l.$slots.title || l.$slots.subtitle ? (w(), T("div", RS, [
            U(l.$slots, "icon", {}, () => [
              oe(ke, {
                class: ne(t.value),
                icon: e.icon,
                size: 24
              }, null, 8, ["class", "icon"])
            ]),
            E("div", FS, [
              e.title || l.$slots.title ? (w(), T("p", VS, [
                U(l.$slots, "title", {}, () => [
                  Ue(ue(e.title), 1)
                ])
              ])) : P("", !0),
              e.subtitle || l.$slots.subtitle ? (w(), T("p", LS, [
                U(l.$slots, "subtitle", {}, () => [
                  Ue(ue(e.subtitle), 1)
                ])
              ])) : P("", !0)
            ])
          ])) : P("", !0),
          E("div", NS, [
            (w(!0), T(Te, null, Pe(e.features, (o, u) => (w(), T("div", {
              key: u,
              class: "flex items-center gap-3 p-3 rounded-lg bg-cardBg/50 border border-base-400/50"
            }, [
              E("div", {
                class: ne([a(o.color), "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"])
              }, [
                oe(ke, {
                  class: ne(s(o.color)),
                  icon: o.icon,
                  size: 20
                }, null, 8, ["class", "icon"])
              ], 2),
              E("div", BS, [
                E("p", zS, ue(o.title), 1),
                o.description ? (w(), T("p", WS, ue(o.description), 1)) : P("", !0)
              ])
            ]))), 128))
          ]),
          e.hint || l.$slots.hint ? (w(), T("div", YS, [
            oe(ke, {
              size: 16,
              class: "text-secondaryText flex-shrink-0",
              icon: "lucide:info"
            }),
            E("span", null, [
              U(l.$slots, "hint", {}, () => [
                Ue(ue(e.hint), 1)
              ])
            ])
          ])) : P("", !0)
        ])) : (w(), T("div", HS, [
          U(l.$slots, "icon", {}, () => [
            oe(ke, {
              class: ne(t.value),
              icon: e.icon,
              size: e.size
            }, null, 8, ["class", "icon", "size"])
          ]),
          E("div", US, [
            e.title || l.$slots.title ? (w(), T("p", qS, [
              U(l.$slots, "title", {}, () => [
                Ue(ue(e.title), 1)
              ])
            ])) : P("", !0),
            e.subtitle || l.$slots.subtitle ? (w(), T("p", jS, [
              U(l.$slots, "subtitle", {}, () => [
                Ue(ue(e.subtitle), 1)
              ])
            ])) : P("", !0),
            l.$slots.default ? (w(), T("div", GS, [
              U(l.$slots, "default")
            ])) : P("", !0)
          ]),
          l.$slots.actions ? (w(), T("div", KS, [
            U(l.$slots, "actions")
          ])) : P("", !0)
        ]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), ZS = { class: "scroll-panel overflow-y-auto p-2.5" }, XS = {
  key: 0,
  class: "scroll-panel__copy"
}, JS = ["aria-label"], QS = { class: "scroll-panel__copy-glyph" }, eT = { class: "scroll-panel__copy-glyph scroll-panel__copy-glyph--check" }, tT = /* @__PURE__ */ Se({
  __name: "VScrollPanel",
  props: {
    copyText: {},
    copyLabel: { default: "Copy to clipboard" }
  },
  setup(e) {
    const { copy: n, copied: t, isSupported: a } = w1({ copiedDuring: 2e3 });
    return (s, r) => (w(), T("div", ZS, [
      e.copyText !== void 0 && v(a) ? (w(), T("div", XS, [
        E("button", {
          "aria-label": v(t) ? "Copied" : e.copyLabel,
          class: ne([{ "scroll-panel__copy-btn--copied": v(t) }, "scroll-panel__copy-btn"]),
          type: "button",
          onClick: r[0] || (r[0] = (l) => v(n)(e.copyText))
        }, [
          E("span", QS, [
            oe(ke, {
              size: 14,
              icon: "lucide:copy"
            })
          ]),
          E("span", eT, [
            oe(ke, {
              size: 14,
              icon: "lucide:check"
            })
          ])
        ], 10, JS)
      ])) : P("", !0),
      U(s.$slots, "default", {}, void 0, !0)
    ]));
  }
}), $D = /* @__PURE__ */ je(tT, [["__scopeId", "data-v-8c1d5f79"]]), nT = { class: "v-tabs" }, aT = {
  key: 0,
  class: "v-tabs__header"
}, sT = {
  key: 0,
  "aria-busy": "true",
  class: "v-tabs__skeleton"
}, rT = { class: "v-tabs__list" }, lT = {
  "aria-label": "Tabs navigation",
  class: "v-tabs__nav",
  role: "tablist"
}, iT = ["aria-disabled", "aria-selected", "data-tab-id", "tabindex", "onClick", "onKeydown"], oT = { class: "v-tabs__tab-label" }, uT = {
  key: 0,
  class: "v-tabs__more"
}, cT = {
  key: 1,
  class: "v-tabs__actions"
}, dT = ["id"], fT = ["aria-labelledby"], hT = { class: "v-tabs__panel" }, mT = 70, vT = /* @__PURE__ */ Se({
  __name: "VTabs",
  props: {
    tabs: {},
    loading: { type: Boolean },
    reset: { type: Boolean },
    useHash: { type: Boolean, default: !0 },
    tabSelectionMode: { default: "auto" },
    actionsTargetId: { default: void 0 }
  },
  emits: ["tabSelected"],
  setup(e, { expose: n, emit: t }) {
    const a = Eu(), s = ai(), r = e, l = t, o = ee((() => {
      var C;
      if (r.useHash && (s != null && s.hash)) {
        const $ = s.hash.replace("#tab-", ""), _ = r.tabs.find((A) => String(A.id) === $);
        if (_)
          return _.id;
      }
      const x = r.tabs.find(($) => $.activeByDefault);
      return (x == null ? void 0 : x.id) || ((C = r.tabs[0]) == null ? void 0 : C.id);
    })()), u = M(() => r.tabs.find((x) => x.id === o.value)), c = (x, C = !0) => {
      const $ = r.tabs.find((A) => A.id === x);
      if (!$ || $.disabled) return;
      const _ = () => {
        o.value = x, r.useHash && C && s && a && s.hash !== `#tab-${x}` && a.push({
          hash: `#tab-${x}`,
          query: s.query
        });
      };
      r.tabSelectionMode === "controlled" ? l("tabSelected", {
        tabId: x,
        callback: _,
        tab: $
      }) : (_(), l("tabSelected", {
        tabId: x,
        callback: () => {
        },
        // Already switched, callback is no-op
        tab: $
      }));
    };
    We(
      () => r.reset,
      (x) => {
        x && r.tabs.length > 0 && c(r.tabs[0].id);
      }
    ), et(() => {
      const x = () => {
        r.useHash && s && a && s.hash !== `#tab-${o.value}` && a.replace({
          hash: `#tab-${o.value}`,
          query: s.query
        });
      }, C = r.tabs.find(($) => $.id === o.value);
      x(), l("tabSelected", {
        tabId: o.value,
        callback: () => {
        },
        // Already initialized, callback is no-op
        tab: C
      });
    });
    const f = (x) => o.value === x, m = ee(null), d = ee([...r.tabs]), p = ee([]), g = ee(/* @__PURE__ */ new Map()), k = () => {
      if (!m.value || r.tabs.length === 0) return;
      const x = m.value, C = x.offsetWidth;
      if (C === 0) return;
      x.querySelectorAll(".tab-button:not(.more-button)").forEach((Z) => {
        const se = Z.getAttribute("data-tab-id");
        if (!se) return;
        const ie = r.tabs.find((ce) => String(ce.id) === se);
        ie && Z && g.value.set(ie.id, Z.offsetWidth);
      });
      let _ = 0;
      const A = [];
      for (const Z of r.tabs) {
        const se = g.value.get(Z.id) || 150;
        A.push(se), _ += se;
      }
      if (_ <= C) {
        d.value = [...r.tabs], p.value = [];
        return;
      }
      const D = C - mT;
      let Y = 0, L = 0;
      for (let Z = 0; Z < r.tabs.length; Z++) {
        const se = A[Z];
        if (Y + se <= D)
          Y += se, L = Z + 1;
        else
          break;
      }
      d.value = r.tabs.slice(0, L), p.value = r.tabs.slice(L);
    }, y = M(() => p.value.map((x) => ({
      label: x.label,
      value: x.id,
      icon: x.icon,
      disabled: x.disabled,
      active: x.id === o.value
    }))), h = (x) => {
      c(x);
    };
    let b = null, S = null;
    return et(async () => {
      await Ze(), await Ze(), m.value && (k(), b = new ResizeObserver(() => {
        S && clearTimeout(S), S = setTimeout(() => {
          k();
        }, 100);
      }), b.observe(m.value));
    }), Is(() => {
      S && clearTimeout(S), b && m.value && (b.unobserve(m.value), b.disconnect());
    }), We(() => r.tabs, async () => {
      await Ze(), k();
    }, { deep: !0 }), n({
      currentTabId: o,
      selectTab: c
    }), (x, C) => (w(), T("div", nT, [
      r.tabs.length > 0 ? (w(), T("div", aT, [
        r.loading ? (w(), T("section", sT, [
          (w(!0), T(Te, null, Pe(r.tabs.length, ($) => (w(), T("div", {
            key: $,
            class: "v-tabs__skeleton-item"
          }))), 128))
        ])) : P("", !0),
        E("div", rT, [
          E("div", {
            ref_key: "tabsContainerRef",
            ref: m,
            class: "v-tabs__scroll"
          }, [
            E("nav", lT, [
              (w(!0), T(Te, null, Pe(d.value, ($) => (w(), T("button", {
                key: $.id,
                "aria-disabled": $.disabled,
                "aria-selected": f($.id),
                class: ne([
                  "v-tabs__tab",
                  {
                    "v-tabs__tab--active": f($.id),
                    "v-tabs__tab--disabled": $.disabled
                  },
                  $.styles
                ]),
                "data-tab-id": $.id,
                tabindex: $.disabled ? -1 : 0,
                role: "tab",
                type: "button",
                onClick: (_) => c($.id),
                onKeydown: [
                  Pt((_) => c($.id), ["enter"]),
                  Pt(Fe((_) => c($.id), ["prevent"]), ["space"])
                ]
              }, [
                $.icon ? (w(), de(ke, {
                  key: 1,
                  icon: $.icon,
                  class: "v-tabs__tab-icon"
                }, null, 8, ["icon"])) : U(x.$slots, `tab-icon-${$.id}`, { key: 0 }, void 0, !0),
                E("span", oT, ue($.label), 1)
              ], 42, iT))), 128))
            ])
          ], 512),
          p.value.length > 0 ? (w(), T("div", uT, [
            oe(Cr, {
              items: y.value,
              placement: "bottom-right",
              onSelect: h
            }, {
              trigger: fe(() => [
                oe(qt, { icon: "mdi:dots-horizontal" })
              ]),
              _: 1
            }, 8, ["items"])
          ])) : P("", !0)
        ]),
        x.$slots["tabs-right"] || e.actionsTargetId ? (w(), T("div", cT, [
          U(x.$slots, "tabs-right", { currentTabId: o.value }, void 0, !0),
          e.actionsTargetId ? (w(), T("div", {
            key: 0,
            id: e.actionsTargetId,
            class: "v-tabs__actions-target"
          }, null, 8, dT)) : P("", !0)
        ])) : P("", !0)
      ])) : P("", !0),
      r.loading ? P("", !0) : (w(), T("div", {
        key: 1,
        "aria-labelledby": `tab-${o.value}`,
        class: "v-tabs__content",
        role: "tabpanel"
      }, [
        E("div", hT, [
          U(x.$slots, `${o.value}`, {}, () => {
            var $;
            return [
              ($ = u.value) != null && $.component ? (w(), de(ht(u.value.component), { key: 0 })) : P("", !0)
            ];
          }, !0)
        ])
      ], 8, fT))
    ]));
  }
}), CD = /* @__PURE__ */ je(vT, [["__scopeId", "data-v-b840b472"]]), pT = ["title"], lu = /* @__PURE__ */ Se({
  __name: "TableCell",
  props: {
    value: {},
    align: { default: "left" },
    depth: { default: 0 },
    isFirstColumn: { type: Boolean, default: !1 },
    row: {},
    column: {},
    colIndex: {},
    rowIndex: {},
    interactive: { type: Boolean, default: !1 },
    isExpanded: { type: Boolean, default: !1 }
  },
  emits: ["toggle-expand"],
  setup(e, { emit: n }) {
    const t = n, a = Ht(), s = ea("tableCellMetadata", void 0), r = M(() => !e.row || !e.column || e.colIndex === void 0 || e.rowIndex === void 0 || !s ? null : s(e.row, e.column, e.colIndex, e.rowIndex)), l = M(() => {
      if (e.isFirstColumn && e.depth > 0)
        return `${e.depth * 24 + 16}px`;
    }), i = M(
      () => r.value ? r.value.formattedValue : e.value
    ), o = () => {
      if (!(e.interactive || a.default))
        return String(i.value);
    }, u = M(() => {
      var p;
      return !!((p = r.value) != null && p.isExpandable);
    }), c = M(() => !!e.row && !!e.column), f = M(() => {
      var p;
      return [
        {
          "v-table-cell--left": e.align === "left",
          "v-table-cell--center": e.align === "center",
          "v-table-cell--right": e.align === "right",
          "v-table-cell--indented": e.isFirstColumn && e.depth > 0
        },
        (p = r.value) == null ? void 0 : p.cssClass
      ];
    }), m = M(() => {
      var g, k;
      const p = (g = r.value) == null ? void 0 : g.indentStyle;
      return {
        paddingLeft: l.value,
        ...p ? { "--cell-indent": p.paddingLeft } : {},
        ...(k = r.value) == null ? void 0 : k.customStyle
      };
    }), d = () => {
      t("toggle-expand");
    };
    return (p, g) => (w(), T("div", {
      class: ne([f.value, "v-table-cell"]),
      style: Ve(m.value)
    }, [
      c.value ? (w(), T(Te, { key: 0 }, [
        U(p.$slots, "pin"),
        u.value ? (w(), T("button", {
          key: 0,
          class: "v-table-cell-expand-btn",
          onClick: Fe(d, ["stop"])
        }, [
          oe(v(ke), {
            icon: e.isExpanded ? "lucide:chevron-down" : "lucide:chevron-right",
            size: 18
          }, null, 8, ["icon"])
        ])) : P("", !0),
        E("span", {
          title: o(),
          class: ne([{ "v-table-cell-text--truncate": !e.interactive }, "v-table-cell-text"])
        }, [
          U(p.$slots, "default", {}, () => [
            Ue(ue(i.value), 1)
          ])
        ], 10, pT)
      ], 64)) : U(p.$slots, "default", { key: 1 })
    ], 6));
  }
}), gT = ["title"], yT = /* @__PURE__ */ Se({
  __name: "TableCellValue",
  props: {
    value: {},
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = M(() => e.interactive ? void 0 : String(e.value));
    return (t, a) => (w(), T("span", { title: n.value }, ue(e.value), 9, gT));
  }
}), bT = /* @__PURE__ */ Se({
  __name: "TableCheckboxCell",
  props: {
    checked: { type: Boolean },
    indeterminate: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = () => {
      t("toggle");
    };
    return (s, r) => (w(), T("div", {
      class: "v-table-checkbox-cell",
      onClick: r[0] || (r[0] = Fe(() => {
      }, ["stop"]))
    }, [
      oe(v(Uc), {
        disabled: e.disabled,
        indeterminate: e.indeterminate,
        "model-value": e.checked,
        "onUpdate:modelValue": a
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), wT = /* @__PURE__ */ je(bT, [["__scopeId", "data-v-499acbc1"]]);
function ls(e) {
  return new Promise((n, t) => {
    e.oncomplete = e.onsuccess = () => n(e.result), e.onabort = e.onerror = () => t(e.error);
  });
}
function Gd(e, n) {
  let t;
  const a = () => {
    if (t)
      return t;
    const s = indexedDB.open(e);
    return s.onupgradeneeded = () => s.result.createObjectStore(n), t = ls(s), t.then((r) => {
      r.onclose = () => t = void 0;
    }, () => {
    }), t;
  };
  return (s, r) => a().then((l) => r(l.transaction(n, s).objectStore(n)));
}
let kl;
function Gr() {
  return kl || (kl = Gd("keyval-store", "keyval")), kl;
}
function iu(e, n = Gr()) {
  return n("readonly", (t) => ls(t.get(e)));
}
function kT(e, n, t = Gr()) {
  return t("readwrite", (a) => (a.put(n, e), ls(a.transaction)));
}
function ou(e, n = Gr()) {
  return n("readwrite", (t) => (t.delete(e), ls(t.transaction)));
}
function xT(e, n) {
  return e.openCursor().onsuccess = function() {
    this.result && (n(this.result), this.result.continue());
  }, ls(e.transaction);
}
function uu(e = Gr()) {
  return e("readonly", (n) => {
    if (n.getAllKeys)
      return ls(n.getAllKeys());
    const t = [];
    return xT(n, (a) => t.push(a.key)).then(() => t);
  });
}
const ST = {
  deserialize: JSON.parse,
  dialect: "redis",
  serialize: JSON.stringify,
  dbName: "keyv",
  storeName: "keyv"
};
class TT {
  constructor(n) {
    this.ttlSupport = !1, this.namespace = "", this.opts = Object.assign({}, ST, n), this.store = Gd(this.opts.dbName, this.opts.storeName);
  }
  _getKey(n) {
    return this.namespace ? `${this.namespace}${n}` : n;
  }
  _innerKeyToKey(n) {
    return this.namespace && n.startsWith(this.namespace) ? n.slice(this.namespace.length) : n;
  }
  on(n, t) {
    return this;
  }
  async get(n) {
    try {
      const t = await iu(this._getKey(n), this.store);
      return t ?? void 0;
    } catch {
    }
  }
  async getMany(n) {
    return Promise.all(n.map((t) => this.get(t)));
  }
  /**
   * Note: `await kv.set()` will wait <options.writeDelay> millseconds to save to disk, it would be slow. Please remove `await` if you find performance issues.
   * @param key
   * @param value
   * @param ttl
   * @returns
   */
  async set(n, t, a) {
    return kT(this._getKey(n), t, this.store);
  }
  async delete(n) {
    let t = await this.has(n);
    return await ou(this._getKey(n), this.store), t;
  }
  async deleteMany(n) {
    return (await Promise.all(n.map((a) => this.delete(a)))).every((a) => a);
  }
  async clear() {
    let n = await uu(this.store), t = [];
    for (let a = 0; a < n.length; a++) {
      const s = n[a];
      typeof s == "string" && s.startsWith(this.namespace) && t.push(ou(s, this.store));
    }
    await Promise.all(t);
  }
  async has(n) {
    return await this.get(n) !== void 0;
  }
  disconnect() {
    return Promise.resolve();
  }
  async *iterator(n = this.namespace) {
    let t = await uu(this.store);
    for (let a = 0; a < t.length; a++) {
      let s = t[a];
      typeof s == "string" && (!n || s.startsWith(n)) && (yield [s, await iu(s, this.store)]);
    }
  }
}
class MT {
  constructor(n = "table-configs") {
    xe(this, "keyv");
    this.keyv = new TT({
      dbName: n,
      storeName: "keyv",
      namespace: n
    });
  }
  async get(n) {
    try {
      return await this.keyv.get(n) ?? null;
    } catch (t) {
      return console.error("IndexedDB get error:", t), null;
    }
  }
  async set(n, t) {
    try {
      await this.keyv.set(n, t);
    } catch (a) {
      throw console.error("IndexedDB set error:", a), a;
    }
  }
  async delete(n) {
    try {
      await this.keyv.delete(n);
    } catch (t) {
      throw console.error("IndexedDB delete error:", t), t;
    }
  }
  async clear() {
    try {
      await this.keyv.clear();
    } catch (n) {
      throw console.error("IndexedDB clear error:", n), n;
    }
  }
}
class cu {
  constructor(n = "localStorage") {
    xe(this, "storage");
    this.storage = n === "sessionStorage" ? sessionStorage : localStorage;
  }
  get(n) {
    try {
      const t = this.storage.getItem(n);
      return Promise.resolve(t ? JSON.parse(t) : null);
    } catch (t) {
      return console.error("WebStorage get error:", t), Promise.resolve(null);
    }
  }
  set(n, t) {
    try {
      return this.storage.setItem(n, JSON.stringify(t)), Promise.resolve();
    } catch (a) {
      return console.error("WebStorage set error:", a), a instanceof DOMException && a.name === "QuotaExceededError" && console.warn("Storage quota exceeded, consider using IndexedDB"), Promise.reject(a);
    }
  }
  delete(n) {
    try {
      return this.storage.removeItem(n), Promise.resolve();
    } catch (t) {
      return console.error("WebStorage delete error:", t), Promise.reject(t);
    }
  }
  clear() {
    try {
      return this.storage.clear(), Promise.resolve();
    } catch (n) {
      return console.error("WebStorage clear error:", n), Promise.reject(n);
    }
  }
}
function du(e = "indexedDB", n) {
  switch (e) {
    case "indexedDB":
      return new MT(n);
    case "localStorage":
      return new cu("localStorage");
    case "sessionStorage":
      return new cu("sessionStorage");
    default:
      throw new Error(`Unknown storage type: ${e}`);
  }
}
const da = class da {
  constructor() {
    xe(this, "adapter");
    xe(this, "storageType");
    this.storageType = "indexedDB", this.adapter = du(this.storageType, "table-configs");
  }
  static getInstance() {
    return da.instance || (da.instance = new da()), da.instance;
  }
  /**
     * Change storage type globally
     * Useful for testing or fallback scenarios
     */
  setStorageType(n, t) {
    this.storageType = n, this.adapter = du(n, t);
  }
  getStorageType() {
    return this.storageType;
  }
  getAdapter() {
    return this.adapter;
  }
  /**
     * Get table configuration
     */
  getTableConfig(n) {
    return this.adapter.get(n);
  }
  /**
     * Save table configuration
     */
  async setTableConfig(n, t) {
    await this.adapter.set(n, t);
  }
  /**
     * Delete table configuration
     */
  async deleteTableConfig(n) {
    await this.adapter.delete(n);
  }
  /**
     * Clear all table configurations
     */
  async clearAllConfigs() {
    await this.adapter.clear();
  }
};
xe(da, "instance");
let Ql = da;
const Qa = Ql.getInstance(), Dr = (e, n) => (n && Qa.setStorageType(n), Qa.getTableConfig(e)), Kd = async (e, n, t) => {
  t && Qa.setStorageType(t), await Qa.setTableConfig(e, n);
}, $T = { class: "column-picker" }, CT = { class: "column-picker-header" }, DT = { class: "column-picker-header-title" }, OT = { class: "column-picker-body" }, _T = { class: "column-picker-panel column-picker-panel--left" }, ET = { class: "column-picker-panel-header" }, IT = { class: "column-picker-panel-count" }, PT = { class: "cp-toolbar" }, AT = { class: "cp-search" }, RT = { class: "cp-sort-group" }, FT = { class: "column-picker-panel-list" }, VT = ["onClick"], LT = ["onClick"], NT = {
  key: 0,
  class: "cp-type-group-header"
}, BT = { class: "cp-type-group-label" }, zT = ["onClick"], WT = {
  key: 0,
  class: "cp-type-icon"
}, YT = { class: "cp-available-item-label" }, HT = {
  class: "cp-available-item-toggle",
  "aria-hidden": "true"
}, UT = ["onClick"], qT = {
  key: 0,
  class: "column-picker-empty"
}, jT = { class: "column-picker-panel column-picker-panel--right" }, GT = { class: "column-picker-panel-header" }, KT = { class: "column-picker-panel-search" }, ZT = { class: "column-picker-panel-list" }, XT = ["draggable", "onDragover", "onDragstart", "onDrop"], JT = { class: "cp-selected-item-drag" }, QT = {
  key: 0,
  class: "cp-type-icon"
}, eM = { class: "cp-selected-item-label" }, tM = ["title", "onClick"], nM = ["onClick"], aM = {
  key: 0,
  class: "column-picker-empty"
}, sM = { class: "column-picker-footer" }, rM = {
  key: 0,
  class: "column-picker-footer-hint column-picker-footer-hint--limit"
}, lM = {
  key: 1,
  class: "column-picker-footer-hint"
}, lr = 6, xl = 40, iM = /* @__PURE__ */ Se({
  __name: "TableColumnPicker",
  props: {
    groups: {},
    columns: {},
    originalColumns: {},
    loading: { type: Boolean, default: !1 },
    storageKey: {},
    storageType: {}
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(""), r = ee("alpha"), l = ee(/* @__PURE__ */ new Set()), i = ee(/* @__PURE__ */ new Set());
    We(r, () => {
      i.value = /* @__PURE__ */ new Set();
    });
    const o = (H) => {
      if (l.value.has(H)) {
        l.value.delete(H);
        const I = new Set(i.value);
        I.delete(H), i.value = I;
      } else
        l.value.add(H);
      l.value = new Set(l.value);
    }, u = M(() => {
      const H = s.value.trim().toLowerCase();
      return H ? t.groups.map((I) => ({
        ...I,
        items: I.items.filter((B) => B.label.toLowerCase().includes(H))
      })).filter((I) => I.items.length > 0) : t.groups;
    });
    We(s, (H) => {
      H.trim() ? l.value = new Set(u.value.map((I) => I.key)) : l.value = /* @__PURE__ */ new Set();
    });
    const c = ["text", "number", "boolean", "date", "sys"];
    function f(H) {
      const I = new Set(i.value);
      I.add(H), i.value = I;
    }
    function m(H) {
      const I = [...H.items];
      return r.value === "alpha" ? I.sort((B, X) => {
        const R = B.label.toLowerCase().trim(), te = X.label.toLowerCase().trim();
        return R < te ? -1 : R > te ? 1 : 0;
      }) : I.sort((B, X) => {
        const R = c.indexOf(B.icon ?? ""), te = c.indexOf(X.icon ?? "");
        return R - te;
      });
    }
    function d(H) {
      const I = m(H);
      return !s.value.trim() && !i.value.has(H.key) && I.length > lr ? I.slice(0, lr) : I;
    }
    function p(H) {
      return !s.value.trim() && !i.value.has(H.key) && m(H).length > lr;
    }
    const g = {
      text: "Text",
      number: "Number",
      boolean: "Boolean",
      date: "Date",
      sys: "File"
    };
    function k(H) {
      if (r.value !== "by-type")
        return H.map((X) => ({ isHeader: !1, key: X.key, item: X }));
      const I = [];
      let B;
      for (const X of H) {
        const R = X.icon ?? "";
        R !== B && (I.push({ isHeader: !0, key: `hdr-${R}`, typeKey: R }), B = R), I.push({ isHeader: !1, key: X.key, item: X });
      }
      return I;
    }
    const y = ee([]), h = ee([]), b = (H, I = !1) => {
      if (H) {
        const B = /* @__PURE__ */ new Map();
        t.groups.forEach((R) => R.items.forEach((te) => B.set(te.key, te)));
        const X = H.order.filter((R) => H.visible.includes(R)).map((R) => {
          var W, me;
          const te = t.columns.find((De) => De.key === R), O = B.get(R), z = (te == null ? void 0 : te.label) ?? (O == null ? void 0 : O.label) ?? ((W = H.labels) == null ? void 0 : W[R]) ?? R, V = (O == null ? void 0 : O.icon) ?? (te == null ? void 0 : te.icon), re = (me = H.fixed) == null ? void 0 : me[R];
          return { key: R, label: z, icon: V, fixed: re };
        }).filter((R) => R !== null);
        y.value = X;
      } else {
        const B = I ? t.originalColumns ?? t.columns : t.columns;
        y.value = B.map((X) => ({
          key: X.key,
          label: X.label,
          icon: X.icon,
          fixed: X.fixed
        }));
      }
      h.value = JSON.parse(JSON.stringify(y.value));
    };
    et(async () => {
      if (t.storageKey)
        try {
          const H = await Dr(t.storageKey, t.storageType);
          b(H);
          return;
        } catch (H) {
          console.error("[TableColumnPicker] Failed to load from storage:", H);
        }
      b();
    });
    const S = ee(""), x = M(() => {
      const H = S.value.trim().toLowerCase();
      return H ? y.value.filter((I) => I.label.toLowerCase().includes(H)) : y.value;
    }), C = M(() => new Set(y.value.map((H) => H.key))), $ = M(() => y.value.length >= xl), _ = M(
      () => t.groups.reduce((H, I) => H + I.items.length, 0)
    );
    function A(H) {
      return H.items.filter((I) => C.value.has(I.key)).length;
    }
    function D(H) {
      return H.items.length > 0 && H.items.every((I) => C.value.has(I.key));
    }
    function Y(H) {
      if (D(H)) {
        const I = new Set(H.items.map((B) => B.key));
        y.value = y.value.filter((B) => I.has(B.key) ? !!B.fixed : !0);
      } else {
        const I = H.items.filter((X) => !C.value.has(X.key)), B = xl - y.value.length;
        y.value = [
          ...y.value,
          ...I.slice(0, B).map((X) => ({ key: X.key, label: X.label, icon: X.icon }))
        ];
      }
    }
    const L = (H) => {
      !C.value.has(H.key) && !$.value && (y.value = [...y.value, { key: H.key, label: H.label, icon: H.icon }]);
    }, Z = (H) => {
      const I = y.value.find((B) => B.key === H);
      I != null && I.fixed || (y.value = y.value.filter((B) => B.key !== H));
    }, se = (H) => {
      C.value.has(H.key) ? Z(H.key) : L(H);
    }, ie = async () => {
      if (t.storageKey)
        try {
          await Qa.deleteTableConfig(t.storageKey);
        } catch (R) {
          console.error("[TableColumnPicker] Failed to clear storage:", R);
        }
      b(null, !0);
      const H = t.originalColumns ?? t.columns, I = new Map(H.map((R) => [R.key, R])), B = /* @__PURE__ */ new Map();
      t.groups.forEach((R) => R.items.forEach((te) => B.set(te.key, te)));
      const X = y.value.map((R) => {
        const te = I.get(R.key);
        if (te) return { ...te, fixed: R.fixed };
        const O = B.get(R.key);
        return { key: R.key, label: R.label, fixed: R.fixed, sortable: O == null ? void 0 : O.sortable, format: O == null ? void 0 : O.format };
      });
      a("update:visible-columns", X), a("close");
    }, ce = (H) => H === 0 || H === 1, G = (H) => H.fixed === "left", le = (H) => {
      !ce(H) || !y.value[H] || (y.value = y.value.map(
        (B, X) => X === H ? { ...B, fixed: B.fixed === "left" ? void 0 : "left" } : B
      ));
    }, q = () => {
      y.value = y.value.map(
        (H, I) => H.fixed === "left" && !ce(I) ? { ...H, fixed: void 0 } : H
      );
    }, N = ee(null), Q = ee(null), he = (H, I) => {
      S.value.trim() || (N.value = H, I.dataTransfer && (I.dataTransfer.effectAllowed = "move", I.dataTransfer.setData("text/html", "")));
    }, pe = (H, I) => {
      I.preventDefault(), I.dataTransfer && (I.dataTransfer.dropEffect = "move"), Q.value = H;
    }, ge = (H, I) => {
      if (I.preventDefault(), N.value === null || N.value === H) {
        N.value = null, Q.value = null;
        return;
      }
      const B = [...y.value], [X] = B.splice(N.value, 1);
      B.splice(H, 0, X), y.value = B, q(), N.value = null, Q.value = null;
    }, Ce = () => {
      N.value = null, Q.value = null;
    }, ye = async (H) => {
      if (!t.storageKey) return;
      const I = {}, B = {};
      H.forEach((R) => {
        R.fixed && (I[R.key] = R.fixed), B[R.key] = R.label;
      });
      const X = {
        visible: H.map((R) => R.key),
        order: H.map((R) => R.key),
        fixed: Object.keys(I).length > 0 ? I : void 0,
        labels: B
      };
      try {
        await Kd(t.storageKey, X, t.storageType);
      } catch (R) {
        console.error("[TableColumnPicker] Failed to save to storage:", R);
      }
    }, K = M(
      () => JSON.stringify(y.value) !== JSON.stringify(h.value)
    ), be = async () => {
      const H = new Map(t.columns.map((X) => [X.key, X])), I = /* @__PURE__ */ new Map();
      t.groups.forEach((X) => X.items.forEach((R) => I.set(R.key, R)));
      const B = y.value.map((X) => {
        const R = H.get(X.key);
        if (R) return { ...R, fixed: X.fixed };
        const te = I.get(X.key);
        return {
          key: X.key,
          label: X.label,
          fixed: X.fixed,
          sortable: te == null ? void 0 : te.sortable,
          format: te == null ? void 0 : te.format
        };
      });
      await ye(y.value), a("update:visible-columns", B), h.value = JSON.parse(JSON.stringify(y.value)), a("close");
    }, Me = () => {
      y.value = JSON.parse(JSON.stringify(h.value)), a("close");
    }, F = {
      text: { colorVar: "--color-secondaryText", lucideIcon: "lucide:align-left" },
      "multi-text": { colorVar: "--color-secondaryText", lucideIcon: "lucide:align-justify" },
      number: { colorVar: "--color-primary", lucideIcon: "lucide:hash" },
      decimal: { colorVar: "--color-primary", lucideIcon: "lucide:percent" },
      boolean: { colorVar: "--color-success", lucideIcon: "lucide:toggle-right" },
      date: { colorVar: "--color-warning", lucideIcon: "lucide:calendar" },
      datetime: { colorVar: "--color-warning", lucideIcon: "lucide:calendar-clock" },
      color: { colorVar: "--color-error", lucideIcon: "lucide:palette" },
      json: { colorVar: "--color-error", lucideIcon: "lucide:braces" },
      url: { colorVar: "--color-secondaryText", lucideIcon: "lucide:link" },
      link: { colorVar: "--color-secondaryText", lucideIcon: "lucide:external-link" },
      select: { colorVar: "--color-primary", lucideIcon: "lucide:list" },
      "multi-select": { colorVar: "--color-primary", lucideIcon: "lucide:list-checks" },
      asset: { colorVar: "--color-info", lucideIcon: "lucide:image" },
      "multi-asset": { colorVar: "--color-info", lucideIcon: "lucide:images" },
      sys: { colorVar: "--color-info", lucideIcon: "lucide:file" }
    };
    function j(H) {
      const I = H ? F[H] : void 0;
      return I ? { "--cp-type-color-raw": `var(${I.colorVar})` } : {};
    }
    return (H, I) => (w(), T("div", $T, [
      E("div", CT, [
        E("div", DT, [
          oe(v(ke), {
            size: 24,
            icon: "lucide:columns",
            variant: "link"
          }),
          I[5] || (I[5] = E("span", null, "Edit columns", -1))
        ]),
        E("button", {
          class: "column-picker-close-btn",
          title: "Close",
          onClick: Me
        }, [
          oe(v(ke), {
            size: 16,
            icon: "lucide:x"
          })
        ])
      ]),
      E("div", OT, [
        E("div", _T, [
          E("div", ET, [
            E("span", IT, ue(_.value) + " columns available ", 1)
          ]),
          E("div", PT, [
            E("div", AT, [
              oe(v(ke), {
                size: 11,
                icon: "lucide:search"
              }),
              mn(E("input", {
                "onUpdate:modelValue": I[0] || (I[0] = (B) => s.value = B),
                placeholder: "Search…"
              }, null, 512), [
                [pf, s.value]
              ])
            ]),
            E("div", RT, [
              E("button", {
                class: ne([{ "cp-sort-btn--active": r.value === "by-type" }, "cp-sort-btn"]),
                title: "Group by type",
                type: "button",
                onClick: I[1] || (I[1] = (B) => r.value = "by-type")
              }, [
                oe(v(ke), {
                  size: 10,
                  icon: "lucide:group"
                })
              ], 2),
              I[6] || (I[6] = E("div", { class: "cp-sort-divider" }, null, -1)),
              E("button", {
                class: ne([{ "cp-sort-btn--active": r.value === "alpha" }, "cp-sort-btn"]),
                title: "Sort alphabetically",
                type: "button",
                onClick: I[2] || (I[2] = (B) => r.value = "alpha")
              }, " A→Z ", 2)
            ])
          ]),
          E("div", FT, [
            e.loading ? (w(), T(Te, { key: 0 }, Pe(6, (B) => E("div", {
              key: B,
              class: "column-picker-skeleton"
            })), 64)) : (w(), T(Te, { key: 1 }, [
              (w(!0), T(Te, null, Pe(u.value, (B) => (w(), T("div", {
                key: B.key
              }, [
                E("div", {
                  class: "cp-group-header",
                  onClick: (X) => o(B.key)
                }, [
                  E("span", {
                    class: ne([{ "cp-group-label--has-selection": A(B) > 0 }, "cp-group-label"])
                  }, ue(B.label), 3),
                  E("button", {
                    class: "cp-group-select-btn",
                    type: "button",
                    onClick: Fe((X) => Y(B), ["stop"])
                  }, ue(D(B) ? "Deselect all" : "Select all"), 9, LT),
                  E("span", {
                    class: ne([A(B) > 0 ? "cp-group-badge--selected" : "cp-group-badge--empty", "cp-group-badge"])
                  }, ue(A(B)) + "/" + ue(B.items.length), 3),
                  oe(v(ke), {
                    class: ne([{ "cp-group-chevron--open": l.value.has(B.key) }, "cp-group-chevron"]),
                    size: 10,
                    icon: "lucide:chevron-right"
                  }, null, 8, ["class"])
                ], 8, VT),
                l.value.has(B.key) ? (w(), T(Te, { key: 0 }, [
                  (w(!0), T(Te, null, Pe(k(d(B)), (X) => {
                    var R;
                    return w(), T(Te, {
                      key: X.key
                    }, [
                      X.isHeader && X.typeKey ? (w(), T("div", NT, [
                        E("div", {
                          style: Ve({
                            background: F[X.typeKey] ? `rgb(var(${F[X.typeKey].colorVar}))` : "rgb(var(--color-secondaryText))"
                          }),
                          class: "cp-type-group-dot"
                        }, null, 4),
                        E("span", BT, ue(g[X.typeKey] ?? X.typeKey), 1)
                      ])) : X.item ? (w(), T("div", {
                        key: 1,
                        class: ne([{ "cp-available-item--selected": C.value.has(X.item.key) }, "cp-available-item"]),
                        style: Ve(j(X.item.icon)),
                        onClick: (te) => se(X.item)
                      }, [
                        X.item.icon ? (w(), T("div", WT, [
                          oe(v(ke), {
                            icon: ((R = F[X.item.icon]) == null ? void 0 : R.lucideIcon) ?? "lucide:help-circle",
                            size: 9
                          }, null, 8, ["icon"])
                        ])) : P("", !0),
                        E("span", YT, ue(X.item.label), 1),
                        E("span", HT, [
                          oe(v(ke), {
                            icon: C.value.has(X.item.key) ? "lucide:check" : "lucide:plus",
                            size: C.value.has(X.item.key) ? 10 : 9
                          }, null, 8, ["icon", "size"])
                        ])
                      ], 14, zT)) : P("", !0)
                    ], 64);
                  }), 128)),
                  p(B) ? (w(), T("button", {
                    key: 0,
                    class: "cp-show-more-btn",
                    type: "button",
                    onClick: Fe((X) => f(B.key), ["stop"])
                  }, " Show " + ue(m(B).length - lr) + " more ", 9, UT)) : P("", !0)
                ], 64)) : P("", !0)
              ]))), 128)),
              u.value.length === 0 ? (w(), T("div", qT, " No columns match your search ")) : P("", !0)
            ], 64))
          ])
        ]),
        I[8] || (I[8] = E("div", { class: "column-picker-divider" }, null, -1)),
        E("div", jT, [
          E("div", GT, [
            E("span", {
              class: ne([{ "column-picker-panel-count--limit": $.value }, "column-picker-panel-count"])
            }, ue(y.value.length) + " selected ", 3),
            E("button", {
              class: "column-picker-text-btn",
              onClick: ie
            }, [
              oe(v(ke), {
                size: 12,
                icon: "lucide:rotate-ccw"
              }),
              I[7] || (I[7] = Ue(" Reset to default ", -1))
            ])
          ]),
          E("div", KT, [
            oe(v($r), {
              modelValue: S.value,
              "onUpdate:modelValue": I[3] || (I[3] = (B) => S.value = B),
              name: "Search",
              placeholder: "Search by column name",
              type: "search"
            }, null, 8, ["modelValue"])
          ]),
          E("div", ZT, [
            (w(!0), T(Te, null, Pe(x.value, (B, X) => {
              var R;
              return w(), T("div", {
                key: B.key,
                class: ne([{
                  "cp-selected-item--dragging": N.value === X,
                  "cp-selected-item--drag-over": Q.value === X,
                  "cp-selected-item--locked": !!B.fixed
                }, "cp-selected-item"]),
                draggable: !B.fixed && !S.value,
                style: Ve(j(B.icon)),
                onDragend: Ce,
                onDragleave: I[4] || (I[4] = (te) => Q.value = null),
                onDragover: (te) => pe(X, te),
                onDragstart: (te) => he(X, te),
                onDrop: (te) => ge(X, te)
              }, [
                E("div", JT, [
                  oe(v(ke), {
                    size: 14,
                    icon: B.fixed ? "lucide:lock" : "lucide:grip-vertical"
                  }, null, 8, ["icon"])
                ]),
                B.icon ? (w(), T("div", QT, [
                  oe(v(ke), {
                    icon: ((R = F[B.icon]) == null ? void 0 : R.lucideIcon) ?? "lucide:help-circle",
                    size: 9
                  }, null, 8, ["icon"])
                ])) : P("", !0),
                E("span", eM, ue(B.label), 1),
                ce(X) && !S.value ? (w(), T("button", {
                  key: 1,
                  class: ne([{ "cp-selected-item-pin--active": G(B) }, "cp-selected-item-pin"]),
                  title: G(B) ? "Unpin column" : "Pin column to left",
                  onClick: Fe((te) => le(X), ["stop"])
                }, [
                  oe(v(ke), {
                    icon: G(B) ? "lucide:pin" : "lucide:pin-off",
                    size: 12
                  }, null, 8, ["icon"])
                ], 10, tM)) : P("", !0),
                B.fixed ? P("", !0) : (w(), T("button", {
                  key: 2,
                  class: "cp-selected-item-remove",
                  title: "Remove column",
                  onClick: (te) => Z(B.key)
                }, [
                  oe(v(ke), {
                    size: 12,
                    icon: "lucide:x"
                  })
                ], 8, nM))
              ], 46, XT);
            }), 128)),
            y.value.length === 0 ? (w(), T("div", aM, " No columns selected. Use the left panel to add columns. ")) : P("", !0)
          ])
        ])
      ]),
      E("div", sM, [
        $.value ? (w(), T("span", rM, [
          oe(v(ke), {
            size: 24,
            icon: "lucide:alert-circle"
          }),
          Ue(" Max " + ue(xl) + " columns reached ")
        ])) : (w(), T("span", lM, [
          oe(v(ke), {
            size: 24,
            icon: "lucide:info"
          }),
          I[9] || (I[9] = Ue(" Drag to reorder · Pin first 2 columns ", -1))
        ])),
        oe(v(qt), {
          disabled: !K.value,
          class: "h-[30px]",
          text: "Apply",
          variant: "primary",
          onClick: be
        }, null, 8, ["disabled"])
      ])
    ]));
  }
}), oM = { class: "column-setup" }, uM = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, cM = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, dM = {
  key: 2,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, fM = { class: "column-setup-toggle-count" }, hM = ["draggable", "onDragover", "onDragstart", "onDrop"], mM = {
  key: 0,
  class: "column-setup-item-drag"
}, vM = ["title", "onClick"], pM = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, gM = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, yM = ["title", "onClick"], bM = {
  key: 2,
  class: "column-setup-item-badge column-setup-item-badge--warning",
  title: "Fixed will be removed — move to top 2 positions"
}, wM = { class: "column-setup-footer" }, kM = {
  key: 0,
  class: "column-setup-hint"
}, xM = /* @__PURE__ */ Se({
  __name: "TableColumnSetup",
  props: {
    columns: {},
    config: { default: () => ({}) }
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = async () => {
      var q;
      if (!((q = t.config) != null && q.key)) return null;
      try {
        return await Dr(t.config.key, t.config.type);
      } catch (N) {
        return console.error("Failed to load column setup from storage:", N), null;
      }
    }, r = async (q) => {
      var N;
      if ((N = t.config) != null && N.key)
        try {
          const Q = {};
          q.forEach((pe) => {
            pe.fixed && (Q[pe.key] = pe.fixed);
          });
          const he = {
            visible: q.filter((pe) => pe.visible).map((pe) => pe.key),
            order: q.map((pe) => pe.key),
            fixed: Object.keys(Q).length > 0 ? Q : void 0
            // Only save if there are fixed columns
          };
          await Kd(t.config.key, he, t.config.type);
        } catch (Q) {
          console.error("Failed to save column setup to storage:", Q);
        }
    }, l = (q) => q.reduce((N, Q) => Q.children && Q.children.length > 0 ? [...N, ...l(Q.children)] : [...N, Q], []), i = (q) => {
      var he;
      const N = l(t.columns);
      if (q) {
        const { visible: pe, order: ge, fixed: Ce } = q, ye = new Map(N.map((be) => [be.key, be])), K = [];
        return ge.forEach((be, Me) => {
          const F = ye.get(be);
          F && (K.push({
            key: F.key,
            label: F.label,
            visible: pe.includes(be),
            order: Me,
            fixed: (Ce == null ? void 0 : Ce[be]) || F.fixed
            // Use saved fixed state, fallback to column's fixed
          }), ye.delete(be));
        }), ye.forEach((be) => {
          K.push({
            key: be.key,
            label: be.label,
            visible: !0,
            order: K.length,
            fixed: be.fixed
          });
        }), K;
      }
      const Q = (he = t.config) == null ? void 0 : he.initialVisible;
      return N.map((pe, ge) => ({
        key: pe.key,
        label: pe.label,
        // If initialVisible is provided, check if column is in the list
        // If not provided, all columns are visible by default
        visible: Q ? Q.includes(pe.key) : !0,
        order: ge,
        fixed: pe.fixed
      }));
    }, o = ee(i()), u = ee(JSON.parse(JSON.stringify(i())));
    s().then((q) => {
      if (q) {
        const N = i(q);
        o.value = N, u.value = JSON.parse(JSON.stringify(N));
      }
    });
    const c = M(() => JSON.stringify(o.value) !== JSON.stringify(u.value)), f = () => {
      const q = l(t.columns), Q = o.value.filter((he) => he.visible).sort((he, pe) => he.order - pe.order).map((he) => {
        const pe = q.find((ge) => ge.key === he.key);
        return pe ? {
          ...pe,
          fixed: he.fixed
        } : null;
      }).filter(Boolean);
      a("update:visible-columns", Q);
    };
    We(
      o,
      () => {
      },
      { deep: !0 }
    );
    const m = () => {
      r(o.value), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    }, d = M(() => o.value.every((q) => q.visible)), p = M(() => o.value.every((q) => !q.visible)), g = M(() => !d.value && !p.value), k = M(() => o.value.filter((q) => q.visible).length), y = ee(null), h = ee(null), b = ee(null), S = ee(null), x = (q) => {
      if (!b.value) return;
      const N = b.value.getBoundingClientRect(), Q = q.clientY, he = 50, pe = 10;
      Q < N.top + he && Q > N.top ? S.value || (S.value = window.setInterval(() => {
        b.value && b.value.scrollTop > 0 && (b.value.scrollTop -= pe);
      }, 16)) : Q > N.bottom - he && Q < N.bottom ? S.value || (S.value = window.setInterval(() => {
        if (b.value) {
          const ge = b.value.scrollHeight - b.value.clientHeight;
          b.value.scrollTop < ge && (b.value.scrollTop += pe);
        }
      }, 16)) : C();
    }, C = () => {
      S.value && (clearInterval(S.value), S.value = null);
    }, $ = (q, N) => {
      var Q;
      ((Q = t.config) == null ? void 0 : Q.allowReorder) !== !1 && (y.value = q, N.dataTransfer && (N.dataTransfer.effectAllowed = "move", N.dataTransfer.setData("text/html", "")));
    }, _ = (q, N) => {
      var Q;
      ((Q = t.config) == null ? void 0 : Q.allowReorder) !== !1 && (N.preventDefault(), N.dataTransfer && (N.dataTransfer.dropEffect = "move"), h.value = q, x(N));
    }, A = () => {
      h.value = null;
    }, D = (q, N) => {
      var pe;
      if (((pe = t.config) == null ? void 0 : pe.allowReorder) === !1) return;
      if (N.preventDefault(), C(), y.value === null || y.value === q) {
        y.value = null, h.value = null;
        return;
      }
      const Q = [...o.value], [he] = Q.splice(y.value, 1);
      Q.splice(q, 0, he), Q.forEach((ge, Ce) => {
        ge.order = Ce;
      }), o.value = Q, G(), y.value = null, h.value = null;
    }, Y = () => {
      y.value = null, h.value = null, C();
    }, L = (q) => {
      const N = o.value.find((Q) => Q.key === q);
      N && (N.visible = !N.visible);
    }, Z = () => {
      const q = !d.value;
      o.value.forEach((N) => {
        N.visible = q;
      });
    }, se = (q) => q === 0 || q === 1, ie = (q) => q.fixed === "left", ce = (q) => {
      if (!se(q)) return;
      const N = o.value[q];
      N && (N.fixed === "left" ? N.fixed = void 0 : N.fixed = "left");
    }, G = () => {
      o.value.forEach((q, N) => {
        q.fixed === "left" && !se(N) && (q.fixed = void 0);
      });
    }, le = async () => {
      var q;
      if ((q = t.config) != null && q.key)
        try {
          await Qa.deleteTableConfig(t.config.key);
        } catch (N) {
          console.error("Failed to clear storage:", N);
        }
      o.value = i(), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    };
    return (q, N) => {
      var Q;
      return w(), T("div", oM, [
        E("div", { class: "column-setup-header" }, [
          N[1] || (N[1] = E("span", { class: "column-setup-title" }, "Column Settings", -1)),
          E("button", {
            class: "column-setup-reset-btn",
            title: "Reset to default",
            onClick: le
          }, [...N[0] || (N[0] = [
            E("svg", {
              fill: "none",
              height: "13",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.3",
              viewBox: "0 0 24 24",
              width: "13"
            }, [
              E("polyline", { points: "1 4 1 10 7 10" }),
              E("path", { d: "M3.51 15a9 9 0 1 0 .49-4.5" })
            ], -1)
          ])])
        ]),
        E("div", {
          class: "column-setup-toggle-all",
          onClick: Z
        }, [
          E("div", {
            class: ne([{
              "column-setup-toggle-eye--none": p.value
            }, "column-setup-toggle-eye"])
          }, [
            d.value ? (w(), T("svg", uM, [...N[2] || (N[2] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              }, null, -1)
            ])])) : g.value ? (w(), T("svg", cM, [...N[3] || (N[3] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("line", {
                x1: "9",
                x2: "15",
                y1: "12",
                y2: "12"
              }, null, -1)
            ])])) : (w(), T("svg", dM, [...N[4] || (N[4] = [
              E("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
              E("line", {
                x1: "1",
                x2: "23",
                y1: "1",
                y2: "23"
              }, null, -1)
            ])]))
          ], 2),
          N[5] || (N[5] = E("span", { class: "column-setup-toggle-label" }, "Show all columns", -1)),
          E("span", fM, ue(k.value) + " / " + ue(o.value.length), 1)
        ]),
        E("div", {
          ref_key: "listRef",
          ref: b,
          class: "column-setup-list"
        }, [
          (w(!0), T(Te, null, Pe(o.value, (he, pe) => {
            var ge, Ce, ye;
            return w(), T("div", {
              key: he.key,
              class: ne([{
                "column-setup-item--dragging": y.value === pe,
                "column-setup-item--drag-over": h.value === pe,
                "column-setup-item--no-reorder": ((ge = e.config) == null ? void 0 : ge.allowReorder) === !1
              }, "column-setup-item"]),
              draggable: ((Ce = e.config) == null ? void 0 : Ce.allowReorder) !== !1,
              onDragend: Y,
              onDragleave: A,
              onDragover: (K) => _(pe, K),
              onDragstart: (K) => $(pe, K),
              onDrop: (K) => D(pe, K)
            }, [
              ((ye = e.config) == null ? void 0 : ye.allowReorder) !== !1 ? (w(), T("div", mM, [
                oe(v(ke), {
                  size: 16,
                  icon: "lucide:grip-vertical"
                })
              ])) : P("", !0),
              E("button", {
                class: ne([he.visible ? "column-setup-item-eye--visible" : "column-setup-item-eye--hidden", "column-setup-item-eye"]),
                title: he.visible ? "Hide column" : "Show column",
                onClick: Fe((K) => L(he.key), ["stop"])
              }, [
                he.visible ? (w(), T("svg", pM, [...N[6] || (N[6] = [
                  E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                  E("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  }, null, -1)
                ])])) : (w(), T("svg", gM, [...N[7] || (N[7] = [
                  E("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1),
                  E("line", {
                    x1: "1",
                    x2: "23",
                    y1: "1",
                    y2: "23"
                  }, null, -1)
                ])]))
              ], 10, vM),
              E("div", {
                class: ne([{ "column-setup-item-label--hidden": !he.visible }, "column-setup-item-label"])
              }, ue(he.label), 3),
              se(pe) ? (w(), T("button", {
                key: 1,
                class: ne([{ "column-setup-item-fixed-btn--active": ie(he) }, "column-setup-item-fixed-btn"]),
                title: ie(he) ? "Unpin column" : "Pin column to left",
                onClick: Fe((K) => ce(pe), ["stop"])
              }, [
                oe(v(ke), {
                  icon: ie(he) ? "lucide:pin" : "lucide:pin-off",
                  size: 16
                }, null, 8, ["icon"])
              ], 10, yM)) : P("", !0),
              he.fixed && !se(pe) ? (w(), T("div", bM, [
                oe(v(ke), {
                  size: 16,
                  icon: "lucide:triangle-alert"
                })
              ])) : P("", !0)
            ], 42, hM);
          }), 128))
        ], 512),
        E("div", wM, [
          ((Q = e.config) == null ? void 0 : Q.allowReorder) !== !1 ? (w(), T("span", kM, [
            oe(v(ke), {
              size: 11,
              icon: "lucide:grip-vertical"
            }),
            N[8] || (N[8] = Ue(" Drag to reorder ", -1))
          ])) : P("", !0),
          oe(v(qt), {
            disabled: !c.value,
            text: "Apply",
            variant: "primary",
            class: "h-[30px]",
            onClick: m
          }, null, 8, ["disabled"])
        ])
      ]);
    };
  }
}), SM = /* @__PURE__ */ je(xM, [["__scopeId", "data-v-4fee774a"]]), TM = { class: "v-table-empty-state" }, MM = { class: "v-table-empty-state-content" }, $M = {
  key: 0,
  class: "v-table-empty-state-icon"
}, CM = {
  key: 1,
  class: "v-table-empty-state-title"
}, DM = {
  key: 2,
  class: "v-table-empty-state-description"
}, OM = {
  key: 3,
  class: "v-table-empty-state-slot"
}, _M = /* @__PURE__ */ Se({
  __name: "TableEmptyState",
  props: {
    title: {},
    description: {},
    icon: {}
  },
  setup(e) {
    return (n, t) => (w(), T("div", TM, [
      E("div", MM, [
        e.icon ? (w(), T("div", $M, [
          oe(v(ke), {
            icon: e.icon,
            size: 48
          }, null, 8, ["icon"])
        ])) : P("", !0),
        e.title ? (w(), T("h3", CM, ue(e.title), 1)) : P("", !0),
        e.description ? (w(), T("p", DM, ue(e.description), 1)) : P("", !0),
        n.$slots.default ? (w(), T("div", OM, [
          U(n.$slots, "default", {}, void 0, !0)
        ])) : P("", !0)
      ])
    ]));
  }
}), EM = /* @__PURE__ */ je(_M, [["__scopeId", "data-v-0cf402c5"]]), IM = ["aria-label", "title"], PM = /* @__PURE__ */ Se({
  __name: "TableFullscreenToggle",
  props: {
    isFullscreen: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = M(() => e.isFullscreen ? "Collapse table" : "Expand table"), s = M(() => e.isFullscreen ? "lucide:minimize-2" : "lucide:maximize-2");
    return (r, l) => (w(), T("button", {
      "aria-label": a.value,
      class: ne([{ "v-table-fullscreen-toggle--active": e.isFullscreen }, "v-table-fullscreen-toggle"]),
      title: a.value,
      type: "button",
      onClick: l[0] || (l[0] = (i) => t("toggle"))
    }, [
      oe(v(ke), {
        icon: s.value,
        size: 15
      }, null, 8, ["icon"])
    ], 10, IM));
  }
}), AM = /* @__PURE__ */ Se({
  __name: "TableHeaderCheckbox",
  props: {
    state: {},
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = () => {
      t.disabled || a("toggle");
    };
    return (r, l) => (w(), T("div", {
      class: "v-table-header-checkbox-cell",
      onClick: l[0] || (l[0] = Fe(() => {
      }, ["stop"]))
    }, [
      oe(v(Uc), {
        disabled: e.disabled,
        indeterminate: e.state === "indeterminate",
        "model-value": e.state === "checked",
        "onUpdate:modelValue": s
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), RM = /* @__PURE__ */ je(AM, [["__scopeId", "data-v-6525801e"]]), FM = ["aria-label", "aria-pressed"], Zd = /* @__PURE__ */ Se({
  __name: "TablePinButton",
  props: {
    pinned: { type: Boolean },
    label: {}
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = M(() => e.pinned ? `Unpin ${e.label}` : `Pin ${e.label}`), s = (r) => {
      r.stopPropagation(), t("toggle");
    };
    return (r, l) => (w(), T("button", {
      "aria-label": a.value,
      "aria-pressed": e.pinned,
      class: ne([{ "v-table-pin-button--active": e.pinned }, "v-table-pin-button"]),
      type: "button",
      onClick: s,
      onMousedown: l[0] || (l[0] = Fe(() => {
      }, ["stop"]))
    }, [
      oe(v(ke), {
        icon: e.pinned ? "lucide:x" : "lucide:pin",
        size: 13
      }, null, 8, ["icon"])
    ], 42, FM));
  }
}), VM = { class: "v-table-header-content" }, LM = ["title"], NM = { class: "items-center justify-center flex p-0 w-[16px]" }, BM = ["title"], zM = ["aria-label"], WM = /* @__PURE__ */ Se({
  __name: "TableHeader",
  props: {
    column: {},
    label: {},
    align: { default: "left" },
    columnKey: {},
    resizable: { type: Boolean, default: !0 },
    isSorted: { type: Boolean, default: !1 },
    sortOrder: { default: null },
    sortIndex: { default: -1 }
  },
  emits: ["sort-click", "resize-start", "resize-dblclick"],
  setup(e, { emit: n }) {
    const t = ea("tableSlots", {}), a = ea("tableHighlight", null), s = e, r = n, l = M(() => !s.isSorted || !s.sortOrder ? "lucide:arrow-up-down" : s.sortOrder === "asc" ? "lucide:arrow-up" : "lucide:arrow-down"), i = M(() => s.isSorted ? "v-sort-icon v-sort-icon--active" : "v-sort-icon"), o = (d) => {
      s.column.sortable && (d.stopPropagation(), r("sort-click"));
    }, u = (d) => {
      s.column.onHeaderClick && (d.stopPropagation(), s.column.onHeaderClick({
        column: s.column,
        columnKey: s.columnKey,
        event: d
      }));
    }, c = (d) => {
      r("resize-start", s.columnKey, d);
    }, f = () => {
      r("resize-dblclick", s.columnKey);
    }, m = (d) => {
      s.column.sortable && (d.key === "Enter" || d.key === " ") && (d.preventDefault(), r("sort-click"));
    };
    return (d, p) => {
      var g;
      return w(), T("div", {
        class: ne([{
          "v-table-header-cell--left": e.align === "left",
          "v-table-header-cell--center": e.align === "center",
          "v-table-header-cell--right": e.align === "right",
          "v-table-header-cell--sortable": e.column.sortable,
          "v-table-header-cell--clickable": e.column.onHeaderClick
        }, "v-table-header-cell"])
      }, [
        E("div", VM, [
          E("div", {
            class: ne([{ "v-table-header-label-wrapper--clickable": e.column.onHeaderClick }, "v-table-header-label-wrapper"]),
            onClick: u
          }, [
            U(d.$slots, "default", {
              column: e.column,
              isSorted: e.isSorted,
              sortOrder: e.sortOrder
            }, () => [
              E("span", {
                title: e.label,
                class: "v-table-header-label"
              }, ue(e.label), 9, LM)
            ], !0),
            U(d.$slots, "icon", { column: e.column }, void 0, !0),
            e.column.tooltip ? (w(), de(v(Ja), {
              key: 0,
              text: e.column.tooltip,
              placement: "top",
              "tooltip-class": "bg-cardBg opacity-1 w-[300px]"
            }, {
              default: fe(() => [
                E("div", NM, [
                  oe(v(ke), {
                    size: 14,
                    class: "v-table-header-info-icon",
                    icon: "lucide:info"
                  })
                ])
              ]),
              _: 1
            }, 8, ["text"])) : P("", !0),
            e.column.onHeaderClick ? (w(), T("div", {
              key: 1,
              title: `Click to interact with ${e.label}`,
              class: "v-table-header-click-indicator"
            }, [
              oe(v(ke), {
                size: 14,
                class: "click-indicator-icon",
                icon: "lucide:mouse-pointer-click"
              })
            ], 8, BM)) : P("", !0)
          ], 2),
          e.column.sortable ? (w(), T("div", {
            key: 0,
            "aria-label": `Sort by ${e.label}`,
            tabindex: 0,
            class: "v-table-header-sort",
            role: "button",
            onClick: o,
            onKeydown: m
          }, [
            oe(v(ke), {
              class: ne(i.value),
              icon: l.value,
              size: 16
            }, null, 8, ["class", "icon"])
          ], 40, zM)) : P("", !0),
          v(t).headerCellCustomAction ? (w(), de(ht(v(t).headerCellCustomAction), {
            key: 1,
            column: e.column
          }, null, 8, ["column"])) : P("", !0),
          (g = v(a)) != null && g.columnEnabled.value ? (w(), de(Zd, {
            key: 2,
            label: e.label,
            pinned: v(a).isColumnPinned(e.columnKey),
            onToggle: p[0] || (p[0] = (k) => v(a).toggleColumn(e.columnKey))
          }, null, 8, ["label", "pinned"])) : P("", !0)
        ]),
        e.resizable ? (w(), T("div", {
          key: 0,
          class: "v-table-resize-handle",
          onMousedown: Fe(c, ["stop"]),
          onDblclick: Fe(f, ["stop"])
        }, [...p[1] || (p[1] = [
          E("div", { class: "v-table-resize-indicator" }, [
            E("div", { class: "v-table-resize-line" }),
            E("div", { class: "v-table-resize-line" })
          ], -1),
          E("div", { class: "v-table-resize-divider" }, null, -1)
        ])], 32)) : P("", !0)
      ], 2);
    };
  }
}), Xd = /* @__PURE__ */ je(WM, [["__scopeId", "data-v-bd73d8e9"]]), YM = { class: "v-table-header-group-label" }, HM = /* @__PURE__ */ Se({
  __name: "TableHeaderGroup",
  props: {
    cell: {},
    groupWidth: {}
  },
  setup(e) {
    return (n, t) => (w(), T("div", {
      class: ne([{
        "v-table-header-group--left": e.cell.column.align === "left",
        "v-table-header-group--center": e.cell.column.align === "center",
        "v-table-header-group--right": e.cell.column.align === "right"
      }, "v-table-header-group"])
    }, [
      E("span", YM, ue(e.cell.label), 1)
    ], 2));
  }
}), UM = /* @__PURE__ */ Se({
  __name: "TableHeaderGrouped",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getGroupWidth: { type: Function },
    getGroupFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, r = (i) => {
      a("resize-dblclick", i);
    }, l = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (w(!0), T(Te, null, Pe(e.columns, (u, c) => (w(), T("div", {
      key: `header-level-${c}`,
      class: ne([`v-table-header-row-level-${c}`, "v-table-header-row"])
    }, [
      c === 0 ? U(i.$slots, "checkbox-header", { key: 0 }) : P("", !0),
      (w(!0), T(Te, null, Pe(u, (f) => (w(), T(Te, {
        key: f.key
      }, [
        f.isGroup ? (w(), de(HM, {
          key: 0,
          cell: f,
          class: ne(e.getColumnClasses(f.column)),
          "group-width": e.getGroupWidth(f.column),
          style: Ve({
            gridColumn: `span ${f.colspan}`,
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getGroupFixedStyles(f.column)
          })
        }, null, 8, ["cell", "class", "group-width", "style"])) : (w(), de(Xd, {
          key: 1,
          align: f.column.align,
          class: ne([
            e.getColumnClasses(f.column),
            {
              "v-table-header-cell--grouped": c > 0,
              "v-table-header-cell--rowspan": f.rowspan > 1
            }
          ]),
          column: f.column,
          "column-key": f.column.key,
          "is-sorted": e.getSortState(f.column.key).isSorted,
          label: f.label,
          resizable: t.isColumnResizable(f.column),
          "sort-index": e.getSortState(f.column.key).index,
          "sort-order": e.getSortState(f.column.key).order,
          style: Ve({
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getFixedStyles(f.column)
          }),
          onSortClick: (m) => l(f.column),
          onResizeStart: s,
          onResizeDblclick: r
        }, dt({ _: 2 }, [
          i.$slots[`header-icon-${f.column.key}`] ? {
            name: "icon",
            fn: fe((m) => [
              U(i.$slots, `header-icon-${f.column.key}`, rt({ ref_for: !0 }, m))
            ]),
            key: "0"
          } : void 0,
          i.$slots[`header-${f.column.key}`] ? {
            name: "default",
            fn: fe((m) => [
              U(i.$slots, `header-${f.column.key}`, rt({ ref_for: !0 }, m))
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))
      ], 64))), 128))
    ], 2))), 128));
  }
}), qM = { class: "v-table-header-row" }, jM = /* @__PURE__ */ Se({
  __name: "TableHeaderSimple",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, r = (i) => {
      a("resize-dblclick", i);
    }, l = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (w(), T("div", qM, [
      U(i.$slots, "checkbox-header"),
      (w(!0), T(Te, null, Pe(e.columns, (u) => (w(), de(Xd, {
        key: u.key,
        align: u.align,
        class: ne(e.getColumnClasses(u)),
        column: u,
        "column-key": u.key,
        "is-sorted": e.getSortState(u.key).isSorted,
        label: u.label,
        resizable: t.isColumnResizable(u),
        "sort-index": e.getSortState(u.key).index,
        "sort-order": e.getSortState(u.key).order,
        style: Ve(e.getFixedStyles(u)),
        onSortClick: (c) => l(u),
        onResizeStart: s,
        onResizeDblclick: r
      }, dt({ _: 2 }, [
        i.$slots[`header-icon-${u.key}`] ? {
          name: "icon",
          fn: fe((c) => [
            U(i.$slots, `header-icon-${u.key}`, rt({ ref_for: !0 }, c))
          ]),
          key: "0"
        } : void 0,
        i.$slots[`header-${u.key}`] ? {
          name: "default",
          fn: fe((c) => [
            U(i.$slots, `header-${u.key}`, rt({ ref_for: !0 }, c))
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))), 128))
    ]));
  }
}), GM = {
  key: 0,
  class: "v-table-loading-overlay"
}, KM = { class: "v-table-loading-spinner" }, ZM = /* @__PURE__ */ Se({
  __name: "TableLoadingOverlay",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (w(), de(Dt, { name: "fade" }, {
      default: fe(() => [
        e.loading ? (w(), T("div", GM, [
          t[0] || (t[0] = E("div", { class: "v-table-loading-backdrop" }, null, -1)),
          E("div", KM, [
            oe(v(jr), {
              size: "large",
              variant: "primary"
            })
          ])
        ])) : P("", !0)
      ]),
      _: 1
    }));
  }
}), XM = { class: "v-table-pagination" }, JM = { class: "v-table-pagination-info" }, QM = { class: "v-table-pagination-info-highlight" }, e$ = { class: "v-table-pagination-info-highlight" }, t$ = { class: "v-table-pagination-controls" }, n$ = ["disabled"], a$ = ["disabled", "onClick"], s$ = {
  key: 1,
  class: "v-table-pagination-ellipsis"
}, r$ = ["disabled"], l$ = {
  key: 0,
  class: "v-table-pagination-size"
}, i$ = ["disabled", "value"], o$ = ["value"], u$ = /* @__PURE__ */ Se({
  __name: "TablePagination",
  props: {
    page: {},
    pageSize: {},
    total: {},
    pageSizeOptions: { default: () => [10, 25, 50, 100] },
    showSizeChanger: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = M(() => Math.ceil(t.total / t.pageSize)), r = M(() => t.total === 0 ? 0 : Ua((t.page - 1) * t.pageSize + 1)), l = M(() => {
      const p = t.page * t.pageSize;
      return Ua(Math.min(p, t.total));
    }), i = M(() => {
      const p = [], g = s.value, k = t.page;
      if (g <= 7) {
        for (let y = 1; y <= g; y++)
          p.push(y);
        return p;
      }
      return p.push(1), k <= 3 ? (p.push(2, 3, 4), p.push("ellipsis"), p.push(g)) : k >= g - 2 ? (p.push("ellipsis"), p.push(g - 3, g - 2, g - 1, g)) : (p.push("ellipsis"), p.push(k - 1, k, k + 1), p.push("ellipsis"), p.push(g)), p;
    }), o = (p) => {
      t.loading || p !== t.page && (p < 1 || p > s.value || a("page-change", { page: p, pageSize: t.pageSize }));
    }, u = () => {
      t.page > 1 && o(t.page - 1);
    }, c = () => {
      t.page < s.value && o(t.page + 1);
    }, f = (p) => {
      t.loading || p !== t.pageSize && a("page-change", { page: 1, pageSize: p });
    }, m = M(() => t.loading || t.page <= 1), d = M(() => t.loading || t.page >= s.value);
    return (p, g) => (w(), T("div", XM, [
      E("div", JM, [
        g[1] || (g[1] = Ue(" Showing ", -1)),
        E("span", QM, ue(r.value) + "–" + ue(l.value), 1),
        g[2] || (g[2] = Ue(" of ", -1)),
        E("span", e$, ue(v(Ua)(e.total)), 1)
      ]),
      E("div", t$, [
        E("button", {
          disabled: m.value,
          "aria-label": "Previous page",
          class: "v-table-pagination-btn",
          onClick: u
        }, [
          oe(v(ke), {
            size: 18,
            icon: "lucide:chevron-left"
          })
        ], 8, n$),
        (w(!0), T(Te, null, Pe(i.value, (k, y) => (w(), T(Te, { key: y }, [
          k !== "ellipsis" ? (w(), T("button", {
            key: 0,
            class: ne([{ "v-table-pagination-btn--active": k === e.page }, "v-table-pagination-btn"]),
            disabled: e.loading,
            onClick: (h) => o(k)
          }, ue(k), 11, a$)) : (w(), T("span", s$, " ... "))
        ], 64))), 128)),
        E("button", {
          disabled: d.value,
          "aria-label": "Next page",
          class: "v-table-pagination-btn",
          onClick: c
        }, [
          oe(v(ke), {
            size: 18,
            icon: "lucide:chevron-right"
          })
        ], 8, r$)
      ]),
      e.showSizeChanger ? (w(), T("div", l$, [
        g[3] || (g[3] = E("label", { for: "pagination-size" }, "Rows:", -1)),
        E("select", {
          id: "pagination-size",
          disabled: e.loading,
          value: e.pageSize,
          onChange: g[0] || (g[0] = (k) => f(Number(k.target.value)))
        }, [
          (w(!0), T(Te, null, Pe(e.pageSizeOptions, (k) => (w(), T("option", {
            key: k,
            value: k
          }, ue(k), 9, o$))), 128))
        ], 40, i$)
      ])) : P("", !0)
    ]));
  }
}), c$ = /* @__PURE__ */ je(u$, [["__scopeId", "data-v-d308e929"]]), d$ = { class: "v-toolbar v-toolbar--split" }, f$ = { class: "v-toolbar-split-left" }, h$ = { key: 0 }, m$ = { class: "v-toolbar-title" }, v$ = {
  key: 0,
  class: "v-toolbar-subtitle"
}, p$ = {
  key: 0,
  class: "v-toolbar-search-split flex h-full items-center"
}, g$ = { class: "v-toolbar-split-right" }, y$ = /* @__PURE__ */ Se({
  __name: "TableToolbar",
  props: {
    config: { default: void 0 },
    search: { default: "" }
  },
  emits: ["update:search", "refresh", "reset-sort", "export"],
  setup(e, { emit: n }) {
    const t = ea("tableSlots", {}), a = e, s = n, r = M({
      get: () => a.search,
      set: (h) => s("update:search", h)
    }), l = M(() => {
      var h;
      return (h = a.config) != null && h.search ? typeof a.config.search == "boolean" ? { placeholder: "Search..." } : a.config.search : null;
    }), i = M(() => {
      var b, S;
      const h = (S = (b = a.config) == null ? void 0 : b.actions) == null ? void 0 : S.refresh;
      return h ? typeof h == "object" ? { loading: h.loading ?? !1 } : { loading: !1 } : null;
    }), o = M(() => {
      var b, S;
      const h = (S = (b = a.config) == null ? void 0 : b.actions) == null ? void 0 : S.export;
      return !h || !h ? null : typeof h == "object" ? {
        mode: h.mode,
        formats: h.formats || [],
        selectedOnly: h.selectedOnly ?? !1,
        loading: h.loading ?? !1
      } : {
        mode: h,
        formats: [],
        selectedOnly: !1,
        loading: !1
      };
    }), u = M(() => o.value !== null), c = M(() => {
      var h;
      return ((h = o.value) == null ? void 0 : h.loading) || !1;
    }), f = M(() => {
      var h;
      return ((h = o.value) == null ? void 0 : h.formats) || [];
    }), m = M(() => f.value.some((h) => h.loading)), d = M(() => {
      var h;
      return (h = o.value) == null ? void 0 : h.mode;
    }), p = () => {
      s("refresh");
    }, g = () => {
      s("reset-sort");
    }, k = (h) => {
      var b;
      s("export", String(h), (b = o.value) == null ? void 0 : b.selectedOnly);
    }, y = () => {
      var h;
      s("export", "csv", (h = o.value) == null ? void 0 : h.selectedOnly);
    };
    return (h, b) => {
      var S, x, C, $, _, A;
      return w(), T("div", d$, [
        E("div", f$, [
          v(t).toolbarTitle ? (w(), de(ht(v(t).toolbarTitle), { key: 0 })) : U(h.$slots, "title", { key: 1 }, () => {
            var D;
            return [
              (D = e.config) != null && D.title ? (w(), T("div", h$, [
                E("h3", m$, ue(e.config.title), 1),
                e.config.subtitle ? (w(), T("p", v$, ue(e.config.subtitle), 1)) : P("", !0)
              ])) : P("", !0)
            ];
          }),
          v(t).toolbarSearch ? (w(), de(ht(v(t).toolbarSearch), { key: 2 })) : U(h.$slots, "search", { key: 3 }, () => [
            l.value ? (w(), T("div", p$, [
              b[1] || (b[1] = E("span", { class: "w-px h-5 bg-base-300 ml-[1px] mr-4" }, null, -1)),
              oe(v($r), {
                modelValue: r.value,
                "onUpdate:modelValue": b[0] || (b[0] = (D) => r.value = D),
                name: l.value.placeholder,
                placeholder: l.value.placeholder,
                class: "min-w-[300px]",
                debounce: "",
                type: "search"
              }, null, 8, ["modelValue", "name", "placeholder"])
            ])) : P("", !0)
          ]),
          v(t).toolbarFilters ? (w(), de(ht(v(t).toolbarFilters), { key: 4 })) : U(h.$slots, "filters", { key: 5 })
        ]),
        E("div", g$, [
          v(t).toolbarActions ? (w(), de(ht(v(t).toolbarActions), { key: 0 })) : U(h.$slots, "actions", { key: 1 }),
          i.value ? (w(), de(v(qt), {
            key: 2,
            loading: i.value.loading,
            icon: "lucide:refresh-cw",
            variant: "default",
            onClick: p
          }, null, 8, ["loading"])) : P("", !0),
          (x = (S = e.config) == null ? void 0 : S.actions) != null && x.resetSort ? (w(), de(v(qt), {
            key: 3,
            icon: "lucide:arrow-up-down",
            text: "Reset Sort",
            variant: "default",
            onClick: g
          })) : P("", !0),
          u.value && d.value === "single" ? (w(), de(v(qt), {
            key: 4,
            disabled: c.value,
            loading: c.value,
            icon: "lucide:file-down",
            text: "Export",
            variant: "primary",
            onClick: y
          }, null, 8, ["disabled", "loading"])) : P("", !0),
          u.value && d.value === "multi" ? (w(), de(v(Cr), {
            key: 5,
            items: f.value,
            placement: "bottom-right",
            onSelect: k
          }, {
            trigger: fe(() => [
              oe(v(qt), {
                loading: m.value,
                icon: "lucide:file-down",
                text: "Export",
                variant: "primary"
              }, null, 8, ["loading"])
            ]),
            _: 1
          }, 8, ["items"])) : P("", !0),
          v(t).toolbarColumnActions ? (w(), de(ht(v(t).toolbarColumnActions), { key: 6 })) : P("", !0),
          ($ = (C = e.config) == null ? void 0 : C.actions) != null && $.columnSetup || (A = (_ = e.config) == null ? void 0 : _.actions) != null && A.columnPicker ? U(h.$slots, "column-setup", { key: 7 }) : P("", !0)
        ])
      ]);
    };
  }
}), lt = {
  SM: 640,
  // Tailwind sm
  MD: 768,
  // Tailwind md
  LG: 1024,
  // Tailwind lg
  XL: 1280,
  // Tailwind xl
  "2XL": 1536,
  // Tailwind 2xl
  "3XL": 1920,
  // custom 3xl
  ULTRA: 2560,
  // custom ultra
  "4K": 3440
  // custom 4k
}, Ai = typeof window < "u" ? window.innerWidth : 1920;
function Jd(e = Ai) {
  return e < lt.SM || e < lt.MD ? "sm" : e < lt.LG ? "md" : e < lt.XL ? "lg" : e < lt["2XL"] ? "xl" : e < lt["3XL"] ? "2xl" : e < lt.ULTRA ? "3xl" : e < lt["4K"] ? "ultra" : "4k";
}
function Sl(e, n = Ai) {
  const t = Jd(n), a = ["4k", "ultra", "3xl", "2xl", "xl", "lg", "md", "sm"], s = a.indexOf(t);
  for (let r = s; r < a.length; r++) {
    const l = e[a[r]];
    if (l !== void 0) return l;
  }
  return e.default;
}
function DD(e, n = 1920, t, a, s = Ai) {
  const r = s / n;
  let l = Math.round(e * r);
  return t !== void 0 && (l = Math.max(l, t)), a !== void 0 && (l = Math.min(l, a)), l;
}
const sa = Jd(), Ri = sa === "sm", Fi = sa === "md", Qd = sa === "lg", ef = sa === "xl", tf = sa === "2xl", Vi = sa === "3xl", Kr = sa === "ultra", Zr = sa === "4k", b$ = Ri || Fi, OD = Ri || Fi || Qd, w$ = ef || tf || Vi || Kr || Zr, k$ = Vi || Kr || Zr, x$ = Kr || Zr, _D = {
  sm: Ri,
  md: Fi,
  lg: Qd,
  xl: ef,
  "2xl": tf,
  "3xl": Vi,
  ultra: Kr,
  "4k": Zr,
  // Grouped checks
  isMobileOrTablet: b$,
  isDesktopOrLarger: w$,
  isLargeOrBigger: k$,
  isUltraOrBigger: x$
}, ED = {
  sm: `(max-width: ${lt.SM - 1}px)`,
  md: `(min-width: ${lt.SM}px) and (max-width: ${lt.MD - 1}px)`,
  lg: `(min-width: ${lt.MD}px) and (max-width: ${lt.LG - 1}px)`,
  xl: `(min-width: ${lt.LG}px) and (max-width: ${lt.XL - 1}px)`,
  "2xl": `(min-width: ${lt.XL}px) and (max-width: ${lt["2XL"] - 1}px)`,
  "3xl": `(min-width: ${lt["2XL"]}px) and (max-width: ${lt["3XL"] - 1}px)`,
  ultra: `(min-width: ${lt["3XL"]}px) and (max-width: ${lt.ULTRA - 1}px)`,
  "4k": `(min-width: ${lt.ULTRA}px)`,
  // Range queries (min-width)
  minMd: `(min-width: ${lt.SM}px)`,
  minLg: `(min-width: ${lt.MD}px)`,
  minXl: `(min-width: ${lt.LG}px)`,
  min2Xl: `(min-width: ${lt.XL}px)`,
  min3Xl: `(min-width: ${lt["2XL"]}px)`,
  minUltra: `(min-width: ${lt["3XL"]}px)`,
  min4K: `(min-width: ${lt.ULTRA}px)`
}, nf = {
  MIN_COLUMN_WIDTH: Sl({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 110,
    ultra: 120,
    default: 100
  }),
  DEFAULT_MIN_WIDTH: Sl({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 120,
    ultra: 190,
    default: 100
  }),
  DEFAULT_COLUMN_WIDTH: Sl({
    sm: 100,
    md: 120,
    lg: 140,
    xl: 150,
    "3xl": 180,
    ultra: 270,
    default: 150
  })
}, {
  MIN_COLUMN_WIDTH: S$,
  DEFAULT_MIN_WIDTH: fu,
  DEFAULT_COLUMN_WIDTH: gs
} = nf;
function T$(e) {
  const n = ee(/* @__PURE__ */ new Map()), t = ee({
    isResizing: !1,
    columnKey: null,
    startX: 0,
    startWidth: 0
  });
  let a = null, s = null, r = 0;
  const l = (y) => y.width !== "flex", i = (y) => {
    const h = n.value.get(y.key);
    return h !== void 0 ? `${h}px` : y.width === "flex" ? `minmax(${fu}px, 1fr)` : y.width ? y.width : `${gs}px`;
  }, o = M(() => e.value.map((y) => i(y)).join(" ")), u = (y = 50) => `${y}px ${o.value}`, c = (y, h) => {
    h.preventDefault(), h.stopPropagation();
    const b = e.value.find((C) => C.key === y);
    if (!b || !l(b))
      return;
    let S;
    const x = n.value.get(y);
    if (x !== void 0)
      S = x;
    else if (b.width && b.width !== "flex" && b.width.endsWith("px"))
      S = parseInt(b.width, 10);
    else if (!b.width)
      S = gs;
    else {
      const C = h.target.closest('[role="columnheader"]');
      S = C ? C.offsetWidth : gs;
    }
    t.value = {
      isResizing: !0,
      columnKey: y,
      startX: h.clientX,
      startWidth: S
    }, document.addEventListener("mousemove", m), document.addEventListener("mouseup", d), document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
  }, f = () => {
    if (a = null, s === null) return;
    const y = new Map(n.value);
    y.set(s, r), n.value = y;
  }, m = (y) => {
    if (!t.value.isResizing || !t.value.columnKey)
      return;
    const h = y.clientX - t.value.startX, b = Math.max(
      S$,
      t.value.startWidth + h
    );
    s = t.value.columnKey, r = b, a === null && (a = requestAnimationFrame(f));
  }, d = () => {
    a !== null && (cancelAnimationFrame(a), a = null), f(), s = null, t.value = {
      isResizing: !1,
      columnKey: null,
      startX: 0,
      startWidth: 0
    }, document.removeEventListener("mousemove", m), document.removeEventListener("mouseup", d), document.body.style.cursor = "", document.body.style.userSelect = "";
  }, p = (y) => {
    const h = new Map(n.value);
    h.delete(y), n.value = h;
  }, g = () => {
    n.value = /* @__PURE__ */ new Map();
  }, k = (y) => {
    const h = n.value.get(y);
    if (h !== void 0)
      return h;
    const b = e.value.find((S) => S.key === y);
    return b ? b.width === "flex" ? `minmax(${fu}px, 1fr)` : b.width ? b.width : gs : gs;
  };
  return {
    gridTemplateColumns: o,
    getGridTemplateWithCheckbox: u,
    resizedWidths: n,
    isResizing: M(() => t.value.isResizing),
    isColumnResizable: l,
    startResize: c,
    autoFitColumn: p,
    getColumnWidth: k,
    resetWidths: g
  };
}
function M$(e) {
  const n = ee(/* @__PURE__ */ new Set());
  return {
    flattenedData: M(() => {
      const i = [], o = (u, c = 0, f) => {
        u.forEach((m) => {
          var g, k;
          const d = !!((g = m.children) != null && g.length || m.expandable && m.expandedContent), p = n.value.has(m.id);
          i.push({
            ...m,
            depth: c,
            parentId: f,
            hasChildren: d,
            isExpanded: p
          }), p && ((k = m.children) != null && k.length) && o(m.children, c + 1, m.id);
        });
      };
      return o(e.value), i;
    }),
    // For passing to virtualizer
    expandedRows: n,
    // For UI indicators
    toggleRow: (i) => {
      n.value.has(i) ? n.value.delete(i) : n.value.add(i), n.value = new Set(n.value);
    },
    // For click handlers
    expandAll: () => {
      const i = (o) => {
        const u = [];
        return o.forEach((c) => {
          var f;
          ((f = c.children) != null && f.length || c.expandable) && (u.push(c.id), c.children && u.push(...i(c.children)));
        }), u;
      };
      n.value = new Set(i(e.value));
    },
    collapseAll: () => {
      n.value.clear(), n.value = /* @__PURE__ */ new Set();
    },
    isExpandable: (i) => {
      var o;
      return !!((o = i.children) != null && o.length || i.expandable);
    }
  };
}
const { DEFAULT_COLUMN_WIDTH: Ia } = nf;
function $$(e, n) {
  const t = M(
    () => e.value.filter((g) => g.fixed === "left")
  ), a = M(
    () => e.value.filter((g) => g.fixed === "right")
  ), s = M(
    () => e.value.filter((g) => !g.fixed)
  ), r = M(() => {
    const g = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map();
    let y = 0;
    for (const h of e.value)
      if (h.fixed === "left") {
        k.set(h.key, y);
        let b = Ia;
        if (g) {
          const S = g.get(h.key);
          S !== void 0 ? b = S : b = ir(h.width) || Ia;
        } else
          b = ir(h.width) || Ia;
        y += b;
      }
    return k;
  }), l = M(() => {
    const g = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map(), y = e.value.filter((b) => b.fixed === "right");
    let h = 0;
    for (let b = y.length - 1; b >= 0; b--) {
      const S = y[b];
      k.set(S.key, h);
      let x = Ia;
      if (g) {
        const C = g.get(S.key);
        C !== void 0 ? x = C : x = ir(S.width) || Ia;
      } else
        x = ir(S.width) || Ia;
      h += x;
    }
    return k;
  }), i = (g, k) => {
    if (k.fixed === "left") {
      const h = e.value.findIndex((S) => S.key === g);
      let b = 0;
      for (let S = 0; S < h; S++)
        e.value[S].fixed === "left" && b++;
      return 50 + (t.value.length - b);
    }
    if (k.fixed === "right") {
      const h = e.value.findIndex((S) => S.key === g);
      let b = 0;
      for (let S = h + 1; S < e.value.length; S++)
        e.value[S].fixed === "right" && b++;
      return 50 + b + 1;
    }
    return 1;
  }, o = M(() => {
    const g = /* @__PURE__ */ new Map();
    return e.value.forEach((k) => {
      if (!k.fixed) {
        g.set(k.key, {});
        return;
      }
      const y = {
        // position: sticky added through CSS classes!
        // zIndex also controlled through CSS for proper hierarchy
      };
      if (k.fixed === "left") {
        const h = r.value.get(k.key) || 0;
        y.left = `${h}px`;
      } else if (k.fixed === "right") {
        const h = l.value.get(k.key) || 0;
        y.right = `${h}px`;
      }
      g.set(k.key, y);
    }), g;
  }), u = (g) => o.value.get(g.key) || {}, c = (g) => !!g.fixed, f = M(() => {
    let g = null;
    for (const k of e.value)
      k.fixed === "left" && (g = k.key);
    return g;
  }), m = M(() => {
    for (const g of e.value)
      if (g.fixed === "right")
        return g.key;
    return null;
  });
  return {
    leftFixedColumns: t,
    rightFixedColumns: a,
    normalColumns: s,
    getFixedStyles: u,
    isFixed: c,
    isLastLeftFixed: (g) => f.value === g,
    isFirstRightFixed: (g) => m.value === g,
    getZIndex: i
  };
}
function ir(e) {
  return e && e.endsWith("px") ? Number.parseInt(e, 10) : null;
}
function C$(e, n) {
  const a = M(() => ((p) => p.some((g) => !!(g.children && g.children.length > 0)))(e.value)), s = (d, p = 1) => {
    let g = p;
    return d.forEach((k) => {
      if (k.children && k.children.length > 0) {
        const y = s(k.children, p + 1);
        g = Math.max(g, y);
      }
    }), g;
  }, r = M(() => {
    const d = [], p = (g) => {
      g.forEach((k) => {
        k.children && k.children.length > 0 ? p(k.children) : d.push(k);
      });
    };
    return p(e.value), d;
  }), l = (d) => !d.children || d.children.length === 0 ? 1 : d.children.reduce((p, g) => p + l(g), 0), i = (d) => d && d.endsWith("px") ? parseInt(d, 10) : 150, o = (d) => {
    const p = n.value.get(d.key);
    return p !== void 0 ? p : i(d.width);
  }, u = (d) => !d.children || d.children.length === 0 ? o(d) : d.children.reduce((p, g) => p + u(g), 0), c = (d, p, g = 0, k = 1) => {
    const y = [];
    return d.forEach((h) => {
      if (!!(h.children && h.children.length > 0))
        g === p && y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: l(h),
          rowspan: 1,
          isGroup: !0,
          level: g
        }), g < p && y.push(...c(h.children, p, g + 1, k));
      else if (g === p) {
        const S = g === 0;
        y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: 1,
          rowspan: S ? k : 1,
          // Root level spans all, others just 1
          isGroup: !1,
          level: g
        });
      }
    }), y;
  }, f = M(() => {
    if (!a.value)
      return [
        e.value.map((g) => ({
          key: g.key,
          label: g.label,
          column: g,
          colspan: 1,
          rowspan: 1,
          isGroup: !1,
          level: 0
        }))
      ];
    const d = s(e.value), p = [];
    for (let g = 0; g < d; g++)
      p.push(c(e.value, g, 0, d));
    return p;
  });
  return {
    hasGroups: a,
    // Boolean - do we have grouped headers?
    flatColumns: r,
    // Flat list of leaf columns for data rows
    headerLevels: f,
    // Array of header rows (one per level)
    getGroupWidth: u,
    // Calculate width of group dynamically
    getColspan: l,
    // Get colspan for any column
    isGroupFixed: (d) => {
      if (!d.children || d.children.length === 0)
        return d.fixed || null;
      const p = (h) => !h.children || h.children.length === 0 ? [h.fixed] : h.children.flatMap((b) => p(b)), g = p(d), k = g.every((h) => h === "left"), y = g.every((h) => h === "right");
      return k ? "left" : y ? "right" : null;
    }
    // Check if group should be sticky
  };
}
const D$ = (e, n, t) => {
  if (!n.format)
    return e;
  const a = n.format;
  if (a.formatter)
    return a.formatter(e, t);
  if (a.currency !== void 0 && a.currency !== !1) {
    const s = a.currency === !0 ? "USD" : a.currency;
    return Cs(e, s);
  }
  return a.percentage !== void 0 ? Oi(e, a.percentage) : a.number ? Ua(e, a.number) : a.date ? Nd(e, a.date) : a.boolean ? Ld(e, a.boolean) : a.fileSize !== void 0 ? Bd(e, a.fileSize) : e;
}, O$ = () => ({
  formatCellValue: D$,
  // Export individual formatters for custom use
  formatCurrency: Cs,
  formatPercentage: Oi,
  formatNumber: Ua,
  formatDate: Nd,
  formatBoolean: Ld,
  formatFileSize: Bd
}), _$ = (e) => {
  const { isExpandable: n, isRowExpandable: t } = e, { formatCellValue: a } = O$(), s = (o, u, c) => {
    if (!u.format)
      return o;
    const f = a(o, u, c);
    return f && typeof f == "object" && !Array.isArray(f) && "text" in f && typeof f.text < "u" ? f.text : f;
  }, r = (o, u, c) => {
    if (!u.format)
      return;
    const f = a(o, u, c);
    if (f && typeof f == "object" && !Array.isArray(f) && "class" in f && typeof f.class == "string")
      return f.class;
  }, l = /* @__PURE__ */ new WeakMap();
  return { getCellValue: s, getCellClass: r, getCellMetadata: (o, u, c, f) => {
    let m = l.get(o);
    m || (m = /* @__PURE__ */ new WeakMap(), l.set(o, m));
    const d = m.get(u);
    if (d) return d;
    const p = u.format ? a(o[u.key], u, o) : o[u.key];
    let g = p, k;
    if (p && typeof p == "object" && !Array.isArray(p) && "text" in p && (g = p.text, k = p.class), u.cellClass) {
      const C = u.cellClass({ value: o[u.key], row: o, rowIndex: f });
      C && (k = k ? `${k} ${C}` : C);
    }
    const y = u.cellStyle ? u.cellStyle({ value: o[u.key], row: o, rowIndex: f }) : void 0, h = o.depth || 0, b = c === 0 && h ? { paddingLeft: `${h * 24 + 16}px` } : null, S = c === 0 && Qe(n) ? t(o) : !1, x = {
      formattedValue: g,
      cssClass: k,
      indentStyle: b,
      customStyle: y,
      isExpandable: S
    };
    return m.set(u, x), x;
  } };
}, E$ = (e) => {
  const n = M(() => Qe(e.columns)), t = M(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" || typeof k == "object";
  }), a = M(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" ? {
      key: k,
      type: "indexedDB",
      allowReorder: !0
    } : typeof k == "object" ? {
      ...k,
      type: k.type || "indexedDB"
      // Default to indexedDB
    } : {};
  }), s = (k, y, h) => {
    const b = (_) => _.flatMap((A) => A.children && A.children.length ? b(A.children) : [A]), S = new Map(b(n.value).map((_) => [_.key, _])), x = [], C = k.fixed, $ = (_) => {
      var L;
      if (!k.visible.includes(_)) return;
      const A = S.get(_);
      if (A) {
        x.push({ ...A, fixed: (C == null ? void 0 : C[_]) || A.fixed });
        return;
      }
      const D = y == null ? void 0 : y.get(_);
      if (D) {
        x.push({
          key: D.key,
          label: D.label,
          fixed: C == null ? void 0 : C[_],
          sortable: D.sortable ?? h
        });
        return;
      }
      const Y = (L = k.labels) == null ? void 0 : L[_];
      Y && x.push({
        key: _,
        label: Y,
        fixed: C == null ? void 0 : C[_],
        sortable: h
      });
    };
    return k.order.forEach($), !x.length && k.visible.length && k.visible.forEach($), x.length ? x : null;
  }, r = async () => {
    const k = t.value, y = Qe(e.columnPicker), h = !!y && typeof y == "object";
    if (!k && !h) return null;
    if (k) {
      const b = a.value;
      if (b.key)
        try {
          const x = await Dr(b.key, b.type);
          if (x) return s(x);
        } catch (x) {
          console.warn("[VTable] Failed to load stored column setup", x);
        }
      const S = Array.isArray(b.initialVisible) ? b.initialVisible : null;
      if (S) {
        const x = n.value.filter((C) => S.includes(C.key));
        return S.length === 0 ? [] : x.length ? x : null;
      }
    }
    if (h && typeof y == "object") {
      const b = y.key, S = y.type;
      if (b)
        try {
          const x = await Dr(b, S);
          if (x) {
            const C = /* @__PURE__ */ new Map();
            return y.groups.forEach(($) => $.items.forEach((_) => C.set(_.key, _))), s(x, C, y.defaultSortable);
          }
        } catch (x) {
          console.warn("[VTable] Failed to load stored column picker state", x);
        }
    }
    return null;
  }, l = ee(null), i = ee(null), o = ee(null);
  r().then((k) => {
    k !== null && (l.value = k);
  });
  const u = (k) => {
    l.value = [...k];
  }, c = () => {
    var k;
    (k = i.value) == null || k.close();
  }, f = () => {
    var k;
    (k = o.value) == null || k.close();
  }, m = M(() => {
    const k = Qe(e.columnPicker);
    return !!k && typeof k == "object";
  }), d = M(() => {
    const k = Qe(e.columnPicker);
    return !k || typeof k != "object" ? null : k;
  }), p = (k) => {
    const y = k.filter((S) => S.fixed === "left"), h = k.filter((S) => !S.fixed), b = k.filter((S) => S.fixed === "right");
    return !y.length && !b.length ? k : [...y, ...h, ...b];
  }, g = M(() => !t.value && !m.value ? p(n.value) : p(l.value ?? n.value));
  return {
    columnSetupEnabledBasic: t,
    columnSetupConfig: a,
    columnSetupPopoverRef: i,
    columnPickerPopoverRef: o,
    handleVisibleColumnsUpdate: u,
    handleColumnSetupClose: c,
    handleColumnPickerClose: f,
    columnPickerEnabled: m,
    columnPickerConfig: d,
    effectiveColumns: g
  };
}, hu = { duration: 200, easing: "cubic-bezier(0, 0, 0.2, 1)" }, mu = { duration: 160, easing: "cubic-bezier(0.4, 0, 1, 1)" }, or = 0, Tl = () => {
  const { innerWidth: e, innerHeight: n } = window;
  return {
    top: n * or,
    left: e * or,
    width: e * (1 - 2 * or),
    height: n * (1 - 2 * or)
  };
}, vu = (e) => e instanceof HTMLElement ? e : void 0, I$ = (e) => {
  var t;
  const n = vu(e);
  return n ? n.offsetHeight : ((t = vu(e == null ? void 0 : e.$el)) == null ? void 0 : t.offsetHeight) ?? 0;
}, pu = "v-table-fullscreen", ys = ee(!1);
let Ml = null;
const gu = (e, n, t) => {
  const a = n.width / t.width, s = n.height / t.height, r = n.left - t.left, l = n.top - t.top;
  e.style.transformOrigin = "top left", e.style.transform = `translate(${r}px, ${l}px) scale(${a}, ${s})`;
}, P$ = (e) => {
  const { wrapperRef: n, placeholderRef: t } = e, a = ee(!1), s = ee(null), r = ee(null), l = ee(0);
  let i = null, o = null, u = 0, c = !1;
  const { zIndex: f, open: m, close: d } = Pi(pu, !1), p = Hd(), g = () => {
    l.value = (e.chromeRefs ?? []).reduce((D, Y) => D + I$(Y.value), 0);
  }, k = async () => {
    const D = n.value;
    if (!D) return;
    const Y = ++u, L = D.getBoundingClientRect();
    s.value = L, r.value = Tl(), g();
    const Z = window.scrollX, se = window.scrollY;
    if (a.value = !0, await Ze(), Y !== u) return;
    (window.scrollX !== Z || window.scrollY !== se) && window.scrollTo({ left: Z, top: se, behavior: "instant" }), D.style.transition = "none";
    const ie = D.getBoundingClientRect();
    gu(D, L, ie), D.offsetHeight, D.style.transition = `transform ${hu.duration}ms ${hu.easing}`, D.style.transform = "translate(0, 0) scale(1, 1)";
    const ce = (G) => {
      G.target !== D || G.propertyName !== "transform" || (D.removeEventListener("transitionend", ce), o = null, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    o = { el: D, handler: ce }, D.addEventListener("transitionend", ce);
  }, y = async () => {
    var G;
    const D = n.value;
    if (!D) return;
    const Y = ++u, L = window.scrollX, Z = window.scrollY;
    if (await Ze(), Y !== u) return;
    (window.scrollX !== L || window.scrollY !== Z) && window.scrollTo({ left: L, top: Z, behavior: "instant" }), o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null);
    const se = D.getBoundingClientRect(), ie = ((G = t == null ? void 0 : t.value) == null ? void 0 : G.getBoundingClientRect()) ?? s.value ?? se;
    D.style.transition = `transform ${mu.duration}ms ${mu.easing}`, gu(D, ie, se);
    const ce = (le) => {
      le.target !== D || le.propertyName !== "transform" || (D.removeEventListener("transitionend", ce), i = null, a.value = !1, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    i = { el: D, handler: ce }, D.addEventListener("transitionend", ce);
  }, h = () => {
    a.value ? y() : k();
  }, b = () => {
    a.value && y();
  };
  We(a, (D) => {
    D ? m() : c || d();
  });
  const S = (D) => {
    D.key !== "Escape" || !a.value || Math.max(
      0,
      ...p.openModals.value.filter((L) => L.id !== pu).map((L) => L.zIndex)
    ) > f.value || h();
  };
  We(a, (D) => {
    D ? window.addEventListener("keydown", S) : window.removeEventListener("keydown", S);
  });
  const x = () => {
    a.value && (r.value = Tl(), g());
  };
  We(a, (D) => {
    D ? window.addEventListener("resize", x) : window.removeEventListener("resize", x);
  }), We(a, async (D) => {
    var Y;
    await Ze(), await ((Y = e.onToggle) == null ? void 0 : Y.call(e, D));
  });
  const C = () => {
    g(), s.value = Ml, r.value = Tl(), a.value = !0;
  };
  Cu(() => {
    a.value && (c = !0, r.value = null, a.value = !1, u += 1, o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null), ys.value = !0, Ml = s.value, Ze().then(() => {
      c = !1, ys.value && (ys.value = !1, Ml = null, d());
    }));
  }), Du(() => {
    ys.value && Qe(e.isEnabled) && (ys.value = !1, C());
  }), rn(() => {
    a.value && d(), window.removeEventListener("keydown", S), window.removeEventListener("resize", x), i && (i.el.removeEventListener("transitionend", i.handler), i = null), o && (o.el.removeEventListener("transitionend", o.handler), o = null);
  });
  const $ = M(() => !a.value || !s.value ? null : {
    width: `${s.value.width}px`,
    height: `${s.value.height}px`
  }), _ = M(() => {
    if (!a.value || !r.value) return null;
    const { top: D, left: Y, width: L, height: Z } = r.value;
    return {
      top: `${D}px`,
      left: `${Y}px`,
      width: `${L}px`,
      height: `${Z}px`
    };
  }), A = M(() => !a.value || !r.value ? 0 : r.value.height - l.value);
  return {
    isFullscreen: ei(a),
    isEnabled: M(() => Qe(e.isEnabled)),
    zIndex: f,
    placeholderStyle: $,
    panelStyle: _,
    contentHeight: A,
    toggle: h,
    close: b
  };
}, A$ = (e) => e ? e === !0 ? { enabled: !0, row: !0, column: !0 } : {
  enabled: !0,
  row: e.row ?? !0,
  column: e.column ?? !0
} : { enabled: !1, row: !1, column: !1 }, R$ = (e) => {
  const n = ee(null), t = ee(null), a = () => Qe(e.config), s = M(() => n.value !== null || t.value !== null), r = (g) => n.value === null ? !1 : g !== void 0 && n.value === g, l = (g) => t.value === null ? !1 : t.value === g, i = () => {
    var g;
    (g = e.onChange) == null || g.call(e, {
      rowId: n.value,
      columnKey: t.value
    });
  };
  return {
    pinnedRowId: n,
    pinnedColumnKey: t,
    hasPin: s,
    isRowPinned: r,
    isColumnPinned: l,
    toggleRow: (g) => {
      const { enabled: k, row: y } = a();
      !k || !y || (n.value = n.value === g ? null : g, i());
    },
    toggleColumn: (g) => {
      const { enabled: k, column: y } = a();
      !k || !y || (t.value = t.value === g ? null : g, i());
    },
    unpinRow: () => {
      n.value !== null && (n.value = null, i());
    },
    unpinColumn: () => {
      t.value !== null && (t.value = null, i());
    },
    clear: () => {
      s.value && (n.value = null, t.value = null, i());
    },
    applyRemote: (g) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? g.rowId : null, t.value = h ? g.columnKey : null);
    },
    setPin: (g) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? g.rowId : null, t.value = h ? g.columnKey : null, i());
    }
  };
}, af = Symbol("tablePageKey");
function ID(e = []) {
  const n = ee(1);
  return e.length && We(e, () => {
    n.value === 1 ? Cl(n) : n.value = 1;
  }, { flush: "pre", deep: !0 }), Na(af, n), n;
}
function F$(e) {
  const { config: n, flattenedData: t, selectedRows: a, onSelectionChange: s } = e, r = ee(/* @__PURE__ */ new Set()), l = (x) => x.id;
  We(
    a,
    (x) => {
      r.value = new Set(x.map((C) => l(C)));
    },
    { immediate: !0 }
  );
  const i = M(() => {
    var x;
    return ((x = n.value) == null ? void 0 : x.enabled) ?? !1;
  }), o = M(
    () => {
      var x;
      return ((x = n.value) == null ? void 0 : x.selectionMode) === "dependent";
    }
  ), u = (x) => r.value.has(x), c = (x) => {
    var C;
    return (C = n.value) != null && C.isRowSelectable ? n.value.isRowSelectable(x) : !0;
  }, f = (x) => {
    if (!x.children || x.children.length === 0) return [];
    const C = [], $ = (_) => {
      _.forEach((A) => {
        C.push(l(A)), A.children && $(A.children);
      });
    };
    return $(x.children), C;
  }, m = (x) => {
    if (!x.children || x.children.length === 0) return [];
    const C = [], $ = t.value.filter((D) => D.isExpanded), _ = new Set($.map((D) => l(D))), A = (D, Y) => {
      D.forEach((L) => {
        if (Y) {
          C.push(l(L));
          const Z = _.has(l(L));
          L.children && A(L.children, Z);
        }
      });
    };
    return A(x.children, !0), C;
  }, d = (x) => t.value.find(
    (C) => {
      var $;
      return ($ = C.children) == null ? void 0 : $.some((_) => _.id === x);
    }
  ), p = (x) => {
    var _;
    if (!x.children || x.children.length === 0)
      return u(l(x)) ? "checked" : "unchecked";
    const C = (_ = n.value) != null && _.selectOnlyVisible ? m(x) : f(x);
    if (C.length === 0)
      return u(l(x)) ? "checked" : "unchecked";
    const $ = C.filter(
      (A) => r.value.has(A)
    ).length;
    return $ === 0 && !u(l(x)) ? "unchecked" : $ === C.length && u(l(x)) ? "checked" : "indeterminate";
  }, g = (x) => {
    var A, D, Y, L, Z, se;
    if (!i.value || !c(x)) return;
    const C = l(x), $ = u(C), _ = new Set(r.value);
    if ($ ? (_.delete(C), o.value && ((A = n.value) != null && A.selectChildren) && ((D = n.value) != null && D.selectOnlyVisible ? m(x) : f(x)).forEach((ce) => _.delete(ce))) : (_.add(C), o.value && ((Y = n.value) != null && Y.selectChildren) && ((L = n.value) != null && L.selectOnlyVisible ? m(x) : f(x)).forEach((ce) => _.add(ce))), o.value && ((Z = n.value) != null && Z.selectParent)) {
      const ie = d(C);
      ie && ((((se = ie.children) == null ? void 0 : se.map((le) => l(le))) || []).every(
        (le) => _.has(le)
      ) ? _.add(l(ie)) : _.delete(l(ie)));
    }
    r.value = _, h();
  }, k = () => {
    const x = t.value.filter(
      ($) => c($)
    );
    if (x.length === 0) return "unchecked";
    const C = x.filter(
      ($) => u(l($))
    ).length;
    return C === 0 ? "unchecked" : C === x.length ? "checked" : "indeterminate";
  }, y = () => {
    if (!i.value) return;
    const x = k(), C = new Set(r.value), $ = t.value.filter(
      (_) => c(_)
    );
    x === "checked" ? $.forEach((_) => {
      C.delete(l(_));
    }) : $.forEach((_) => {
      C.add(l(_));
    }), r.value = C, h();
  }, h = () => {
    const x = (_, A) => {
      for (const D of A) {
        if (D.id === _) return D;
        if (D.children) {
          const Y = x(_, D.children);
          if (Y) return Y;
        }
      }
    }, C = t.value.map((_) => {
      const { depth: A, parentId: D, hasChildren: Y, isExpanded: L, ...Z } = _;
      return Z;
    }), $ = Array.from(r.value).map((_) => x(_, C)).filter((_) => _ !== void 0);
    s($);
  };
  return {
    // State
    isEnabled: i,
    isDependentMode: o,
    selectedIds: r,
    // Methods
    isRowSelected: u,
    isRowSelectable: c,
    toggleRow: g,
    toggleAllRows: y,
    getParentCheckboxState: p,
    getHeaderCheckboxState: k,
    clearSelection: () => {
      r.value = /* @__PURE__ */ new Set(), h();
    },
    selectRows: (x) => {
      r.value = new Set(x), h();
    }
  };
}
const V$ = (e) => {
  const {
    sort: n = {},
    sortState: t,
    columns: a,
    page: s,
    pageSize: r,
    data: l,
    onRequest: i,
    onSort: o,
    onUpdateSortState: u
  } = e, c = M(() => ({
    type: n.type || "server",
    multiple: n.multiple !== void 0 ? n.multiple : !0
  })), f = ee((t == null ? void 0 : t.value) || []);
  t && We(t, (x) => {
    f.value = x || [];
  });
  const m = (x, C) => {
    const $ = a.value.find((D) => D.key === C);
    if ($ != null && $.sortValue)
      return $.sortValue(x, C);
    const _ = C.split(".");
    let A = x;
    for (const D of _) {
      if (A == null) return null;
      A = A[D];
    }
    return A;
  }, d = (x, C, $) => {
    if (x == null && C == null) return 0;
    if (x == null) return 1;
    if (C == null) return -1;
    const _ = typeof x == "string" ? parseFloat(x) : x, A = typeof C == "string" ? parseFloat(C) : C;
    if (typeof _ == "number" && typeof A == "number" && !Number.isNaN(_) && !Number.isNaN(A))
      return $ === "asc" ? _ - A : A - _;
    const D = String(x).toLowerCase(), Y = String(C).toLowerCase();
    return $ === "asc" ? D.localeCompare(Y, void 0, { numeric: !0 }) : Y.localeCompare(D, void 0, { numeric: !0 });
  }, p = (x, C) => C.length === 0 ? [...x] : [...x].sort(($, _) => {
    for (const A of C) {
      const D = m($, A.field), Y = m(_, A.field), L = d(D, Y, A.order);
      if (L !== 0)
        return L;
    }
    return 0;
  }), g = M(() => c.value.type !== "front" || !l ? (l == null ? void 0 : l.value) || [] : p(l.value, f.value)), k = (x) => {
    const C = f.value.find(($) => $.field === x);
    return {
      isSorted: !!C,
      order: (C == null ? void 0 : C.order) || null,
      index: C ? f.value.indexOf(C) : -1
      // For multi-sort indicator
    };
  }, y = (x) => x ? x === "asc" ? "desc" : null : "asc", h = (x) => {
    if (!x.sortable) return;
    const C = x.key, $ = k(C), _ = y($.order);
    let A;
    if (c.value.multiple ? _ === null ? A = f.value.filter((D) => D.field !== C) : $.isSorted ? A = f.value.map(
      (D) => D.field === C ? { field: C, order: _ } : D
    ) : A = [...f.value, { field: C, order: _ }] : _ === null ? A = [] : A = [{ field: C, order: _ }], f.value = A, u == null || u(A), c.value.type === "front") {
      if (A.length > 0) {
        const D = A.find((Y) => Y.field === C);
        D && (o == null || o({
          field: C,
          order: D.order,
          sortState: A
        }));
      }
    } else {
      const D = {
        // page: page?.value ?? 1,
        page: 1,
        pageSize: (r == null ? void 0 : r.value) ?? 10,
        sort: A
      };
      i == null || i(D);
    }
  }, b = M(() => f.value.length > 0);
  return {
    sortState: f,
    sortConfig: c,
    getSortState: k,
    handleSortClick: h,
    hasSortedColumns: b,
    resetSort: () => {
      if (f.value = [], u == null || u([]), c.value.type === "server") {
        const x = {
          page: (s == null ? void 0 : s.value) ?? 1,
          pageSize: (r == null ? void 0 : r.value) ?? 10,
          sort: []
        };
        i == null || i(x);
      }
    },
    // Frontend sorting
    sortedData: g
    // Reactive sorted data for frontend sorting
  };
};
function Pa(e, n, t) {
  let a = t.initialDeps ?? [], s, r = !0;
  function l() {
    var i, o, u;
    let c;
    t.key && ((i = t.debug) != null && i.call(t)) && (c = Date.now());
    const f = e();
    if (!(f.length !== a.length || f.some((p, g) => a[g] !== p)))
      return s;
    a = f;
    let d;
    if (t.key && ((o = t.debug) != null && o.call(t)) && (d = Date.now()), s = n(...f), t.key && ((u = t.debug) != null && u.call(t))) {
      const p = Math.round((Date.now() - c) * 100) / 100, g = Math.round((Date.now() - d) * 100) / 100, k = g / 16, y = (h, b) => {
        for (h = String(h); h.length < b; )
          h = " " + h;
        return h;
      };
      console.info(
        `%c⏱ ${y(g, 5)} /${y(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * k, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return t != null && t.onChange && !(r && t.skipInitialOnChange) && t.onChange(s), r = !1, s;
  }
  return l.updateDeps = (i) => {
    a = i;
  }, l;
}
function yu(e, n) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const L$ = (e, n) => Math.abs(e - n) < 1.01, N$ = (e, n, t) => {
  let a;
  return function(...s) {
    e.clearTimeout(a), a = e.setTimeout(() => n.apply(this, s), t);
  };
}, bu = (e) => {
  const { offsetWidth: n, offsetHeight: t } = e;
  return { width: n, height: t };
}, B$ = (e) => e, z$ = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), t = Math.min(e.endIndex + e.overscan, e.count - 1), a = [];
  for (let s = n; s <= t; s++)
    a.push(s);
  return a;
}, W$ = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  const s = (l) => {
    const { width: i, height: o } = l;
    n({ width: Math.round(i), height: Math.round(o) });
  };
  if (s(bu(t)), !a.ResizeObserver)
    return () => {
    };
  const r = new a.ResizeObserver((l) => {
    const i = () => {
      const o = l[0];
      if (o != null && o.borderBoxSize) {
        const u = o.borderBoxSize[0];
        if (u) {
          s({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      s(bu(t));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(i) : i();
  });
  return r.observe(t, { box: "border-box" }), () => {
    r.unobserve(t);
  };
}, wu = {
  passive: !0
}, ku = typeof window > "u" ? !0 : "onscrollend" in window, Y$ = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  let s = 0;
  const r = e.options.useScrollendEvent && ku ? () => {
  } : N$(
    a,
    () => {
      n(s, !1);
    },
    e.options.isScrollingResetDelay
  ), l = (c) => () => {
    const { horizontal: f, isRtl: m } = e.options;
    s = f ? t.scrollLeft * (m && -1 || 1) : t.scrollTop, r(), n(s, c);
  }, i = l(!0), o = l(!1);
  t.addEventListener("scroll", i, wu);
  const u = e.options.useScrollendEvent && ku;
  return u && t.addEventListener("scrollend", o, wu), () => {
    t.removeEventListener("scroll", i), u && t.removeEventListener("scrollend", o);
  };
}, H$ = (e, n, t) => {
  if (n != null && n.borderBoxSize) {
    const a = n.borderBoxSize[0];
    if (a)
      return Math.round(
        a[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[t.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, U$ = (e, {
  adjustments: n = 0,
  behavior: t
}, a) => {
  var s, r;
  const l = e + n;
  (r = (s = a.scrollElement) == null ? void 0 : s.scrollTo) == null || r.call(s, {
    [a.options.horizontal ? "left" : "top"]: l,
    behavior: t
  });
};
class q$ {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.currentScrollToIndex = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const a = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((r) => {
          const l = () => {
            this._measureElement(r.target, r);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(l) : l();
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = a()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var r;
          return (r = a()) == null ? void 0 : r.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var r;
          return (r = a()) == null ? void 0 : r.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([a, s]) => {
        typeof s > "u" && delete t[a];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: B$,
        rangeExtractor: z$,
        onChange: () => {
        },
        measureElement: H$,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...t
      };
    }, this.notify = (t) => {
      var a, s;
      (s = (a = this.options).onChange) == null || s.call(a, this, t);
    }, this.maybeNotify = Pa(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const a = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== a) {
        if (this.cleanup(), !a) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = a, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, r) => {
            this.scrollAdjustments = 0, this.scrollDirection = r ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = r, this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, a) => {
      const s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
      for (let l = a - 1; l >= 0; l--) {
        const i = t[l];
        if (s.has(i.lane))
          continue;
        const o = r.get(
          i.lane
        );
        if (o == null || i.end > o.end ? r.set(i.lane, i) : i.end < o.end && s.set(i.lane, !0), s.size === this.options.lanes)
          break;
      }
      return r.size === this.options.lanes ? Array.from(r.values()).sort((l, i) => l.end === i.end ? l.index - i.index : l.end - i.end)[0] : void 0;
    }, this.getMeasurementOptions = Pa(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (t, a, s, r, l, i) => (this.prevLanes !== void 0 && this.prevLanes !== i && (this.lanesChangedFlag = !0), this.prevLanes = i, this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: a,
        scrollMargin: s,
        getItemKey: r,
        enabled: l,
        lanes: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Pa(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: a, scrollMargin: s, getItemKey: r, enabled: l, lanes: i }, o) => {
        if (!l)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > t)
          for (const m of this.laneAssignments.keys())
            m >= t && this.laneAssignments.delete(m);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((m) => {
          this.itemSizeCache.set(m.key, m.size);
        }));
        const u = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === t && (this.lanesSettling = !1);
        const c = this.measurementsCache.slice(0, u), f = new Array(i).fill(
          void 0
        );
        for (let m = 0; m < u; m++) {
          const d = c[m];
          d && (f[d.lane] = m);
        }
        for (let m = u; m < t; m++) {
          const d = r(m), p = this.laneAssignments.get(m);
          let g, k;
          if (p !== void 0 && this.options.lanes > 1) {
            g = p;
            const S = f[g], x = S !== void 0 ? c[S] : void 0;
            k = x ? x.end + this.options.gap : a + s;
          } else {
            const S = this.options.lanes === 1 ? c[m - 1] : this.getFurthestMeasurement(c, m);
            k = S ? S.end + this.options.gap : a + s, g = S ? S.lane : m % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(m, g);
          }
          const y = o.get(d), h = typeof y == "number" ? y : this.options.estimateSize(m), b = k + h;
          c[m] = {
            index: m,
            start: k,
            size: h,
            end: b,
            key: d,
            lane: g
          }, f[g] = m;
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Pa(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (t, a, s, r) => this.range = t.length > 0 && a > 0 ? j$({
        measurements: t,
        outerSize: a,
        scrollOffset: s,
        lanes: r
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Pa(
      () => {
        let t = null, a = null;
        const s = this.calculateRange();
        return s && (t = s.startIndex, a = s.endIndex), this.maybeNotify.updateDeps([this.isScrolling, t, a]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          t,
          a
        ];
      },
      (t, a, s, r, l) => r === null || l === null ? [] : t({
        startIndex: r,
        endIndex: l,
        overscan: a,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const a = this.options.indexAttribute, s = t.getAttribute(a);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${a}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, a) => {
      const s = this.indexFromElement(t), r = this.measurementsCache[s];
      if (!r)
        return;
      const l = r.key, i = this.elementsCache.get(l);
      i !== t && (i && this.observer.unobserve(i), this.observer.observe(t), this.elementsCache.set(l, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, a, this));
    }, this.resizeItem = (t, a) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const r = this.itemSizeCache.get(s.key) ?? s.size, l = a - r;
      l !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, l, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", l), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += l,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, a)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((a, s) => {
          a.isConnected || (this.observer.unobserve(a), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = Pa(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (t, a) => {
        const s = [];
        for (let r = 0, l = t.length; r < l; r++) {
          const i = t[r], o = a[i];
          s.push(o);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const a = this.getMeasurements();
      if (a.length !== 0)
        return yu(
          a[sf(
            0,
            a.length - 1,
            (s) => yu(a[s]).start,
            t
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const t = this.scrollElement.document.documentElement;
        return this.options.horizontal ? t.scrollWidth - this.scrollElement.innerWidth : t.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (t, a, s = 0) => {
      if (!this.scrollElement) return 0;
      const r = this.getSize(), l = this.getScrollOffset();
      a === "auto" && (a = t >= l + r ? "end" : "start"), a === "center" ? t += (s - r) / 2 : a === "end" && (t -= r);
      const i = this.getMaxScrollOffset();
      return Math.max(Math.min(i, t), 0);
    }, this.getOffsetForIndex = (t, a = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const r = this.getSize(), l = this.getScrollOffset();
      if (a === "auto")
        if (s.end >= l + r - this.options.scrollPaddingEnd)
          a = "end";
        else if (s.start <= l + this.options.scrollPaddingStart)
          a = "start";
        else
          return [l, a];
      if (a === "end" && t === this.options.count - 1)
        return [this.getMaxScrollOffset(), a];
      const i = a === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(i, a, s.size),
        a
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (t, { align: a = "start", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, a), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: a = "auto", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), t = Math.max(0, Math.min(t, this.options.count - 1)), this.currentScrollToIndex = t;
      let r = 0;
      const l = 10, i = (u) => {
        if (!this.targetWindow) return;
        const c = this.getOffsetForIndex(t, u);
        if (!c) {
          console.warn("Failed to get offset for index:", t);
          return;
        }
        const [f, m] = c;
        this._scrollToOffset(f, { adjustments: void 0, behavior: s }), this.targetWindow.requestAnimationFrame(() => {
          const d = () => {
            if (this.currentScrollToIndex !== t) return;
            const p = this.getScrollOffset(), g = this.getOffsetForIndex(t, m);
            if (!g) {
              console.warn("Failed to get offset for index:", t);
              return;
            }
            L$(g[0], p) || o(m);
          };
          this.isDynamicMode() ? this.targetWindow.requestAnimationFrame(d) : d();
        });
      }, o = (u) => {
        this.targetWindow && this.currentScrollToIndex === t && (r++, r < l ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", r, l), this.targetWindow.requestAnimationFrame(() => i(u))) : console.warn(
          `Failed to scroll to index ${t} after ${l} attempts.`
        ));
      };
      i(a);
    }, this.scrollBy = (t, { behavior: a } = {}) => {
      a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: a
      });
    }, this.getTotalSize = () => {
      var t;
      const a = this.getMeasurements();
      let s;
      if (a.length === 0)
        s = this.options.paddingStart;
      else if (this.options.lanes === 1)
        s = ((t = a[a.length - 1]) == null ? void 0 : t.end) ?? 0;
      else {
        const r = Array(this.options.lanes).fill(null);
        let l = a.length - 1;
        for (; l >= 0 && r.some((i) => i === null); ) {
          const i = a[l];
          r[i.lane] === null && (r[i.lane] = i.end), l--;
        }
        s = Math.max(...r.filter((i) => i !== null));
      }
      return Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: a,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: a }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(n);
  }
}
const sf = (e, n, t, a) => {
  for (; e <= n; ) {
    const s = (e + n) / 2 | 0, r = t(s);
    if (r < a)
      e = s + 1;
    else if (r > a)
      n = s - 1;
    else
      return s;
  }
  return e > 0 ? e - 1 : 0;
};
function j$({
  measurements: e,
  outerSize: n,
  scrollOffset: t,
  lanes: a
}) {
  const s = e.length - 1, r = (o) => e[o].start;
  if (e.length <= a)
    return {
      startIndex: 0,
      endIndex: s
    };
  let l = sf(
    0,
    s,
    r,
    t
  ), i = l;
  if (a === 1)
    for (; i < s && e[i].end < t + n; )
      i++;
  else if (a > 1) {
    const o = Array(a).fill(0);
    for (; i < s && o.some((c) => c < t + n); ) {
      const c = e[i];
      o[c.lane] = c.end, i++;
    }
    const u = Array(a).fill(t + n);
    for (; l >= 0 && u.some((c) => c >= t); ) {
      const c = e[l];
      u[c.lane] = c.start, l--;
    }
    l = Math.max(0, l - l % a), i = Math.min(s, i + (a - 1 - i % a));
  }
  return { startIndex: l, endIndex: i };
}
function G$(e) {
  const n = new q$(v(e)), t = It(n), a = n._didMount();
  return We(
    () => v(e).getScrollElement(),
    (s) => {
      s && n._willUpdate();
    },
    {
      immediate: !0
    }
  ), We(
    () => v(e),
    (s) => {
      n.setOptions({
        ...s,
        onChange: (r, l) => {
          var i;
          Cl(t), (i = s.onChange) == null || i.call(s, r, l);
        }
      }), n._willUpdate(), Cl(t);
    },
    {
      immediate: !0
    }
  ), _r(a), t;
}
function K$(e) {
  return G$(
    M(() => ({
      observeElementRect: W$,
      observeElementOffset: Y$,
      scrollToFn: U$,
      ...v(e)
    }))
  );
}
function Z$(e, n, t = {}) {
  const {
    estimateSize: a = 50,
    overscan: s = 3,
    measureElement: r = !1
  } = t, l = It(!1);
  let i = null, o = !1;
  const u = {
    get count() {
      return n.value.length;
    },
    getScrollElement: () => e.value,
    estimateSize: () => a,
    overscan: s,
    scrollingDelay: 150
  };
  r && (u.measureElement = (h) => !h || l.value ? a : h.getBoundingClientRect().height || a);
  const c = K$(u), f = M(() => c.value.getVirtualItems()), m = M(() => c.value.getTotalSize()), d = () => {
    l.value = !0, i && clearTimeout(i), i = setTimeout(() => {
      l.value = !1;
    }, 150);
  }, p = () => {
    const h = e.value;
    !h || !c.value || (c.value.measure(), h.dispatchEvent(new Event("scroll", { bubbles: !0 })));
  }, g = () => {
    const h = e.value;
    h && !o && (h.addEventListener("scroll", d, { passive: !0 }), o = !0);
  }, k = () => {
    const h = e.value;
    h && o && (h.removeEventListener("scroll", d), o = !1);
  }, y = () => {
    i && (clearTimeout(i), i = null);
  };
  return et(() => {
    requestAnimationFrame(() => {
      g();
    });
  }), Du(() => {
    requestAnimationFrame(() => {
      p(), g();
    });
  }), Cu(() => {
    y();
  }), rn(() => {
    k(), y();
  }), {
    virtualizer: c,
    virtualItems: f,
    totalSize: m,
    remeasure: p
  };
}
const X$ = {
  key: 1,
  ref: "toolbarSlot",
  class: "v-table-toolbar-slot"
}, J$ = { class: "v-table-container-wrapper" }, Q$ = {
  key: 1,
  class: "v-table-header-checkbox-cell v-table-header-checkbox-cell--empty"
}, eC = ["onClick"], tC = {
  key: 0,
  class: "v-table-total-cell v-table-checkbox-cell"
}, nC = { class: "v-table-total-content" }, aC = {
  key: 0,
  class: "v-table-total-spacer"
}, PD = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "VTable",
  props: /* @__PURE__ */ Ln({
    columns: {},
    data: {},
    loading: { type: Boolean, default: !1 },
    virtualized: { type: Boolean, default: !0 },
    rowHeight: { default: 50 },
    height: {},
    totalRow: {},
    selectedRows: {},
    multiSelect: {},
    expandMode: { default: "auto" },
    sort: { default: () => ({ type: "server", multiple: !0 }) },
    sortState: {},
    pagination: {},
    page: {},
    pageSize: {},
    toolbar: { default: void 0 },
    search: { default: "" },
    rowClassName: {},
    scrollSync: {},
    highlight: { type: [Boolean, Object] },
    highlightState: {},
    highlightSync: {}
  }, {
    search: {},
    searchModifiers: {}
  }),
  emits: /* @__PURE__ */ Ln(["row-click", "update:selected-rows", "expand-click", "update:sort-state", "update:highlight-state", "update:page", "update:pageSize", "request", "sort", "update:search", "toolbar:refresh", "toolbar:reset-sort", "toolbar:export"], ["update:search"]),
  setup(e, { emit: n }) {
    const t = e, a = n, s = Ht(), r = ni(), l = Je("wrapper"), i = Je("fullscreenPlaceholder"), o = Je("toolbarSlot"), u = Je("pagination");
    Na("tableSlots", {
      headerCellCustomAction: s["header-cell-custom-action"],
      toolbarTitle: s["toolbar-title"],
      toolbarSearch: s["toolbar-search"],
      toolbarFilters: s["toolbar-filters"],
      toolbarActions: s["toolbar-actions"],
      toolbarColumnActions: s["toolbar-column-actions"]
    });
    const c = es(e, "search"), f = M(() => {
      var ae;
      return ((ae = t.toolbar) == null ? void 0 : ae.enabled) || s.toolbar;
    }), m = M(() => {
      var ae, we;
      return !!f.value && ((we = (ae = t.toolbar) == null ? void 0 : ae.actions) == null ? void 0 : we.fullscreen) !== !1;
    }), {
      isFullscreen: d,
      zIndex: p,
      placeholderStyle: g,
      panelStyle: k,
      contentHeight: y,
      toggle: h
    } = P$({
      wrapperRef: l,
      placeholderRef: i,
      // The toolbar/pagination chrome is already rendered and is the same size in
      // both fullscreen and normal mode — the composable measures it before the
      // fullscreen flag flips (see useTableFullScreen's enter()) so
      // fullscreenContentHeight is a final px value on the very first fullscreen
      // render (see scrollContainerStyle below).
      chromeRefs: [o, u],
      isEnabled: m,
      // The scroll container's own height changed the instant the fullscreen class
      // applied — the virtualizer's cached scroll element rect is now stale. We
      // don't preserve scroll position across the toggle, so reset to top and
      // force a remeasure (delegated to useVirtualTable's own remeasure()) instead
      // of waiting for the user's next real scroll to reveal any rows.
      onToggle: () => {
        const ae = $t.value;
        ae && (ae.scrollTop = 0, ae.scrollLeft = 0), _e();
      }
    }), b = M(() => r.class), S = M(() => {
      const ae = r.style, we = typeof ae == "object" && ae !== null ? ae : {};
      if (g.value)
        return { ...we, ...g.value };
    }), x = () => {
      var He, Ie;
      a("toolbar:refresh");
      const ae = (Ie = (He = t.toolbar) == null ? void 0 : He.actions) == null ? void 0 : Ie.refresh;
      (typeof ae == "object" ? ae.mode ?? "default" : ae) !== "custom" && (z.value = [], re.value = 1, _t.collapseAll(), yt.clear(), a("request", {
        page: re.value,
        pageSize: me.value,
        sort: []
      }));
    }, C = () => {
      var we, He;
      a("toolbar:reset-sort"), ((He = (we = t.toolbar) == null ? void 0 : we.actions) == null ? void 0 : He.resetSort) !== "custom" && (z.value = [], re.value = 1, _t.collapseAll(), yt.clear(), a("request", {
        page: re.value,
        pageSize: me.value,
        sort: []
      }));
    }, $ = (ae, we) => {
      a("toolbar:export", ae, we);
    }, {
      columnSetupEnabledBasic: _,
      columnSetupConfig: A,
      columnSetupPopoverRef: D,
      columnPickerPopoverRef: Y,
      handleVisibleColumnsUpdate: L,
      handleColumnSetupClose: Z,
      handleColumnPickerClose: se,
      columnPickerEnabled: ie,
      columnPickerConfig: ce,
      effectiveColumns: G
    } = E$({
      columns: () => t.columns,
      columnSetup: () => {
        var ae, we;
        return (we = (ae = t.toolbar) == null ? void 0 : ae.actions) == null ? void 0 : we.columnSetup;
      },
      columnPicker: () => {
        var ae, we;
        return (we = (ae = t.toolbar) == null ? void 0 : ae.actions) == null ? void 0 : we.columnPicker;
      }
    }), le = M(() => t.totalRow !== void 0), q = ee(/* @__PURE__ */ new Map()), {
      hasGroups: N,
      flatColumns: Q,
      headerLevels: he,
      getGroupWidth: pe,
      isGroupFixed: ge
    } = C$(G, q), Ce = M(() => _.value ? N.value ? (console.warn("Column Setup is not supported with grouped headers yet"), !1) : !0 : !1), ye = M(() => N.value ? Q.value : G.value), {
      gridTemplateColumns: K,
      getGridTemplateWithCheckbox: be,
      startResize: Me,
      autoFitColumn: F,
      isResizing: j,
      resizedWidths: H,
      isColumnResizable: I
    } = T$(ye);
    We(H, () => {
      const ae = /* @__PURE__ */ new Map();
      ye.value.forEach((we) => {
        var Ie;
        const He = H.value.get(we.key);
        He !== void 0 ? ae.set(we.key, He) : (Ie = we.width) != null && Ie.endsWith("px") && ae.set(we.key, parseInt(we.width, 10));
      }), q.value = ae;
    }, { immediate: !0 });
    const {
      getFixedStyles: B,
      isLastLeftFixed: X,
      isFirstRightFixed: R
    } = $$(ye, q), te = M(() => t.height ? typeof t.height == "number" ? `${t.height}px` : t.height : "600px"), O = M(() => d.value ? {
      height: `${y.value}px`,
      overscrollBehavior: "contain"
    } : { height: te.value, overscrollBehavior: "contain" }), z = M({
      get: () => t.sortState || [],
      set: (ae) => a("update:sort-state", ae)
    }), V = ea(af, null), re = M({
      get: () => {
        var ae;
        return t.page ?? (V == null ? void 0 : V.value) ?? ((ae = t.pagination) == null ? void 0 : ae.page) ?? 1;
      },
      set: (ae) => {
        t.page !== void 0 ? a("update:page", ae) : V && (V.value = ae);
      }
    }), W = M(() => {
      var ae, we;
      return ((ae = t.pagination) == null ? void 0 : ae.showSizeChanger) ?? ((we = t.pagination) == null ? void 0 : we.pageSizeOptions) !== void 0;
    }), me = M({
      get: () => {
        var ae;
        return t.pageSize ?? ((ae = t.pagination) == null ? void 0 : ae.pageSize) ?? 10;
      },
      set: (ae) => {
        t.pageSize !== void 0 && a("update:pageSize", ae);
      }
    }), {
      getSortState: De,
      handleSortClick: Re,
      sortedData: Ee
    } = V$({
      sort: t.sort,
      sortState: z,
      columns: G,
      page: M(() => {
        var ae;
        return (ae = t.pagination) == null ? void 0 : ae.page;
      }),
      pageSize: M(() => {
        var ae;
        return (ae = t.pagination) == null ? void 0 : ae.pageSize;
      }),
      data: M(() => t.data),
      // Pass data for frontend sorting
      onRequest: (ae) => {
        re.value = ae.page, _t.collapseAll(), yt.clear(), a("request", ae);
      },
      onSort: (ae) => a("sort", ae),
      onUpdateSortState: (ae) => a("update:sort-state", ae)
    }), Ye = (ae) => {
      Re(ae);
    }, At = M(() => {
      var He;
      const ae = ((He = t.sort) == null ? void 0 : He.type) === "front" ? Ee.value : t.data, we = (Ie, ft = "") => Ie.map((Et, Pn) => {
        var Zs;
        const os = Et.id ?? `${ft}row-${Pn}`, Un = (Zs = Et.children) != null && Zs.length ? we(Et.children, `${os}-`) : Et.children;
        return Et.id !== void 0 && Un === Et.children ? Et : { ...Et, id: os, children: Un };
      });
      return we(ae);
    }), Zt = M(
      () => At.value.some((ae) => ae.children && ae.children.length > 0)
    ), Wn = M(() => At.value), _t = M$(Wn), Wt = M(() => Zt.value ? _t.flattenedData.value : At.value), En = M(() => t.multiSelect), Yn = M({
      get: () => t.selectedRows || [],
      set: (ae) => a("update:selected-rows", ae)
    }), xt = F$({
      config: En,
      flattenedData: Wt,
      selectedRows: Yn,
      onSelectionChange: (ae) => {
        a("update:selected-rows", ae);
      }
    }), $t = ee(null), {
      virtualItems: St,
      totalSize: Xt,
      remeasure: _e
    } = Z$(
      $t,
      Wt,
      {
        estimateSize: t.rowHeight,
        overscan: 2,
        // Reduced from 5 for better performance
        // PERFORMANCE: Disable measureElement to prevent memory leaks
        // Using fixed height improves performance dramatically for large datasets
        // Trade-off: scroll bar may be slightly inaccurate with expanded rows
        measureElement: !1
      }
    ), ut = M(() => ({
      display: "grid",
      gridTemplateColumns: xt.isEnabled.value ? be(50) : K.value,
      gridAutoRows: "auto"
      // All rows auto-sized (headers get height from CSS)
    })), Ct = (ae) => {
      a("row-click", ae);
    }, kn = ({ page: ae, pageSize: we }) => {
      !t.pagination || t.loading || ($t.value && $t.value.scrollTop > 0 && $t.value.scrollTo({
        top: 0,
        behavior: "smooth"
      }), re.value = ae, me.value = we, _t.collapseAll(), yt.clear(), a("request", {
        page: ae,
        pageSize: we,
        sort: z.value
      }));
    }, In = (ae) => {
      const we = ae.target;
      t.scrollSync && t.scrollSync.onScroll(we.scrollLeft, we.scrollTop);
    }, Sa = (ae, we, He) => {
      Zt.value && (t.expandMode === "controlled" ? a("expand-click", {
        row: we,
        column: He,
        callback: () => _t.toggleRow(ae),
        expanded: Ta(we)
      }) : (_t.toggleRow(ae), a("expand-click", {
        row: we,
        column: He,
        callback: () => {
        },
        // Already toggled, callback is no-op
        expanded: !Ta(we)
        // New state after toggle
      })));
    }, Ta = (ae) => ae.isExpanded || !1, Xr = (ae) => ae.hasChildren || !1, { getCellValue: Jr, getCellClass: Qr, getCellMetadata: js } = _$({
      isExpandable: Zt,
      isRowExpandable: (ae) => _t.isExpandable(ae)
    });
    Na("tableCellMetadata", js);
    const Hn = M(() => A$(t.highlight)), Gs = () => {
      const ae = yt.pinnedRowId.value, we = yt.pinnedColumnKey.value;
      if (ae === null && we === null) return null;
      const He = ae === null ? -1 : Wt.value.findIndex((Un) => Un.id === ae), Ie = He >= 0 ? Wt.value[He] : void 0, ft = we === null ? void 0 : ye.value.find((Un) => Un.key === we), Et = Ie && ae !== null ? { rowId: ae, rowIndex: He, row: Ie } : null, Pn = ft && we !== null ? { columnKey: we, column: ft } : null;
      let os = null;
      if (Et && Pn) {
        const Un = ye.value.indexOf(Pn.column), Zs = js(Et.row, Pn.column, Un, Et.rowIndex);
        os = {
          value: Et.row[Pn.columnKey],
          formattedValue: String(Zs.formattedValue ?? "")
        };
      }
      return { row: Et, column: Pn, cell: os };
    }, yt = R$({
      config: Hn,
      onChange: (ae) => {
        var we;
        a("update:highlight-state", Gs()), (we = t.highlightSync) == null || we.broadcast(ae);
      }
    }), el = (ae) => {
      yt.applyRemote(ae), a("update:highlight-state", Gs());
    }, Ks = (ae) => yt.isRowPinned(ae);
    Na("tableHighlight", {
      columnEnabled: M(() => Hn.value.column),
      isColumnPinned: yt.isColumnPinned,
      toggleColumn: yt.toggleColumn
    });
    const J = (ae, we) => t.rowClassName ? typeof t.rowClassName == "string" ? t.rowClassName : typeof t.rowClassName == "function" ? t.rowClassName(ae, we) : "" : "", ve = M(() => t.virtualized ? $t.value ? St.value.length === 0 ? [] : St.value.map((ae) => {
      const we = Wt.value[ae.index], He = we ? J(we, ae.index) : "";
      return {
        row: we,
        index: ae.index,
        // CRITICAL: Use row.id as key, not index! Index causes memory leaks
        // because Vue reuses components for different data at same index
        key: (we == null ? void 0 : we.id) || `row-${ae.index}`,
        isVirtual: !0,
        virtualRow: ae,
        rowClass: He,
        isCustomRow: !!He
      };
    }) : [] : Wt.value.map((ae, we) => {
      const He = J(ae, we);
      return {
        row: ae,
        index: we,
        key: ae.id || we,
        isVirtual: !1,
        rowClass: He,
        isCustomRow: !!He
      };
    })), Ae = (ae) => ae.isVirtual ? {
      height: `${t.rowHeight}px`,
      minHeight: `${t.rowHeight}px`
    } : {}, ze = (ae) => {
      const we = [], He = ae.fixed || (N.value ? ge(ae) : null);
      return He && (we.push("v-table-fixed-column"), He === "left" ? we.push("v-table-fixed-left") : He === "right" && we.push("v-table-fixed-right"), X(ae.key) && we.push("v-table-fixed-left-last"), R(ae.key) && we.push("v-table-fixed-right-first")), yt.isColumnPinned(ae.key) && we.push("v-table-cell--pinned-col"), we;
    }, at = M(() => {
      const ae = /* @__PURE__ */ new Map();
      return ye.value.forEach((we) => {
        ae.set(we.key, ze(we));
      }), N.value && he.value.forEach((we) => {
        we.forEach((He) => {
          ae.has(He.column.key) || ae.set(He.column.key, ze(He.column));
        });
      }), ae;
    }), Lt = (ae) => at.value.get(ae.key) ?? [], on = (ae) => ge(ae) ? B(ae) : {}, ra = M(() => N.value ? UM : jM), Ma = M(() => N.value ? he.value : ye.value);
    return rn(() => {
      var ae, we;
      _t && _t.collapseAll(), $t.value = null, (ae = t.scrollSync) == null || ae.unregister(), (we = t.highlightSync) == null || we.unregister();
    }), et(() => {
      var ae;
      (ae = t.highlightSync) == null || ae.register(el), t.scrollSync && $t.value && t.scrollSync.register($t.value);
    }), Hn.value.enabled && (We(() => t.highlightState, (ae) => {
      var Ie, ft;
      const we = ((Ie = ae == null ? void 0 : ae.row) == null ? void 0 : Ie.rowId) ?? null, He = ((ft = ae == null ? void 0 : ae.column) == null ? void 0 : ft.columnKey) ?? null;
      we === yt.pinnedRowId.value && He === yt.pinnedColumnKey.value || yt.setPin({ rowId: we, columnKey: He });
    }), We(Hn, (ae) => {
      if (!ae.enabled) {
        yt.clear();
        return;
      }
      ae.row || yt.unpinRow(), ae.column || yt.unpinColumn();
    })), (ae, we) => {
      var He;
      return w(), T(Te, null, [
        (w(), de(zn, {
          disabled: !v(d),
          to: "body"
        }, [
          E("div", rt({
            ref: "wrapper",
            class: [{
              "v-table-wrapper--with-toolbar": f.value,
              "v-table-wrapper--fullscreen": v(d)
            }, "v-table-wrapper"],
            style: v(d) ? { ...v(k), zIndex: v(p) + 1 } : void 0
          }, v(r)), [
            m.value ? (w(), de(PM, {
              key: 0,
              "is-fullscreen": v(d),
              onToggle: v(h)
            }, null, 8, ["is-fullscreen", "onToggle"])) : P("", !0),
            f.value ? (w(), T("div", X$, [
              v(s).toolbar ? U(ae.$slots, "toolbar", { key: 0 }) : (He = e.toolbar) != null && He.enabled ? (w(), de(y$, {
                key: 1,
                search: c.value,
                "onUpdate:search": we[0] || (we[0] = (Ie) => c.value = Ie),
                config: e.toolbar,
                onExport: $,
                onRefresh: x,
                onResetSort: C
              }, dt({ _: 2 }, [
                Ce.value || v(ie) ? {
                  name: "column-setup",
                  fn: fe(() => [
                    v(ie) ? (w(), de(v(Cr), {
                      key: 0,
                      ref_key: "columnPickerPopoverRef",
                      ref: Y,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: fe(() => [
                        oe(v(qt), {
                          icon: "lucide:columns",
                          variant: "default"
                        })
                      ]),
                      content: fe(() => [
                        oe(iM, {
                          columns: v(G),
                          groups: v(ce).groups,
                          loading: v(ce).loading,
                          "original-columns": t.columns,
                          "storage-key": v(ce).key,
                          "storage-type": v(ce).type,
                          onClose: v(se),
                          "onUpdate:visibleColumns": v(L)
                        }, null, 8, ["columns", "groups", "loading", "original-columns", "storage-key", "storage-type", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : P("", !0),
                    Ce.value ? (w(), de(v(Cr), {
                      key: 1,
                      ref_key: "columnSetupPopoverRef",
                      ref: D,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: fe(() => [
                        oe(v(qt), {
                          icon: "lucide:table-2",
                          variant: "default"
                        })
                      ]),
                      content: fe(() => [
                        oe(SM, {
                          columns: e.columns,
                          config: v(A),
                          onClose: v(Z),
                          "onUpdate:visibleColumns": v(L)
                        }, null, 8, ["columns", "config", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : P("", !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["search", "config"])) : P("", !0)
            ], 512)) : P("", !0),
            E("div", J$, [
              Wt.value.length === 0 ? (w(), de(EM, {
                key: 0,
                description: "Try adjusting your filters or search criteria",
                icon: "lucide:inbox",
                title: "No data to display"
              }, {
                default: fe(() => [
                  U(ae.$slots, "empty-state")
                ]),
                _: 3
              })) : P("", !0),
              oe(ZM, { loading: e.loading }, null, 8, ["loading"]),
              E("div", {
                ref_key: "scrollContainerRef",
                ref: $t,
                class: ne([{ "v-table-scroll-container--loading": e.loading }, "v-table-scroll-container v-table-scrollbar-styled"]),
                style: Ve(O.value),
                onScrollPassive: In
              }, [
                E("div", {
                  class: ne([{
                    "v-is-resizing": v(j),
                    "v-table-grid--highlight": v(yt).hasPin.value
                  }, "v-table-grid"]),
                  style: Ve(ut.value)
                }, [
                  (w(), de(ht(ra.value), {
                    columns: Ma.value,
                    "get-column-classes": Lt,
                    "get-fixed-styles": v(B),
                    "get-group-fixed-styles": on,
                    "get-group-width": v(pe),
                    "get-sort-state": v(De),
                    "is-column-resizable": v(I),
                    onResizeStart: v(Me),
                    onResizeDblclick: v(F),
                    onSortClick: Ye
                  }, dt({ _: 2 }, [
                    v(xt).isEnabled.value ? {
                      name: "checkbox-header",
                      fn: fe(() => {
                        var Ie;
                        return [
                          ((Ie = En.value) == null ? void 0 : Ie.showHeaderCheckbox) !== !1 ? (w(), de(RM, {
                            key: 0,
                            state: v(xt).getHeaderCheckboxState(),
                            onToggle: v(xt).toggleAllRows
                          }, null, 8, ["state", "onToggle"])) : (w(), T("div", Q$))
                        ];
                      }),
                      key: "0"
                    } : void 0,
                    Pe(ye.value, (Ie) => ({
                      name: `header-icon-${Ie.key}`,
                      fn: fe((ft) => [
                        U(ae.$slots, `header-icon-${Ie.key}`, Mt(Bt(ft)))
                      ])
                    })),
                    Pe(ye.value, (Ie) => ({
                      name: `header-${Ie.key}`,
                      fn: fe((ft) => [
                        U(ae.$slots, `header-${Ie.key}`, Mt(Bt(ft)))
                      ])
                    }))
                  ]), 1064, ["columns", "get-fixed-styles", "get-group-width", "get-sort-state", "is-column-resizable", "onResizeStart", "onResizeDblclick"])),
                  t.virtualized && v(St).length > 0 && v(St)[0] ? (w(), T("div", {
                    key: 0,
                    style: Ve({ height: `${v(St)[0].start}px` }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : P("", !0),
                  (w(!0), T(Te, null, Pe(ve.value, (Ie) => (w(), T("div", {
                    key: Ie.key,
                    class: ne([{ "v-table-row-wrapper--pinned": Ks(Ie.row.id) }, "v-table-row-wrapper"]),
                    style: Ve(Ae(Ie)),
                    onClick: (ft) => Ct(Ie.row)
                  }, [
                    v(xt).isEnabled.value ? (w(), de(wT, {
                      key: 0,
                      checked: v(xt).isRowSelected(Ie.row.id),
                      class: ne(Ie.rowClass),
                      "data-custom-row": Ie.isCustomRow ? "true" : void 0,
                      disabled: !v(xt).isRowSelectable(Ie.row),
                      indeterminate: v(xt).isDependentMode.value && Xr(Ie.row) && v(xt).getParentCheckboxState(Ie.row) === "indeterminate",
                      onToggle: (ft) => v(xt).toggleRow(Ie.row)
                    }, null, 8, ["checked", "class", "data-custom-row", "disabled", "indeterminate", "onToggle"])) : P("", !0),
                    (w(!0), T(Te, null, Pe(ye.value, (ft, Et) => (w(), de(lu, {
                      key: ft.key,
                      align: ft.align,
                      class: ne([
                        Lt(ft),
                        Ie.rowClass,
                        { "v-table-cell--pin-host": Hn.value.row && Et === 0 }
                      ]),
                      "col-index": Et,
                      column: ft,
                      "data-custom-row": Ie.isCustomRow ? "true" : void 0,
                      interactive: ft.interactive,
                      "is-expanded": !!Ie.row.isExpanded,
                      row: Ie.row,
                      "row-index": Ie.index,
                      style: Ve(v(B)(ft)),
                      onToggleExpand: (Pn) => Sa(Ie.row.id, Ie.row, ft)
                    }, dt({ _: 2 }, [
                      Hn.value.row && Et === 0 ? {
                        name: "pin",
                        fn: fe(() => [
                          oe(Zd, {
                            pinned: Ks(Ie.row.id),
                            label: "row",
                            onToggle: (Pn) => v(yt).toggleRow(Ie.row.id)
                          }, null, 8, ["pinned", "onToggle"])
                        ]),
                        key: "0"
                      } : void 0,
                      v(s)[`cell-${ft.key}`] ? {
                        name: "default",
                        fn: fe(() => [
                          U(ae.$slots, `cell-${ft.key}`, {
                            column: ft,
                            depth: Ie.row.depth || 0,
                            index: Ie.index,
                            row: Ie.row,
                            value: Ie.row[ft.key]
                          })
                        ]),
                        key: "1"
                      } : void 0
                    ]), 1032, ["align", "class", "col-index", "column", "data-custom-row", "interactive", "is-expanded", "row", "row-index", "style", "onToggleExpand"]))), 128))
                  ], 14, eC))), 128)),
                  t.virtualized && v(St).length > 0 && v(St)[v(St).length - 1] ? (w(), T("div", {
                    key: 1,
                    style: Ve({
                      height: `${v(Xt) - v(St)[v(St).length - 1].end}px`
                    }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : P("", !0),
                  le.value && e.totalRow ? (w(), T(Te, { key: 2 }, [
                    v(xt).isEnabled.value ? (w(), T("div", tC)) : P("", !0),
                    (w(!0), T(Te, null, Pe(ye.value, (Ie, ft) => (w(), de(lu, {
                      key: Ie.key,
                      align: Ie.align,
                      class: ne([Lt(Ie), "v-table-total-cell"]),
                      style: Ve(v(B)(Ie))
                    }, {
                      default: fe(() => [
                        E("div", nC, [
                          ft === 0 && Zt.value ? (w(), T("div", aC)) : P("", !0),
                          E("div", {
                            class: ne([{ "v-table-total-text--truncate": !Ie.interactive }, "v-table-total-text"])
                          }, [
                            U(ae.$slots, `total-cell-${Ie.key}`, {
                              column: Ie,
                              row: e.totalRow,
                              value: e.totalRow[Ie.key]
                            }, () => [
                              oe(yT, {
                                class: ne(v(Qr)(e.totalRow[Ie.key], Ie, e.totalRow)),
                                interactive: Ie.interactive,
                                value: v(Jr)(e.totalRow[Ie.key], Ie, e.totalRow)
                              }, null, 8, ["class", "interactive", "value"])
                            ])
                          ], 2)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["align", "class", "style"]))), 128))
                  ], 64)) : P("", !0)
                ], 6)
              ], 38)
            ]),
            e.pagination ? (w(), de(c$, {
              key: 2,
              ref: "pagination",
              loading: e.loading,
              page: re.value,
              "page-size": me.value,
              "page-size-options": e.pagination.pageSizeOptions || [10, 25, 50, 100],
              "show-size-changer": W.value,
              total: e.pagination.total,
              onPageChange: kn
            }, null, 8, ["loading", "page", "page-size", "page-size-options", "show-size-changer", "total"])) : P("", !0)
          ], 16)
        ], 8, ["disabled"])),
        v(g) ? (w(), T("div", {
          key: 0,
          ref: "fullscreenPlaceholder",
          class: ne(b.value),
          style: Ve(S.value),
          "aria-hidden": "true"
        }, null, 6)) : P("", !0)
      ], 64);
    };
  }
}), sC = { class: "delta-value flex flex-col" }, AD = /* @__PURE__ */ Se({
  __name: "DeltaValue",
  props: {
    value: { default: void 0 },
    delta: { default: void 0 },
    format: { default: void 0 },
    deltaFormat: { default: void 0 },
    deltaAsPercentage: { type: Boolean, default: !0 },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showZeroDelta: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = M(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta < 0 : n.delta > 0), a = M(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta > 0 : n.delta < 0), s = M(() => n.delta === 0), r = M(() => n.delta === null || n.delta === void 0 ? !1 : n.showZeroDelta || n.delta !== 0), l = M(() => {
      var f;
      if (n.delta === null || n.delta === void 0) return "";
      const u = Math.abs(n.delta);
      if (n.deltaFormat) {
        const { type: m = "number", decimals: d = 0, currencyCode: p = "USD" } = n.deltaFormat;
        switch (m) {
          case "currency":
            return new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: p,
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u);
          case "percentage":
            return `${new Intl.NumberFormat("en-US", {
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u)}%`;
          default:
            return new Intl.NumberFormat("en-US", {
              minimumFractionDigits: d,
              maximumFractionDigits: d
            }).format(u);
        }
      }
      const c = u.toFixed(((f = n.format) == null ? void 0 : f.decimals) ?? 0);
      return n.deltaAsPercentage ? `${c}%` : c;
    }), i = M(() => {
      if (n.value === null || n.value === void 0) return null;
      if (typeof n.value == "string") return n.value;
      const { type: u = "number", decimals: c = 0, currencyCode: f = "USD" } = n.format || {};
      switch (u) {
        case "currency":
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: f,
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value);
        case "percentage":
          return `${new Intl.NumberFormat("en-US", {
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value)}%`;
        default:
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: c,
            maximumFractionDigits: c
          }).format(n.value);
      }
    }), o = M(() => {
      switch (n.size) {
        case "sm":
          return {
            value: "text-sm",
            delta: "text-xs",
            icon: 14
          };
        case "lg":
          return {
            value: "text-lg font-semibold",
            delta: "text-sm",
            icon: 20
          };
        default:
          return {
            value: "text-base",
            delta: "text-sm",
            icon: 16
          };
      }
    });
    return (u, c) => (w(), T("div", sC, [
      i.value !== null ? (w(), T("span", {
        key: 0,
        class: ne([o.value.value, "text-mainText"])
      }, ue(i.value), 3)) : P("", !0),
      r.value ? (w(), T("div", {
        key: 1,
        class: ne([o.value.delta, "flex items-center gap-0.5"])
      }, [
        t.value ? (w(), de(v(ke), {
          key: 0,
          size: o.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : a.value ? (w(), de(v(ke), {
          key: 1,
          size: o.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : s.value ? (w(), de(v(ke), {
          key: 2,
          size: o.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : P("", !0),
        E("span", {
          class: ne({
            "text-success": t.value,
            "text-negative": a.value,
            "text-secondaryText": s.value
          })
        }, ue(l.value), 3)
      ], 2)) : P("", !0)
    ]));
  }
}), RD = /* @__PURE__ */ Se({
  __name: "DeltaIndicator",
  props: {
    value: { default: 0 },
    format: { default: () => {
    } },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showIcon: { type: Boolean, default: !0 },
    showZero: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = M(
      () => e.value !== null && e.value !== void 0
    ), t = M(
      () => n.value && (e.showZero || e.value !== 0)
    ), a = M(() => n.value ? e.reverse ? e.value < 0 : e.value > 0 : null), s = M(() => n.value ? e.reverse ? e.value > 0 : e.value < 0 : null), r = M(() => e.value === 0), l = M(() => {
      if (!n.value) return "";
      const o = e.format;
      if (!o) return String(e.value);
      if (o.currency !== void 0) {
        if (typeof o.currency == "object") {
          const { code: u, decimals: c } = o.currency;
          return Cs(e.value, { code: u, decimals: c });
        }
        return typeof o.currency == "string" ? Cs(e.value, o.currency) : Cs(e.value);
      }
      return o.percentage !== void 0 ? Oi(e.value, o.percentage === !0 ? void 0 : o.percentage) : o.number !== void 0 ? Ua(e.value, o.number) : String(e.value);
    }), i = M(() => {
      switch (e.size) {
        case "sm":
          return { text: "text-xs", icon: 12 };
        case "lg":
          return { text: "text-sm font-semibold", icon: 18 };
        default:
          return { text: "text-sm", icon: 14 };
      }
    });
    return (o, u) => t.value ? (w(), T("div", {
      key: 0,
      class: ne([i.value.text, "flex items-center gap-0.5"])
    }, [
      e.showIcon ? (w(), T(Te, { key: 0 }, [
        a.value ? (w(), de(v(ke), {
          key: 0,
          size: i.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : s.value ? (w(), de(v(ke), {
          key: 1,
          size: i.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : r.value ? (w(), de(v(ke), {
          key: 2,
          size: i.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : P("", !0)
      ], 64)) : P("", !0),
      E("span", {
        class: ne({
          "text-success": a.value,
          "text-negative": s.value,
          "text-secondaryText": r.value
        })
      }, ue(l.value), 3)
    ], 2)) : P("", !0);
  }
}), rC = { class: "v-table-title-block" }, lC = { class: "v-table-title-block__title-section" }, iC = {
  key: 1,
  class: "v-table-title-block__title"
}, oC = {
  key: 2,
  class: "v-table-title-block__separator"
}, uC = {
  key: 0,
  class: "v-table-title-block__actions"
}, cC = /* @__PURE__ */ Se({
  __name: "TableTitleBlock",
  props: {
    title: { default: "" },
    icon: { default: "" }
  },
  setup(e) {
    return (n, t) => (w(), T("div", rC, [
      E("div", lC, [
        e.icon ? (w(), de(v(ke), {
          key: 0,
          icon: e.icon,
          size: 20,
          class: "v-table-title-block__icon"
        }, null, 8, ["icon"])) : P("", !0),
        e.title ? (w(), T("h3", iC, ue(e.title), 1)) : P("", !0),
        e.title && n.$slots.default ? (w(), T("span", oC)) : P("", !0)
      ]),
      n.$slots.default ? (w(), T("div", uC, [
        U(n.$slots, "default", {}, void 0, !0)
      ])) : P("", !0)
    ]));
  }
}), FD = /* @__PURE__ */ je(cC, [["__scopeId", "data-v-c3a3c2e6"]]);
function dC(e) {
  const {
    granularity: n,
    dateRange: t,
    includeSummary: a = !1,
    onPeriodChange: s
  } = e, r = ee(null), l = ee(!0), i = M(() => {
    const g = n.value, k = [], y = g === "MONTH" ? "All Months" : g === "WEEK" ? "All Weeks" : "All Days";
    return k.push({ label: y, value: "all" }), a && k.push({ label: "Summary", value: "summary" }), g === "MONTH" ? k.push(...u()) : g === "WEEK" ? k.push(...c()) : g === "DAY" && k.push(...f()), k;
  }), o = M(() => i.value[0]);
  function u() {
    const { since: g, until: k } = t.value, y = Oe.fromISO(g, { zone: "utc" }), h = Oe.fromISO(k, { zone: "utc" }), b = [];
    let S = y.startOf("month");
    for (; S <= h; )
      b.push({
        label: S.toFormat("MMMM yyyy"),
        value: S.toISODate()
      }), S = S.plus({ months: 1 });
    return b.sort(
      (x, C) => Oe.fromISO(C.value).toMillis() - Oe.fromISO(x.value).toMillis()
    );
  }
  function c() {
    const { since: g, until: k } = t.value, y = Oe.fromISO(g, { zone: "utc" }), h = Oe.fromISO(k, { zone: "utc" }), b = Oe.utc().startOf("day"), S = [];
    let x = y.startOf("week").plus({ days: 6 });
    for (; x <= h && x < b; )
      S.push({
        label: x.toFormat("MM/dd/yyyy"),
        value: x.toISODate()
      }), x = x.plus({ weeks: 1 });
    return S.sort(
      (C, $) => Oe.fromISO($.value).toMillis() - Oe.fromISO(C.value).toMillis()
    );
  }
  function f() {
    const { since: g, until: k } = t.value, y = Oe.fromISO(g, { zone: "utc" }), h = Oe.fromISO(k, { zone: "utc" }), b = Oe.utc().startOf("day"), S = [];
    let x = y;
    for (; x <= h && x < b; )
      S.push({
        label: x.toFormat("MM/dd/yyyy"),
        value: x.toISODate()
      }), x = x.plus({ days: 1 });
    return S.sort(
      (C, $) => Oe.fromISO($.value).toMillis() - Oe.fromISO(C.value).toMillis()
    );
  }
  const m = M(() => {
    var y;
    const g = (y = r.value) == null ? void 0 : y.value;
    if (!g || g === "all" || g === "summary")
      return {};
    const k = n.value;
    if (k === "MONTH") {
      const b = Oe.fromISO(g, { zone: "utc" }).endOf("month");
      return {
        period: {
          since: g,
          until: b.toISODate()
        }
      };
    }
    if (k === "WEEK") {
      const h = Oe.fromISO(g, { zone: "utc" });
      return {
        period: {
          since: g,
          until: h.plus({ days: 6 }).toISODate()
        }
      };
    }
    return k === "DAY" ? {
      period: {
        since: g,
        until: g
      }
    } : {};
  }), d = (g) => {
    r.value = g, l.value = g.value !== "summary", s && s(m.value, l.value);
  }, p = async () => {
    r.value = o.value, l.value = !0, s && s(m.value, l.value);
  };
  return We(
    () => [n.value, t.value],
    () => {
      p();
    },
    { flush: "pre", deep: !0 }
  ), r.value || (r.value = o.value), {
    /** Currently selected period */
    selectedPeriod: r,
    /** Available period options for dropdown */
    periodOptions: i,
    /** Default period option */
    defaultPeriod: o,
    /** Request params to spread into API call */
    periodRequestParams: m,
    /** Whether to group by date (false when "Summary" is selected) */
    isGroupByDate: l,
    /** Handle period selection change */
    handlePeriodChange: d,
    /** Reset to default period */
    resetPeriod: p
  };
}
const fC = { class: "w-[160px]" }, VD = /* @__PURE__ */ Se({
  __name: "TablePeriodSelect",
  props: {
    granularity: {},
    dateRange: {},
    includeSummary: { type: Boolean, default: !1 },
    widthClass: { default: "w-40" },
    placeholder: { default: "Select period" }
  },
  emits: ["change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, {
      selectedPeriod: r,
      periodOptions: l,
      periodRequestParams: i,
      isGroupByDate: o,
      handlePeriodChange: u
    } = dC({
      granularity: vr(a, "granularity"),
      dateRange: vr(a, "dateRange"),
      includeSummary: a.includeSummary,
      onPeriodChange: () => {
        c();
      }
    }), c = () => {
      s("change", {
        selected: r.value,
        requestParams: i.value,
        isGroupByDate: o.value
      });
    }, f = (m) => {
      u(m);
    };
    return n({
      selectedPeriod: r,
      periodRequestParams: i,
      isGroupByDate: o
    }), (m, d) => (w(), T("div", fC, [
      oe(v(Mk), rt({
        modelValue: v(r),
        "onUpdate:modelValue": d[0] || (d[0] = (p) => Ou(r) ? r.value = p : null),
        class: e.widthClass,
        "close-on-select": !0,
        options: v(l),
        placeholder: e.placeholder,
        searchable: !1
      }, m.$attrs, { onSelect: f }), null, 16, ["modelValue", "class", "options", "placeholder"])
    ]));
  }
}), hC = /* @__PURE__ */ Se({
  __name: "TableExpandAdditionalHeadersButton",
  props: {
    isExpanded: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, s) => (w(), T("button", {
      class: ne([{ "is-expanded": e.isExpanded }, "expand-button"]),
      type: "button",
      onClick: s[0] || (s[0] = Fe((r) => t("click"), ["stop"]))
    }, [
      oe(v(ke), {
        size: 16,
        class: "expand-icon",
        icon: "lucide:chevron-right"
      })
    ], 2));
  }
}), LD = /* @__PURE__ */ je(hC, [["__scopeId", "data-v-41dc3668"]]), ua = /* @__PURE__ */ new Map(), ND = (e, n, t) => {
  const a = (t == null ? void 0 : t.paginationMode) === "sync" ? t.totalPages : void 0, s = (t == null ? void 0 : t.paginationMode) ?? "independent", r = (t == null ? void 0 : t.initialPage) ?? 1, l = t == null ? void 0 : t.namespace, i = l ? `${l}:${e}` : e, o = n.filter((h) => h !== e), u = ee(r), c = ee(null), f = {
    scrollEl: null,
    scrollPosition: c,
    isReceivingScroll: !1,
    pendingScrollX: 0,
    pendingScrollY: 0,
    scrollRafId: null,
    page: u,
    paginationMode: s,
    totalPages: a,
    receiveHighlight: null,
    isReceivingHighlight: !1
  };
  ua.set(i, f);
  const m = (h) => l ? `${l}:${h}` : h, d = {
    register: (h) => {
      f.scrollEl = h;
      for (const b of o) {
        const S = ua.get(m(b));
        if (S != null && S.scrollEl) {
          h.scrollLeft = S.scrollEl.scrollLeft, h.scrollTop = S.scrollEl.scrollTop;
          break;
        }
      }
    },
    unregister: () => {
      f.scrollEl = null;
    },
    onScroll: (h, b) => {
      f.isReceivingScroll || o.forEach((S) => {
        const x = ua.get(m(S));
        !x || !x.scrollEl || x.scrollEl.scrollLeft === h && x.scrollEl.scrollTop === b || (x.pendingScrollX = h, x.pendingScrollY = b, x.scrollRafId === null && (x.scrollRafId = requestAnimationFrame(() => {
          x.scrollRafId = null, x.scrollEl && (x.isReceivingScroll = !0, x.scrollEl.scrollLeft = x.pendingScrollX, x.scrollEl.scrollTop = x.pendingScrollY, requestAnimationFrame(() => {
            x.isReceivingScroll = !1;
          }));
        })));
      });
    },
    scrollPosition: c
  }, p = {
    register: (h) => {
      f.receiveHighlight = h;
    },
    unregister: () => {
      f.receiveHighlight = null;
    },
    // No rAF throttling here, unlike onScroll: this fires once per click.
    broadcast: (h) => {
      f.isReceivingHighlight || o.forEach((b) => {
        const S = ua.get(m(b));
        S != null && S.receiveHighlight && (S.isReceivingHighlight = !0, S.receiveHighlight(h), S.isReceivingHighlight = !1);
      });
    }
  }, g = (h) => {
    u.value = h, o.forEach((b) => {
      const S = ua.get(m(b));
      if (!(!S || S.paginationMode === "independent")) {
        if (S.paginationMode === "reset") {
          S.page.value = 1;
          return;
        }
        S.totalPages && (S.page.value = Math.min(h, S.totalPages.value));
      }
    });
  }, k = (h = 1) => {
    var b;
    f.page.value = h, f.scrollPosition.value = null, (b = f.receiveHighlight) == null || b.call(f, { rowId: null, columnKey: null }), f.scrollEl && (f.scrollEl.scrollLeft = 0, f.scrollEl.scrollTop = 0), o.forEach((S) => {
      var C;
      const x = ua.get(m(S));
      x && (x.page.value = h, x.scrollPosition.value = null, (C = x.receiveHighlight) == null || C.call(x, { rowId: null, columnKey: null }), x.scrollEl && (x.scrollEl.scrollLeft = 0, x.scrollEl.scrollTop = 0));
    });
  }, y = t == null ? void 0 : t.resetOn;
  return y !== void 0 && We(() => Qe(y), () => k()), _r(() => {
    ua.delete(i);
  }), {
    // markRaw prevents reactive() from deep-wrapping the controllers
    link: ga({
      scrollSync: Ni(d),
      highlightSync: Ni(p),
      page: u,
      "onUpdate:page": g
    }),
    resetState: k
  };
};
function BD(e, n = 100, t = !1) {
  const a = Math.max(0, Math.min(1, e / n)), s = Math.round(t ? 255 * a : 255 * (1 - a)), r = Math.round(t ? 255 * (1 - a) : 255 * a);
  return `rgba(${s}, ${r}, 0, 0.4)`;
}
function zD(e) {
  const n = Math.max(0, Math.min(100, e)), t = Math.round(255 * (100 - n) / 100), a = Math.round(255 * n / 100);
  return `bg-[rgb(${t},${a},0)]`;
}
const WD = () => ({
  success: (i, o) => {
    oa.success(i, {
      description: o,
      duration: 4e3
    });
  },
  error: (i, o) => {
    oa.error(i, {
      description: o,
      duration: 5e3
    });
  },
  warning: (i, o) => {
    oa.warning(i, {
      description: o,
      duration: 4e3
    });
  },
  info: (i, o) => {
    oa.info(i, {
      description: o,
      duration: 4e3
    });
  },
  promise: (i, o) => oa.promise(i, o),
  custom: (i, o) => oa(i, o),
  dismiss: (i) => {
    oa.dismiss(i);
  }
}), rf = Symbol("SidebarState");
function mC(e) {
  const n = M(
    () => Ou(e.items) ? e.items.value : e.items
  ), t = () => {
    e.isCollapsed.value = !e.isCollapsed.value;
  }, a = (u) => {
    const c = e.expandedItems.value;
    c.has(u) ? c.delete(u) : c.add(u), e.expandedItems.value = new Set(c);
  }, s = (u) => {
    if (!u.length) return;
    const c = new Set(e.expandedItems.value);
    u.forEach((f) => c.add(f)), e.expandedItems.value = c;
  }, r = (u) => e.expandedItems.value.has(u), l = () => {
    e.isMobileOpen.value = !0;
  }, i = () => {
    e.isMobileOpen.value = !1;
  }, o = () => {
    e.isMobileOpen.value = !e.isMobileOpen.value;
  };
  return {
    isCollapsed: e.isCollapsed,
    isMobileOpen: e.isMobileOpen,
    expandedItems: e.expandedItems,
    resolvedItems: n,
    options: e.options,
    toggleCollapse: t,
    toggleExpanded: a,
    expandMany: s,
    isExpanded: r,
    openMobile: l,
    closeMobile: i,
    toggleMobile: o
  };
}
function is() {
  const e = ea(rf);
  if (!e)
    throw new Error(
      '[NavigationSidebar] useSidebarState() called outside of <NavigationSidebar>. Make sure the component is wrapped in <NavigationSidebar :sidebar="...">.'
    );
  return e;
}
function lf(e, n = []) {
  const t = ai();
  return { resolvedTo: M(() => {
    const s = e.to;
    if (!s) return;
    if (!n.length) return s;
    const r = {};
    for (const l of n) {
      const i = t.query[l];
      i != null && (r[l] = Array.isArray(i) ? i[0] ?? "" : i);
    }
    return Object.keys(r).length ? typeof s == "string" ? { path: s, query: r } : {
      ...s,
      query: {
        ...r,
        ...s.query ?? {}
      }
    } : s;
  }) };
}
const vC = { class: "sidebar-flyout__item-label" }, pC = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, gC = /* @__PURE__ */ Se({
  __name: "SidebarMenuFlyoutItem",
  props: {
    item: {}
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n, { isActive: a, onPrefetch: s, options: r } = is(), { resolvedTo: l } = lf(e.item, r.persistentQueryParams), i = M(() => a(e.item.id)), o = M(() => ({
      "sidebar-flyout__item--active": i.value,
      "sidebar-flyout__item--disabled": e.item.disabled
    })), u = () => {
      e.item.disabled || !l.value || s(l.value);
    }, c = () => {
      e.item.disabled || t("click", e.item);
    };
    return (f, m) => {
      const d = _u("router-link");
      return e.item.to ? (w(), de(d, {
        key: 0,
        "aria-current": i.value ? "page" : void 0,
        class: ne([o.value, "sidebar-flyout__item"]),
        style: Ve(`--depth: ${e.item.level}`),
        to: v(l),
        onClick: c,
        onMouseenter: u
      }, {
        default: fe(() => [
          e.item.icon ? (w(), de(ke, {
            key: 0,
            icon: e.item.icon,
            size: 16,
            class: "sidebar-flyout__item-icon"
          }, null, 8, ["icon"])) : P("", !0),
          E("span", vC, ue(e.item.label), 1),
          e.item.badge ? (w(), T("span", pC, ue(e.item.badge), 1)) : P("", !0)
        ]),
        _: 1
      }, 8, ["aria-current", "class", "style", "to"])) : P("", !0);
    };
  }
}), yC = { class: "sidebar-flyout__item-label" }, bC = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, wC = /* @__PURE__ */ Se({
  __name: "SidebarMenuFlyoutParent",
  props: {
    item: {}
  },
  setup(e) {
    return (n, t) => (w(), T("div", {
      style: Ve(`--depth: ${e.item.level}`),
      class: "sidebar-flyout__item sidebar-flyout__item--parent"
    }, [
      e.item.icon ? (w(), de(ke, {
        key: 0,
        icon: e.item.icon,
        size: 16,
        class: "sidebar-flyout__item-icon"
      }, null, 8, ["icon"])) : P("", !0),
      E("span", yC, ue(e.item.label), 1),
      e.item.badge ? (w(), T("span", bC, ue(e.item.badge), 1)) : P("", !0)
    ], 4));
  }
}), kC = { class: "sidebar-flyout" }, xC = { class: "sidebar-flyout__title" }, SC = { class: "sidebar-flyout__list" }, xu = 16, TC = /* @__PURE__ */ Se({
  __name: "SidebarMenuFlyout",
  props: {
    item: {}
  },
  setup(e) {
    const { closeMobile: n } = is(), t = ee(!1), a = ee(null), s = ee(null), r = ee({ top: 0, left: 0, right: 0 }), l = ee(!1), { width: i, height: o } = k1(), u = () => {
      if (!a.value || !s.value) return;
      const h = a.value.getBoundingClientRect(), b = s.value.getBoundingClientRect(), S = h.right + 8, x = s.value.offsetHeight, C = Math.max(
        xu,
        Math.min(h.top, o.value - xu - x)
      );
      S + b.width > i.value - 20 ? (l.value = !0, r.value = {
        top: C,
        right: i.value - h.left + 8,
        left: 0
      }) : (l.value = !1, r.value = { top: C, left: S, right: 0 });
    };
    We([i, o], () => {
      t.value && u();
    });
    const { start: c, stop: f } = Xl(async () => {
      t.value = !0, await Ze(), requestAnimationFrame(u);
    }, 150, { immediate: !1 }), { start: m, stop: d } = Xl(() => {
      t.value = !1;
    }, 100, { immediate: !1 }), p = () => {
      if (d(), !t.value) {
        if (a.value) {
          const h = a.value.getBoundingClientRect();
          r.value = { top: h.top, left: h.right + 8, right: 0 };
        }
        c();
      }
    }, g = () => {
      f(), m();
    }, k = M(() => {
      const h = (b, S = 0) => {
        var C;
        const x = [];
        for (const $ of b)
          x.push({ ...$, level: S }), (C = $.children) != null && C.length && x.push(...h($.children, S + 1));
        return x;
      };
      return e.item.children ? h(e.item.children) : [];
    }), y = (h) => {
      h.disabled || (n(), t.value = !1);
    };
    return (h, b) => (w(), T("div", {
      ref_key: "buttonRef",
      ref: a,
      class: "sidebar-flyout-trigger",
      onMouseenter: p,
      onMouseleave: g
    }, [
      U(h.$slots, "default", {}, void 0, !0),
      (w(), de(zn, { to: "body" }, [
        oe(Dt, {
          "enter-active-class": "sidebar-flyout-enter-active",
          "enter-from-class": "sidebar-flyout-enter-from",
          "enter-to-class": "sidebar-flyout-enter-to",
          "leave-active-class": "sidebar-flyout-leave-active",
          "leave-from-class": "sidebar-flyout-leave-from",
          "leave-to-class": "sidebar-flyout-leave-to"
        }, {
          default: fe(() => {
            var S;
            return [
              t.value && ((S = e.item.children) != null && S.length) ? (w(), T("div", {
                key: 0,
                style: Ve({
                  top: `${r.value.top}px`,
                  ...l.value ? { right: `${r.value.right - 8}px` } : { left: `${r.value.left - 8}px` }
                }),
                class: "sidebar-flyout-portal",
                onMouseenter: p,
                onMouseleave: g
              }, [
                E("div", {
                  class: ne([l.value ? "sidebar-flyout-bridge--left" : "sidebar-flyout-bridge--right", "sidebar-flyout-bridge"])
                }, null, 2),
                E("div", {
                  ref_key: "flyoutRef",
                  ref: s,
                  class: "sidebar-flyout-content"
                }, [
                  E("div", kC, [
                    E("div", xC, ue(e.item.label), 1),
                    E("div", SC, [
                      (w(!0), T(Te, null, Pe(k.value, (x) => (w(), T(Te, {
                        key: x.id
                      }, [
                        x.to ? (w(), de(gC, {
                          key: 0,
                          item: x,
                          onClick: y
                        }, null, 8, ["item"])) : (w(), de(wC, {
                          key: 1,
                          item: x
                        }, null, 8, ["item"]))
                      ], 64))), 128))
                    ])
                  ])
                ], 512)
              ], 36)) : P("", !0)
            ];
          }),
          _: 1
        })
      ]))
    ], 544));
  }
}), MC = /* @__PURE__ */ je(TC, [["__scopeId", "data-v-c6f7104b"]]), $C = ["aria-label"], CC = ["title"], DC = {
  key: 1,
  class: "sidebar-item__badge"
}, OC = { class: "sidebar-item-children__inner" }, _C = /* @__PURE__ */ Se({
  __name: "SidebarNavItem",
  props: {
    item: {},
    level: { default: 0 }
  },
  setup(e) {
    const {
      isCollapsed: n,
      isExpanded: t,
      toggleExpanded: a,
      closeMobile: s,
      isActive: r,
      isOnActivePath: l,
      onPrefetch: i,
      options: o
    } = is(), { resolvedTo: u } = lf(e.item, o.persistentQueryParams), c = Je("label"), f = ee(!1), m = M(() => {
      var x;
      return !!((x = e.item.children) != null && x.length);
    }), d = M(() => m.value && t(e.item.id)), p = M(() => r(e.item.id)), g = M(
      () => !p.value && m.value && l(e.item.id)
    ), k = () => {
      m.value || e.item.disabled || !u.value || i(u.value);
    }, y = () => {
      const x = c.value;
      x && (f.value = x.scrollWidth > x.clientWidth);
    }, h = () => {
      if (!e.item.disabled) {
        if (e.item.onClick) {
          e.item.onClick(), s();
          return;
        }
        m.value ? a(e.item.id) : s();
      }
    }, b = M(() => e.item.icon ?? null), S = M(() => ({
      "sidebar-item--active": p.value,
      "sidebar-item--has-active-child": g.value,
      "sidebar-item--disabled": e.item.disabled,
      "sidebar-item--collapsed": n.value,
      "sidebar-item--nested": e.level > 0,
      "sidebar-item--no-icon": !b.value
    }));
    return (x, C) => {
      const $ = _u("SidebarNavItem", !0);
      return w(), T("div", {
        style: Ve(`--depth: ${e.level}`),
        class: "sidebar-item-wrapper"
      }, [
        v(n) && m.value && !e.item.disabled ? (w(), de(MC, {
          key: 0,
          item: e.item
        }, {
          default: fe(() => [
            E("button", {
              "aria-label": e.item.label,
              class: ne([{
                "sidebar-item--active": p.value,
                "sidebar-item--has-active-child": g.value
              }, "sidebar-item sidebar-item--collapsed"]),
              type: "button",
              onClick: h
            }, [
              e.item.icon ? (w(), de(ke, {
                key: 0,
                icon: e.item.icon,
                size: 20,
                class: "sidebar-item__icon"
              }, null, 8, ["icon"])) : P("", !0)
            ], 10, $C)
          ]),
          _: 1
        }, 8, ["item"])) : v(n) && !e.item.disabled ? (w(), de(Ja, {
          key: 1,
          delay: 200,
          text: e.item.label,
          placement: "right"
        }, {
          default: fe(() => [
            (w(), de(ht(e.item.to ? "router-link" : "button"), {
              "aria-label": e.item.label,
              class: ne([{ "sidebar-item--active": p.value }, "sidebar-item sidebar-item--collapsed"]),
              disabled: e.item.disabled || void 0,
              to: e.item.to ? v(u) : void 0,
              type: e.item.to ? void 0 : "button",
              onClick: h,
              onMouseenter: k
            }, {
              default: fe(() => [
                e.item.icon ? (w(), de(ke, {
                  key: 0,
                  icon: e.item.icon,
                  size: 20,
                  class: "sidebar-item__icon"
                }, null, 8, ["icon"])) : P("", !0)
              ]),
              _: 1
            }, 40, ["aria-label", "class", "disabled", "to", "type"]))
          ]),
          _: 1
        }, 8, ["text"])) : (w(), de(ht(m.value || !e.item.to ? "button" : "router-link"), {
          key: 2,
          "aria-current": p.value ? "page" : void 0,
          "aria-expanded": m.value ? d.value : void 0,
          "aria-label": e.item.label,
          class: ne([S.value, "sidebar-item"]),
          disabled: e.item.disabled || void 0,
          to: !m.value && e.item.to ? v(u) : void 0,
          type: m.value || !e.item.to ? "button" : void 0,
          onClick: h,
          onMouseenter: k
        }, {
          default: fe(() => [
            b.value ? (w(), de(ke, {
              key: 0,
              icon: b.value,
              size: 20,
              class: "sidebar-item__icon"
            }, null, 8, ["icon"])) : P("", !0),
            oe(Dt, {
              "enter-active-class": "sidebar-label-enter-active",
              "enter-from-class": "sidebar-label-enter-from",
              "enter-to-class": "sidebar-label-enter-to",
              "leave-active-class": "sidebar-label-leave-active",
              "leave-from-class": "sidebar-label-leave-from",
              "leave-to-class": "sidebar-label-leave-to"
            }, {
              default: fe(() => [
                v(n) ? P("", !0) : (w(), T("span", {
                  key: 0,
                  ref: "label",
                  title: f.value ? e.item.label : void 0,
                  class: "sidebar-item__label",
                  onMouseenter: y
                }, ue(e.item.label), 41, CC))
              ]),
              _: 1
            }),
            e.item.badge && !v(n) ? (w(), T("span", DC, ue(e.item.badge), 1)) : P("", !0),
            m.value && !v(n) ? (w(), de(ke, {
              key: 2,
              class: ne([{ "sidebar-item__chevron--expanded": d.value }, "sidebar-item__chevron"]),
              size: 16,
              icon: "mdi:chevron-down"
            }, null, 8, ["class"])) : P("", !0)
          ]),
          _: 1
        }, 40, ["aria-current", "aria-expanded", "aria-label", "class", "disabled", "to", "type"])),
        m.value && !v(n) ? (w(), T("div", {
          key: 3,
          class: ne([{ "sidebar-item-children--expanded": d.value }, "sidebar-item-children"])
        }, [
          E("div", OC, [
            (w(!0), T(Te, null, Pe(e.item.children, (_) => (w(), de($, {
              key: _.id,
              item: _,
              level: e.level + 1
            }, null, 8, ["item", "level"]))), 128))
          ])
        ], 2)) : P("", !0)
      ], 4);
    };
  }
}), of = /* @__PURE__ */ je(_C, [["__scopeId", "data-v-25de8820"]]), EC = {
  key: 0,
  class: "v-sidebar-footer__slot"
}, IC = {
  key: 1,
  class: "v-sidebar-footer__nav"
}, PC = {
  key: 2,
  class: "v-sidebar-footer__slot"
}, AC = /* @__PURE__ */ Se({
  __name: "SidebarFooter",
  props: {
    items: { default: () => [] }
  },
  setup(e) {
    const { isCollapsed: n } = is();
    return (t, a) => (w(), T("div", {
      class: ne([{ "v-sidebar-footer--collapsed": v(n) }, "v-sidebar-footer"])
    }, [
      t.$slots.start ? (w(), T("div", EC, [
        U(t.$slots, "start")
      ])) : P("", !0),
      e.items.length ? (w(), T("nav", IC, [
        (w(!0), T(Te, null, Pe(e.items, (s) => (w(), de(of, {
          key: s.id,
          item: s,
          level: 0
        }, null, 8, ["item"]))), 128))
      ])) : P("", !0),
      t.$slots.end ? (w(), T("div", PC, [
        U(t.$slots, "end")
      ])) : P("", !0)
    ], 2));
  }
}), RC = {
  key: 0,
  class: "sidebar-header__brand"
}, FC = {
  key: 0,
  class: "sidebar-header__logo"
}, VC = ["alt", "src"], LC = { class: "sidebar-header__name" }, NC = { class: "sidebar-header__controls" }, BC = ["aria-label"], zC = { class: "sidebar-header__toggle-icons" }, WC = /* @__PURE__ */ Se({
  __name: "SidebarHeader",
  setup(e) {
    const { isCollapsed: n, toggleCollapse: t, options: a } = is();
    return (s, r) => (w(), T("div", {
      class: ne([{ "sidebar-header--collapsed": v(n) }, "sidebar-header"])
    }, [
      oe(Dt, {
        "enter-active-class": "sidebar-label-enter-active",
        "enter-from-class": "sidebar-label-enter-from",
        "enter-to-class": "sidebar-label-enter-to",
        "leave-active-class": "sidebar-label-leave-active",
        "leave-from-class": "sidebar-label-leave-from",
        "leave-to-class": "sidebar-label-leave-to"
      }, {
        default: fe(() => [
          v(n) ? P("", !0) : (w(), T("div", RC, [
            U(s.$slots, "start", {}, () => [
              v(a).logoUrl ? (w(), T("div", FC, [
                E("img", {
                  alt: v(a).brandName,
                  src: v(a).logoUrl
                }, null, 8, VC)
              ])) : P("", !0),
              E("span", LC, ue(v(a).brandName), 1)
            ], !0)
          ]))
        ]),
        _: 3
      }),
      E("div", NC, [
        U(s.$slots, "end", {}, void 0, !0),
        E("button", {
          "aria-label": v(n) ? "Expand sidebar" : "Collapse sidebar",
          class: ne([{ "sidebar-header__toggle--collapsed": v(n) }, "sidebar-header__toggle"]),
          type: "button",
          onClick: r[0] || (r[0] = //@ts-ignore
          (...l) => v(t) && v(t)(...l))
        }, [
          E("span", zC, [
            oe(ke, {
              size: 20,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--close",
              icon: "lucide:panel-left-close"
            }),
            oe(ke, {
              size: 20,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--open",
              icon: "lucide:panel-left-open"
            })
          ])
        ], 10, BC)
      ])
    ], 2));
  }
}), YC = /* @__PURE__ */ je(WC, [["__scopeId", "data-v-ef54c1d6"]]), HC = { class: "sidebar-nav__list" }, UC = /* @__PURE__ */ Se({
  __name: "SidebarNav",
  setup(e) {
    const {
      resolvedItems: n,
      isCollapsed: t,
      expandedItems: a,
      activeItemId: s
    } = is();
    return (r, l) => (w(), T("nav", {
      class: ne([{ "sidebar-nav--collapsed": v(t) }, "sidebar-nav"])
    }, [
      E("div", HC, [
        (w(!0), T(Te, null, Pe(v(n), (i, o, u, c) => {
          const f = [v(s), v(a), v(t), i.id];
          if (c && c.key === i.id && gf(c, f)) return c;
          const m = (w(), de(of, {
            key: i.id,
            item: i,
            level: 0
          }, null, 8, ["item"]));
          return m.memo = f, m;
        }, l, 0), 128))
      ])
    ], 2));
  }
});
function uf(e, n = []) {
  var a;
  const t = [];
  for (const s of e) {
    const r = [...n, s.id];
    if (s.to) {
      const l = { itemId: s.id, ancestorIds: r };
      typeof s.to == "string" ? l.path = s.to : typeof s.to == "object" && "name" in s.to && s.to.name ? l.routeName = s.to.name : typeof s.to == "object" && "path" in s.to && s.to.path && (l.path = s.to.path), t.push(l);
    }
    (a = s.children) != null && a.length && t.push(...uf(s.children, r));
  }
  return t;
}
function qC(e) {
  const n = ai(), t = M(() => uf(e.value)), a = It(null), s = It(/* @__PURE__ */ new Set());
  We(
    () => ({ path: n.path, name: n.name }),
    ({ path: u, name: c }) => {
      let f;
      for (const m of t.value) {
        if (m.path && m.path === u) {
          f = m;
          break;
        }
        if (m.routeName && m.routeName === c) {
          f = m;
          break;
        }
      }
      f ? (a.value = f.itemId, s.value = new Set(f.ancestorIds)) : (a.value = null, s.value = /* @__PURE__ */ new Set());
    },
    { immediate: !0 }
  );
  const r = M(() => a.value), l = M(() => s.value);
  return { activeItemId: r, activePathIds: l, isActive: (u) => a.value === u, isOnActivePath: (u) => s.value.has(u) };
}
const YD = /* @__PURE__ */ Se({
  __name: "NavigationSidebar",
  props: {
    sidebar: {}
  },
  emits: ["prefetch", "collapse", "item-click"],
  setup(e, { emit: n }) {
    const t = n, a = yf(
      () => import("./NavigationSidebarMobile-DFaT9eaY.js")
    ), s = mC(e.sidebar), { activeItemId: r, activePathIds: l, isActive: i, isOnActivePath: o } = qC(
      s.resolvedItems
    );
    Na(rf, {
      ...s,
      activeItemId: r,
      activePathIds: l,
      isActive: i,
      isOnActivePath: o,
      onPrefetch: (c) => t("prefetch", c)
    });
    const u = M(() => e.sidebar.isCollapsed.value);
    return We(
      l,
      (c) => {
        s.expandMany([...c]);
      },
      { immediate: !0 }
    ), (c, f) => (w(), T("div", null, [
      E("aside", {
        class: ne([{ "sidebar--collapsed": u.value }, "sidebar sidebar--flat"]),
        "aria-label": "Main navigation"
      }, [
        oe(YC, null, dt({ _: 2 }, [
          c.$slots["header-title"] ? {
            name: "start",
            fn: fe(() => [
              U(c.$slots, "header-title")
            ]),
            key: "0"
          } : void 0,
          c.$slots["header-end"] ? {
            name: "end",
            fn: fe(() => [
              U(c.$slots, "header-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024),
        U(c.$slots, "subtitle-block"),
        oe(UC),
        oe(AC, null, dt({ _: 2 }, [
          c.$slots["footer-start"] ? {
            name: "start",
            fn: fe(() => [
              U(c.$slots, "footer-start")
            ]),
            key: "0"
          } : void 0,
          c.$slots["footer-end"] ? {
            name: "end",
            fn: fe(() => [
              U(c.$slots, "footer-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024)
      ], 2),
      oe(v(a), null, dt({ _: 2 }, [
        c.$slots["footer-start"] ? {
          name: "start",
          fn: fe(() => [
            U(c.$slots, "footer-start")
          ]),
          key: "0"
        } : void 0,
        c.$slots["footer-end"] ? {
          name: "end",
          fn: fe(() => [
            U(c.$slots, "footer-end")
          ]),
          key: "1"
        } : void 0
      ]), 1024)
    ]));
  }
}), jC = "ui-sidebar";
function GC(e) {
  try {
    return localStorage.getItem(`${e}:collapsed`) === "true";
  } catch {
    return !1;
  }
}
function KC(e, n) {
  try {
    localStorage.setItem(`${e}:collapsed`, String(n));
  } catch {
  }
}
function ZC(e) {
  try {
    const n = localStorage.getItem(`${e}:expanded`);
    if (!n) return /* @__PURE__ */ new Set();
    const t = JSON.parse(n);
    return Array.isArray(t) ? new Set(t) : /* @__PURE__ */ new Set();
  } catch {
    return /* @__PURE__ */ new Set();
  }
}
function XC(e, n) {
  try {
    localStorage.setItem(`${e}:expanded`, JSON.stringify([...n]));
  } catch {
  }
}
function HD(e) {
  const n = {
    brandName: e.brandName ?? "",
    logoUrl: e.logoUrl ?? "",
    storageKey: e.storageKey ?? jC,
    persistCollapse: e.persistCollapse ?? !0,
    persistentQueryParams: e.persistentQueryParams ?? []
  }, t = ee(!1), a = ee(!1), s = ee(/* @__PURE__ */ new Set());
  return n.persistCollapse && typeof window < "u" && (t.value = GC(n.storageKey), s.value = ZC(n.storageKey), Ut(() => {
    KC(n.storageKey, t.value);
  }), Ut(() => {
    XC(n.storageKey, s.value);
  })), {
    items: e.items,
    isCollapsed: t,
    isMobileOpen: a,
    expandedItems: s,
    options: n,
    toggleCollapse: () => {
      t.value = !t.value;
    },
    toggleMobile: () => {
      a.value = !a.value;
    }
  };
}
function JC(e, n, t, a, s) {
  let r = e.find((l) => l.id === n);
  return r || (r = { id: n, label: t, icon: a, order: s ?? 999, children: [] }, e.push(r)), r;
}
function QC(e, n, t) {
  if (!t.menuGroup) {
    e.push(n);
    return;
  }
  const a = t.menuGroup.split("/");
  let s = e;
  a.forEach((r, l) => {
    var c;
    const i = `group:${a.slice(0, l + 1).join("/")}`, o = (c = t.menuGroupMeta) == null ? void 0 : c[r];
    s = JC(
      s,
      i,
      r,
      (o == null ? void 0 : o.icon) ?? (l === 0 ? t.menuGroupIcon : void 0),
      (o == null ? void 0 : o.order) ?? (l === 0 ? t.menuGroupOrder : void 0)
    ).children;
  }), s.push(n);
}
function cf(e) {
  return e.sort((n, t) => (n.order ?? 999) - (t.order ?? 999)).map((n) => {
    var t;
    return {
      ...n,
      children: (t = n.children) != null && t.length ? cf(n.children) : void 0
    };
  });
}
function UD(e) {
  const n = [];
  for (const { item: t, meta: a } of e)
    QC(n, t, a);
  return cf(n);
}
export {
  Ld as $,
  bD as A,
  lt as B,
  kw as C,
  cD as D,
  gD as E,
  wD as F,
  $D as G,
  mD as H,
  Mk as I,
  vD as J,
  PD as K,
  c$ as L,
  ED as M,
  CD as N,
  Yu as O,
  kD as P,
  xD as Q,
  nf as R,
  A1 as S,
  EM as T,
  Ja as U,
  ke as V,
  lx as W,
  UD as X,
  HD as Y,
  sa as Z,
  je as _,
  lf as a,
  $s as a0,
  D$ as a1,
  Cs as a2,
  Nd as a3,
  Bd as a4,
  uD as a5,
  Ua as a6,
  Oi as a7,
  Jd as a8,
  Vd as a9,
  qC as aA,
  Zk as aB,
  O$ as aC,
  ID as aD,
  dC as aE,
  Rd as aF,
  WD as aG,
  Ai as aH,
  BD as aa,
  zD as ab,
  Sl as ac,
  DD as ad,
  tf as ae,
  Vi as af,
  Zr as ag,
  w$ as ah,
  oD as ai,
  OD as aj,
  k$ as ak,
  Qd as al,
  Fi as am,
  b$ as an,
  Us as ao,
  Ri as ap,
  Kr as aq,
  x$ as ar,
  _D as as,
  ef as at,
  E1 as au,
  Qa as av,
  fD as aw,
  Fd as ax,
  ND as ay,
  Pi as az,
  Es as b,
  RD as c,
  AD as d,
  yD as e,
  YD as f,
  LD as g,
  VD as h,
  FD as i,
  SD as j,
  TD as k,
  sD as l,
  qt as m,
  PS as n,
  Uc as o,
  rD as p,
  lD as q,
  iD as r,
  pD as s,
  dD as t,
  is as u,
  Cr as v,
  MD as w,
  $r as x,
  hD as y,
  jr as z
};
//# sourceMappingURL=index-CmviphZ2.js.map
